export const addressJson = [
  {
    label: '安徽省',
    
    
    parentId: 1,
    code: '340000000000',
    value: '2',
    children: [
      {
        label: '合肥市',
        
        
        parentId: 2,
        code: '340100000000',
        value: '363',
        children: [
          {
            label: '巢湖市',
            
            
            parentId: 363,
            code: '340181000000',
            value: '1499',
            
            id: 1499
          },
          {
            label: '庐江县',
            
            
            parentId: 363,
            code: '340124000000',
            value: '1500',
            
            id: 1500
          },
          {
            label: '长丰县',
            
            
            parentId: 363,
            code: '340121000000',
            value: '1501',
            
            id: 1501
          },
          {
            label: '肥东县',
            
            
            parentId: 363,
            code: '340122000000',
            value: '1502',
            
            id: 1502
          },
          {
            label: '肥西县',
            
            
            parentId: 363,
            code: '340123000000',
            value: '1503',
            
            id: 1503
          },
          {
            label: '瑶海区',
            
            
            parentId: 363,
            code: '340102000000',
            value: '1504',
            
            id: 1504
          },
          {
            label: '庐阳区',
            
            
            parentId: 363,
            code: '340103000000',
            value: '1505',
            
            id: 1505
          },
          {
            label: '蜀山区',
            
            
            parentId: 363,
            code: '340104000000',
            value: '1506',
            
            id: 1506
          },
          {
            label: '包河区',
            
            
            parentId: 363,
            code: '340111000000',
            value: '1507',
            
            id: 1507
          }
        ],
        id: 363
      },
      {
        label: '芜湖市',
        
        
        parentId: 2,
        code: '340200000000',
        value: '364',
        children: [
          {
            label: '镜湖区',
            
            
            parentId: 364,
            code: '340202000000',
            value: '1508',
            
            id: 1508
          },
          {
            label: '弋江区',
            
            
            parentId: 364,
            code: '340203000000',
            value: '1509',
            
            id: 1509
          },
          {
            label: '鸠江区',
            
            
            parentId: 364,
            code: '340207000000',
            value: '1510',
            
            id: 1510
          },
          {
            label: '芜湖县',
            
            
            parentId: 364,
            code: '340221000000',
            value: '1511',
            
            id: 1511
          },
          {
            label: '繁昌县',
            
            
            parentId: 364,
            code: '340222000000',
            value: '1512',
            
            id: 1512
          },
          {
            label: '南陵县',
            
            
            parentId: 364,
            code: '340223000000',
            value: '1513',
            
            id: 1513
          },
          {
            label: '无为县',
            
            
            parentId: 364,
            code: '340225000000',
            value: '1514',
            
            id: 1514
          },
          {
            label: '三山区',
            
            
            parentId: 364,
            code: '340208000000',
            value: '1515',
            
            id: 1515
          }
        ],
        id: 364
      },
      {
        label: '蚌埠市',
        
        
        parentId: 2,
        code: '340300000000',
        value: '365',
        children: [
          {
            label: '怀远县',
            
            
            parentId: 365,
            code: '340321000000',
            value: '1516',
            
            id: 1516
          },
          {
            label: '五河县',
            
            
            parentId: 365,
            code: '340322000000',
            value: '1517',
            
            id: 1517
          },
          {
            label: '固镇县',
            
            
            parentId: 365,
            code: '340323000000',
            value: '1518',
            
            id: 1518
          },
          {
            label: '龙子湖区',
            
            
            parentId: 365,
            code: '340302000000',
            value: '1519',
            
            id: 1519
          },
          {
            label: '蚌山区',
            
            
            parentId: 365,
            code: '340303000000',
            value: '1520',
            
            id: 1520
          },
          {
            label: '禹会区',
            
            
            parentId: 365,
            code: '340304000000',
            value: '1521',
            
            id: 1521
          },
          {
            label: '淮上区',
            
            
            parentId: 365,
            code: '340311000000',
            value: '1522',
            
            id: 1522
          }
        ],
        id: 365
      },
      {
        label: '淮南市',
        
        
        parentId: 2,
        code: '340400000000',
        value: '366',
        children: [
          {
            label: '大通区',
            
            
            parentId: 366,
            code: '340402000000',
            value: '1523',
            
            id: 1523
          },
          {
            label: '田家庵区',
            
            
            parentId: 366,
            code: '340403000000',
            value: '1524',
            
            id: 1524
          },
          {
            label: '谢家集区',
            
            
            parentId: 366,
            code: '340404000000',
            value: '1525',
            
            id: 1525
          },
          {
            label: '八公山区',
            
            
            parentId: 366,
            code: '340405000000',
            value: '1526',
            
            id: 1526
          },
          {
            label: '潘集区',
            
            
            parentId: 366,
            code: '340406000000',
            value: '1527',
            
            id: 1527
          },
          {
            label: '凤台县',
            
            
            parentId: 366,
            code: '340421000000',
            value: '1528',
            
            id: 1528
          }
        ],
        id: 366
      },
      {
        label: '马鞍山市',
        
        
        parentId: 2,
        code: '340500000000',
        value: '367',
        children: [
          {
            label: '博望区',
            
            
            parentId: 367,
            code: '340506000000',
            value: '1529',
            
            id: 1529
          },
          {
            label: '当涂县',
            
            
            parentId: 367,
            code: '340521000000',
            value: '1530',
            
            id: 1530
          },
          {
            label: '含山县',
            
            
            parentId: 367,
            code: '340522000000',
            value: '1531',
            
            id: 1531
          },
          {
            label: '和县',
            
            
            parentId: 367,
            code: '340523000000',
            value: '1532',
            
            id: 1532
          },
          {
            label: '花山区',
            
            
            parentId: 367,
            code: '340503000000',
            value: '1533',
            
            id: 1533
          },
          {
            label: '雨山区',
            
            
            parentId: 367,
            code: '340504000000',
            value: '1534',
            
            id: 1534
          }
        ],
        id: 367
      },
      {
        label: '淮北市',
        
        
        parentId: 2,
        code: '340600000000',
        value: '368',
        children: [
          {
            label: '杜集区',
            
            
            parentId: 368,
            code: '340602000000',
            value: '1535',
            
            id: 1535
          },
          {
            label: '相山区',
            
            
            parentId: 368,
            code: '340603000000',
            value: '1536',
            
            id: 1536
          },
          {
            label: '烈山区',
            
            
            parentId: 368,
            code: '340604000000',
            value: '1537',
            
            id: 1537
          },
          {
            label: '濉溪县',
            
            
            parentId: 368,
            code: '340621000000',
            value: '1538',
            
            id: 1538
          }
        ],
        id: 368
      },
      {
        label: '铜陵市',
        
        
        parentId: 2,
        code: '340700000000',
        value: '369',
        children: [
          {
            label: '铜陵县',
            
            
            parentId: 369,
            code: '340721000000',
            value: '1539',
            
            id: 1539
          },
          {
            label: '铜官山区',
            
            
            parentId: 369,
            code: '340702000000',
            value: '1540',
            
            id: 1540
          },
          {
            label: '狮子山区',
            
            
            parentId: 369,
            code: '340703000000',
            value: '1541',
            
            id: 1541
          },
          {
            label: '郊区',
            
            
            parentId: 369,
            code: '340711000000',
            value: '1542',
            
            id: 1542
          }
        ],
        id: 369
      },
      {
        label: '安庆市',
        
        
        parentId: 2,
        code: '340800000000',
        value: '370',
        children: [
          {
            label: '迎江区',
            
            
            parentId: 370,
            code: '340802000000',
            value: '1543',
            
            id: 1543
          },
          {
            label: '大观区',
            
            
            parentId: 370,
            code: '340803000000',
            value: '1544',
            
            id: 1544
          },
          {
            label: '宜秀区',
            
            
            parentId: 370,
            code: '340811000000',
            value: '1545',
            
            id: 1545
          },
          {
            label: '怀宁县',
            
            
            parentId: 370,
            code: '340822000000',
            value: '1546',
            
            id: 1546
          },
          {
            label: '枞阳县',
            
            
            parentId: 370,
            code: '340823000000',
            value: '1547',
            
            id: 1547
          },
          {
            label: '潜山县',
            
            
            parentId: 370,
            code: '340824000000',
            value: '1548',
            
            id: 1548
          },
          {
            label: '太湖县',
            
            
            parentId: 370,
            code: '340825000000',
            value: '1549',
            
            id: 1549
          },
          {
            label: '宿松县',
            
            
            parentId: 370,
            code: '340826000000',
            value: '1550',
            
            id: 1550
          },
          {
            label: '望江县',
            
            
            parentId: 370,
            code: '340827000000',
            value: '1551',
            
            id: 1551
          },
          {
            label: '岳西县',
            
            
            parentId: 370,
            code: '340828000000',
            value: '1552',
            
            id: 1552
          },
          {
            label: '桐城市',
            
            
            parentId: 370,
            code: '340881000000',
            value: '1553',
            
            id: 1553
          }
        ],
        id: 370
      },
      {
        label: '黄山市',
        
        
        parentId: 2,
        code: '341000000000',
        value: '371',
        children: [
          {
            label: '歙县',
            
            
            parentId: 371,
            code: '341021000000',
            value: '1554',
            
            id: 1554
          },
          {
            label: '休宁县',
            
            
            parentId: 371,
            code: '341022000000',
            value: '1555',
            
            id: 1555
          },
          {
            label: '黟县',
            
            
            parentId: 371,
            code: '341023000000',
            value: '1556',
            
            id: 1556
          },
          {
            label: '祁门县',
            
            
            parentId: 371,
            code: '341024000000',
            value: '1557',
            
            id: 1557
          },
          {
            label: '屯溪区',
            
            
            parentId: 371,
            code: '341002000000',
            value: '1558',
            
            id: 1558
          },
          {
            label: '黄山区',
            
            
            parentId: 371,
            code: '341003000000',
            value: '1559',
            
            id: 1559
          },
          {
            label: '徽州区',
            
            
            parentId: 371,
            code: '341004000000',
            value: '1560',
            
            id: 1560
          }
        ],
        id: 371
      },
      {
        label: '滁州市',
        
        
        parentId: 2,
        code: '341100000000',
        value: '372',
        children: [
          {
            label: '琅琊区',
            
            
            parentId: 372,
            code: '341102000000',
            value: '1561',
            
            id: 1561
          },
          {
            label: '南谯区',
            
            
            parentId: 372,
            code: '341103000000',
            value: '1562',
            
            id: 1562
          },
          {
            label: '来安县',
            
            
            parentId: 372,
            code: '341122000000',
            value: '1563',
            
            id: 1563
          },
          {
            label: '全椒县',
            
            
            parentId: 372,
            code: '341124000000',
            value: '1564',
            
            id: 1564
          },
          {
            label: '定远县',
            
            
            parentId: 372,
            code: '341125000000',
            value: '1565',
            
            id: 1565
          },
          {
            label: '凤阳县',
            
            
            parentId: 372,
            code: '341126000000',
            value: '1566',
            
            id: 1566
          },
          {
            label: '天长市',
            
            
            parentId: 372,
            code: '341181000000',
            value: '1567',
            
            id: 1567
          },
          {
            label: '明光市',
            
            
            parentId: 372,
            code: '341182000000',
            value: '1568',
            
            id: 1568
          }
        ],
        id: 372
      },
      {
        label: '阜阳市',
        
        
        parentId: 2,
        code: '341200000000',
        value: '373',
        children: [
          {
            label: '界首市',
            
            
            parentId: 373,
            code: '341282000000',
            value: '1569',
            
            id: 1569
          },
          {
            label: '临泉县',
            
            
            parentId: 373,
            code: '341221000000',
            value: '1570',
            
            id: 1570
          },
          {
            label: '太和县',
            
            
            parentId: 373,
            code: '341222000000',
            value: '1571',
            
            id: 1571
          },
          {
            label: '阜南县',
            
            
            parentId: 373,
            code: '341225000000',
            value: '1572',
            
            id: 1572
          },
          {
            label: '颍上县',
            
            
            parentId: 373,
            code: '341226000000',
            value: '1573',
            
            id: 1573
          },
          {
            label: '颍州区',
            
            
            parentId: 373,
            code: '341202000000',
            value: '1574',
            
            id: 1574
          },
          {
            label: '颍东区',
            
            
            parentId: 373,
            code: '341203000000',
            value: '1575',
            
            id: 1575
          },
          {
            label: '颍泉区',
            
            
            parentId: 373,
            code: '341204000000',
            value: '1576',
            
            id: 1576
          }
        ],
        id: 373
      },
      {
        label: '宿州市',
        
        
        parentId: 2,
        code: '341300000000',
        value: '374',
        children: [
          {
            label: '埇桥区',
            
            
            parentId: 374,
            code: '341302000000',
            value: '1577',
            
            id: 1577
          },
          {
            label: '砀山县',
            
            
            parentId: 374,
            code: '341321000000',
            value: '1578',
            
            id: 1578
          },
          {
            label: '萧县',
            
            
            parentId: 374,
            code: '341322000000',
            value: '1579',
            
            id: 1579
          },
          {
            label: '灵璧县',
            
            
            parentId: 374,
            code: '341323000000',
            value: '1580',
            
            id: 1580
          },
          {
            label: '泗县',
            
            
            parentId: 374,
            code: '341324000000',
            value: '1581',
            
            id: 1581
          }
        ],
        id: 374
      },
      {
        label: '六安市',
        
        
        parentId: 2,
        code: '341500000000',
        value: '375',
        children: [
          {
            label: '寿县',
            
            
            parentId: 375,
            code: '341521000000',
            value: '1582',
            
            id: 1582
          },
          {
            label: '霍邱县',
            
            
            parentId: 375,
            code: '341522000000',
            value: '1583',
            
            id: 1583
          },
          {
            label: '舒城县',
            
            
            parentId: 375,
            code: '341523000000',
            value: '1584',
            
            id: 1584
          },
          {
            label: '金寨县',
            
            
            parentId: 375,
            code: '341524000000',
            value: '1585',
            
            id: 1585
          },
          {
            label: '霍山县',
            
            
            parentId: 375,
            code: '341525000000',
            value: '1586',
            
            id: 1586
          },
          {
            label: '金安区',
            
            
            parentId: 375,
            code: '341502000000',
            value: '1587',
            
            id: 1587
          },
          {
            label: '裕安区',
            
            
            parentId: 375,
            code: '341503000000',
            value: '1588',
            
            id: 1588
          }
        ],
        id: 375
      },
      {
        label: '亳州市',
        
        
        parentId: 2,
        code: '341600000000',
        value: '376',
        children: [
          {
            label: '谯城区',
            
            
            parentId: 376,
            code: '341602000000',
            value: '1589',
            
            id: 1589
          },
          {
            label: '涡阳县',
            
            
            parentId: 376,
            code: '341621000000',
            value: '1590',
            
            id: 1590
          },
          {
            label: '蒙城县',
            
            
            parentId: 376,
            code: '341622000000',
            value: '1591',
            
            id: 1591
          },
          {
            label: '利辛县',
            
            
            parentId: 376,
            code: '341623000000',
            value: '1592',
            
            id: 1592
          }
        ],
        id: 376
      },
      {
        label: '池州市',
        
        
        parentId: 2,
        code: '341700000000',
        value: '377',
        children: [
          {
            label: '贵池区',
            
            
            parentId: 377,
            code: '341702000000',
            value: '1593',
            
            id: 1593
          },
          {
            label: '东至县',
            
            
            parentId: 377,
            code: '341721000000',
            value: '1594',
            
            id: 1594
          },
          {
            label: '石台县',
            
            
            parentId: 377,
            code: '341722000000',
            value: '1595',
            
            id: 1595
          },
          {
            label: '青阳县',
            
            
            parentId: 377,
            code: '341723000000',
            value: '1596',
            
            id: 1596
          }
        ],
        id: 377
      },
      {
        label: '宣城市',
        
        
        parentId: 2,
        code: '341800000000',
        value: '378',
        children: [
          {
            label: '郎溪县',
            
            
            parentId: 378,
            code: '341821000000',
            value: '1597',
            
            id: 1597
          },
          {
            label: '广德县',
            
            
            parentId: 378,
            code: '341822000000',
            value: '1598',
            
            id: 1598
          },
          {
            label: '泾县',
            
            
            parentId: 378,
            code: '341823000000',
            value: '1599',
            
            id: 1599
          },
          {
            label: '绩溪县',
            
            
            parentId: 378,
            code: '341824000000',
            value: '1600',
            
            id: 1600
          },
          {
            label: '旌德县',
            
            
            parentId: 378,
            code: '341825000000',
            value: '1601',
            
            id: 1601
          },
          {
            label: '宣州区',
            
            
            parentId: 378,
            code: '341802000000',
            value: '1602',
            
            id: 1602
          },
          {
            label: '宁国市',
            
            
            parentId: 378,
            code: '341881000000',
            value: '1603',
            
            id: 1603
          }
        ],
        id: 378
      }
    ],
    id: 2
  },
  {
    label: '北京市',
    
    
    parentId: 1,
    code: '110000000000',
    value: '3',
    children: [
      {
        label: '市辖区',
        
        
        parentId: 3,
        code: '110100000000',
        value: '33',
        children: [
          {
            label: '昌平区',
            
            
            parentId: 33,
            code: '110114000000',
            value: '3161',
            
            id: 3161
          },
          {
            label: '朝阳区',
            
            
            parentId: 33,
            code: '110105000000',
            value: '3162',
            
            id: 3162
          },
          {
            label: '大兴区',
            
            
            parentId: 33,
            code: '110115000000',
            value: '3163',
            
            id: 3163
          },
          {
            label: '东城区',
            
            
            parentId: 33,
            code: '110101000000',
            value: '3164',
            
            id: 3164
          },
          {
            label: '房山区',
            
            
            parentId: 33,
            code: '110111000000',
            value: '3165',
            
            id: 3165
          },
          {
            label: '丰台区',
            
            
            parentId: 33,
            code: '110106000000',
            value: '3166',
            
            id: 3166
          },
          {
            label: '海淀区',
            
            
            parentId: 33,
            code: '110108000000',
            value: '3167',
            
            id: 3167
          },
          {
            label: '怀柔区',
            
            
            parentId: 33,
            code: '110116000000',
            value: '3168',
            
            id: 3168
          },
          {
            label: '门头沟区',
            
            
            parentId: 33,
            code: '110109000000',
            value: '3169',
            
            id: 3169
          },
          {
            label: '平谷区',
            
            
            parentId: 33,
            code: '110117000000',
            value: '3170',
            
            id: 3170
          },
          {
            label: '石景山区',
            
            
            parentId: 33,
            code: '110107000000',
            value: '3171',
            
            id: 3171
          },
          {
            label: '顺义区',
            
            
            parentId: 33,
            code: '110113000000',
            value: '3172',
            
            id: 3172
          },
          {
            label: '通州区',
            
            
            parentId: 33,
            code: '110112000000',
            value: '3173',
            
            id: 3173
          },
          {
            label: '西城区',
            
            
            parentId: 33,
            code: '110102000000',
            value: '3174',
            
            id: 3174
          }
        ],
        id: 33
      },
      {
        label: '县',
        
        
        parentId: 3,
        code: '110200000000',
        value: '34',
        children: [
          {
            label: '密云县',
            
            
            parentId: 34,
            code: '110228000000',
            value: '3175',
            
            id: 3175
          },
          {
            label: '延庆县',
            
            
            parentId: 34,
            code: '110229000000',
            value: '3176',
            
            id: 3176
          }
        ],
        id: 34
      }
    ],
    id: 3
  },
  {
    label: '福建省',
    
    
    parentId: 1,
    code: '350000000000',
    value: '4',
    children: [
      {
        label: '福州市',
        
        
        parentId: 4,
        code: '350100000000',
        value: '35',
        children: [
          {
            label: '福清市',
            
            
            parentId: 35,
            code: '350181000000',
            value: '1604',
            
            id: 1604
          },
          {
            label: '长乐市',
            
            
            parentId: 35,
            code: '350182000000',
            value: '1605',
            
            id: 1605
          },
          {
            label: '鼓楼区',
            
            
            parentId: 35,
            code: '350102000000',
            value: '1606',
            
            id: 1606
          },
          {
            label: '台江区',
            
            
            parentId: 35,
            code: '350103000000',
            value: '1607',
            
            id: 1607
          },
          {
            label: '仓山区',
            
            
            parentId: 35,
            code: '350104000000',
            value: '1608',
            
            id: 1608
          },
          {
            label: '马尾区',
            
            
            parentId: 35,
            code: '350105000000',
            value: '1609',
            
            id: 1609
          },
          {
            label: '晋安区',
            
            
            parentId: 35,
            code: '350111000000',
            value: '1610',
            
            id: 1610
          },
          {
            label: '闽侯县',
            
            
            parentId: 35,
            code: '350121000000',
            value: '1611',
            
            id: 1611
          },
          {
            label: '连江县',
            
            
            parentId: 35,
            code: '350122000000',
            value: '1612',
            
            id: 1612
          },
          {
            label: '罗源县',
            
            
            parentId: 35,
            code: '350123000000',
            value: '1613',
            
            id: 1613
          },
          {
            label: '闽清县',
            
            
            parentId: 35,
            code: '350124000000',
            value: '1614',
            
            id: 1614
          },
          {
            label: '永泰县',
            
            
            parentId: 35,
            code: '350125000000',
            value: '1615',
            
            id: 1615
          },
          {
            label: '平潭县',
            
            
            parentId: 35,
            code: '350128000000',
            value: '1616',
            
            id: 1616
          }
        ],
        id: 35
      },
      {
        label: '厦门市',
        
        
        parentId: 4,
        code: '350200000000',
        value: '36',
        children: [
          {
            label: '思明区',
            
            
            parentId: 36,
            code: '350203000000',
            value: '1617',
            
            id: 1617
          },
          {
            label: '海沧区',
            
            
            parentId: 36,
            code: '350205000000',
            value: '1618',
            
            id: 1618
          },
          {
            label: '湖里区',
            
            
            parentId: 36,
            code: '350206000000',
            value: '1619',
            
            id: 1619
          },
          {
            label: '集美区',
            
            
            parentId: 36,
            code: '350211000000',
            value: '1620',
            
            id: 1620
          },
          {
            label: '同安区',
            
            
            parentId: 36,
            code: '350212000000',
            value: '1621',
            
            id: 1621
          },
          {
            label: '翔安区',
            
            
            parentId: 36,
            code: '350213000000',
            value: '1622',
            
            id: 1622
          }
        ],
        id: 36
      },
      {
        label: '莆田市',
        
        
        parentId: 4,
        code: '350300000000',
        value: '37',
        children: [
          {
            label: '仙游县',
            
            
            parentId: 37,
            code: '350322000000',
            value: '1623',
            
            id: 1623
          },
          {
            label: '城厢区',
            
            
            parentId: 37,
            code: '350302000000',
            value: '1624',
            
            id: 1624
          },
          {
            label: '涵江区',
            
            
            parentId: 37,
            code: '350303000000',
            value: '1625',
            
            id: 1625
          },
          {
            label: '荔城区',
            
            
            parentId: 37,
            code: '350304000000',
            value: '1626',
            
            id: 1626
          },
          {
            label: '秀屿区',
            
            
            parentId: 37,
            code: '350305000000',
            value: '1627',
            
            id: 1627
          }
        ],
        id: 37
      },
      {
        label: '三明市',
        
        
        parentId: 4,
        code: '350400000000',
        value: '38',
        children: [
          {
            label: '梅列区',
            
            
            parentId: 38,
            code: '350402000000',
            value: '1628',
            
            id: 1628
          },
          {
            label: '三元区',
            
            
            parentId: 38,
            code: '350403000000',
            value: '1629',
            
            id: 1629
          },
          {
            label: '明溪县',
            
            
            parentId: 38,
            code: '350421000000',
            value: '1630',
            
            id: 1630
          },
          {
            label: '清流县',
            
            
            parentId: 38,
            code: '350423000000',
            value: '1631',
            
            id: 1631
          },
          {
            label: '宁化县',
            
            
            parentId: 38,
            code: '350424000000',
            value: '1632',
            
            id: 1632
          },
          {
            label: '大田县',
            
            
            parentId: 38,
            code: '350425000000',
            value: '1633',
            
            id: 1633
          },
          {
            label: '尤溪县',
            
            
            parentId: 38,
            code: '350426000000',
            value: '1634',
            
            id: 1634
          },
          {
            label: '沙县',
            
            
            parentId: 38,
            code: '350427000000',
            value: '1635',
            
            id: 1635
          },
          {
            label: '将乐县',
            
            
            parentId: 38,
            code: '350428000000',
            value: '1636',
            
            id: 1636
          },
          {
            label: '泰宁县',
            
            
            parentId: 38,
            code: '350429000000',
            value: '1637',
            
            id: 1637
          },
          {
            label: '建宁县',
            
            
            parentId: 38,
            code: '350430000000',
            value: '1638',
            
            id: 1638
          },
          {
            label: '永安市',
            
            
            parentId: 38,
            code: '350481000000',
            value: '1639',
            
            id: 1639
          }
        ],
        id: 38
      },
      {
        label: '泉州市',
        
        
        parentId: 4,
        code: '350500000000',
        value: '39',
        children: [
          {
            label: '石狮市',
            
            
            parentId: 39,
            code: '350581000000',
            value: '1640',
            
            id: 1640
          },
          {
            label: '晋江市',
            
            
            parentId: 39,
            code: '350582000000',
            value: '1641',
            
            id: 1641
          },
          {
            label: '南安市',
            
            
            parentId: 39,
            code: '350583000000',
            value: '1642',
            
            id: 1642
          },
          {
            label: '惠安县',
            
            
            parentId: 39,
            code: '350521000000',
            value: '1643',
            
            id: 1643
          },
          {
            label: '安溪县',
            
            
            parentId: 39,
            code: '350524000000',
            value: '1644',
            
            id: 1644
          },
          {
            label: '永春县',
            
            
            parentId: 39,
            code: '350525000000',
            value: '1645',
            
            id: 1645
          },
          {
            label: '德化县',
            
            
            parentId: 39,
            code: '350526000000',
            value: '1646',
            
            id: 1646
          },
          {
            label: '金门县',
            
            
            parentId: 39,
            code: '350527000000',
            value: '1647',
            
            id: 1647
          },
          {
            label: '鲤城区',
            
            
            parentId: 39,
            code: '350502000000',
            value: '1648',
            
            id: 1648
          },
          {
            label: '丰泽区',
            
            
            parentId: 39,
            code: '350503000000',
            value: '1649',
            
            id: 1649
          },
          {
            label: '洛江区',
            
            
            parentId: 39,
            code: '350504000000',
            value: '1650',
            
            id: 1650
          },
          {
            label: '泉港区',
            
            
            parentId: 39,
            code: '350505000000',
            value: '1651',
            
            id: 1651
          }
        ],
        id: 39
      },
      {
        label: '漳州市',
        
        
        parentId: 4,
        code: '350600000000',
        value: '40',
        children: [
          {
            label: '芗城区',
            
            
            parentId: 40,
            code: '350602000000',
            value: '1652',
            
            id: 1652
          },
          {
            label: '龙文区',
            
            
            parentId: 40,
            code: '350603000000',
            value: '1653',
            
            id: 1653
          },
          {
            label: '云霄县',
            
            
            parentId: 40,
            code: '350622000000',
            value: '1654',
            
            id: 1654
          },
          {
            label: '漳浦县',
            
            
            parentId: 40,
            code: '350623000000',
            value: '1655',
            
            id: 1655
          },
          {
            label: '诏安县',
            
            
            parentId: 40,
            code: '350624000000',
            value: '1656',
            
            id: 1656
          },
          {
            label: '长泰县',
            
            
            parentId: 40,
            code: '350625000000',
            value: '1657',
            
            id: 1657
          },
          {
            label: '东山县',
            
            
            parentId: 40,
            code: '350626000000',
            value: '1658',
            
            id: 1658
          },
          {
            label: '南靖县',
            
            
            parentId: 40,
            code: '350627000000',
            value: '1659',
            
            id: 1659
          },
          {
            label: '平和县',
            
            
            parentId: 40,
            code: '350628000000',
            value: '1660',
            
            id: 1660
          },
          {
            label: '华安县',
            
            
            parentId: 40,
            code: '350629000000',
            value: '1661',
            
            id: 1661
          },
          {
            label: '龙海市',
            
            
            parentId: 40,
            code: '350681000000',
            value: '1662',
            
            id: 1662
          }
        ],
        id: 40
      },
      {
        label: '南平市',
        
        
        parentId: 4,
        code: '350700000000',
        value: '41',
        children: [
          {
            label: '邵武市',
            
            
            parentId: 41,
            code: '350781000000',
            value: '1663',
            
            id: 1663
          },
          {
            label: '武夷山市',
            
            
            parentId: 41,
            code: '350782000000',
            value: '1664',
            
            id: 1664
          },
          {
            label: '建瓯市',
            
            
            parentId: 41,
            code: '350783000000',
            value: '1665',
            
            id: 1665
          },
          {
            label: '建阳市',
            
            
            parentId: 41,
            code: '350784000000',
            value: '1666',
            
            id: 1666
          },
          {
            label: '顺昌县',
            
            
            parentId: 41,
            code: '350721000000',
            value: '1667',
            
            id: 1667
          },
          {
            label: '浦城县',
            
            
            parentId: 41,
            code: '350722000000',
            value: '1668',
            
            id: 1668
          },
          {
            label: '光泽县',
            
            
            parentId: 41,
            code: '350723000000',
            value: '1669',
            
            id: 1669
          },
          {
            label: '松溪县',
            
            
            parentId: 41,
            code: '350724000000',
            value: '1670',
            
            id: 1670
          },
          {
            label: '政和县',
            
            
            parentId: 41,
            code: '350725000000',
            value: '1671',
            
            id: 1671
          },
          {
            label: '延平区',
            
            
            parentId: 41,
            code: '350702000000',
            value: '1672',
            
            id: 1672
          }
        ],
        id: 41
      },
      {
        label: '龙岩市',
        
        
        parentId: 4,
        code: '350800000000',
        value: '42',
        children: [
          {
            label: '新罗区',
            
            
            parentId: 42,
            code: '350802000000',
            value: '1673',
            
            id: 1673
          },
          {
            label: '长汀县',
            
            
            parentId: 42,
            code: '350821000000',
            value: '1674',
            
            id: 1674
          },
          {
            label: '永定县',
            
            
            parentId: 42,
            code: '350822000000',
            value: '1675',
            
            id: 1675
          },
          {
            label: '上杭县',
            
            
            parentId: 42,
            code: '350823000000',
            value: '1676',
            
            id: 1676
          },
          {
            label: '武平县',
            
            
            parentId: 42,
            code: '350824000000',
            value: '1677',
            
            id: 1677
          },
          {
            label: '连城县',
            
            
            parentId: 42,
            code: '350825000000',
            value: '1678',
            
            id: 1678
          },
          {
            label: '漳平市',
            
            
            parentId: 42,
            code: '350881000000',
            value: '1679',
            
            id: 1679
          }
        ],
        id: 42
      },
      {
        label: '宁德市',
        
        
        parentId: 4,
        code: '350900000000',
        value: '43',
        children: [
          {
            label: '福安市',
            
            
            parentId: 43,
            code: '350981000000',
            value: '1680',
            
            id: 1680
          },
          {
            label: '福鼎市',
            
            
            parentId: 43,
            code: '350982000000',
            value: '1681',
            
            id: 1681
          },
          {
            label: '霞浦县',
            
            
            parentId: 43,
            code: '350921000000',
            value: '1682',
            
            id: 1682
          },
          {
            label: '古田县',
            
            
            parentId: 43,
            code: '350922000000',
            value: '1683',
            
            id: 1683
          },
          {
            label: '屏南县',
            
            
            parentId: 43,
            code: '350923000000',
            value: '1684',
            
            id: 1684
          },
          {
            label: '寿宁县',
            
            
            parentId: 43,
            code: '350924000000',
            value: '1685',
            
            id: 1685
          },
          {
            label: '周宁县',
            
            
            parentId: 43,
            code: '350925000000',
            value: '1686',
            
            id: 1686
          },
          {
            label: '柘荣县',
            
            
            parentId: 43,
            code: '350926000000',
            value: '1687',
            
            id: 1687
          },
          {
            label: '蕉城区',
            
            
            parentId: 43,
            code: '350902000000',
            value: '1688',
            
            id: 1688
          }
        ],
        id: 43
      }
    ],
    id: 4
  },
  {
    label: '甘肃省',
    
    
    parentId: 1,
    code: '620000000000',
    value: '5',
    children: [
      {
        label: '兰州市',
        
        
        parentId: 5,
        code: '620100000000',
        value: '44',
        children: [
          {
            label: '永登县',
            
            
            parentId: 44,
            code: '620121000000',
            value: '2955',
            
            id: 2955
          },
          {
            label: '皋兰县',
            
            
            parentId: 44,
            code: '620122000000',
            value: '2956',
            
            id: 2956
          },
          {
            label: '榆中县',
            
            
            parentId: 44,
            code: '620123000000',
            value: '2957',
            
            id: 2957
          },
          {
            label: '城关区',
            
            
            parentId: 44,
            code: '620102000000',
            value: '2958',
            
            id: 2958
          },
          {
            label: '七里河区',
            
            
            parentId: 44,
            code: '620103000000',
            value: '2959',
            
            id: 2959
          },
          {
            label: '西固区',
            
            
            parentId: 44,
            code: '620104000000',
            value: '2960',
            
            id: 2960
          },
          {
            label: '安宁区',
            
            
            parentId: 44,
            code: '620105000000',
            value: '2961',
            
            id: 2961
          },
          {
            label: '红古区',
            
            
            parentId: 44,
            code: '620111000000',
            value: '2962',
            
            id: 2962
          }
        ],
        id: 44
      },
      {
        label: '嘉峪关市',
        
        
        parentId: 5,
        code: '620200000000',
        value: '45',
        children: [],
        id: 45
      },
      {
        label: '金昌市',
        
        
        parentId: 5,
        code: '620300000000',
        value: '46',
        children: [
          {
            label: '金川区',
            
            
            parentId: 46,
            code: '620302000000',
            value: '2963',
            
            id: 2963
          },
          {
            label: '永昌县',
            
            
            parentId: 46,
            code: '620321000000',
            value: '2964',
            
            id: 2964
          }
        ],
        id: 46
      },
      {
        label: '白银市',
        
        
        parentId: 5,
        code: '620400000000',
        value: '47',
        children: [
          {
            label: '靖远县',
            
            
            parentId: 47,
            code: '620421000000',
            value: '2965',
            
            id: 2965
          },
          {
            label: '会宁县',
            
            
            parentId: 47,
            code: '620422000000',
            value: '2966',
            
            id: 2966
          },
          {
            label: '景泰县',
            
            
            parentId: 47,
            code: '620423000000',
            value: '2967',
            
            id: 2967
          },
          {
            label: '白银区',
            
            
            parentId: 47,
            code: '620402000000',
            value: '2968',
            
            id: 2968
          },
          {
            label: '平川区',
            
            
            parentId: 47,
            code: '620403000000',
            value: '2969',
            
            id: 2969
          }
        ],
        id: 47
      },
      {
        label: '天水市',
        
        
        parentId: 5,
        code: '620500000000',
        value: '48',
        children: [
          {
            label: '秦州区',
            
            
            parentId: 48,
            code: '620502000000',
            value: '2970',
            
            id: 2970
          },
          {
            label: '麦积区',
            
            
            parentId: 48,
            code: '620503000000',
            value: '2971',
            
            id: 2971
          },
          {
            label: '张家川回族自治县',
            
            
            parentId: 48,
            code: '620525000000',
            value: '2972',
            
            id: 2972
          },
          {
            label: '清水县',
            
            
            parentId: 48,
            code: '620521000000',
            value: '2973',
            
            id: 2973
          },
          {
            label: '秦安县',
            
            
            parentId: 48,
            code: '620522000000',
            value: '2974',
            
            id: 2974
          },
          {
            label: '甘谷县',
            
            
            parentId: 48,
            code: '620523000000',
            value: '2975',
            
            id: 2975
          },
          {
            label: '武山县',
            
            
            parentId: 48,
            code: '620524000000',
            value: '2976',
            
            id: 2976
          }
        ],
        id: 48
      },
      {
        label: '武威市',
        
        
        parentId: 5,
        code: '620600000000',
        value: '49',
        children: [
          {
            label: '民勤县',
            
            
            parentId: 49,
            code: '620621000000',
            value: '2977',
            
            id: 2977
          },
          {
            label: '古浪县',
            
            
            parentId: 49,
            code: '620622000000',
            value: '2978',
            
            id: 2978
          },
          {
            label: '天祝藏族自治县',
            
            
            parentId: 49,
            code: '620623000000',
            value: '2979',
            
            id: 2979
          },
          {
            label: '凉州区',
            
            
            parentId: 49,
            code: '620602000000',
            value: '2980',
            
            id: 2980
          }
        ],
        id: 49
      },
      {
        label: '张掖市',
        
        
        parentId: 5,
        code: '620700000000',
        value: '50',
        children: [
          {
            label: '甘州区',
            
            
            parentId: 50,
            code: '620702000000',
            value: '2981',
            
            id: 2981
          },
          {
            label: '肃南裕固族自治县',
            
            
            parentId: 50,
            code: '620721000000',
            value: '2982',
            
            id: 2982
          },
          {
            label: '民乐县',
            
            
            parentId: 50,
            code: '620722000000',
            value: '2983',
            
            id: 2983
          },
          {
            label: '临泽县',
            
            
            parentId: 50,
            code: '620723000000',
            value: '2984',
            
            id: 2984
          },
          {
            label: '高台县',
            
            
            parentId: 50,
            code: '620724000000',
            value: '2985',
            
            id: 2985
          },
          {
            label: '山丹县',
            
            
            parentId: 50,
            code: '620725000000',
            value: '2986',
            
            id: 2986
          }
        ],
        id: 50
      },
      {
        label: '平凉市',
        
        
        parentId: 5,
        code: '620800000000',
        value: '51',
        children: [
          {
            label: '泾川县',
            
            
            parentId: 51,
            code: '620821000000',
            value: '2987',
            
            id: 2987
          },
          {
            label: '灵台县',
            
            
            parentId: 51,
            code: '620822000000',
            value: '2988',
            
            id: 2988
          },
          {
            label: '崇信县',
            
            
            parentId: 51,
            code: '620823000000',
            value: '2989',
            
            id: 2989
          },
          {
            label: '华亭县',
            
            
            parentId: 51,
            code: '620824000000',
            value: '2990',
            
            id: 2990
          },
          {
            label: '庄浪县',
            
            
            parentId: 51,
            code: '620825000000',
            value: '2991',
            
            id: 2991
          },
          {
            label: '静宁县',
            
            
            parentId: 51,
            code: '620826000000',
            value: '2992',
            
            id: 2992
          },
          {
            label: '崆峒区',
            
            
            parentId: 51,
            code: '620802000000',
            value: '2993',
            
            id: 2993
          }
        ],
        id: 51
      },
      {
        label: '酒泉市',
        
        
        parentId: 5,
        code: '620900000000',
        value: '52',
        children: [
          {
            label: '肃州区',
            
            
            parentId: 52,
            code: '620902000000',
            value: '2994',
            
            id: 2994
          },
          {
            label: '玉门市',
            
            
            parentId: 52,
            code: '620981000000',
            value: '2995',
            
            id: 2995
          },
          {
            label: '敦煌市',
            
            
            parentId: 52,
            code: '620982000000',
            value: '2996',
            
            id: 2996
          },
          {
            label: '肃北蒙古族自治县',
            
            
            parentId: 52,
            code: '620923000000',
            value: '2997',
            
            id: 2997
          },
          {
            label: '阿克塞哈萨克族自治县',
            
            
            parentId: 52,
            code: '620924000000',
            value: '2998',
            
            id: 2998
          },
          {
            label: '金塔县',
            
            
            parentId: 52,
            code: '620921000000',
            value: '2999',
            
            id: 2999
          },
          {
            label: '瓜州县',
            
            
            parentId: 52,
            code: '620922000000',
            value: '3000',
            
            id: 3000
          }
        ],
        id: 52
      },
      {
        label: '庆阳市',
        
        
        parentId: 5,
        code: '621000000000',
        value: '53',
        children: [
          {
            label: '庆城县',
            
            
            parentId: 53,
            code: '621021000000',
            value: '3001',
            
            id: 3001
          },
          {
            label: '环县',
            
            
            parentId: 53,
            code: '621022000000',
            value: '3002',
            
            id: 3002
          },
          {
            label: '华池县',
            
            
            parentId: 53,
            code: '621023000000',
            value: '3003',
            
            id: 3003
          },
          {
            label: '合水县',
            
            
            parentId: 53,
            code: '621024000000',
            value: '3004',
            
            id: 3004
          },
          {
            label: '正宁县',
            
            
            parentId: 53,
            code: '621025000000',
            value: '3005',
            
            id: 3005
          },
          {
            label: '宁县',
            
            
            parentId: 53,
            code: '621026000000',
            value: '3006',
            
            id: 3006
          },
          {
            label: '镇原县',
            
            
            parentId: 53,
            code: '621027000000',
            value: '3007',
            
            id: 3007
          },
          {
            label: '西峰区',
            
            
            parentId: 53,
            code: '621002000000',
            value: '3008',
            
            id: 3008
          }
        ],
        id: 53
      },
      {
        label: '定西市',
        
        
        parentId: 5,
        code: '621100000000',
        value: '54',
        children: [
          {
            label: '安定区',
            
            
            parentId: 54,
            code: '621102000000',
            value: '3009',
            
            id: 3009
          },
          {
            label: '通渭县',
            
            
            parentId: 54,
            code: '621121000000',
            value: '3010',
            
            id: 3010
          },
          {
            label: '陇西县',
            
            
            parentId: 54,
            code: '621122000000',
            value: '3011',
            
            id: 3011
          },
          {
            label: '渭源县',
            
            
            parentId: 54,
            code: '621123000000',
            value: '3012',
            
            id: 3012
          },
          {
            label: '临洮县',
            
            
            parentId: 54,
            code: '621124000000',
            value: '3013',
            
            id: 3013
          },
          {
            label: '漳县',
            
            
            parentId: 54,
            code: '621125000000',
            value: '3014',
            
            id: 3014
          },
          {
            label: '岷县',
            
            
            parentId: 54,
            code: '621126000000',
            value: '3015',
            
            id: 3015
          }
        ],
        id: 54
      },
      {
        label: '陇南市',
        
        
        parentId: 5,
        code: '621200000000',
        value: '55',
        children: [
          {
            label: '武都区',
            
            
            parentId: 55,
            code: '621202000000',
            value: '3016',
            
            id: 3016
          },
          {
            label: '宕昌县',
            
            
            parentId: 55,
            code: '621223000000',
            value: '3017',
            
            id: 3017
          },
          {
            label: '成县',
            
            
            parentId: 55,
            code: '621221000000',
            value: '3018',
            
            id: 3018
          },
          {
            label: '康县',
            
            
            parentId: 55,
            code: '621224000000',
            value: '3019',
            
            id: 3019
          },
          {
            label: '文县',
            
            
            parentId: 55,
            code: '621222000000',
            value: '3020',
            
            id: 3020
          },
          {
            label: '西和县',
            
            
            parentId: 55,
            code: '621225000000',
            value: '3021',
            
            id: 3021
          },
          {
            label: '礼县',
            
            
            parentId: 55,
            code: '621226000000',
            value: '3022',
            
            id: 3022
          },
          {
            label: '两当县',
            
            
            parentId: 55,
            code: '621228000000',
            value: '3023',
            
            id: 3023
          },
          {
            label: '徽县',
            
            
            parentId: 55,
            code: '621227000000',
            value: '3024',
            
            id: 3024
          }
        ],
        id: 55
      },
      {
        label: '临夏回族自治州',
        
        
        parentId: 5,
        code: '622900000000',
        value: '56',
        children: [
          {
            label: '东乡族自治县',
            
            
            parentId: 56,
            code: '622926000000',
            value: '1113',
            
            id: 1113
          },
          {
            label: '积石山保安族东乡族撒拉族自治县',
            
            
            parentId: 56,
            code: '622927000000',
            value: '1114',
            
            id: 1114
          },
          {
            label: '临夏市',
            
            
            parentId: 56,
            code: '622901000000',
            value: '1115',
            
            id: 1115
          },
          {
            label: '和政县',
            
            
            parentId: 56,
            code: '622925000000',
            value: '1116',
            
            id: 1116
          },
          {
            label: '临夏县',
            
            
            parentId: 56,
            code: '622921000000',
            value: '1117',
            
            id: 1117
          },
          {
            label: '康乐县',
            
            
            parentId: 56,
            code: '622922000000',
            value: '1118',
            
            id: 1118
          },
          {
            label: '永靖县',
            
            
            parentId: 56,
            code: '622923000000',
            value: '1119',
            
            id: 1119
          },
          {
            label: '广河县',
            
            
            parentId: 56,
            code: '622924000000',
            value: '1120',
            
            id: 1120
          }
        ],
        id: 56
      },
      {
        label: '甘南藏族自治州',
        
        
        parentId: 5,
        code: '623000000000',
        value: '57',
        children: [
          {
            label: '临潭县',
            
            
            parentId: 57,
            code: '623021000000',
            value: '1121',
            
            id: 1121
          },
          {
            label: '卓尼县',
            
            
            parentId: 57,
            code: '623022000000',
            value: '1122',
            
            id: 1122
          },
          {
            label: '舟曲县',
            
            
            parentId: 57,
            code: '623023000000',
            value: '1123',
            
            id: 1123
          },
          {
            label: '迭部县',
            
            
            parentId: 57,
            code: '623024000000',
            value: '1124',
            
            id: 1124
          },
          {
            label: '玛曲县',
            
            
            parentId: 57,
            code: '623025000000',
            value: '1125',
            
            id: 1125
          },
          {
            label: '碌曲县',
            
            
            parentId: 57,
            code: '623026000000',
            value: '1126',
            
            id: 1126
          },
          {
            label: '夏河县',
            
            
            parentId: 57,
            code: '623027000000',
            value: '1127',
            
            id: 1127
          },
          {
            label: '合作市',
            
            
            parentId: 57,
            code: '623001000000',
            value: '1128',
            
            id: 1128
          }
        ],
        id: 57
      }
    ],
    id: 5
  },
  {
    label: '广东省',
    
    
    parentId: 1,
    code: '440000000000',
    value: '6',
    children: [
      {
        label: '广州市',
        
        
        parentId: 6,
        code: '440100000000',
        value: '58',
        children: [
          {
            label: '增城区',
            
            
            parentId: 58,
            code: '440118000000',
            value: '538',
            
            id: 538
          },
          {
            label: '从化区',
            
            
            parentId: 58,
            code: '440117000000',
            value: '539',
            
            id: 539
          },
          {
            label: '南沙区',
            
            
            parentId: 58,
            code: '440115000000',
            value: '540',
            
            id: 540
          },
          {
            label: '荔湾区',
            
            
            parentId: 58,
            code: '440103000000',
            value: '541',
            
            id: 541
          },
          {
            label: '越秀区',
            
            
            parentId: 58,
            code: '440104000000',
            value: '542',
            
            id: 542
          },
          {
            label: '海珠区',
            
            
            parentId: 58,
            code: '440105000000',
            value: '543',
            
            id: 543
          },
          {
            label: '天河区',
            
            
            parentId: 58,
            code: '440106000000',
            value: '544',
            
            id: 544
          },
          {
            label: '萝岗区',
            
            
            parentId: 58,
            code: '440116000000',
            value: '545',
            
            id: 545
          },
          {
            label: '白云区',
            
            
            parentId: 58,
            code: '440111000000',
            value: '546',
            
            id: 546
          },
          {
            label: '黄埔区',
            
            
            parentId: 58,
            code: '440112000000',
            value: '547',
            
            id: 547
          },
          {
            label: '番禺区',
            
            
            parentId: 58,
            code: '440113000000',
            value: '548',
            
            id: 548
          },
          {
            label: '花都区',
            
            
            parentId: 58,
            code: '440114000000',
            value: '549',
            
            id: 549
          }
        ],
        id: 58
      },
      {
        label: '韶关市',
        
        
        parentId: 6,
        code: '440200000000',
        value: '59',
        children: [
          {
            label: '始兴县',
            
            
            parentId: 59,
            code: '440222000000',
            value: '550',
            
            id: 550
          },
          {
            label: '仁化县',
            
            
            parentId: 59,
            code: '440224000000',
            value: '551',
            
            id: 551
          },
          {
            label: '翁源县',
            
            
            parentId: 59,
            code: '440229000000',
            value: '552',
            
            id: 552
          },
          {
            label: '新丰县',
            
            
            parentId: 59,
            code: '440233000000',
            value: '553',
            
            id: 553
          },
          {
            label: '武江区',
            
            
            parentId: 59,
            code: '440203000000',
            value: '554',
            
            id: 554
          },
          {
            label: '浈江区',
            
            
            parentId: 59,
            code: '440204000000',
            value: '555',
            
            id: 555
          },
          {
            label: '曲江区',
            
            
            parentId: 59,
            code: '440205000000',
            value: '556',
            
            id: 556
          },
          {
            label: '乳源瑶族自治县',
            
            
            parentId: 59,
            code: '440232000000',
            value: '557',
            
            id: 557
          },
          {
            label: '乐昌市',
            
            
            parentId: 59,
            code: '440281000000',
            value: '558',
            
            id: 558
          },
          {
            label: '南雄市',
            
            
            parentId: 59,
            code: '440282000000',
            value: '559',
            
            id: 559
          }
        ],
        id: 59
      },
      {
        label: '深圳市',
        
        
        parentId: 6,
        code: '440300000000',
        value: '60',
        children: [
          {
            label: '罗湖区',
            
            
            parentId: 60,
            code: '440303000000',
            value: '560',
            
            id: 560
          },
          {
            label: '福田区',
            
            
            parentId: 60,
            code: '440304000000',
            value: '561',
            
            id: 561
          },
          {
            label: '南山区',
            
            
            parentId: 60,
            code: '440305000000',
            value: '562',
            
            id: 562
          },
          {
            label: '宝安区',
            
            
            parentId: 60,
            code: '440306000000',
            value: '563',
            
            id: 563
          },
          {
            label: '龙岗区',
            
            
            parentId: 60,
            code: '440307000000',
            value: '564',
            
            id: 564
          },
          {
            label: '盐田区',
            
            
            parentId: 60,
            code: '440308000000',
            value: '565',
            
            id: 565
          }
        ],
        id: 60
      },
      {
        label: '珠海市',
        
        
        parentId: 6,
        code: '440400000000',
        value: '61',
        children: [
          {
            label: '香洲区',
            
            
            parentId: 61,
            code: '440402000000',
            value: '566',
            
            id: 566
          },
          {
            label: '斗门区',
            
            
            parentId: 61,
            code: '440403000000',
            value: '567',
            
            id: 567
          },
          {
            label: '金湾区',
            
            
            parentId: 61,
            code: '440404000000',
            value: '568',
            
            id: 568
          }
        ],
        id: 61
      },
      {
        label: '汕头市',
        
        
        parentId: 6,
        code: '440500000000',
        value: '62',
        children: [
          {
            label: '濠江区',
            
            
            parentId: 62,
            code: '440512000000',
            value: '569',
            
            id: 569
          },
          {
            label: '潮南区',
            
            
            parentId: 62,
            code: '440514000000',
            value: '570',
            
            id: 570
          },
          {
            label: '潮阳区',
            
            
            parentId: 62,
            code: '440513000000',
            value: '571',
            
            id: 571
          },
          {
            label: '澄海区',
            
            
            parentId: 62,
            code: '440515000000',
            value: '572',
            
            id: 572
          },
          {
            label: '南澳县',
            
            
            parentId: 62,
            code: '440523000000',
            value: '573',
            
            id: 573
          },
          {
            label: '龙湖区',
            
            
            parentId: 62,
            code: '440507000000',
            value: '574',
            
            id: 574
          },
          {
            label: '金平区',
            
            
            parentId: 62,
            code: '440511000000',
            value: '575',
            
            id: 575
          }
        ],
        id: 62
      },
      {
        label: '佛山市',
        
        
        parentId: 6,
        code: '440600000000',
        value: '63',
        children: [
          {
            label: '禅城区',
            
            
            parentId: 63,
            code: '440604000000',
            value: '576',
            
            id: 576
          },
          {
            label: '南海区',
            
            
            parentId: 63,
            code: '440605000000',
            value: '577',
            
            id: 577
          },
          {
            label: '顺德区',
            
            
            parentId: 63,
            code: '440606000000',
            value: '578',
            
            id: 578
          },
          {
            label: '三水区',
            
            
            parentId: 63,
            code: '440607000000',
            value: '579',
            
            id: 579
          },
          {
            label: '高明区',
            
            
            parentId: 63,
            code: '440608000000',
            value: '580',
            
            id: 580
          }
        ],
        id: 63
      },
      {
        label: '江门市',
        
        
        parentId: 6,
        code: '440700000000',
        value: '64',
        children: [
          {
            label: '台山市',
            
            
            parentId: 64,
            code: '440781000000',
            value: '581',
            
            id: 581
          },
          {
            label: '开平市',
            
            
            parentId: 64,
            code: '440783000000',
            value: '582',
            
            id: 582
          },
          {
            label: '鹤山市',
            
            
            parentId: 64,
            code: '440784000000',
            value: '583',
            
            id: 583
          },
          {
            label: '恩平市',
            
            
            parentId: 64,
            code: '440785000000',
            value: '584',
            
            id: 584
          },
          {
            label: '蓬江区',
            
            
            parentId: 64,
            code: '440703000000',
            value: '585',
            
            id: 585
          },
          {
            label: '江海区',
            
            
            parentId: 64,
            code: '440704000000',
            value: '586',
            
            id: 586
          },
          {
            label: '新会区',
            
            
            parentId: 64,
            code: '440705000000',
            value: '587',
            
            id: 587
          }
        ],
        id: 64
      },
      {
        label: '湛江市',
        
        
        parentId: 6,
        code: '440800000000',
        value: '65',
        children: [
          {
            label: '赤坎区',
            
            
            parentId: 65,
            code: '440802000000',
            value: '588',
            
            id: 588
          },
          {
            label: '霞山区',
            
            
            parentId: 65,
            code: '440803000000',
            value: '589',
            
            id: 589
          },
          {
            label: '坡头区',
            
            
            parentId: 65,
            code: '440804000000',
            value: '590',
            
            id: 590
          },
          {
            label: '麻章区',
            
            
            parentId: 65,
            code: '440811000000',
            value: '591',
            
            id: 591
          },
          {
            label: '廉江市',
            
            
            parentId: 65,
            code: '440881000000',
            value: '592',
            
            id: 592
          },
          {
            label: '雷州市',
            
            
            parentId: 65,
            code: '440882000000',
            value: '593',
            
            id: 593
          },
          {
            label: '吴川市',
            
            
            parentId: 65,
            code: '440883000000',
            value: '594',
            
            id: 594
          },
          {
            label: '遂溪县',
            
            
            parentId: 65,
            code: '440823000000',
            value: '595',
            
            id: 595
          },
          {
            label: '徐闻县',
            
            
            parentId: 65,
            code: '440825000000',
            value: '596',
            
            id: 596
          }
        ],
        id: 65
      },
      {
        label: '茂名市',
        
        
        parentId: 6,
        code: '440900000000',
        value: '66',
        children: [
          {
            label: '电白区',
            
            
            parentId: 66,
            code: '440904000000',
            value: '597',
            
            id: 597
          },
          {
            label: '高州市',
            
            
            parentId: 66,
            code: '440981000000',
            value: '598',
            
            id: 598
          },
          {
            label: '化州市',
            
            
            parentId: 66,
            code: '440982000000',
            value: '599',
            
            id: 599
          },
          {
            label: '信宜市',
            
            
            parentId: 66,
            code: '440983000000',
            value: '600',
            
            id: 600
          },
          {
            label: '茂南区',
            
            
            parentId: 66,
            code: '440902000000',
            value: '601',
            
            id: 601
          }
        ],
        id: 66
      },
      {
        label: '肇庆市',
        
        
        parentId: 6,
        code: '441200000000',
        value: '67',
        children: [
          {
            label: '高要市',
            
            
            parentId: 67,
            code: '441283000000',
            value: '602',
            
            id: 602
          },
          {
            label: '四会市',
            
            
            parentId: 67,
            code: '441284000000',
            value: '603',
            
            id: 603
          },
          {
            label: '端州区',
            
            
            parentId: 67,
            code: '441202000000',
            value: '604',
            
            id: 604
          },
          {
            label: '鼎湖区',
            
            
            parentId: 67,
            code: '441203000000',
            value: '605',
            
            id: 605
          },
          {
            label: '广宁县',
            
            
            parentId: 67,
            code: '441223000000',
            value: '606',
            
            id: 606
          },
          {
            label: '怀集县',
            
            
            parentId: 67,
            code: '441224000000',
            value: '607',
            
            id: 607
          },
          {
            label: '封开县',
            
            
            parentId: 67,
            code: '441225000000',
            value: '608',
            
            id: 608
          },
          {
            label: '德庆县',
            
            
            parentId: 67,
            code: '441226000000',
            value: '609',
            
            id: 609
          }
        ],
        id: 67
      },
      {
        label: '惠州市',
        
        
        parentId: 6,
        code: '441300000000',
        value: '68',
        children: [
          {
            label: '博罗县',
            
            
            parentId: 68,
            code: '441322000000',
            value: '610',
            
            id: 610
          },
          {
            label: '惠东县',
            
            
            parentId: 68,
            code: '441323000000',
            value: '611',
            
            id: 611
          },
          {
            label: '龙门县',
            
            
            parentId: 68,
            code: '441324000000',
            value: '612',
            
            id: 612
          },
          {
            label: '惠城区',
            
            
            parentId: 68,
            code: '441302000000',
            value: '613',
            
            id: 613
          },
          {
            label: '惠阳区',
            
            
            parentId: 68,
            code: '441303000000',
            value: '614',
            
            id: 614
          }
        ],
        id: 68
      },
      {
        label: '梅州市',
        
        
        parentId: 6,
        code: '441400000000',
        value: '69',
        children: [
          {
            label: '兴宁市',
            
            
            parentId: 69,
            code: '441481000000',
            value: '615',
            
            id: 615
          },
          {
            label: '梅江区',
            
            
            parentId: 69,
            code: '441402000000',
            value: '616',
            
            id: 616
          },
          {
            label: '梅县区',
            
            
            parentId: 69,
            code: '441403000000',
            value: '617',
            
            id: 617
          },
          {
            label: '大埔县',
            
            
            parentId: 69,
            code: '441422000000',
            value: '618',
            
            id: 618
          },
          {
            label: '丰顺县',
            
            
            parentId: 69,
            code: '441423000000',
            value: '619',
            
            id: 619
          },
          {
            label: '五华县',
            
            
            parentId: 69,
            code: '441424000000',
            value: '620',
            
            id: 620
          },
          {
            label: '平远县',
            
            
            parentId: 69,
            code: '441426000000',
            value: '621',
            
            id: 621
          },
          {
            label: '蕉岭县',
            
            
            parentId: 69,
            code: '441427000000',
            value: '622',
            
            id: 622
          }
        ],
        id: 69
      },
      {
        label: '汕尾市',
        
        
        parentId: 6,
        code: '441500000000',
        value: '70',
        children: [
          {
            label: '海丰县',
            
            
            parentId: 70,
            code: '441521000000',
            value: '623',
            
            id: 623
          },
          {
            label: '陆河县',
            
            
            parentId: 70,
            code: '441523000000',
            value: '624',
            
            id: 624
          },
          {
            label: '城区',
            
            
            parentId: 70,
            code: '441502000000',
            value: '625',
            
            id: 625
          },
          {
            label: '陆丰市',
            
            
            parentId: 70,
            code: '441581000000',
            value: '626',
            
            id: 626
          }
        ],
        id: 70
      },
      {
        label: '河源市',
        
        
        parentId: 6,
        code: '441600000000',
        value: '71',
        children: [
          {
            label: '源城区',
            
            
            parentId: 71,
            code: '441602000000',
            value: '627',
            
            id: 627
          },
          {
            label: '紫金县',
            
            
            parentId: 71,
            code: '441621000000',
            value: '628',
            
            id: 628
          },
          {
            label: '龙川县',
            
            
            parentId: 71,
            code: '441622000000',
            value: '629',
            
            id: 629
          },
          {
            label: '连平县',
            
            
            parentId: 71,
            code: '441623000000',
            value: '630',
            
            id: 630
          },
          {
            label: '和平县',
            
            
            parentId: 71,
            code: '441624000000',
            value: '631',
            
            id: 631
          },
          {
            label: '东源县',
            
            
            parentId: 71,
            code: '441625000000',
            value: '632',
            
            id: 632
          }
        ],
        id: 71
      },
      {
        label: '阳江市',
        
        
        parentId: 6,
        code: '441700000000',
        value: '72',
        children: [
          {
            label: '江城区',
            
            
            parentId: 72,
            code: '441702000000',
            value: '633',
            
            id: 633
          },
          {
            label: '阳春市',
            
            
            parentId: 72,
            code: '441781000000',
            value: '634',
            
            id: 634
          },
          {
            label: '阳西县',
            
            
            parentId: 72,
            code: '441721000000',
            value: '635',
            
            id: 635
          },
          {
            label: '阳东县',
            
            
            parentId: 72,
            code: '441723000000',
            value: '636',
            
            id: 636
          }
        ],
        id: 72
      },
      {
        label: '清远市',
        
        
        parentId: 6,
        code: '441800000000',
        value: '73',
        children: [
          {
            label: '清新区',
            
            
            parentId: 73,
            code: '441803000000',
            value: '637',
            
            id: 637
          },
          {
            label: '佛冈县',
            
            
            parentId: 73,
            code: '441821000000',
            value: '638',
            
            id: 638
          },
          {
            label: '阳山县',
            
            
            parentId: 73,
            code: '441823000000',
            value: '639',
            
            id: 639
          },
          {
            label: '英德市',
            
            
            parentId: 73,
            code: '441881000000',
            value: '640',
            
            id: 640
          },
          {
            label: '连州市',
            
            
            parentId: 73,
            code: '441882000000',
            value: '641',
            
            id: 641
          },
          {
            label: '连山壮族瑶族自治县',
            
            
            parentId: 73,
            code: '441825000000',
            value: '642',
            
            id: 642
          },
          {
            label: '连南瑶族自治县',
            
            
            parentId: 73,
            code: '441826000000',
            value: '643',
            
            id: 643
          },
          {
            label: '清城区',
            
            
            parentId: 73,
            code: '441802000000',
            value: '644',
            
            id: 644
          }
        ],
        id: 73
      },
      {
        label: '东莞市',
        
        
        parentId: 6,
        code: '441900000000',
        value: '74',
        children: [],
        id: 74
      },
      {
        label: '中山市',
        
        
        parentId: 6,
        code: '442000000000',
        value: '75',
        children: [],
        id: 75
      },
      {
        label: '潮州市',
        
        
        parentId: 6,
        code: '445100000000',
        value: '76',
        children: [
          {
            label: '潮安区',
            
            
            parentId: 76,
            code: '445103000000',
            value: '645',
            
            id: 645
          },
          {
            label: '饶平县',
            
            
            parentId: 76,
            code: '445122000000',
            value: '646',
            
            id: 646
          },
          {
            label: '湘桥区',
            
            
            parentId: 76,
            code: '445102000000',
            value: '647',
            
            id: 647
          }
        ],
        id: 76
      },
      {
        label: '揭阳市',
        
        
        parentId: 6,
        code: '445200000000',
        value: '77',
        children: [
          {
            label: '榕城区',
            
            
            parentId: 77,
            code: '445202000000',
            value: '648',
            
            id: 648
          },
          {
            label: '揭东区',
            
            
            parentId: 77,
            code: '445203000000',
            value: '649',
            
            id: 649
          },
          {
            label: '揭西县',
            
            
            parentId: 77,
            code: '445222000000',
            value: '650',
            
            id: 650
          },
          {
            label: '惠来县',
            
            
            parentId: 77,
            code: '445224000000',
            value: '651',
            
            id: 651
          },
          {
            label: '普宁市',
            
            
            parentId: 77,
            code: '445281000000',
            value: '652',
            
            id: 652
          }
        ],
        id: 77
      },
      {
        label: '云浮市',
        
        
        parentId: 6,
        code: '445300000000',
        value: '78',
        children: [
          {
            label: '罗定市',
            
            
            parentId: 78,
            code: '445381000000',
            value: '653',
            
            id: 653
          },
          {
            label: '新兴县',
            
            
            parentId: 78,
            code: '445321000000',
            value: '654',
            
            id: 654
          },
          {
            label: '郁南县',
            
            
            parentId: 78,
            code: '445322000000',
            value: '655',
            
            id: 655
          },
          {
            label: '云安区',
            
            
            parentId: 78,
            code: '445303000000',
            value: '656',
            
            id: 656
          },
          {
            label: '云城区',
            
            
            parentId: 78,
            code: '445302000000',
            value: '657',
            
            id: 657
          }
        ],
        id: 78
      }
    ],
    id: 6
  },
  {
    label: '广西壮族自治区',
    
    
    parentId: 1,
    code: '450000000000',
    value: '7',
    children: [
      {
        label: '南宁市',
        
        
        parentId: 7,
        code: '450100000000',
        value: '79',
        children: [
          {
            label: '兴宁区',
            
            
            parentId: 79,
            code: '450102000000',
            value: '658',
            
            id: 658
          },
          {
            label: '青秀区',
            
            
            parentId: 79,
            code: '450103000000',
            value: '659',
            
            id: 659
          },
          {
            label: '西乡塘区',
            
            
            parentId: 79,
            code: '450107000000',
            value: '660',
            
            id: 660
          },
          {
            label: '江南区',
            
            
            parentId: 79,
            code: '450105000000',
            value: '661',
            
            id: 661
          },
          {
            label: '良庆区',
            
            
            parentId: 79,
            code: '450108000000',
            value: '662',
            
            id: 662
          },
          {
            label: '邕宁区',
            
            
            parentId: 79,
            code: '450109000000',
            value: '663',
            
            id: 663
          },
          {
            label: '上林县',
            
            
            parentId: 79,
            code: '450125000000',
            value: '664',
            
            id: 664
          },
          {
            label: '宾阳县',
            
            
            parentId: 79,
            code: '450126000000',
            value: '665',
            
            id: 665
          },
          {
            label: '横县',
            
            
            parentId: 79,
            code: '450127000000',
            value: '666',
            
            id: 666
          },
          {
            label: '武鸣县',
            
            
            parentId: 79,
            code: '450122000000',
            value: '667',
            
            id: 667
          },
          {
            label: '隆安县',
            
            
            parentId: 79,
            code: '450123000000',
            value: '668',
            
            id: 668
          },
          {
            label: '马山县',
            
            
            parentId: 79,
            code: '450124000000',
            value: '669',
            
            id: 669
          }
        ],
        id: 79
      },
      {
        label: '柳州市',
        
        
        parentId: 7,
        code: '450200000000',
        value: '80',
        children: [
          {
            label: '融水苗族自治县',
            
            
            parentId: 80,
            code: '450225000000',
            value: '670',
            
            id: 670
          },
          {
            label: '三江侗族自治县',
            
            
            parentId: 80,
            code: '450226000000',
            value: '671',
            
            id: 671
          },
          {
            label: '城中区',
            
            
            parentId: 80,
            code: '450202000000',
            value: '672',
            
            id: 672
          },
          {
            label: '鱼峰区',
            
            
            parentId: 80,
            code: '450203000000',
            value: '673',
            
            id: 673
          },
          {
            label: '柳南区',
            
            
            parentId: 80,
            code: '450204000000',
            value: '674',
            
            id: 674
          },
          {
            label: '柳北区',
            
            
            parentId: 80,
            code: '450205000000',
            value: '675',
            
            id: 675
          },
          {
            label: '柳江县',
            
            
            parentId: 80,
            code: '450221000000',
            value: '676',
            
            id: 676
          },
          {
            label: '柳城县',
            
            
            parentId: 80,
            code: '450222000000',
            value: '677',
            
            id: 677
          },
          {
            label: '鹿寨县',
            
            
            parentId: 80,
            code: '450223000000',
            value: '678',
            
            id: 678
          },
          {
            label: '融安县',
            
            
            parentId: 80,
            code: '450224000000',
            value: '679',
            
            id: 679
          }
        ],
        id: 80
      },
      {
        label: '桂林市',
        
        
        parentId: 7,
        code: '450300000000',
        value: '81',
        children: [
          {
            label: '资源县',
            
            
            parentId: 81,
            code: '450329000000',
            value: '680',
            
            id: 680
          },
          {
            label: '平乐县',
            
            
            parentId: 81,
            code: '450330000000',
            value: '681',
            
            id: 681
          },
          {
            label: '荔浦县',
            
            
            parentId: 81,
            code: '450331000000',
            value: '682',
            
            id: 682
          },
          {
            label: '阳朔县',
            
            
            parentId: 81,
            code: '450321000000',
            value: '683',
            
            id: 683
          },
          {
            label: '临桂区',
            
            
            parentId: 81,
            code: '450312000000',
            value: '684',
            
            id: 684
          },
          {
            label: '灵川县',
            
            
            parentId: 81,
            code: '450323000000',
            value: '685',
            
            id: 685
          },
          {
            label: '全州县',
            
            
            parentId: 81,
            code: '450324000000',
            value: '686',
            
            id: 686
          },
          {
            label: '兴安县',
            
            
            parentId: 81,
            code: '450325000000',
            value: '687',
            
            id: 687
          },
          {
            label: '永福县',
            
            
            parentId: 81,
            code: '450326000000',
            value: '688',
            
            id: 688
          },
          {
            label: '灌阳县',
            
            
            parentId: 81,
            code: '450327000000',
            value: '689',
            
            id: 689
          },
          {
            label: '秀峰区',
            
            
            parentId: 81,
            code: '450302000000',
            value: '690',
            
            id: 690
          },
          {
            label: '叠彩区',
            
            
            parentId: 81,
            code: '450303000000',
            value: '691',
            
            id: 691
          },
          {
            label: '象山区',
            
            
            parentId: 81,
            code: '450304000000',
            value: '692',
            
            id: 692
          },
          {
            label: '七星区',
            
            
            parentId: 81,
            code: '450305000000',
            value: '693',
            
            id: 693
          },
          {
            label: '雁山区',
            
            
            parentId: 81,
            code: '450311000000',
            value: '694',
            
            id: 694
          },
          {
            label: '龙胜各族自治县',
            
            
            parentId: 81,
            code: '450328000000',
            value: '695',
            
            id: 695
          },
          {
            label: '恭城瑶族自治县',
            
            
            parentId: 81,
            code: '450332000000',
            value: '696',
            
            id: 696
          }
        ],
        id: 81
      },
      {
        label: '梧州市',
        
        
        parentId: 7,
        code: '450400000000',
        value: '82',
        children: [
          {
            label: '万秀区',
            
            
            parentId: 82,
            code: '450403000000',
            value: '697',
            
            id: 697
          },
          {
            label: '苍梧县',
            
            
            parentId: 82,
            code: '450421000000',
            value: '698',
            
            id: 698
          },
          {
            label: '岑溪市',
            
            
            parentId: 82,
            code: '450481000000',
            value: '699',
            
            id: 699
          },
          {
            label: '藤县',
            
            
            parentId: 82,
            code: '450422000000',
            value: '700',
            
            id: 700
          },
          {
            label: '蒙山县',
            
            
            parentId: 82,
            code: '450423000000',
            value: '701',
            
            id: 701
          },
          {
            label: '龙圩区',
            
            
            parentId: 82,
            code: '450406000000',
            value: '702',
            
            id: 702
          },
          {
            label: '长洲区',
            
            
            parentId: 82,
            code: '450405000000',
            value: '703',
            
            id: 703
          }
        ],
        id: 82
      },
      {
        label: '北海市',
        
        
        parentId: 7,
        code: '450500000000',
        value: '83',
        children: [
          {
            label: '海城区',
            
            
            parentId: 83,
            code: '450502000000',
            value: '704',
            
            id: 704
          },
          {
            label: '银海区',
            
            
            parentId: 83,
            code: '450503000000',
            value: '705',
            
            id: 705
          },
          {
            label: '铁山港区',
            
            
            parentId: 83,
            code: '450512000000',
            value: '706',
            
            id: 706
          },
          {
            label: '合浦县',
            
            
            parentId: 83,
            code: '450521000000',
            value: '707',
            
            id: 707
          }
        ],
        id: 83
      },
      {
        label: '防城港市',
        
        
        parentId: 7,
        code: '450600000000',
        value: '84',
        children: [
          {
            label: '上思县',
            
            
            parentId: 84,
            code: '450621000000',
            value: '708',
            
            id: 708
          },
          {
            label: '东兴市',
            
            
            parentId: 84,
            code: '450681000000',
            value: '709',
            
            id: 709
          },
          {
            label: '港口区',
            
            
            parentId: 84,
            code: '450602000000',
            value: '710',
            
            id: 710
          },
          {
            label: '防城区',
            
            
            parentId: 84,
            code: '450603000000',
            value: '711',
            
            id: 711
          }
        ],
        id: 84
      },
      {
        label: '钦州市',
        
        
        parentId: 7,
        code: '450700000000',
        value: '85',
        children: [
          {
            label: '钦南区',
            
            
            parentId: 85,
            code: '450702000000',
            value: '712',
            
            id: 712
          },
          {
            label: '钦北区',
            
            
            parentId: 85,
            code: '450703000000',
            value: '713',
            
            id: 713
          },
          {
            label: '灵山县',
            
            
            parentId: 85,
            code: '450721000000',
            value: '714',
            
            id: 714
          },
          {
            label: '浦北县',
            
            
            parentId: 85,
            code: '450722000000',
            value: '715',
            
            id: 715
          }
        ],
        id: 85
      },
      {
        label: '贵港市',
        
        
        parentId: 7,
        code: '450800000000',
        value: '86',
        children: [
          {
            label: '平南县',
            
            
            parentId: 86,
            code: '450821000000',
            value: '716',
            
            id: 716
          },
          {
            label: '桂平市',
            
            
            parentId: 86,
            code: '450881000000',
            value: '717',
            
            id: 717
          },
          {
            label: '覃塘区',
            
            
            parentId: 86,
            code: '450804000000',
            value: '718',
            
            id: 718
          },
          {
            label: '港北区',
            
            
            parentId: 86,
            code: '450802000000',
            value: '719',
            
            id: 719
          },
          {
            label: '港南区',
            
            
            parentId: 86,
            code: '450803000000',
            value: '720',
            
            id: 720
          }
        ],
        id: 86
      },
      {
        label: '玉林市',
        
        
        parentId: 7,
        code: '450900000000',
        value: '87',
        children: [
          {
            label: '玉州区',
            
            
            parentId: 87,
            code: '450902000000',
            value: '721',
            
            id: 721
          },
          {
            label: '北流市',
            
            
            parentId: 87,
            code: '450981000000',
            value: '722',
            
            id: 722
          },
          {
            label: '福绵区',
            
            
            parentId: 87,
            code: '450903000000',
            value: '723',
            
            id: 723
          },
          {
            label: '容县',
            
            
            parentId: 87,
            code: '450921000000',
            value: '724',
            
            id: 724
          },
          {
            label: '陆川县',
            
            
            parentId: 87,
            code: '450922000000',
            value: '725',
            
            id: 725
          },
          {
            label: '博白县',
            
            
            parentId: 87,
            code: '450923000000',
            value: '726',
            
            id: 726
          },
          {
            label: '兴业县',
            
            
            parentId: 87,
            code: '450924000000',
            value: '727',
            
            id: 727
          }
        ],
        id: 87
      },
      {
        label: '百色市',
        
        
        parentId: 7,
        code: '451000000000',
        value: '88',
        children: [
          {
            label: '田阳县',
            
            
            parentId: 88,
            code: '451021000000',
            value: '728',
            
            id: 728
          },
          {
            label: '田东县',
            
            
            parentId: 88,
            code: '451022000000',
            value: '729',
            
            id: 729
          },
          {
            label: '平果县',
            
            
            parentId: 88,
            code: '451023000000',
            value: '730',
            
            id: 730
          },
          {
            label: '德保县',
            
            
            parentId: 88,
            code: '451024000000',
            value: '731',
            
            id: 731
          },
          {
            label: '靖西县',
            
            
            parentId: 88,
            code: '451025000000',
            value: '732',
            
            id: 732
          },
          {
            label: '那坡县',
            
            
            parentId: 88,
            code: '451026000000',
            value: '733',
            
            id: 733
          },
          {
            label: '凌云县',
            
            
            parentId: 88,
            code: '451027000000',
            value: '734',
            
            id: 734
          },
          {
            label: '乐业县',
            
            
            parentId: 88,
            code: '451028000000',
            value: '735',
            
            id: 735
          },
          {
            label: '田林县',
            
            
            parentId: 88,
            code: '451029000000',
            value: '736',
            
            id: 736
          },
          {
            label: '西林县',
            
            
            parentId: 88,
            code: '451030000000',
            value: '737',
            
            id: 737
          },
          {
            label: '隆林各族自治县',
            
            
            parentId: 88,
            code: '451031000000',
            value: '738',
            
            id: 738
          },
          {
            label: '右江区',
            
            
            parentId: 88,
            code: '451002000000',
            value: '739',
            
            id: 739
          }
        ],
        id: 88
      },
      {
        label: '贺州市',
        
        
        parentId: 7,
        code: '451100000000',
        value: '89',
        children: [
          {
            label: '富川瑶族自治县',
            
            
            parentId: 89,
            code: '451123000000',
            value: '740',
            
            id: 740
          },
          {
            label: '八步区',
            
            
            parentId: 89,
            code: '451102000000',
            value: '741',
            
            id: 741
          },
          {
            label: '昭平县',
            
            
            parentId: 89,
            code: '451121000000',
            value: '742',
            
            id: 742
          },
          {
            label: '钟山县',
            
            
            parentId: 89,
            code: '451122000000',
            value: '743',
            
            id: 743
          }
        ],
        id: 89
      },
      {
        label: '河池市',
        
        
        parentId: 7,
        code: '451200000000',
        value: '90',
        children: [
          {
            label: '南丹县',
            
            
            parentId: 90,
            code: '451221000000',
            value: '744',
            
            id: 744
          },
          {
            label: '天峨县',
            
            
            parentId: 90,
            code: '451222000000',
            value: '745',
            
            id: 745
          },
          {
            label: '凤山县',
            
            
            parentId: 90,
            code: '451223000000',
            value: '746',
            
            id: 746
          },
          {
            label: '东兰县',
            
            
            parentId: 90,
            code: '451224000000',
            value: '747',
            
            id: 747
          },
          {
            label: '宜州市',
            
            
            parentId: 90,
            code: '451281000000',
            value: '748',
            
            id: 748
          },
          {
            label: '罗城仫佬族自治县',
            
            
            parentId: 90,
            code: '451225000000',
            value: '749',
            
            id: 749
          },
          {
            label: '环江毛南族自治县',
            
            
            parentId: 90,
            code: '451226000000',
            value: '750',
            
            id: 750
          },
          {
            label: '巴马瑶族自治县',
            
            
            parentId: 90,
            code: '451227000000',
            value: '751',
            
            id: 751
          },
          {
            label: '都安瑶族自治县',
            
            
            parentId: 90,
            code: '451228000000',
            value: '752',
            
            id: 752
          },
          {
            label: '大化瑶族自治县',
            
            
            parentId: 90,
            code: '451229000000',
            value: '753',
            
            id: 753
          },
          {
            label: '金城江区',
            
            
            parentId: 90,
            code: '451202000000',
            value: '754',
            
            id: 754
          }
        ],
        id: 90
      },
      {
        label: '来宾市',
        
        
        parentId: 7,
        code: '451300000000',
        value: '91',
        children: [
          {
            label: '兴宾区',
            
            
            parentId: 91,
            code: '451302000000',
            value: '755',
            
            id: 755
          },
          {
            label: '金秀瑶族自治县',
            
            
            parentId: 91,
            code: '451324000000',
            value: '756',
            
            id: 756
          },
          {
            label: '合山市',
            
            
            parentId: 91,
            code: '451381000000',
            value: '757',
            
            id: 757
          },
          {
            label: '忻城县',
            
            
            parentId: 91,
            code: '451321000000',
            value: '758',
            
            id: 758
          },
          {
            label: '象州县',
            
            
            parentId: 91,
            code: '451322000000',
            value: '759',
            
            id: 759
          },
          {
            label: '武宣县',
            
            
            parentId: 91,
            code: '451323000000',
            value: '760',
            
            id: 760
          }
        ],
        id: 91
      },
      {
        label: '崇左市',
        
        
        parentId: 7,
        code: '451400000000',
        value: '92',
        children: [
          {
            label: '扶绥县',
            
            
            parentId: 92,
            code: '451421000000',
            value: '761',
            
            id: 761
          },
          {
            label: '宁明县',
            
            
            parentId: 92,
            code: '451422000000',
            value: '762',
            
            id: 762
          },
          {
            label: '龙州县',
            
            
            parentId: 92,
            code: '451423000000',
            value: '763',
            
            id: 763
          },
          {
            label: '大新县',
            
            
            parentId: 92,
            code: '451424000000',
            value: '764',
            
            id: 764
          },
          {
            label: '天等县',
            
            
            parentId: 92,
            code: '451425000000',
            value: '765',
            
            id: 765
          },
          {
            label: '凭祥市',
            
            
            parentId: 92,
            code: '451481000000',
            value: '766',
            
            id: 766
          },
          {
            label: '江州区',
            
            
            parentId: 92,
            code: '451402000000',
            value: '767',
            
            id: 767
          }
        ],
        id: 92
      }
    ],
    id: 7
  },
  {
    label: '贵州省',
    
    
    parentId: 1,
    code: '520000000000',
    value: '8',
    children: [
      {
        label: '黔西南布依族苗族自治州',
        
        
        parentId: 8,
        code: '522300000000',
        value: '93',
        children: [
          {
            label: '兴义市',
            
            
            parentId: 93,
            code: '522301000000',
            value: '1066',
            
            id: 1066
          },
          {
            label: '兴仁县',
            
            
            parentId: 93,
            code: '522322000000',
            value: '1067',
            
            id: 1067
          },
          {
            label: '普安县',
            
            
            parentId: 93,
            code: '522323000000',
            value: '1068',
            
            id: 1068
          },
          {
            label: '晴隆县',
            
            
            parentId: 93,
            code: '522324000000',
            value: '1069',
            
            id: 1069
          },
          {
            label: '贞丰县',
            
            
            parentId: 93,
            code: '522325000000',
            value: '1070',
            
            id: 1070
          },
          {
            label: '望谟县',
            
            
            parentId: 93,
            code: '522326000000',
            value: '1071',
            
            id: 1071
          },
          {
            label: '册亨县',
            
            
            parentId: 93,
            code: '522327000000',
            value: '1072',
            
            id: 1072
          },
          {
            label: '安龙县',
            
            
            parentId: 93,
            code: '522328000000',
            value: '1073',
            
            id: 1073
          }
        ],
        id: 93
      },
      {
        label: '毕节市',
        
        
        parentId: 8,
        code: '520500000000',
        value: '94',
        children: [
          {
            label: '威宁彝族回族苗族自治县',
            
            
            parentId: 94,
            code: '520526000000',
            value: '958',
            
            id: 958
          },
          {
            label: '七星关区',
            
            
            parentId: 94,
            code: '520502000000',
            value: '959',
            
            id: 959
          },
          {
            label: '赫章县',
            
            
            parentId: 94,
            code: '520527000000',
            value: '960',
            
            id: 960
          },
          {
            label: '大方县',
            
            
            parentId: 94,
            code: '520521000000',
            value: '961',
            
            id: 961
          },
          {
            label: '黔西县',
            
            
            parentId: 94,
            code: '520522000000',
            value: '962',
            
            id: 962
          },
          {
            label: '金沙县',
            
            
            parentId: 94,
            code: '520523000000',
            value: '963',
            
            id: 963
          },
          {
            label: '织金县',
            
            
            parentId: 94,
            code: '520524000000',
            value: '964',
            
            id: 964
          },
          {
            label: '纳雍县',
            
            
            parentId: 94,
            code: '520525000000',
            value: '965',
            
            id: 965
          }
        ],
        id: 94
      },
      {
        label: '贵阳市',
        
        
        parentId: 8,
        code: '520100000000',
        value: '95',
        children: [
          {
            label: '清镇市',
            
            
            parentId: 95,
            code: '520181000000',
            value: '2745',
            
            id: 2745
          },
          {
            label: '南明区',
            
            
            parentId: 95,
            code: '520102000000',
            value: '2746',
            
            id: 2746
          },
          {
            label: '云岩区',
            
            
            parentId: 95,
            code: '520103000000',
            value: '2747',
            
            id: 2747
          },
          {
            label: '花溪区',
            
            
            parentId: 95,
            code: '520111000000',
            value: '2748',
            
            id: 2748
          },
          {
            label: '乌当区',
            
            
            parentId: 95,
            code: '520112000000',
            value: '2749',
            
            id: 2749
          },
          {
            label: '白云区',
            
            
            parentId: 95,
            code: '520113000000',
            value: '2750',
            
            id: 2750
          },
          {
            label: '观山湖区',
            
            
            parentId: 95,
            code: '520115000000',
            value: '2751',
            
            id: 2751
          },
          {
            label: '开阳县',
            
            
            parentId: 95,
            code: '520121000000',
            value: '2752',
            
            id: 2752
          },
          {
            label: '息烽县',
            
            
            parentId: 95,
            code: '520122000000',
            value: '2753',
            
            id: 2753
          },
          {
            label: '修文县',
            
            
            parentId: 95,
            code: '520123000000',
            value: '2754',
            
            id: 2754
          }
        ],
        id: 95
      },
      {
        label: '六盘水市',
        
        
        parentId: 8,
        code: '520200000000',
        value: '96',
        children: [
          {
            label: '钟山区',
            
            
            parentId: 96,
            code: '520201000000',
            value: '2755',
            
            id: 2755
          },
          {
            label: '六枝特区',
            
            
            parentId: 96,
            code: '520203000000',
            value: '2756',
            
            id: 2756
          },
          {
            label: '水城县',
            
            
            parentId: 96,
            code: '520221000000',
            value: '2757',
            
            id: 2757
          },
          {
            label: '盘县',
            
            
            parentId: 96,
            code: '520222000000',
            value: '2758',
            
            id: 2758
          }
        ],
        id: 96
      },
      {
        label: '遵义市',
        
        
        parentId: 8,
        code: '520300000000',
        value: '97',
        children: [
          {
            label: '遵义县',
            
            
            parentId: 97,
            code: '520321000000',
            value: '2759',
            
            id: 2759
          },
          {
            label: '桐梓县',
            
            
            parentId: 97,
            code: '520322000000',
            value: '2760',
            
            id: 2760
          },
          {
            label: '绥阳县',
            
            
            parentId: 97,
            code: '520323000000',
            value: '2761',
            
            id: 2761
          },
          {
            label: '正安县',
            
            
            parentId: 97,
            code: '520324000000',
            value: '2762',
            
            id: 2762
          },
          {
            label: '道真仡佬族苗族自治县',
            
            
            parentId: 97,
            code: '520325000000',
            value: '2763',
            
            id: 2763
          },
          {
            label: '务川仡佬族苗族自治县',
            
            
            parentId: 97,
            code: '520326000000',
            value: '2764',
            
            id: 2764
          },
          {
            label: '红花岗区',
            
            
            parentId: 97,
            code: '520302000000',
            value: '2765',
            
            id: 2765
          },
          {
            label: '汇川区',
            
            
            parentId: 97,
            code: '520303000000',
            value: '2766',
            
            id: 2766
          },
          {
            label: '赤水市',
            
            
            parentId: 97,
            code: '520381000000',
            value: '2767',
            
            id: 2767
          },
          {
            label: '仁怀市',
            
            
            parentId: 97,
            code: '520382000000',
            value: '2768',
            
            id: 2768
          },
          {
            label: '凤冈县',
            
            
            parentId: 97,
            code: '520327000000',
            value: '2769',
            
            id: 2769
          },
          {
            label: '湄潭县',
            
            
            parentId: 97,
            code: '520328000000',
            value: '2770',
            
            id: 2770
          },
          {
            label: '余庆县',
            
            
            parentId: 97,
            code: '520329000000',
            value: '2771',
            
            id: 2771
          },
          {
            label: '习水县',
            
            
            parentId: 97,
            code: '520330000000',
            value: '2772',
            
            id: 2772
          }
        ],
        id: 97
      },
      {
        label: '安顺市',
        
        
        parentId: 8,
        code: '520400000000',
        value: '98',
        children: [
          {
            label: '平坝县',
            
            
            parentId: 98,
            code: '520421000000',
            value: '2773',
            
            id: 2773
          },
          {
            label: '普定县',
            
            
            parentId: 98,
            code: '520422000000',
            value: '2774',
            
            id: 2774
          },
          {
            label: '镇宁布依族苗族自治县',
            
            
            parentId: 98,
            code: '520423000000',
            value: '2775',
            
            id: 2775
          },
          {
            label: '关岭布依族苗族自治县',
            
            
            parentId: 98,
            code: '520424000000',
            value: '2776',
            
            id: 2776
          },
          {
            label: '紫云苗族布依族自治县',
            
            
            parentId: 98,
            code: '520425000000',
            value: '2777',
            
            id: 2777
          },
          {
            label: '西秀区',
            
            
            parentId: 98,
            code: '520402000000',
            value: '2778',
            
            id: 2778
          }
        ],
        id: 98
      },
      {
        label: '铜仁市',
        
        
        parentId: 8,
        code: '520600000000',
        value: '99',
        children: [
          {
            label: '江口县',
            
            
            parentId: 99,
            code: '520621000000',
            value: '1053',
            
            id: 1053
          },
          {
            label: '石阡县',
            
            
            parentId: 99,
            code: '520623000000',
            value: '1054',
            
            id: 1054
          },
          {
            label: '思南县',
            
            
            parentId: 99,
            code: '520624000000',
            value: '1055',
            
            id: 1055
          },
          {
            label: '德江县',
            
            
            parentId: 99,
            code: '520626000000',
            value: '1056',
            
            id: 1056
          },
          {
            label: '碧江区',
            
            
            parentId: 99,
            code: '520602000000',
            value: '1057',
            
            id: 1057
          },
          {
            label: '沿河土家族自治县',
            
            
            parentId: 99,
            code: '520627000000',
            value: '1058',
            
            id: 1058
          },
          {
            label: '松桃苗族自治县',
            
            
            parentId: 99,
            code: '520628000000',
            value: '1059',
            
            id: 1059
          },
          {
            label: '印江土家族苗族自治县',
            
            
            parentId: 99,
            code: '520625000000',
            value: '1060',
            
            id: 1060
          },
          {
            label: '玉屏侗族自治县',
            
            
            parentId: 99,
            code: '520622000000',
            value: '1061',
            
            id: 1061
          },
          {
            label: '万山区',
            
            
            parentId: 99,
            code: '520603000000',
            value: '1062',
            
            id: 1062
          }
        ],
        id: 99
      },
      {
        label: '黔东南苗族侗族自治州',
        
        
        parentId: 8,
        code: '522600000000',
        value: '100',
        children: [
          {
            label: '黄平县',
            
            
            parentId: 100,
            code: '522622000000',
            value: '1186',
            
            id: 1186
          },
          {
            label: '施秉县',
            
            
            parentId: 100,
            code: '522623000000',
            value: '1187',
            
            id: 1187
          },
          {
            label: '三穗县',
            
            
            parentId: 100,
            code: '522624000000',
            value: '1188',
            
            id: 1188
          },
          {
            label: '镇远县',
            
            
            parentId: 100,
            code: '522625000000',
            value: '1189',
            
            id: 1189
          },
          {
            label: '岑巩县',
            
            
            parentId: 100,
            code: '522626000000',
            value: '1190',
            
            id: 1190
          },
          {
            label: '天柱县',
            
            
            parentId: 100,
            code: '522627000000',
            value: '1191',
            
            id: 1191
          },
          {
            label: '锦屏县',
            
            
            parentId: 100,
            code: '522628000000',
            value: '1192',
            
            id: 1192
          },
          {
            label: '剑河县',
            
            
            parentId: 100,
            code: '522629000000',
            value: '1193',
            
            id: 1193
          },
          {
            label: '台江县',
            
            
            parentId: 100,
            code: '522630000000',
            value: '1194',
            
            id: 1194
          },
          {
            label: '黎平县',
            
            
            parentId: 100,
            code: '522631000000',
            value: '1195',
            
            id: 1195
          },
          {
            label: '榕江县',
            
            
            parentId: 100,
            code: '522632000000',
            value: '1196',
            
            id: 1196
          },
          {
            label: '从江县',
            
            
            parentId: 100,
            code: '522633000000',
            value: '1197',
            
            id: 1197
          },
          {
            label: '雷山县',
            
            
            parentId: 100,
            code: '522634000000',
            value: '1198',
            
            id: 1198
          },
          {
            label: '麻江县',
            
            
            parentId: 100,
            code: '522635000000',
            value: '1199',
            
            id: 1199
          },
          {
            label: '丹寨县',
            
            
            parentId: 100,
            code: '522636000000',
            value: '1200',
            
            id: 1200
          },
          {
            label: '凯里市',
            
            
            parentId: 100,
            code: '522601000000',
            value: '1201',
            
            id: 1201
          }
        ],
        id: 100
      },
      {
        label: '黔南布依族苗族自治州',
        
        
        parentId: 8,
        code: '522700000000',
        value: '101',
        children: [
          {
            label: '都匀市',
            
            
            parentId: 101,
            code: '522701000000',
            value: '1202',
            
            id: 1202
          },
          {
            label: '福泉市',
            
            
            parentId: 101,
            code: '522702000000',
            value: '1203',
            
            id: 1203
          },
          {
            label: '三都水族自治县',
            
            
            parentId: 101,
            code: '522732000000',
            value: '1204',
            
            id: 1204
          },
          {
            label: '长顺县',
            
            
            parentId: 101,
            code: '522729000000',
            value: '1205',
            
            id: 1205
          },
          {
            label: '龙里县',
            
            
            parentId: 101,
            code: '522730000000',
            value: '1206',
            
            id: 1206
          },
          {
            label: '惠水县',
            
            
            parentId: 101,
            code: '522731000000',
            value: '1207',
            
            id: 1207
          },
          {
            label: '荔波县',
            
            
            parentId: 101,
            code: '522722000000',
            value: '1208',
            
            id: 1208
          },
          {
            label: '贵定县',
            
            
            parentId: 101,
            code: '522723000000',
            value: '1209',
            
            id: 1209
          },
          {
            label: '瓮安县',
            
            
            parentId: 101,
            code: '522725000000',
            value: '1210',
            
            id: 1210
          },
          {
            label: '独山县',
            
            
            parentId: 101,
            code: '522726000000',
            value: '1211',
            
            id: 1211
          },
          {
            label: '平塘县',
            
            
            parentId: 101,
            code: '522727000000',
            value: '1212',
            
            id: 1212
          },
          {
            label: '罗甸县',
            
            
            parentId: 101,
            code: '522728000000',
            value: '1213',
            
            id: 1213
          }
        ],
        id: 101
      }
    ],
    id: 8
  },
  {
    label: '海南省',
    
    
    parentId: 1,
    code: '460000000000',
    value: '9',
    children: [
      {
        label: '省直辖县级行政区划',
        
        
        parentId: 9,
        code: '469000000000',
        value: '102',
        children: [
          {
            label: '白沙黎族自治县',
            
            
            parentId: 102,
            code: '469025000000',
            value: '3221',
            
            id: 3221
          },
          {
            label: '保亭黎族苗族自治县',
            
            
            parentId: 102,
            code: '469029000000',
            value: '3222',
            
            id: 3222
          },
          {
            label: '昌江黎族自治县',
            
            
            parentId: 102,
            code: '469026000000',
            value: '3223',
            
            id: 3223
          },
          {
            label: '澄迈县',
            
            
            parentId: 102,
            code: '469023000000',
            value: '3224',
            
            id: 3224
          },
          {
            label: '儋州市',
            
            
            parentId: 102,
            code: '469003000000',
            value: '3225',
            
            id: 3225
          },
          {
            label: '定安县',
            
            
            parentId: 102,
            code: '469021000000',
            value: '3226',
            
            id: 3226
          },
          {
            label: '东方市',
            
            
            parentId: 102,
            code: '469007000000',
            value: '3227',
            
            id: 3227
          },
          {
            label: '乐东黎族自治县',
            
            
            parentId: 102,
            code: '469027000000',
            value: '3228',
            
            id: 3228
          },
          {
            label: '临高县',
            
            
            parentId: 102,
            code: '469024000000',
            value: '3229',
            
            id: 3229
          },
          {
            label: '陵水黎族自治县',
            
            
            parentId: 102,
            code: '469028000000',
            value: '3230',
            
            id: 3230
          },
          {
            label: '琼海市',
            
            
            parentId: 102,
            code: '469002000000',
            value: '3231',
            
            id: 3231
          },
          {
            label: '琼中黎族苗族自治县',
            
            
            parentId: 102,
            code: '469030000000',
            value: '3232',
            
            id: 3232
          },
          {
            label: '屯昌县',
            
            
            parentId: 102,
            code: '469022000000',
            value: '3233',
            
            id: 3233
          },
          {
            label: '万宁市',
            
            
            parentId: 102,
            code: '469006000000',
            value: '3234',
            
            id: 3234
          },
          {
            label: '文昌市',
            
            
            parentId: 102,
            code: '469005000000',
            value: '3235',
            
            id: 3235
          },
          {
            label: '五指山市',
            
            
            parentId: 102,
            code: '469001000000',
            value: '3236',
            
            id: 3236
          }
        ],
        id: 102
      },
      {
        label: '海口市',
        
        
        parentId: 9,
        code: '460100000000',
        value: '103',
        children: [
          {
            label: '秀英区',
            
            
            parentId: 103,
            code: '460105000000',
            value: '768',
            
            id: 768
          },
          {
            label: '龙华区',
            
            
            parentId: 103,
            code: '460106000000',
            value: '769',
            
            id: 769
          },
          {
            label: '美兰区',
            
            
            parentId: 103,
            code: '460108000000',
            value: '770',
            
            id: 770
          },
          {
            label: '琼山区',
            
            
            parentId: 103,
            code: '460107000000',
            value: '771',
            
            id: 771
          }
        ],
        id: 103
      },
      {
        label: '三亚市',
        
        
        parentId: 9,
        code: '460200000000',
        value: '104',
        children: [
          {
            label: '海棠区',
            
            
            parentId: 104,
            code: '460202000000',
            value: '772',
            
            id: 772
          },
          {
            label: '吉阳区',
            
            
            parentId: 104,
            code: '460203000000',
            value: '773',
            
            id: 773
          },
          {
            label: '天涯区',
            
            
            parentId: 104,
            code: '460204000000',
            value: '774',
            
            id: 774
          },
          {
            label: '崖州区',
            
            
            parentId: 104,
            code: '460205000000',
            value: '775',
            
            id: 775
          }
        ],
        id: 104
      },
      {
        label: '三沙市',
        
        
        parentId: 9,
        code: '460300000000',
        value: '105',
        children: [
          {
            label: '西沙群岛',
            
            
            parentId: 105,
            code: '460321000000',
            value: '1354',
            
            id: 1354
          },
          {
            label: '南沙群岛',
            
            
            parentId: 105,
            code: '460322000000',
            value: '1355',
            
            id: 1355
          },
          {
            label: '中沙群岛的岛礁及其海域',
            
            
            parentId: 105,
            code: '460323000000',
            value: '1356',
            
            id: 1356
          }
        ],
        id: 105
      }
    ],
    id: 9
  },
  {
    label: '河北省',
    
    
    parentId: 1,
    code: '130000000000',
    value: '10',
    children: [
      {
        label: '石家庄市',
        
        
        parentId: 10,
        code: '130100000000',
        value: '106',
        children: [
          {
            label: '藁城区',
            
            
            parentId: 106,
            code: '130109000000',
            value: '2175',
            
            id: 2175
          },
          {
            label: '晋州市',
            
            
            parentId: 106,
            code: '130183000000',
            value: '2176',
            
            id: 2176
          },
          {
            label: '新乐市',
            
            
            parentId: 106,
            code: '130184000000',
            value: '2177',
            
            id: 2177
          },
          {
            label: '鹿泉区',
            
            
            parentId: 106,
            code: '130110000000',
            value: '2178',
            
            id: 2178
          },
          {
            label: '井陉县',
            
            
            parentId: 106,
            code: '130121000000',
            value: '2179',
            
            id: 2179
          },
          {
            label: '正定县',
            
            
            parentId: 106,
            code: '130123000000',
            value: '2180',
            
            id: 2180
          },
          {
            label: '栾城区',
            
            
            parentId: 106,
            code: '130111000000',
            value: '2181',
            
            id: 2181
          },
          {
            label: '行唐县',
            
            
            parentId: 106,
            code: '130125000000',
            value: '2182',
            
            id: 2182
          },
          {
            label: '灵寿县',
            
            
            parentId: 106,
            code: '130126000000',
            value: '2183',
            
            id: 2183
          },
          {
            label: '高邑县',
            
            
            parentId: 106,
            code: '130127000000',
            value: '2184',
            
            id: 2184
          },
          {
            label: '深泽县',
            
            
            parentId: 106,
            code: '130128000000',
            value: '2185',
            
            id: 2185
          },
          {
            label: '赞皇县',
            
            
            parentId: 106,
            code: '130129000000',
            value: '2186',
            
            id: 2186
          },
          {
            label: '无极县',
            
            
            parentId: 106,
            code: '130130000000',
            value: '2187',
            
            id: 2187
          },
          {
            label: '平山县',
            
            
            parentId: 106,
            code: '130131000000',
            value: '2188',
            
            id: 2188
          },
          {
            label: '元氏县',
            
            
            parentId: 106,
            code: '130132000000',
            value: '2189',
            
            id: 2189
          },
          {
            label: '赵县',
            
            
            parentId: 106,
            code: '130133000000',
            value: '2190',
            
            id: 2190
          },
          {
            label: '长安区',
            
            
            parentId: 106,
            code: '130102000000',
            value: '2191',
            
            id: 2191
          },
          {
            label: '桥西区',
            
            
            parentId: 106,
            code: '130104000000',
            value: '2192',
            
            id: 2192
          },
          {
            label: '新华区',
            
            
            parentId: 106,
            code: '130105000000',
            value: '2193',
            
            id: 2193
          },
          {
            label: '井陉矿区',
            
            
            parentId: 106,
            code: '130107000000',
            value: '2194',
            
            id: 2194
          },
          {
            label: '裕华区',
            
            
            parentId: 106,
            code: '130108000000',
            value: '2195',
            
            id: 2195
          }
        ],
        id: 106
      },
      {
        label: '唐山市',
        
        
        parentId: 10,
        code: '130200000000',
        value: '107',
        children: [
          {
            label: '路南区',
            
            
            parentId: 107,
            code: '130202000000',
            value: '2196',
            
            id: 2196
          },
          {
            label: '路北区',
            
            
            parentId: 107,
            code: '130203000000',
            value: '2197',
            
            id: 2197
          },
          {
            label: '古冶区',
            
            
            parentId: 107,
            code: '130204000000',
            value: '2198',
            
            id: 2198
          },
          {
            label: '开平区',
            
            
            parentId: 107,
            code: '130205000000',
            value: '2199',
            
            id: 2199
          },
          {
            label: '丰南区',
            
            
            parentId: 107,
            code: '130207000000',
            value: '2200',
            
            id: 2200
          },
          {
            label: '丰润区',
            
            
            parentId: 107,
            code: '130208000000',
            value: '2201',
            
            id: 2201
          },
          {
            label: '滦县',
            
            
            parentId: 107,
            code: '130223000000',
            value: '2202',
            
            id: 2202
          },
          {
            label: '滦南县',
            
            
            parentId: 107,
            code: '130224000000',
            value: '2203',
            
            id: 2203
          },
          {
            label: '乐亭县',
            
            
            parentId: 107,
            code: '130225000000',
            value: '2204',
            
            id: 2204
          },
          {
            label: '迁西县',
            
            
            parentId: 107,
            code: '130227000000',
            value: '2205',
            
            id: 2205
          },
          {
            label: '玉田县',
            
            
            parentId: 107,
            code: '130229000000',
            value: '2206',
            
            id: 2206
          },
          {
            label: '曹妃甸区',
            
            
            parentId: 107,
            code: '130209000000',
            value: '2207',
            
            id: 2207
          },
          {
            label: '遵化市',
            
            
            parentId: 107,
            code: '130281000000',
            value: '2208',
            
            id: 2208
          },
          {
            label: '迁安市',
            
            
            parentId: 107,
            code: '130283000000',
            value: '2209',
            
            id: 2209
          }
        ],
        id: 107
      },
      {
        label: '秦皇岛市',
        
        
        parentId: 10,
        code: '130300000000',
        value: '108',
        children: [
          {
            label: '海港区',
            
            
            parentId: 108,
            code: '130302000000',
            value: '2210',
            
            id: 2210
          },
          {
            label: '山海关区',
            
            
            parentId: 108,
            code: '130303000000',
            value: '2211',
            
            id: 2211
          },
          {
            label: '北戴河区',
            
            
            parentId: 108,
            code: '130304000000',
            value: '2212',
            
            id: 2212
          },
          {
            label: '昌黎县',
            
            
            parentId: 108,
            code: '130322000000',
            value: '2213',
            
            id: 2213
          },
          {
            label: '抚宁县',
            
            
            parentId: 108,
            code: '130323000000',
            value: '2214',
            
            id: 2214
          },
          {
            label: '卢龙县',
            
            
            parentId: 108,
            code: '130324000000',
            value: '2215',
            
            id: 2215
          },
          {
            label: '青龙满族自治县',
            
            
            parentId: 108,
            code: '130321000000',
            value: '2216',
            
            id: 2216
          }
        ],
        id: 108
      },
      {
        label: '邯郸市',
        
        
        parentId: 10,
        code: '130400000000',
        value: '109',
        children: [
          {
            label: '邯郸县',
            
            
            parentId: 109,
            code: '130421000000',
            value: '2217',
            
            id: 2217
          },
          {
            label: '临漳县',
            
            
            parentId: 109,
            code: '130423000000',
            value: '2218',
            
            id: 2218
          },
          {
            label: '成安县',
            
            
            parentId: 109,
            code: '130424000000',
            value: '2219',
            
            id: 2219
          },
          {
            label: '大名县',
            
            
            parentId: 109,
            code: '130425000000',
            value: '2220',
            
            id: 2220
          },
          {
            label: '涉县',
            
            
            parentId: 109,
            code: '130426000000',
            value: '2221',
            
            id: 2221
          },
          {
            label: '磁县',
            
            
            parentId: 109,
            code: '130427000000',
            value: '2222',
            
            id: 2222
          },
          {
            label: '肥乡县',
            
            
            parentId: 109,
            code: '130428000000',
            value: '2223',
            
            id: 2223
          },
          {
            label: '永年县',
            
            
            parentId: 109,
            code: '130429000000',
            value: '2224',
            
            id: 2224
          },
          {
            label: '邱县',
            
            
            parentId: 109,
            code: '130430000000',
            value: '2225',
            
            id: 2225
          },
          {
            label: '鸡泽县',
            
            
            parentId: 109,
            code: '130431000000',
            value: '2226',
            
            id: 2226
          },
          {
            label: '广平县',
            
            
            parentId: 109,
            code: '130432000000',
            value: '2227',
            
            id: 2227
          },
          {
            label: '馆陶县',
            
            
            parentId: 109,
            code: '130433000000',
            value: '2228',
            
            id: 2228
          },
          {
            label: '魏县',
            
            
            parentId: 109,
            code: '130434000000',
            value: '2229',
            
            id: 2229
          },
          {
            label: '曲周县',
            
            
            parentId: 109,
            code: '130435000000',
            value: '2230',
            
            id: 2230
          },
          {
            label: '武安市',
            
            
            parentId: 109,
            code: '130481000000',
            value: '2231',
            
            id: 2231
          },
          {
            label: '邯山区',
            
            
            parentId: 109,
            code: '130402000000',
            value: '2232',
            
            id: 2232
          },
          {
            label: '丛台区',
            
            
            parentId: 109,
            code: '130403000000',
            value: '2233',
            
            id: 2233
          },
          {
            label: '复兴区',
            
            
            parentId: 109,
            code: '130404000000',
            value: '2234',
            
            id: 2234
          },
          {
            label: '峰峰矿区',
            
            
            parentId: 109,
            code: '130406000000',
            value: '2235',
            
            id: 2235
          }
        ],
        id: 109
      },
      {
        label: '邢台市',
        
        
        parentId: 10,
        code: '130500000000',
        value: '110',
        children: [
          {
            label: '桥东区',
            
            
            parentId: 110,
            code: '130502000000',
            value: '2236',
            
            id: 2236
          },
          {
            label: '桥西区',
            
            
            parentId: 110,
            code: '130503000000',
            value: '2237',
            
            id: 2237
          },
          {
            label: '南宫市',
            
            
            parentId: 110,
            code: '130581000000',
            value: '2238',
            
            id: 2238
          },
          {
            label: '沙河市',
            
            
            parentId: 110,
            code: '130582000000',
            value: '2239',
            
            id: 2239
          },
          {
            label: '邢台县',
            
            
            parentId: 110,
            code: '130521000000',
            value: '2240',
            
            id: 2240
          },
          {
            label: '临城县',
            
            
            parentId: 110,
            code: '130522000000',
            value: '2241',
            
            id: 2241
          },
          {
            label: '内丘县',
            
            
            parentId: 110,
            code: '130523000000',
            value: '2242',
            
            id: 2242
          },
          {
            label: '柏乡县',
            
            
            parentId: 110,
            code: '130524000000',
            value: '2243',
            
            id: 2243
          },
          {
            label: '隆尧县',
            
            
            parentId: 110,
            code: '130525000000',
            value: '2244',
            
            id: 2244
          },
          {
            label: '任县',
            
            
            parentId: 110,
            code: '130526000000',
            value: '2245',
            
            id: 2245
          },
          {
            label: '南和县',
            
            
            parentId: 110,
            code: '130527000000',
            value: '2246',
            
            id: 2246
          },
          {
            label: '宁晋县',
            
            
            parentId: 110,
            code: '130528000000',
            value: '2247',
            
            id: 2247
          },
          {
            label: '巨鹿县',
            
            
            parentId: 110,
            code: '130529000000',
            value: '2248',
            
            id: 2248
          },
          {
            label: '新河县',
            
            
            parentId: 110,
            code: '130530000000',
            value: '2249',
            
            id: 2249
          },
          {
            label: '广宗县',
            
            
            parentId: 110,
            code: '130531000000',
            value: '2250',
            
            id: 2250
          },
          {
            label: '平乡县',
            
            
            parentId: 110,
            code: '130532000000',
            value: '2251',
            
            id: 2251
          },
          {
            label: '威县',
            
            
            parentId: 110,
            code: '130533000000',
            value: '2252',
            
            id: 2252
          },
          {
            label: '清河县',
            
            
            parentId: 110,
            code: '130534000000',
            value: '2253',
            
            id: 2253
          },
          {
            label: '临西县',
            
            
            parentId: 110,
            code: '130535000000',
            value: '2254',
            
            id: 2254
          }
        ],
        id: 110
      },
      {
        label: '保定市',
        
        
        parentId: 10,
        code: '130600000000',
        value: '111',
        children: [
          {
            label: '满城县',
            
            
            parentId: 111,
            code: '130621000000',
            value: '2255',
            
            id: 2255
          },
          {
            label: '清苑县',
            
            
            parentId: 111,
            code: '130622000000',
            value: '2256',
            
            id: 2256
          },
          {
            label: '涞水县',
            
            
            parentId: 111,
            code: '130623000000',
            value: '2257',
            
            id: 2257
          },
          {
            label: '阜平县',
            
            
            parentId: 111,
            code: '130624000000',
            value: '2258',
            
            id: 2258
          },
          {
            label: '徐水县',
            
            
            parentId: 111,
            code: '130625000000',
            value: '2259',
            
            id: 2259
          },
          {
            label: '定兴县',
            
            
            parentId: 111,
            code: '130626000000',
            value: '2260',
            
            id: 2260
          },
          {
            label: '唐县',
            
            
            parentId: 111,
            code: '130627000000',
            value: '2261',
            
            id: 2261
          },
          {
            label: '高阳县',
            
            
            parentId: 111,
            code: '130628000000',
            value: '2262',
            
            id: 2262
          },
          {
            label: '容城县',
            
            
            parentId: 111,
            code: '130629000000',
            value: '2263',
            
            id: 2263
          },
          {
            label: '涞源县',
            
            
            parentId: 111,
            code: '130630000000',
            value: '2264',
            
            id: 2264
          },
          {
            label: '望都县',
            
            
            parentId: 111,
            code: '130631000000',
            value: '2265',
            
            id: 2265
          },
          {
            label: '安新县',
            
            
            parentId: 111,
            code: '130632000000',
            value: '2266',
            
            id: 2266
          },
          {
            label: '易县',
            
            
            parentId: 111,
            code: '130633000000',
            value: '2267',
            
            id: 2267
          },
          {
            label: '曲阳县',
            
            
            parentId: 111,
            code: '130634000000',
            value: '2268',
            
            id: 2268
          },
          {
            label: '蠡县',
            
            
            parentId: 111,
            code: '130635000000',
            value: '2269',
            
            id: 2269
          },
          {
            label: '顺平县',
            
            
            parentId: 111,
            code: '130636000000',
            value: '2270',
            
            id: 2270
          },
          {
            label: '博野县',
            
            
            parentId: 111,
            code: '130637000000',
            value: '2271',
            
            id: 2271
          },
          {
            label: '雄县',
            
            
            parentId: 111,
            code: '130638000000',
            value: '2272',
            
            id: 2272
          },
          {
            label: '涿州市',
            
            
            parentId: 111,
            code: '130681000000',
            value: '2273',
            
            id: 2273
          },
          {
            label: '新市区',
            
            
            parentId: 111,
            code: '130602000000',
            value: '2274',
            
            id: 2274
          },
          {
            label: '北市区',
            
            
            parentId: 111,
            code: '130603000000',
            value: '2275',
            
            id: 2275
          },
          {
            label: '南市区',
            
            
            parentId: 111,
            code: '130604000000',
            value: '2276',
            
            id: 2276
          },
          {
            label: '安国市',
            
            
            parentId: 111,
            code: '130683000000',
            value: '2277',
            
            id: 2277
          },
          {
            label: '高碑店市',
            
            
            parentId: 111,
            code: '130684000000',
            value: '2278',
            
            id: 2278
          }
        ],
        id: 111
      },
      {
        label: '张家口市',
        
        
        parentId: 10,
        code: '130700000000',
        value: '112',
        children: [
          {
            label: '桥东区',
            
            
            parentId: 112,
            code: '130702000000',
            value: '2279',
            
            id: 2279
          },
          {
            label: '桥西区',
            
            
            parentId: 112,
            code: '130703000000',
            value: '2280',
            
            id: 2280
          },
          {
            label: '宣化区',
            
            
            parentId: 112,
            code: '130705000000',
            value: '2281',
            
            id: 2281
          },
          {
            label: '下花园区',
            
            
            parentId: 112,
            code: '130706000000',
            value: '2282',
            
            id: 2282
          },
          {
            label: '宣化县',
            
            
            parentId: 112,
            code: '130721000000',
            value: '2283',
            
            id: 2283
          },
          {
            label: '张北县',
            
            
            parentId: 112,
            code: '130722000000',
            value: '2284',
            
            id: 2284
          },
          {
            label: '康保县',
            
            
            parentId: 112,
            code: '130723000000',
            value: '2285',
            
            id: 2285
          },
          {
            label: '沽源县',
            
            
            parentId: 112,
            code: '130724000000',
            value: '2286',
            
            id: 2286
          },
          {
            label: '尚义县',
            
            
            parentId: 112,
            code: '130725000000',
            value: '2287',
            
            id: 2287
          },
          {
            label: '蔚县',
            
            
            parentId: 112,
            code: '130726000000',
            value: '2288',
            
            id: 2288
          },
          {
            label: '阳原县',
            
            
            parentId: 112,
            code: '130727000000',
            value: '2289',
            
            id: 2289
          },
          {
            label: '怀安县',
            
            
            parentId: 112,
            code: '130728000000',
            value: '2290',
            
            id: 2290
          },
          {
            label: '万全县',
            
            
            parentId: 112,
            code: '130729000000',
            value: '2291',
            
            id: 2291
          },
          {
            label: '怀来县',
            
            
            parentId: 112,
            code: '130730000000',
            value: '2292',
            
            id: 2292
          },
          {
            label: '涿鹿县',
            
            
            parentId: 112,
            code: '130731000000',
            value: '2293',
            
            id: 2293
          },
          {
            label: '赤城县',
            
            
            parentId: 112,
            code: '130732000000',
            value: '2294',
            
            id: 2294
          },
          {
            label: '崇礼县',
            
            
            parentId: 112,
            code: '130733000000',
            value: '2295',
            
            id: 2295
          }
        ],
        id: 112
      },
      {
        label: '承德市',
        
        
        parentId: 10,
        code: '130800000000',
        value: '113',
        children: [
          {
            label: '丰宁满族自治县',
            
            
            parentId: 113,
            code: '130826000000',
            value: '2296',
            
            id: 2296
          },
          {
            label: '宽城满族自治县',
            
            
            parentId: 113,
            code: '130827000000',
            value: '2297',
            
            id: 2297
          },
          {
            label: '围场满族蒙古族自治县',
            
            
            parentId: 113,
            code: '130828000000',
            value: '2298',
            
            id: 2298
          },
          {
            label: '双桥区',
            
            
            parentId: 113,
            code: '130802000000',
            value: '2299',
            
            id: 2299
          },
          {
            label: '双滦区',
            
            
            parentId: 113,
            code: '130803000000',
            value: '2300',
            
            id: 2300
          },
          {
            label: '鹰手营子矿区',
            
            
            parentId: 113,
            code: '130804000000',
            value: '2301',
            
            id: 2301
          },
          {
            label: '承德县',
            
            
            parentId: 113,
            code: '130821000000',
            value: '2302',
            
            id: 2302
          },
          {
            label: '兴隆县',
            
            
            parentId: 113,
            code: '130822000000',
            value: '2303',
            
            id: 2303
          },
          {
            label: '平泉县',
            
            
            parentId: 113,
            code: '130823000000',
            value: '2304',
            
            id: 2304
          },
          {
            label: '滦平县',
            
            
            parentId: 113,
            code: '130824000000',
            value: '2305',
            
            id: 2305
          },
          {
            label: '隆化县',
            
            
            parentId: 113,
            code: '130825000000',
            value: '2306',
            
            id: 2306
          }
        ],
        id: 113
      },
      {
        label: '沧州市',
        
        
        parentId: 10,
        code: '130900000000',
        value: '114',
        children: [
          {
            label: '沧县',
            
            
            parentId: 114,
            code: '130921000000',
            value: '2307',
            
            id: 2307
          },
          {
            label: '青县',
            
            
            parentId: 114,
            code: '130922000000',
            value: '2308',
            
            id: 2308
          },
          {
            label: '东光县',
            
            
            parentId: 114,
            code: '130923000000',
            value: '2309',
            
            id: 2309
          },
          {
            label: '海兴县',
            
            
            parentId: 114,
            code: '130924000000',
            value: '2310',
            
            id: 2310
          },
          {
            label: '盐山县',
            
            
            parentId: 114,
            code: '130925000000',
            value: '2311',
            
            id: 2311
          },
          {
            label: '肃宁县',
            
            
            parentId: 114,
            code: '130926000000',
            value: '2312',
            
            id: 2312
          },
          {
            label: '南皮县',
            
            
            parentId: 114,
            code: '130927000000',
            value: '2313',
            
            id: 2313
          },
          {
            label: '吴桥县',
            
            
            parentId: 114,
            code: '130928000000',
            value: '2314',
            
            id: 2314
          },
          {
            label: '献县',
            
            
            parentId: 114,
            code: '130929000000',
            value: '2315',
            
            id: 2315
          },
          {
            label: '新华区',
            
            
            parentId: 114,
            code: '130902000000',
            value: '2316',
            
            id: 2316
          },
          {
            label: '运河区',
            
            
            parentId: 114,
            code: '130903000000',
            value: '2317',
            
            id: 2317
          },
          {
            label: '泊头市',
            
            
            parentId: 114,
            code: '130981000000',
            value: '2318',
            
            id: 2318
          },
          {
            label: '任丘市',
            
            
            parentId: 114,
            code: '130982000000',
            value: '2319',
            
            id: 2319
          },
          {
            label: '黄骅市',
            
            
            parentId: 114,
            code: '130983000000',
            value: '2320',
            
            id: 2320
          },
          {
            label: '河间市',
            
            
            parentId: 114,
            code: '130984000000',
            value: '2321',
            
            id: 2321
          },
          {
            label: '孟村回族自治县',
            
            
            parentId: 114,
            code: '130930000000',
            value: '2322',
            
            id: 2322
          }
        ],
        id: 114
      },
      {
        label: '廊坊市',
        
        
        parentId: 10,
        code: '131000000000',
        value: '115',
        children: [
          {
            label: '大厂回族自治县',
            
            
            parentId: 115,
            code: '131028000000',
            value: '2323',
            
            id: 2323
          },
          {
            label: '霸州市',
            
            
            parentId: 115,
            code: '131081000000',
            value: '2324',
            
            id: 2324
          },
          {
            label: '三河市',
            
            
            parentId: 115,
            code: '131082000000',
            value: '2325',
            
            id: 2325
          },
          {
            label: '安次区',
            
            
            parentId: 115,
            code: '131002000000',
            value: '2326',
            
            id: 2326
          },
          {
            label: '广阳区',
            
            
            parentId: 115,
            code: '131003000000',
            value: '2327',
            
            id: 2327
          },
          {
            label: '固安县',
            
            
            parentId: 115,
            code: '131022000000',
            value: '2328',
            
            id: 2328
          },
          {
            label: '永清县',
            
            
            parentId: 115,
            code: '131023000000',
            value: '2329',
            
            id: 2329
          },
          {
            label: '香河县',
            
            
            parentId: 115,
            code: '131024000000',
            value: '2330',
            
            id: 2330
          },
          {
            label: '大城县',
            
            
            parentId: 115,
            code: '131025000000',
            value: '2331',
            
            id: 2331
          },
          {
            label: '文安县',
            
            
            parentId: 115,
            code: '131026000000',
            value: '2332',
            
            id: 2332
          }
        ],
        id: 115
      },
      {
        label: '衡水市',
        
        
        parentId: 10,
        code: '131100000000',
        value: '116',
        children: [
          {
            label: '桃城区',
            
            
            parentId: 116,
            code: '131102000000',
            value: '2333',
            
            id: 2333
          },
          {
            label: '冀州市',
            
            
            parentId: 116,
            code: '131181000000',
            value: '2334',
            
            id: 2334
          },
          {
            label: '深州市',
            
            
            parentId: 116,
            code: '131182000000',
            value: '2335',
            
            id: 2335
          },
          {
            label: '枣强县',
            
            
            parentId: 116,
            code: '131121000000',
            value: '2336',
            
            id: 2336
          },
          {
            label: '武邑县',
            
            
            parentId: 116,
            code: '131122000000',
            value: '2337',
            
            id: 2337
          },
          {
            label: '武强县',
            
            
            parentId: 116,
            code: '131123000000',
            value: '2338',
            
            id: 2338
          },
          {
            label: '饶阳县',
            
            
            parentId: 116,
            code: '131124000000',
            value: '2339',
            
            id: 2339
          },
          {
            label: '安平县',
            
            
            parentId: 116,
            code: '131125000000',
            value: '2340',
            
            id: 2340
          },
          {
            label: '故城县',
            
            
            parentId: 116,
            code: '131126000000',
            value: '2341',
            
            id: 2341
          },
          {
            label: '景县',
            
            
            parentId: 116,
            code: '131127000000',
            value: '2342',
            
            id: 2342
          },
          {
            label: '阜城县',
            
            
            parentId: 116,
            code: '131128000000',
            value: '2343',
            
            id: 2343
          }
        ],
        id: 116
      },
      {
        label: '省直辖县级行政区划',
        
        
        parentId: 10,
        code: '139000000000',
        value: '117',
        children: [
          {
            label: '定州市',
            
            
            parentId: 117,
            code: '139001000000',
            value: '3217',
            
            id: 3217
          },
          {
            label: '辛集市',
            
            
            parentId: 117,
            code: '139002000000',
            value: '3218',
            
            id: 3218
          }
        ],
        id: 117
      }
    ],
    id: 10
  },
  {
    label: '河南省',
    
    
    parentId: 1,
    code: '410000000000',
    value: '11',
    children: [
      {
        label: '省直辖县级行政区划',
        
        
        parentId: 11,
        code: '419000000000',
        value: '118',
        children: [
          {
            label: '济源市',
            
            
            parentId: 118,
            code: '419001000000',
            value: '3219',
            
            id: 3219
          }
        ],
        id: 118
      },
      {
        label: '郑州市',
        
        
        parentId: 11,
        code: '410100000000',
        value: '119',
        children: [
          {
            label: '中原区',
            
            
            parentId: 119,
            code: '410102000000',
            value: '1926',
            
            id: 1926
          },
          {
            label: '二七区',
            
            
            parentId: 119,
            code: '410103000000',
            value: '1927',
            
            id: 1927
          },
          {
            label: '管城回族区',
            
            
            parentId: 119,
            code: '410104000000',
            value: '1928',
            
            id: 1928
          },
          {
            label: '金水区',
            
            
            parentId: 119,
            code: '410105000000',
            value: '1929',
            
            id: 1929
          },
          {
            label: '上街区',
            
            
            parentId: 119,
            code: '410106000000',
            value: '1930',
            
            id: 1930
          },
          {
            label: '惠济区',
            
            
            parentId: 119,
            code: '410108000000',
            value: '1931',
            
            id: 1931
          },
          {
            label: '中牟县',
            
            
            parentId: 119,
            code: '410122000000',
            value: '1932',
            
            id: 1932
          },
          {
            label: '巩义市',
            
            
            parentId: 119,
            code: '410181000000',
            value: '1933',
            
            id: 1933
          },
          {
            label: '荥阳市',
            
            
            parentId: 119,
            code: '410182000000',
            value: '1934',
            
            id: 1934
          },
          {
            label: '新密市',
            
            
            parentId: 119,
            code: '410183000000',
            value: '1935',
            
            id: 1935
          },
          {
            label: '新郑市',
            
            
            parentId: 119,
            code: '410184000000',
            value: '1936',
            
            id: 1936
          },
          {
            label: '登封市',
            
            
            parentId: 119,
            code: '410185000000',
            value: '1937',
            
            id: 1937
          }
        ],
        id: 119
      },
      {
        label: '开封市',
        
        
        parentId: 11,
        code: '410200000000',
        value: '120',
        children: [
          {
            label: '杞县',
            
            
            parentId: 120,
            code: '410221000000',
            value: '1938',
            
            id: 1938
          },
          {
            label: '通许县',
            
            
            parentId: 120,
            code: '410222000000',
            value: '1939',
            
            id: 1939
          },
          {
            label: '尉氏县',
            
            
            parentId: 120,
            code: '410223000000',
            value: '1940',
            
            id: 1940
          },
          {
            label: '开封县',
            
            
            parentId: 120,
            code: '410224000000',
            value: '1941',
            
            id: 1941
          },
          {
            label: '兰考县',
            
            
            parentId: 120,
            code: '410225000000',
            value: '1942',
            
            id: 1942
          },
          {
            label: '龙亭区',
            
            
            parentId: 120,
            code: '410202000000',
            value: '1943',
            
            id: 1943
          },
          {
            label: '顺河回族区',
            
            
            parentId: 120,
            code: '410203000000',
            value: '1944',
            
            id: 1944
          },
          {
            label: '鼓楼区',
            
            
            parentId: 120,
            code: '410204000000',
            value: '1945',
            
            id: 1945
          },
          {
            label: '禹王台区',
            
            
            parentId: 120,
            code: '410205000000',
            value: '1946',
            
            id: 1946
          },
          {
            label: '金明区',
            
            
            parentId: 120,
            code: '410211000000',
            value: '1947',
            
            id: 1947
          }
        ],
        id: 120
      },
      {
        label: '洛阳市',
        
        
        parentId: 11,
        code: '410300000000',
        value: '121',
        children: [
          {
            label: '老城区',
            
            
            parentId: 121,
            code: '410302000000',
            value: '1948',
            
            id: 1948
          },
          {
            label: '西工区',
            
            
            parentId: 121,
            code: '410303000000',
            value: '1949',
            
            id: 1949
          },
          {
            label: '瀍河回族区',
            
            
            parentId: 121,
            code: '410304000000',
            value: '1950',
            
            id: 1950
          },
          {
            label: '涧西区',
            
            
            parentId: 121,
            code: '410305000000',
            value: '1951',
            
            id: 1951
          },
          {
            label: '吉利区',
            
            
            parentId: 121,
            code: '410306000000',
            value: '1952',
            
            id: 1952
          },
          {
            label: '洛龙区',
            
            
            parentId: 121,
            code: '410311000000',
            value: '1953',
            
            id: 1953
          },
          {
            label: '孟津县',
            
            
            parentId: 121,
            code: '410322000000',
            value: '1954',
            
            id: 1954
          },
          {
            label: '新安县',
            
            
            parentId: 121,
            code: '410323000000',
            value: '1955',
            
            id: 1955
          },
          {
            label: '栾川县',
            
            
            parentId: 121,
            code: '410324000000',
            value: '1956',
            
            id: 1956
          },
          {
            label: '嵩县',
            
            
            parentId: 121,
            code: '410325000000',
            value: '1957',
            
            id: 1957
          },
          {
            label: '汝阳县',
            
            
            parentId: 121,
            code: '410326000000',
            value: '1958',
            
            id: 1958
          },
          {
            label: '宜阳县',
            
            
            parentId: 121,
            code: '410327000000',
            value: '1959',
            
            id: 1959
          },
          {
            label: '洛宁县',
            
            
            parentId: 121,
            code: '410328000000',
            value: '1960',
            
            id: 1960
          },
          {
            label: '伊川县',
            
            
            parentId: 121,
            code: '410329000000',
            value: '1961',
            
            id: 1961
          },
          {
            label: '偃师市',
            
            
            parentId: 121,
            code: '410381000000',
            value: '1962',
            
            id: 1962
          }
        ],
        id: 121
      },
      {
        label: '平顶山市',
        
        
        parentId: 11,
        code: '410400000000',
        value: '122',
        children: [
          {
            label: '舞钢市',
            
            
            parentId: 122,
            code: '410481000000',
            value: '1963',
            
            id: 1963
          },
          {
            label: '汝州市',
            
            
            parentId: 122,
            code: '410482000000',
            value: '1964',
            
            id: 1964
          },
          {
            label: '宝丰县',
            
            
            parentId: 122,
            code: '410421000000',
            value: '1965',
            
            id: 1965
          },
          {
            label: '叶县',
            
            
            parentId: 122,
            code: '410422000000',
            value: '1966',
            
            id: 1966
          },
          {
            label: '鲁山县',
            
            
            parentId: 122,
            code: '410423000000',
            value: '1967',
            
            id: 1967
          },
          {
            label: '郏县',
            
            
            parentId: 122,
            code: '410425000000',
            value: '1968',
            
            id: 1968
          },
          {
            label: '新华区',
            
            
            parentId: 122,
            code: '410402000000',
            value: '1969',
            
            id: 1969
          },
          {
            label: '卫东区',
            
            
            parentId: 122,
            code: '410403000000',
            value: '1970',
            
            id: 1970
          },
          {
            label: '石龙区',
            
            
            parentId: 122,
            code: '410404000000',
            value: '1971',
            
            id: 1971
          },
          {
            label: '湛河区',
            
            
            parentId: 122,
            code: '410411000000',
            value: '1972',
            
            id: 1972
          }
        ],
        id: 122
      },
      {
        label: '安阳市',
        
        
        parentId: 11,
        code: '410500000000',
        value: '123',
        children: [
          {
            label: '文峰区',
            
            
            parentId: 123,
            code: '410502000000',
            value: '1973',
            
            id: 1973
          },
          {
            label: '北关区',
            
            
            parentId: 123,
            code: '410503000000',
            value: '1974',
            
            id: 1974
          },
          {
            label: '殷都区',
            
            
            parentId: 123,
            code: '410505000000',
            value: '1975',
            
            id: 1975
          },
          {
            label: '龙安区',
            
            
            parentId: 123,
            code: '410506000000',
            value: '1976',
            
            id: 1976
          },
          {
            label: '安阳县',
            
            
            parentId: 123,
            code: '410522000000',
            value: '1977',
            
            id: 1977
          },
          {
            label: '汤阴县',
            
            
            parentId: 123,
            code: '410523000000',
            value: '1978',
            
            id: 1978
          },
          {
            label: '滑县',
            
            
            parentId: 123,
            code: '410526000000',
            value: '1979',
            
            id: 1979
          },
          {
            label: '内黄县',
            
            
            parentId: 123,
            code: '410527000000',
            value: '1980',
            
            id: 1980
          },
          {
            label: '林州市',
            
            
            parentId: 123,
            code: '410581000000',
            value: '1981',
            
            id: 1981
          }
        ],
        id: 123
      },
      {
        label: '鹤壁市',
        
        
        parentId: 11,
        code: '410600000000',
        value: '124',
        children: [
          {
            label: '浚县',
            
            
            parentId: 124,
            code: '410621000000',
            value: '1982',
            
            id: 1982
          },
          {
            label: '淇县',
            
            
            parentId: 124,
            code: '410622000000',
            value: '1983',
            
            id: 1983
          },
          {
            label: '鹤山区',
            
            
            parentId: 124,
            code: '410602000000',
            value: '1984',
            
            id: 1984
          },
          {
            label: '山城区',
            
            
            parentId: 124,
            code: '410603000000',
            value: '1985',
            
            id: 1985
          },
          {
            label: '淇滨区',
            
            
            parentId: 124,
            code: '410611000000',
            value: '1986',
            
            id: 1986
          }
        ],
        id: 124
      },
      {
        label: '新乡市',
        
        
        parentId: 11,
        code: '410700000000',
        value: '125',
        children: [
          {
            label: '红旗区',
            
            
            parentId: 125,
            code: '410702000000',
            value: '1987',
            
            id: 1987
          },
          {
            label: '卫滨区',
            
            
            parentId: 125,
            code: '410703000000',
            value: '1988',
            
            id: 1988
          },
          {
            label: '凤泉区',
            
            
            parentId: 125,
            code: '410704000000',
            value: '1989',
            
            id: 1989
          },
          {
            label: '牧野区',
            
            
            parentId: 125,
            code: '410711000000',
            value: '1990',
            
            id: 1990
          },
          {
            label: '新乡县',
            
            
            parentId: 125,
            code: '410721000000',
            value: '1991',
            
            id: 1991
          },
          {
            label: '获嘉县',
            
            
            parentId: 125,
            code: '410724000000',
            value: '1992',
            
            id: 1992
          },
          {
            label: '原阳县',
            
            
            parentId: 125,
            code: '410725000000',
            value: '1993',
            
            id: 1993
          },
          {
            label: '延津县',
            
            
            parentId: 125,
            code: '410726000000',
            value: '1994',
            
            id: 1994
          },
          {
            label: '封丘县',
            
            
            parentId: 125,
            code: '410727000000',
            value: '1995',
            
            id: 1995
          },
          {
            label: '长垣县',
            
            
            parentId: 125,
            code: '410728000000',
            value: '1996',
            
            id: 1996
          },
          {
            label: '卫辉市',
            
            
            parentId: 125,
            code: '410781000000',
            value: '1997',
            
            id: 1997
          },
          {
            label: '辉县市',
            
            
            parentId: 125,
            code: '410782000000',
            value: '1998',
            
            id: 1998
          }
        ],
        id: 125
      },
      {
        label: '焦作市',
        
        
        parentId: 11,
        code: '410800000000',
        value: '126',
        children: [
          {
            label: '沁阳市',
            
            
            parentId: 126,
            code: '410882000000',
            value: '1999',
            
            id: 1999
          },
          {
            label: '孟州市',
            
            
            parentId: 126,
            code: '410883000000',
            value: '2000',
            
            id: 2000
          },
          {
            label: '修武县',
            
            
            parentId: 126,
            code: '410821000000',
            value: '2001',
            
            id: 2001
          },
          {
            label: '博爱县',
            
            
            parentId: 126,
            code: '410822000000',
            value: '2002',
            
            id: 2002
          },
          {
            label: '武陟县',
            
            
            parentId: 126,
            code: '410823000000',
            value: '2003',
            
            id: 2003
          },
          {
            label: '温县',
            
            
            parentId: 126,
            code: '410825000000',
            value: '2004',
            
            id: 2004
          },
          {
            label: '解放区',
            
            
            parentId: 126,
            code: '410802000000',
            value: '2005',
            
            id: 2005
          },
          {
            label: '中站区',
            
            
            parentId: 126,
            code: '410803000000',
            value: '2006',
            
            id: 2006
          },
          {
            label: '马村区',
            
            
            parentId: 126,
            code: '410804000000',
            value: '2007',
            
            id: 2007
          },
          {
            label: '山阳区',
            
            
            parentId: 126,
            code: '410811000000',
            value: '2008',
            
            id: 2008
          }
        ],
        id: 126
      },
      {
        label: '濮阳市',
        
        
        parentId: 11,
        code: '410900000000',
        value: '127',
        children: [
          {
            label: '华龙区',
            
            
            parentId: 127,
            code: '410902000000',
            value: '2009',
            
            id: 2009
          },
          {
            label: '清丰县',
            
            
            parentId: 127,
            code: '410922000000',
            value: '2010',
            
            id: 2010
          },
          {
            label: '南乐县',
            
            
            parentId: 127,
            code: '410923000000',
            value: '2011',
            
            id: 2011
          },
          {
            label: '范县',
            
            
            parentId: 127,
            code: '410926000000',
            value: '2012',
            
            id: 2012
          },
          {
            label: '台前县',
            
            
            parentId: 127,
            code: '410927000000',
            value: '2013',
            
            id: 2013
          },
          {
            label: '濮阳县',
            
            
            parentId: 127,
            code: '410928000000',
            value: '2014',
            
            id: 2014
          }
        ],
        id: 127
      },
      {
        label: '许昌市',
        
        
        parentId: 11,
        code: '411000000000',
        value: '128',
        children: [
          {
            label: '禹州市',
            
            
            parentId: 128,
            code: '411081000000',
            value: '2015',
            
            id: 2015
          },
          {
            label: '长葛市',
            
            
            parentId: 128,
            code: '411082000000',
            value: '2016',
            
            id: 2016
          },
          {
            label: '许昌县',
            
            
            parentId: 128,
            code: '411023000000',
            value: '2017',
            
            id: 2017
          },
          {
            label: '鄢陵县',
            
            
            parentId: 128,
            code: '411024000000',
            value: '2018',
            
            id: 2018
          },
          {
            label: '襄城县',
            
            
            parentId: 128,
            code: '411025000000',
            value: '2019',
            
            id: 2019
          },
          {
            label: '魏都区',
            
            
            parentId: 128,
            code: '411002000000',
            value: '2020',
            
            id: 2020
          }
        ],
        id: 128
      },
      {
        label: '漯河市',
        
        
        parentId: 11,
        code: '411100000000',
        value: '129',
        children: [
          {
            label: '郾城区',
            
            
            parentId: 129,
            code: '411103000000',
            value: '2021',
            
            id: 2021
          },
          {
            label: '源汇区',
            
            
            parentId: 129,
            code: '411102000000',
            value: '2022',
            
            id: 2022
          },
          {
            label: '舞阳县',
            
            
            parentId: 129,
            code: '411121000000',
            value: '2023',
            
            id: 2023
          },
          {
            label: '临颍县',
            
            
            parentId: 129,
            code: '411122000000',
            value: '2024',
            
            id: 2024
          },
          {
            label: '召陵区',
            
            
            parentId: 129,
            code: '411104000000',
            value: '2025',
            
            id: 2025
          }
        ],
        id: 129
      },
      {
        label: '三门峡市',
        
        
        parentId: 11,
        code: '411200000000',
        value: '130',
        children: [
          {
            label: '义马市',
            
            
            parentId: 130,
            code: '411281000000',
            value: '2026',
            
            id: 2026
          },
          {
            label: '灵宝市',
            
            
            parentId: 130,
            code: '411282000000',
            value: '2027',
            
            id: 2027
          },
          {
            label: '渑池县',
            
            
            parentId: 130,
            code: '411221000000',
            value: '2028',
            
            id: 2028
          },
          {
            label: '陕县',
            
            
            parentId: 130,
            code: '411222000000',
            value: '2029',
            
            id: 2029
          },
          {
            label: '卢氏县',
            
            
            parentId: 130,
            code: '411224000000',
            value: '2030',
            
            id: 2030
          },
          {
            label: '湖滨区',
            
            
            parentId: 130,
            code: '411202000000',
            value: '2031',
            
            id: 2031
          }
        ],
        id: 130
      },
      {
        label: '南阳市',
        
        
        parentId: 11,
        code: '411300000000',
        value: '131',
        children: [
          {
            label: '宛城区',
            
            
            parentId: 131,
            code: '411302000000',
            value: '2032',
            
            id: 2032
          },
          {
            label: '卧龙区',
            
            
            parentId: 131,
            code: '411303000000',
            value: '2033',
            
            id: 2033
          },
          {
            label: '南召县',
            
            
            parentId: 131,
            code: '411321000000',
            value: '2034',
            
            id: 2034
          },
          {
            label: '方城县',
            
            
            parentId: 131,
            code: '411322000000',
            value: '2035',
            
            id: 2035
          },
          {
            label: '西峡县',
            
            
            parentId: 131,
            code: '411323000000',
            value: '2036',
            
            id: 2036
          },
          {
            label: '镇平县',
            
            
            parentId: 131,
            code: '411324000000',
            value: '2037',
            
            id: 2037
          },
          {
            label: '内乡县',
            
            
            parentId: 131,
            code: '411325000000',
            value: '2038',
            
            id: 2038
          },
          {
            label: '淅川县',
            
            
            parentId: 131,
            code: '411326000000',
            value: '2039',
            
            id: 2039
          },
          {
            label: '社旗县',
            
            
            parentId: 131,
            code: '411327000000',
            value: '2040',
            
            id: 2040
          },
          {
            label: '唐河县',
            
            
            parentId: 131,
            code: '411328000000',
            value: '2041',
            
            id: 2041
          },
          {
            label: '新野县',
            
            
            parentId: 131,
            code: '411329000000',
            value: '2042',
            
            id: 2042
          },
          {
            label: '桐柏县',
            
            
            parentId: 131,
            code: '411330000000',
            value: '2043',
            
            id: 2043
          },
          {
            label: '邓州市',
            
            
            parentId: 131,
            code: '411381000000',
            value: '2044',
            
            id: 2044
          }
        ],
        id: 131
      },
      {
        label: '商丘市',
        
        
        parentId: 11,
        code: '411400000000',
        value: '132',
        children: [
          {
            label: '永城市',
            
            
            parentId: 132,
            code: '411481000000',
            value: '2045',
            
            id: 2045
          },
          {
            label: '民权县',
            
            
            parentId: 132,
            code: '411421000000',
            value: '2046',
            
            id: 2046
          },
          {
            label: '睢县',
            
            
            parentId: 132,
            code: '411422000000',
            value: '2047',
            
            id: 2047
          },
          {
            label: '宁陵县',
            
            
            parentId: 132,
            code: '411423000000',
            value: '2048',
            
            id: 2048
          },
          {
            label: '柘城县',
            
            
            parentId: 132,
            code: '411424000000',
            value: '2049',
            
            id: 2049
          },
          {
            label: '虞城县',
            
            
            parentId: 132,
            code: '411425000000',
            value: '2050',
            
            id: 2050
          },
          {
            label: '夏邑县',
            
            
            parentId: 132,
            code: '411426000000',
            value: '2051',
            
            id: 2051
          },
          {
            label: '梁园区',
            
            
            parentId: 132,
            code: '411402000000',
            value: '2052',
            
            id: 2052
          },
          {
            label: '睢阳区',
            
            
            parentId: 132,
            code: '411403000000',
            value: '2053',
            
            id: 2053
          }
        ],
        id: 132
      },
      {
        label: '信阳市',
        
        
        parentId: 11,
        code: '411500000000',
        value: '133',
        children: [
          {
            label: '浉河区',
            
            
            parentId: 133,
            code: '411502000000',
            value: '2054',
            
            id: 2054
          },
          {
            label: '平桥区',
            
            
            parentId: 133,
            code: '411503000000',
            value: '2055',
            
            id: 2055
          },
          {
            label: '罗山县',
            
            
            parentId: 133,
            code: '411521000000',
            value: '2056',
            
            id: 2056
          },
          {
            label: '光山县',
            
            
            parentId: 133,
            code: '411522000000',
            value: '2057',
            
            id: 2057
          },
          {
            label: '新县',
            
            
            parentId: 133,
            code: '411523000000',
            value: '2058',
            
            id: 2058
          },
          {
            label: '商城县',
            
            
            parentId: 133,
            code: '411524000000',
            value: '2059',
            
            id: 2059
          },
          {
            label: '固始县',
            
            
            parentId: 133,
            code: '411525000000',
            value: '2060',
            
            id: 2060
          },
          {
            label: '潢川县',
            
            
            parentId: 133,
            code: '411526000000',
            value: '2061',
            
            id: 2061
          },
          {
            label: '淮滨县',
            
            
            parentId: 133,
            code: '411527000000',
            value: '2062',
            
            id: 2062
          },
          {
            label: '息县',
            
            
            parentId: 133,
            code: '411528000000',
            value: '2063',
            
            id: 2063
          }
        ],
        id: 133
      },
      {
        label: '周口市',
        
        
        parentId: 11,
        code: '411600000000',
        value: '134',
        children: [
          {
            label: '项城市',
            
            
            parentId: 134,
            code: '411681000000',
            value: '2064',
            
            id: 2064
          },
          {
            label: '扶沟县',
            
            
            parentId: 134,
            code: '411621000000',
            value: '2065',
            
            id: 2065
          },
          {
            label: '西华县',
            
            
            parentId: 134,
            code: '411622000000',
            value: '2066',
            
            id: 2066
          },
          {
            label: '商水县',
            
            
            parentId: 134,
            code: '411623000000',
            value: '2067',
            
            id: 2067
          },
          {
            label: '沈丘县',
            
            
            parentId: 134,
            code: '411624000000',
            value: '2068',
            
            id: 2068
          },
          {
            label: '郸城县',
            
            
            parentId: 134,
            code: '411625000000',
            value: '2069',
            
            id: 2069
          },
          {
            label: '淮阳县',
            
            
            parentId: 134,
            code: '411626000000',
            value: '2070',
            
            id: 2070
          },
          {
            label: '太康县',
            
            
            parentId: 134,
            code: '411627000000',
            value: '2071',
            
            id: 2071
          },
          {
            label: '鹿邑县',
            
            
            parentId: 134,
            code: '411628000000',
            value: '2072',
            
            id: 2072
          },
          {
            label: '川汇区',
            
            
            parentId: 134,
            code: '411602000000',
            value: '2073',
            
            id: 2073
          }
        ],
        id: 134
      },
      {
        label: '驻马店市',
        
        
        parentId: 11,
        code: '411700000000',
        value: '135',
        children: [
          {
            label: '驿城区',
            
            
            parentId: 135,
            code: '411702000000',
            value: '2074',
            
            id: 2074
          },
          {
            label: '西平县',
            
            
            parentId: 135,
            code: '411721000000',
            value: '2075',
            
            id: 2075
          },
          {
            label: '上蔡县',
            
            
            parentId: 135,
            code: '411722000000',
            value: '2076',
            
            id: 2076
          },
          {
            label: '平舆县',
            
            
            parentId: 135,
            code: '411723000000',
            value: '2077',
            
            id: 2077
          },
          {
            label: '正阳县',
            
            
            parentId: 135,
            code: '411724000000',
            value: '2078',
            
            id: 2078
          },
          {
            label: '确山县',
            
            
            parentId: 135,
            code: '411725000000',
            value: '2079',
            
            id: 2079
          },
          {
            label: '泌阳县',
            
            
            parentId: 135,
            code: '411726000000',
            value: '2080',
            
            id: 2080
          },
          {
            label: '汝南县',
            
            
            parentId: 135,
            code: '411727000000',
            value: '2081',
            
            id: 2081
          },
          {
            label: '遂平县',
            
            
            parentId: 135,
            code: '411728000000',
            value: '2082',
            
            id: 2082
          },
          {
            label: '新蔡县',
            
            
            parentId: 135,
            code: '411729000000',
            value: '2083',
            
            id: 2083
          }
        ],
        id: 135
      }
    ],
    id: 11
  },
  {
    label: '黑龙江省',
    
    
    parentId: 1,
    code: '230000000000',
    value: '12',
    children: [
      {
        label: '哈尔滨市',
        
        
        parentId: 12,
        code: '230100000000',
        value: '136',
        children: [
          {
            label: '阿城区',
            
            
            parentId: 136,
            code: '230112000000',
            value: '2457',
            
            id: 2457
          },
          {
            label: '双城市',
            
            
            parentId: 136,
            code: '230182000000',
            value: '2458',
            
            id: 2458
          },
          {
            label: '尚志市',
            
            
            parentId: 136,
            code: '230183000000',
            value: '2459',
            
            id: 2459
          },
          {
            label: '五常市',
            
            
            parentId: 136,
            code: '230184000000',
            value: '2460',
            
            id: 2460
          },
          {
            label: '道里区',
            
            
            parentId: 136,
            code: '230102000000',
            value: '2461',
            
            id: 2461
          },
          {
            label: '南岗区',
            
            
            parentId: 136,
            code: '230103000000',
            value: '2462',
            
            id: 2462
          },
          {
            label: '道外区',
            
            
            parentId: 136,
            code: '230104000000',
            value: '2463',
            
            id: 2463
          },
          {
            label: '松北区',
            
            
            parentId: 136,
            code: '230109000000',
            value: '2464',
            
            id: 2464
          },
          {
            label: '香坊区',
            
            
            parentId: 136,
            code: '230110000000',
            value: '2465',
            
            id: 2465
          },
          {
            label: '平房区',
            
            
            parentId: 136,
            code: '230108000000',
            value: '2466',
            
            id: 2466
          },
          {
            label: '呼兰区',
            
            
            parentId: 136,
            code: '230111000000',
            value: '2467',
            
            id: 2467
          },
          {
            label: '依兰县',
            
            
            parentId: 136,
            code: '230123000000',
            value: '2468',
            
            id: 2468
          },
          {
            label: '方正县',
            
            
            parentId: 136,
            code: '230124000000',
            value: '2469',
            
            id: 2469
          },
          {
            label: '宾县',
            
            
            parentId: 136,
            code: '230125000000',
            value: '2470',
            
            id: 2470
          },
          {
            label: '巴彦县',
            
            
            parentId: 136,
            code: '230126000000',
            value: '2471',
            
            id: 2471
          },
          {
            label: '木兰县',
            
            
            parentId: 136,
            code: '230127000000',
            value: '2472',
            
            id: 2472
          },
          {
            label: '通河县',
            
            
            parentId: 136,
            code: '230128000000',
            value: '2473',
            
            id: 2473
          },
          {
            label: '延寿县',
            
            
            parentId: 136,
            code: '230129000000',
            value: '2474',
            
            id: 2474
          }
        ],
        id: 136
      },
      {
        label: '齐齐哈尔市',
        
        
        parentId: 12,
        code: '230200000000',
        value: '137',
        children: [
          {
            label: '龙江县',
            
            
            parentId: 137,
            code: '230221000000',
            value: '2475',
            
            id: 2475
          },
          {
            label: '依安县',
            
            
            parentId: 137,
            code: '230223000000',
            value: '2476',
            
            id: 2476
          },
          {
            label: '泰来县',
            
            
            parentId: 137,
            code: '230224000000',
            value: '2477',
            
            id: 2477
          },
          {
            label: '甘南县',
            
            
            parentId: 137,
            code: '230225000000',
            value: '2478',
            
            id: 2478
          },
          {
            label: '富裕县',
            
            
            parentId: 137,
            code: '230227000000',
            value: '2479',
            
            id: 2479
          },
          {
            label: '克山县',
            
            
            parentId: 137,
            code: '230229000000',
            value: '2480',
            
            id: 2480
          },
          {
            label: '克东县',
            
            
            parentId: 137,
            code: '230230000000',
            value: '2481',
            
            id: 2481
          },
          {
            label: '拜泉县',
            
            
            parentId: 137,
            code: '230231000000',
            value: '2482',
            
            id: 2482
          },
          {
            label: '龙沙区',
            
            
            parentId: 137,
            code: '230202000000',
            value: '2483',
            
            id: 2483
          },
          {
            label: '建华区',
            
            
            parentId: 137,
            code: '230203000000',
            value: '2484',
            
            id: 2484
          },
          {
            label: '铁锋区',
            
            
            parentId: 137,
            code: '230204000000',
            value: '2485',
            
            id: 2485
          },
          {
            label: '昂昂溪区',
            
            
            parentId: 137,
            code: '230205000000',
            value: '2486',
            
            id: 2486
          },
          {
            label: '富拉尔基区',
            
            
            parentId: 137,
            code: '230206000000',
            value: '2487',
            
            id: 2487
          },
          {
            label: '碾子山区',
            
            
            parentId: 137,
            code: '230207000000',
            value: '2488',
            
            id: 2488
          },
          {
            label: '梅里斯达斡尔族区',
            
            
            parentId: 137,
            code: '230208000000',
            value: '2489',
            
            id: 2489
          },
          {
            label: '讷河市',
            
            
            parentId: 137,
            code: '230281000000',
            value: '2490',
            
            id: 2490
          }
        ],
        id: 137
      },
      {
        label: '鸡西市',
        
        
        parentId: 12,
        code: '230300000000',
        value: '138',
        children: [
          {
            label: '虎林市',
            
            
            parentId: 138,
            code: '230381000000',
            value: '2491',
            
            id: 2491
          },
          {
            label: '密山市',
            
            
            parentId: 138,
            code: '230382000000',
            value: '2492',
            
            id: 2492
          },
          {
            label: '鸡冠区',
            
            
            parentId: 138,
            code: '230302000000',
            value: '2493',
            
            id: 2493
          },
          {
            label: '恒山区',
            
            
            parentId: 138,
            code: '230303000000',
            value: '2494',
            
            id: 2494
          },
          {
            label: '滴道区',
            
            
            parentId: 138,
            code: '230304000000',
            value: '2495',
            
            id: 2495
          },
          {
            label: '梨树区',
            
            
            parentId: 138,
            code: '230305000000',
            value: '2496',
            
            id: 2496
          },
          {
            label: '城子河区',
            
            
            parentId: 138,
            code: '230306000000',
            value: '2497',
            
            id: 2497
          },
          {
            label: '麻山区',
            
            
            parentId: 138,
            code: '230307000000',
            value: '2498',
            
            id: 2498
          },
          {
            label: '鸡东县',
            
            
            parentId: 138,
            code: '230321000000',
            value: '2499',
            
            id: 2499
          }
        ],
        id: 138
      },
      {
        label: '鹤岗市',
        
        
        parentId: 12,
        code: '230400000000',
        value: '139',
        children: [
          {
            label: '萝北县',
            
            
            parentId: 139,
            code: '230421000000',
            value: '2500',
            
            id: 2500
          },
          {
            label: '绥滨县',
            
            
            parentId: 139,
            code: '230422000000',
            value: '2501',
            
            id: 2501
          },
          {
            label: '向阳区',
            
            
            parentId: 139,
            code: '230402000000',
            value: '2502',
            
            id: 2502
          },
          {
            label: '工农区',
            
            
            parentId: 139,
            code: '230403000000',
            value: '2503',
            
            id: 2503
          },
          {
            label: '南山区',
            
            
            parentId: 139,
            code: '230404000000',
            value: '2504',
            
            id: 2504
          },
          {
            label: '兴安区',
            
            
            parentId: 139,
            code: '230405000000',
            value: '2505',
            
            id: 2505
          },
          {
            label: '东山区',
            
            
            parentId: 139,
            code: '230406000000',
            value: '2506',
            
            id: 2506
          },
          {
            label: '兴山区',
            
            
            parentId: 139,
            code: '230407000000',
            value: '2507',
            
            id: 2507
          }
        ],
        id: 139
      },
      {
        label: '双鸭山市',
        
        
        parentId: 12,
        code: '230500000000',
        value: '140',
        children: [
          {
            label: '尖山区',
            
            
            parentId: 140,
            code: '230502000000',
            value: '2508',
            
            id: 2508
          },
          {
            label: '岭东区',
            
            
            parentId: 140,
            code: '230503000000',
            value: '2509',
            
            id: 2509
          },
          {
            label: '四方台区',
            
            
            parentId: 140,
            code: '230505000000',
            value: '2510',
            
            id: 2510
          },
          {
            label: '宝山区',
            
            
            parentId: 140,
            code: '230506000000',
            value: '2511',
            
            id: 2511
          },
          {
            label: '集贤县',
            
            
            parentId: 140,
            code: '230521000000',
            value: '2512',
            
            id: 2512
          },
          {
            label: '友谊县',
            
            
            parentId: 140,
            code: '230522000000',
            value: '2513',
            
            id: 2513
          },
          {
            label: '宝清县',
            
            
            parentId: 140,
            code: '230523000000',
            value: '2514',
            
            id: 2514
          },
          {
            label: '饶河县',
            
            
            parentId: 140,
            code: '230524000000',
            value: '2515',
            
            id: 2515
          }
        ],
        id: 140
      },
      {
        label: '大庆市',
        
        
        parentId: 12,
        code: '230600000000',
        value: '141',
        children: [
          {
            label: '肇州县',
            
            
            parentId: 141,
            code: '230621000000',
            value: '2516',
            
            id: 2516
          },
          {
            label: '肇源县',
            
            
            parentId: 141,
            code: '230622000000',
            value: '2517',
            
            id: 2517
          },
          {
            label: '林甸县',
            
            
            parentId: 141,
            code: '230623000000',
            value: '2518',
            
            id: 2518
          },
          {
            label: '杜尔伯特蒙古族自治县',
            
            
            parentId: 141,
            code: '230624000000',
            value: '2519',
            
            id: 2519
          },
          {
            label: '萨尔图区',
            
            
            parentId: 141,
            code: '230602000000',
            value: '2520',
            
            id: 2520
          },
          {
            label: '龙凤区',
            
            
            parentId: 141,
            code: '230603000000',
            value: '2521',
            
            id: 2521
          },
          {
            label: '让胡路区',
            
            
            parentId: 141,
            code: '230604000000',
            value: '2522',
            
            id: 2522
          },
          {
            label: '红岗区',
            
            
            parentId: 141,
            code: '230605000000',
            value: '2523',
            
            id: 2523
          },
          {
            label: '大同区',
            
            
            parentId: 141,
            code: '230606000000',
            value: '2524',
            
            id: 2524
          }
        ],
        id: 141
      },
      {
        label: '伊春市',
        
        
        parentId: 12,
        code: '230700000000',
        value: '142',
        children: [
          {
            label: '伊春区',
            
            
            parentId: 142,
            code: '230702000000',
            value: '2525',
            
            id: 2525
          },
          {
            label: '南岔区',
            
            
            parentId: 142,
            code: '230703000000',
            value: '2526',
            
            id: 2526
          },
          {
            label: '友好区',
            
            
            parentId: 142,
            code: '230704000000',
            value: '2527',
            
            id: 2527
          },
          {
            label: '西林区',
            
            
            parentId: 142,
            code: '230705000000',
            value: '2528',
            
            id: 2528
          },
          {
            label: '翠峦区',
            
            
            parentId: 142,
            code: '230706000000',
            value: '2529',
            
            id: 2529
          },
          {
            label: '新青区',
            
            
            parentId: 142,
            code: '230707000000',
            value: '2530',
            
            id: 2530
          },
          {
            label: '美溪区',
            
            
            parentId: 142,
            code: '230708000000',
            value: '2531',
            
            id: 2531
          },
          {
            label: '金山屯区',
            
            
            parentId: 142,
            code: '230709000000',
            value: '2532',
            
            id: 2532
          },
          {
            label: '五营区',
            
            
            parentId: 142,
            code: '230710000000',
            value: '2533',
            
            id: 2533
          },
          {
            label: '乌马河区',
            
            
            parentId: 142,
            code: '230711000000',
            value: '2534',
            
            id: 2534
          },
          {
            label: '汤旺河区',
            
            
            parentId: 142,
            code: '230712000000',
            value: '2535',
            
            id: 2535
          },
          {
            label: '带岭区',
            
            
            parentId: 142,
            code: '230713000000',
            value: '2536',
            
            id: 2536
          },
          {
            label: '乌伊岭区',
            
            
            parentId: 142,
            code: '230714000000',
            value: '2537',
            
            id: 2537
          },
          {
            label: '红星区',
            
            
            parentId: 142,
            code: '230715000000',
            value: '2538',
            
            id: 2538
          },
          {
            label: '上甘岭区',
            
            
            parentId: 142,
            code: '230716000000',
            value: '2539',
            
            id: 2539
          },
          {
            label: '铁力市',
            
            
            parentId: 142,
            code: '230781000000',
            value: '2540',
            
            id: 2540
          },
          {
            label: '嘉荫县',
            
            
            parentId: 142,
            code: '230722000000',
            value: '2541',
            
            id: 2541
          }
        ],
        id: 142
      },
      {
        label: '佳木斯市',
        
        
        parentId: 12,
        code: '230800000000',
        value: '143',
        children: [
          {
            label: '桦南县',
            
            
            parentId: 143,
            code: '230822000000',
            value: '2542',
            
            id: 2542
          },
          {
            label: '桦川县',
            
            
            parentId: 143,
            code: '230826000000',
            value: '2543',
            
            id: 2543
          },
          {
            label: '汤原县',
            
            
            parentId: 143,
            code: '230828000000',
            value: '2544',
            
            id: 2544
          },
          {
            label: '抚远县',
            
            
            parentId: 143,
            code: '230833000000',
            value: '2545',
            
            id: 2545
          },
          {
            label: '同江市',
            
            
            parentId: 143,
            code: '230881000000',
            value: '2546',
            
            id: 2546
          },
          {
            label: '富锦市',
            
            
            parentId: 143,
            code: '230882000000',
            value: '2547',
            
            id: 2547
          },
          {
            label: '向阳区',
            
            
            parentId: 143,
            code: '230803000000',
            value: '2548',
            
            id: 2548
          },
          {
            label: '前进区',
            
            
            parentId: 143,
            code: '230804000000',
            value: '2549',
            
            id: 2549
          },
          {
            label: '东风区',
            
            
            parentId: 143,
            code: '230805000000',
            value: '2550',
            
            id: 2550
          },
          {
            label: '郊区',
            
            
            parentId: 143,
            code: '230811000000',
            value: '2551',
            
            id: 2551
          }
        ],
        id: 143
      },
      {
        label: '七台河市',
        
        
        parentId: 12,
        code: '230900000000',
        value: '144',
        children: [
          {
            label: '新兴区',
            
            
            parentId: 144,
            code: '230902000000',
            value: '2552',
            
            id: 2552
          },
          {
            label: '桃山区',
            
            
            parentId: 144,
            code: '230903000000',
            value: '2553',
            
            id: 2553
          },
          {
            label: '茄子河区',
            
            
            parentId: 144,
            code: '230904000000',
            value: '2554',
            
            id: 2554
          },
          {
            label: '勃利县',
            
            
            parentId: 144,
            code: '230921000000',
            value: '2555',
            
            id: 2555
          }
        ],
        id: 144
      },
      {
        label: '牡丹江市',
        
        
        parentId: 12,
        code: '231000000000',
        value: '145',
        children: [
          {
            label: '东宁县',
            
            
            parentId: 145,
            code: '231024000000',
            value: '2556',
            
            id: 2556
          },
          {
            label: '林口县',
            
            
            parentId: 145,
            code: '231025000000',
            value: '2557',
            
            id: 2557
          },
          {
            label: '东安区',
            
            
            parentId: 145,
            code: '231002000000',
            value: '2558',
            
            id: 2558
          },
          {
            label: '阳明区',
            
            
            parentId: 145,
            code: '231003000000',
            value: '2559',
            
            id: 2559
          },
          {
            label: '爱民区',
            
            
            parentId: 145,
            code: '231004000000',
            value: '2560',
            
            id: 2560
          },
          {
            label: '西安区',
            
            
            parentId: 145,
            code: '231005000000',
            value: '2561',
            
            id: 2561
          },
          {
            label: '绥芬河市',
            
            
            parentId: 145,
            code: '231081000000',
            value: '2562',
            
            id: 2562
          },
          {
            label: '海林市',
            
            
            parentId: 145,
            code: '231083000000',
            value: '2563',
            
            id: 2563
          },
          {
            label: '宁安市',
            
            
            parentId: 145,
            code: '231084000000',
            value: '2564',
            
            id: 2564
          },
          {
            label: '穆棱市',
            
            
            parentId: 145,
            code: '231085000000',
            value: '2565',
            
            id: 2565
          }
        ],
        id: 145
      },
      {
        label: '黑河市',
        
        
        parentId: 12,
        code: '231100000000',
        value: '146',
        children: [
          {
            label: '北安市',
            
            
            parentId: 146,
            code: '231181000000',
            value: '2566',
            
            id: 2566
          },
          {
            label: '五大连池市',
            
            
            parentId: 146,
            code: '231182000000',
            value: '2567',
            
            id: 2567
          },
          {
            label: '爱辉区',
            
            
            parentId: 146,
            code: '231102000000',
            value: '2568',
            
            id: 2568
          },
          {
            label: '嫩江县',
            
            
            parentId: 146,
            code: '231121000000',
            value: '2569',
            
            id: 2569
          },
          {
            label: '逊克县',
            
            
            parentId: 146,
            code: '231123000000',
            value: '2570',
            
            id: 2570
          },
          {
            label: '孙吴县',
            
            
            parentId: 146,
            code: '231124000000',
            value: '2571',
            
            id: 2571
          }
        ],
        id: 146
      },
      {
        label: '绥化市',
        
        
        parentId: 12,
        code: '231200000000',
        value: '147',
        children: [
          {
            label: '望奎县',
            
            
            parentId: 147,
            code: '231221000000',
            value: '2572',
            
            id: 2572
          },
          {
            label: '兰西县',
            
            
            parentId: 147,
            code: '231222000000',
            value: '2573',
            
            id: 2573
          },
          {
            label: '青冈县',
            
            
            parentId: 147,
            code: '231223000000',
            value: '2574',
            
            id: 2574
          },
          {
            label: '庆安县',
            
            
            parentId: 147,
            code: '231224000000',
            value: '2575',
            
            id: 2575
          },
          {
            label: '明水县',
            
            
            parentId: 147,
            code: '231225000000',
            value: '2576',
            
            id: 2576
          },
          {
            label: '绥棱县',
            
            
            parentId: 147,
            code: '231226000000',
            value: '2577',
            
            id: 2577
          },
          {
            label: '安达市',
            
            
            parentId: 147,
            code: '231281000000',
            value: '2578',
            
            id: 2578
          },
          {
            label: '肇东市',
            
            
            parentId: 147,
            code: '231282000000',
            value: '2579',
            
            id: 2579
          },
          {
            label: '海伦市',
            
            
            parentId: 147,
            code: '231283000000',
            value: '2580',
            
            id: 2580
          },
          {
            label: '北林区',
            
            
            parentId: 147,
            code: '231202000000',
            value: '2581',
            
            id: 2581
          }
        ],
        id: 147
      },
      {
        label: '大兴安岭地区',
        
        
        parentId: 12,
        code: '232700000000',
        value: '148',
        children: [
          {
            label: '呼玛县',
            
            
            parentId: 148,
            code: '232721000000',
            value: '1063',
            
            id: 1063
          },
          {
            label: '塔河县',
            
            
            parentId: 148,
            code: '232722000000',
            value: '1064',
            
            id: 1064
          },
          {
            label: '漠河县',
            
            
            parentId: 148,
            code: '232723000000',
            value: '1065',
            
            id: 1065
          }
        ],
        id: 148
      }
    ],
    id: 12
  },
  {
    label: '湖北省',
    
    
    parentId: 1,
    code: '420000000000',
    value: '13',
    children: [
      {
        label: '武汉市',
        
        
        parentId: 13,
        code: '420100000000',
        value: '149',
        children: [
          {
            label: '江岸区',
            
            
            parentId: 149,
            code: '420102000000',
            value: '2084',
            
            id: 2084
          },
          {
            label: '江汉区',
            
            
            parentId: 149,
            code: '420103000000',
            value: '2085',
            
            id: 2085
          },
          {
            label: '硚口区',
            
            
            parentId: 149,
            code: '420104000000',
            value: '2086',
            
            id: 2086
          },
          {
            label: '汉阳区',
            
            
            parentId: 149,
            code: '420105000000',
            value: '2087',
            
            id: 2087
          },
          {
            label: '武昌区',
            
            
            parentId: 149,
            code: '420106000000',
            value: '2088',
            
            id: 2088
          },
          {
            label: '青山区',
            
            
            parentId: 149,
            code: '420107000000',
            value: '2089',
            
            id: 2089
          },
          {
            label: '洪山区',
            
            
            parentId: 149,
            code: '420111000000',
            value: '2090',
            
            id: 2090
          },
          {
            label: '东西湖区',
            
            
            parentId: 149,
            code: '420112000000',
            value: '2091',
            
            id: 2091
          },
          {
            label: '汉南区',
            
            
            parentId: 149,
            code: '420113000000',
            value: '2092',
            
            id: 2092
          },
          {
            label: '蔡甸区',
            
            
            parentId: 149,
            code: '420114000000',
            value: '2093',
            
            id: 2093
          },
          {
            label: '江夏区',
            
            
            parentId: 149,
            code: '420115000000',
            value: '2094',
            
            id: 2094
          },
          {
            label: '黄陂区',
            
            
            parentId: 149,
            code: '420116000000',
            value: '2095',
            
            id: 2095
          },
          {
            label: '新洲区',
            
            
            parentId: 149,
            code: '420117000000',
            value: '2096',
            
            id: 2096
          }
        ],
        id: 149
      },
      {
        label: '黄石市',
        
        
        parentId: 13,
        code: '420200000000',
        value: '150',
        children: [
          {
            label: '黄石港区',
            
            
            parentId: 150,
            code: '420202000000',
            value: '2097',
            
            id: 2097
          },
          {
            label: '西塞山区',
            
            
            parentId: 150,
            code: '420203000000',
            value: '2098',
            
            id: 2098
          },
          {
            label: '下陆区',
            
            
            parentId: 150,
            code: '420204000000',
            value: '2099',
            
            id: 2099
          },
          {
            label: '铁山区',
            
            
            parentId: 150,
            code: '420205000000',
            value: '2100',
            
            id: 2100
          },
          {
            label: '大冶市',
            
            
            parentId: 150,
            code: '420281000000',
            value: '2101',
            
            id: 2101
          },
          {
            label: '阳新县',
            
            
            parentId: 150,
            code: '420222000000',
            value: '2102',
            
            id: 2102
          }
        ],
        id: 150
      },
      {
        label: '十堰市',
        
        
        parentId: 13,
        code: '420300000000',
        value: '151',
        children: [
          {
            label: '郧阳区',
            
            
            parentId: 151,
            code: '420304000000',
            value: '2103',
            
            id: 2103
          },
          {
            label: '郧西县',
            
            
            parentId: 151,
            code: '420322000000',
            value: '2104',
            
            id: 2104
          },
          {
            label: '竹山县',
            
            
            parentId: 151,
            code: '420323000000',
            value: '2105',
            
            id: 2105
          },
          {
            label: '竹溪县',
            
            
            parentId: 151,
            code: '420324000000',
            value: '2106',
            
            id: 2106
          },
          {
            label: '房县',
            
            
            parentId: 151,
            code: '420325000000',
            value: '2107',
            
            id: 2107
          },
          {
            label: '丹江口市',
            
            
            parentId: 151,
            code: '420381000000',
            value: '2108',
            
            id: 2108
          },
          {
            label: '茅箭区',
            
            
            parentId: 151,
            code: '420302000000',
            value: '2109',
            
            id: 2109
          },
          {
            label: '张湾区',
            
            
            parentId: 151,
            code: '420303000000',
            value: '2110',
            
            id: 2110
          }
        ],
        id: 151
      },
      {
        label: '宜昌市',
        
        
        parentId: 13,
        code: '420500000000',
        value: '152',
        children: [
          {
            label: '西陵区',
            
            
            parentId: 152,
            code: '420502000000',
            value: '2111',
            
            id: 2111
          },
          {
            label: '伍家岗区',
            
            
            parentId: 152,
            code: '420503000000',
            value: '2112',
            
            id: 2112
          },
          {
            label: '点军区',
            
            
            parentId: 152,
            code: '420504000000',
            value: '2113',
            
            id: 2113
          },
          {
            label: '猇亭区',
            
            
            parentId: 152,
            code: '420505000000',
            value: '2114',
            
            id: 2114
          },
          {
            label: '夷陵区',
            
            
            parentId: 152,
            code: '420506000000',
            value: '2115',
            
            id: 2115
          },
          {
            label: '宜都市',
            
            
            parentId: 152,
            code: '420581000000',
            value: '2116',
            
            id: 2116
          },
          {
            label: '当阳市',
            
            
            parentId: 152,
            code: '420582000000',
            value: '2117',
            
            id: 2117
          },
          {
            label: '枝江市',
            
            
            parentId: 152,
            code: '420583000000',
            value: '2118',
            
            id: 2118
          },
          {
            label: '远安县',
            
            
            parentId: 152,
            code: '420525000000',
            value: '2119',
            
            id: 2119
          },
          {
            label: '兴山县',
            
            
            parentId: 152,
            code: '420526000000',
            value: '2120',
            
            id: 2120
          },
          {
            label: '秭归县',
            
            
            parentId: 152,
            code: '420527000000',
            value: '2121',
            
            id: 2121
          },
          {
            label: '长阳土家族自治县',
            
            
            parentId: 152,
            code: '420528000000',
            value: '2122',
            
            id: 2122
          },
          {
            label: '五峰土家族自治县',
            
            
            parentId: 152,
            code: '420529000000',
            value: '2123',
            
            id: 2123
          }
        ],
        id: 152
      },
      {
        label: '襄阳市',
        
        
        parentId: 13,
        code: '420600000000',
        value: '153',
        children: [
          {
            label: '南漳县',
            
            
            parentId: 153,
            code: '420624000000',
            value: '2124',
            
            id: 2124
          },
          {
            label: '谷城县',
            
            
            parentId: 153,
            code: '420625000000',
            value: '2125',
            
            id: 2125
          },
          {
            label: '保康县',
            
            
            parentId: 153,
            code: '420626000000',
            value: '2126',
            
            id: 2126
          },
          {
            label: '老河口市',
            
            
            parentId: 153,
            code: '420682000000',
            value: '2127',
            
            id: 2127
          },
          {
            label: '枣阳市',
            
            
            parentId: 153,
            code: '420683000000',
            value: '2128',
            
            id: 2128
          },
          {
            label: '宜城市',
            
            
            parentId: 153,
            code: '420684000000',
            value: '2129',
            
            id: 2129
          },
          {
            label: '襄州区',
            
            
            parentId: 153,
            code: '420607000000',
            value: '2130',
            
            id: 2130
          },
          {
            label: '襄城区',
            
            
            parentId: 153,
            code: '420602000000',
            value: '2131',
            
            id: 2131
          },
          {
            label: '樊城区',
            
            
            parentId: 153,
            code: '420606000000',
            value: '2132',
            
            id: 2132
          }
        ],
        id: 153
      },
      {
        label: '鄂州市',
        
        
        parentId: 13,
        code: '420700000000',
        value: '154',
        children: [
          {
            label: '梁子湖区',
            
            
            parentId: 154,
            code: '420702000000',
            value: '2133',
            
            id: 2133
          },
          {
            label: '华容区',
            
            
            parentId: 154,
            code: '420703000000',
            value: '2134',
            
            id: 2134
          },
          {
            label: '鄂城区',
            
            
            parentId: 154,
            code: '420704000000',
            value: '2135',
            
            id: 2135
          }
        ],
        id: 154
      },
      {
        label: '荆门市',
        
        
        parentId: 13,
        code: '420800000000',
        value: '155',
        children: [
          {
            label: '京山县',
            
            
            parentId: 155,
            code: '420821000000',
            value: '2136',
            
            id: 2136
          },
          {
            label: '沙洋县',
            
            
            parentId: 155,
            code: '420822000000',
            value: '2137',
            
            id: 2137
          },
          {
            label: '钟祥市',
            
            
            parentId: 155,
            code: '420881000000',
            value: '2138',
            
            id: 2138
          },
          {
            label: '东宝区',
            
            
            parentId: 155,
            code: '420802000000',
            value: '2139',
            
            id: 2139
          },
          {
            label: '掇刀区',
            
            
            parentId: 155,
            code: '420804000000',
            value: '2140',
            
            id: 2140
          }
        ],
        id: 155
      },
      {
        label: '孝感市',
        
        
        parentId: 13,
        code: '420900000000',
        value: '156',
        children: [
          {
            label: '孝南区',
            
            
            parentId: 156,
            code: '420902000000',
            value: '2141',
            
            id: 2141
          },
          {
            label: '孝昌县',
            
            
            parentId: 156,
            code: '420921000000',
            value: '2142',
            
            id: 2142
          },
          {
            label: '大悟县',
            
            
            parentId: 156,
            code: '420922000000',
            value: '2143',
            
            id: 2143
          },
          {
            label: '云梦县',
            
            
            parentId: 156,
            code: '420923000000',
            value: '2144',
            
            id: 2144
          },
          {
            label: '应城市',
            
            
            parentId: 156,
            code: '420981000000',
            value: '2145',
            
            id: 2145
          },
          {
            label: '安陆市',
            
            
            parentId: 156,
            code: '420982000000',
            value: '2146',
            
            id: 2146
          },
          {
            label: '汉川市',
            
            
            parentId: 156,
            code: '420984000000',
            value: '2147',
            
            id: 2147
          }
        ],
        id: 156
      },
      {
        label: '荆州市',
        
        
        parentId: 13,
        code: '421000000000',
        value: '157',
        children: [
          {
            label: '石首市',
            
            
            parentId: 157,
            code: '421081000000',
            value: '2148',
            
            id: 2148
          },
          {
            label: '洪湖市',
            
            
            parentId: 157,
            code: '421083000000',
            value: '2149',
            
            id: 2149
          },
          {
            label: '松滋市',
            
            
            parentId: 157,
            code: '421087000000',
            value: '2150',
            
            id: 2150
          },
          {
            label: '公安县',
            
            
            parentId: 157,
            code: '421022000000',
            value: '2151',
            
            id: 2151
          },
          {
            label: '监利县',
            
            
            parentId: 157,
            code: '421023000000',
            value: '2152',
            
            id: 2152
          },
          {
            label: '江陵县',
            
            
            parentId: 157,
            code: '421024000000',
            value: '2153',
            
            id: 2153
          },
          {
            label: '沙市区',
            
            
            parentId: 157,
            code: '421002000000',
            value: '2154',
            
            id: 2154
          },
          {
            label: '荆州区',
            
            
            parentId: 157,
            code: '421003000000',
            value: '2155',
            
            id: 2155
          }
        ],
        id: 157
      },
      {
        label: '黄冈市',
        
        
        parentId: 13,
        code: '421100000000',
        value: '158',
        children: [
          {
            label: '黄州区',
            
            
            parentId: 158,
            code: '421102000000',
            value: '2156',
            
            id: 2156
          },
          {
            label: '团风县',
            
            
            parentId: 158,
            code: '421121000000',
            value: '2157',
            
            id: 2157
          },
          {
            label: '红安县',
            
            
            parentId: 158,
            code: '421122000000',
            value: '2158',
            
            id: 2158
          },
          {
            label: '罗田县',
            
            
            parentId: 158,
            code: '421123000000',
            value: '2159',
            
            id: 2159
          },
          {
            label: '英山县',
            
            
            parentId: 158,
            code: '421124000000',
            value: '2160',
            
            id: 2160
          },
          {
            label: '浠水县',
            
            
            parentId: 158,
            code: '421125000000',
            value: '2161',
            
            id: 2161
          },
          {
            label: '蕲春县',
            
            
            parentId: 158,
            code: '421126000000',
            value: '2162',
            
            id: 2162
          },
          {
            label: '黄梅县',
            
            
            parentId: 158,
            code: '421127000000',
            value: '2163',
            
            id: 2163
          },
          {
            label: '麻城市',
            
            
            parentId: 158,
            code: '421181000000',
            value: '2164',
            
            id: 2164
          },
          {
            label: '武穴市',
            
            
            parentId: 158,
            code: '421182000000',
            value: '2165',
            
            id: 2165
          }
        ],
        id: 158
      },
      {
        label: '咸宁市',
        
        
        parentId: 13,
        code: '421200000000',
        value: '159',
        children: [
          {
            label: '嘉鱼县',
            
            
            parentId: 159,
            code: '421221000000',
            value: '2166',
            
            id: 2166
          },
          {
            label: '通城县',
            
            
            parentId: 159,
            code: '421222000000',
            value: '2167',
            
            id: 2167
          },
          {
            label: '崇阳县',
            
            
            parentId: 159,
            code: '421223000000',
            value: '2168',
            
            id: 2168
          },
          {
            label: '通山县',
            
            
            parentId: 159,
            code: '421224000000',
            value: '2169',
            
            id: 2169
          },
          {
            label: '赤壁市',
            
            
            parentId: 159,
            code: '421281000000',
            value: '2170',
            
            id: 2170
          },
          {
            label: '咸安区',
            
            
            parentId: 159,
            code: '421202000000',
            value: '2171',
            
            id: 2171
          }
        ],
        id: 159
      },
      {
        label: '随州市',
        
        
        parentId: 13,
        code: '421300000000',
        value: '160',
        children: [
          {
            label: '曾都区',
            
            
            parentId: 160,
            code: '421303000000',
            value: '2172',
            
            id: 2172
          },
          {
            label: '广水市',
            
            
            parentId: 160,
            code: '421381000000',
            value: '2173',
            
            id: 2173
          },
          {
            label: '随县',
            
            
            parentId: 160,
            code: '421321000000',
            value: '2174',
            
            id: 2174
          }
        ],
        id: 160
      },
      {
        label: '省直辖县级行政区划',
        
        
        parentId: 13,
        code: '429000000000',
        value: '161',
        children: [
          {
            label: '潜江市',
            
            
            parentId: 161,
            code: '429005000000',
            value: '3206',
            
            id: 3206
          },
          {
            label: '神农架林区',
            
            
            parentId: 161,
            code: '429021000000',
            value: '3207',
            
            id: 3207
          },
          {
            label: '天门市',
            
            
            parentId: 161,
            code: '429006000000',
            value: '3208',
            
            id: 3208
          },
          {
            label: '仙桃市',
            
            
            parentId: 161,
            code: '429004000000',
            value: '3209',
            
            id: 3209
          }
        ],
        id: 161
      },
      {
        label: '恩施土家族苗族自治州',
        
        
        parentId: 13,
        code: '422800000000',
        value: '162',
        children: [
          {
            label: '恩施市',
            
            
            parentId: 162,
            code: '422801000000',
            value: '1307',
            
            id: 1307
          },
          {
            label: '利川市',
            
            
            parentId: 162,
            code: '422802000000',
            value: '1308',
            
            id: 1308
          },
          {
            label: '建始县',
            
            
            parentId: 162,
            code: '422822000000',
            value: '1309',
            
            id: 1309
          },
          {
            label: '巴东县',
            
            
            parentId: 162,
            code: '422823000000',
            value: '1310',
            
            id: 1310
          },
          {
            label: '宣恩县',
            
            
            parentId: 162,
            code: '422825000000',
            value: '1311',
            
            id: 1311
          },
          {
            label: '咸丰县',
            
            
            parentId: 162,
            code: '422826000000',
            value: '1312',
            
            id: 1312
          },
          {
            label: '来凤县',
            
            
            parentId: 162,
            code: '422827000000',
            value: '1313',
            
            id: 1313
          },
          {
            label: '鹤峰县',
            
            
            parentId: 162,
            code: '422828000000',
            value: '1314',
            
            id: 1314
          }
        ],
        id: 162
      }
    ],
    id: 13
  },
  {
    label: '湖南省',
    
    
    parentId: 1,
    code: '430000000000',
    value: '14',
    children: [
      {
        label: '湘西土家族苗族自治州',
        
        
        parentId: 14,
        code: '433100000000',
        value: '163',
        children: [
          {
            label: '吉首市',
            
            
            parentId: 163,
            code: '433101000000',
            value: '1074',
            
            id: 1074
          },
          {
            label: '泸溪县',
            
            
            parentId: 163,
            code: '433122000000',
            value: '1075',
            
            id: 1075
          },
          {
            label: '凤凰县',
            
            
            parentId: 163,
            code: '433123000000',
            value: '1076',
            
            id: 1076
          },
          {
            label: '花垣县',
            
            
            parentId: 163,
            code: '433124000000',
            value: '1077',
            
            id: 1077
          },
          {
            label: '保靖县',
            
            
            parentId: 163,
            code: '433125000000',
            value: '1078',
            
            id: 1078
          },
          {
            label: '古丈县',
            
            
            parentId: 163,
            code: '433126000000',
            value: '1079',
            
            id: 1079
          },
          {
            label: '永顺县',
            
            
            parentId: 163,
            code: '433127000000',
            value: '1080',
            
            id: 1080
          },
          {
            label: '龙山县',
            
            
            parentId: 163,
            code: '433130000000',
            value: '1081',
            
            id: 1081
          }
        ],
        id: 163
      },
      {
        label: '长沙市',
        
        
        parentId: 14,
        code: '430100000000',
        value: '164',
        children: [
          {
            label: '长沙县',
            
            
            parentId: 164,
            code: '430121000000',
            value: '2582',
            
            id: 2582
          },
          {
            label: '望城区',
            
            
            parentId: 164,
            code: '430112000000',
            value: '2583',
            
            id: 2583
          },
          {
            label: '宁乡县',
            
            
            parentId: 164,
            code: '430124000000',
            value: '2584',
            
            id: 2584
          },
          {
            label: '浏阳市',
            
            
            parentId: 164,
            code: '430181000000',
            value: '2585',
            
            id: 2585
          },
          {
            label: '芙蓉区',
            
            
            parentId: 164,
            code: '430102000000',
            value: '2586',
            
            id: 2586
          },
          {
            label: '天心区',
            
            
            parentId: 164,
            code: '430103000000',
            value: '2587',
            
            id: 2587
          },
          {
            label: '岳麓区',
            
            
            parentId: 164,
            code: '430104000000',
            value: '2588',
            
            id: 2588
          },
          {
            label: '开福区',
            
            
            parentId: 164,
            code: '430105000000',
            value: '2589',
            
            id: 2589
          },
          {
            label: '雨花区',
            
            
            parentId: 164,
            code: '430111000000',
            value: '2590',
            
            id: 2590
          }
        ],
        id: 164
      },
      {
        label: '株洲市',
        
        
        parentId: 14,
        code: '430200000000',
        value: '165',
        children: [
          {
            label: '荷塘区',
            
            
            parentId: 165,
            code: '430202000000',
            value: '2591',
            
            id: 2591
          },
          {
            label: '芦淞区',
            
            
            parentId: 165,
            code: '430203000000',
            value: '2592',
            
            id: 2592
          },
          {
            label: '石峰区',
            
            
            parentId: 165,
            code: '430204000000',
            value: '2593',
            
            id: 2593
          },
          {
            label: '天元区',
            
            
            parentId: 165,
            code: '430211000000',
            value: '2594',
            
            id: 2594
          },
          {
            label: '醴陵市',
            
            
            parentId: 165,
            code: '430281000000',
            value: '2595',
            
            id: 2595
          },
          {
            label: '株洲县',
            
            
            parentId: 165,
            code: '430221000000',
            value: '2596',
            
            id: 2596
          },
          {
            label: '攸县',
            
            
            parentId: 165,
            code: '430223000000',
            value: '2597',
            
            id: 2597
          },
          {
            label: '茶陵县',
            
            
            parentId: 165,
            code: '430224000000',
            value: '2598',
            
            id: 2598
          },
          {
            label: '炎陵县',
            
            
            parentId: 165,
            code: '430225000000',
            value: '2599',
            
            id: 2599
          }
        ],
        id: 165
      },
      {
        label: '湘潭市',
        
        
        parentId: 14,
        code: '430300000000',
        value: '166',
        children: [
          {
            label: '湘潭县',
            
            
            parentId: 166,
            code: '430321000000',
            value: '2600',
            
            id: 2600
          },
          {
            label: '湘乡市',
            
            
            parentId: 166,
            code: '430381000000',
            value: '2601',
            
            id: 2601
          },
          {
            label: '韶山市',
            
            
            parentId: 166,
            code: '430382000000',
            value: '2602',
            
            id: 2602
          },
          {
            label: '雨湖区',
            
            
            parentId: 166,
            code: '430302000000',
            value: '2603',
            
            id: 2603
          },
          {
            label: '岳塘区',
            
            
            parentId: 166,
            code: '430304000000',
            value: '2604',
            
            id: 2604
          }
        ],
        id: 166
      },
      {
        label: '衡阳市',
        
        
        parentId: 14,
        code: '430400000000',
        value: '167',
        children: [
          {
            label: '耒阳市',
            
            
            parentId: 167,
            code: '430481000000',
            value: '2605',
            
            id: 2605
          },
          {
            label: '常宁市',
            
            
            parentId: 167,
            code: '430482000000',
            value: '2606',
            
            id: 2606
          },
          {
            label: '衡阳县',
            
            
            parentId: 167,
            code: '430421000000',
            value: '2607',
            
            id: 2607
          },
          {
            label: '衡南县',
            
            
            parentId: 167,
            code: '430422000000',
            value: '2608',
            
            id: 2608
          },
          {
            label: '衡山县',
            
            
            parentId: 167,
            code: '430423000000',
            value: '2609',
            
            id: 2609
          },
          {
            label: '衡东县',
            
            
            parentId: 167,
            code: '430424000000',
            value: '2610',
            
            id: 2610
          },
          {
            label: '祁东县',
            
            
            parentId: 167,
            code: '430426000000',
            value: '2611',
            
            id: 2611
          },
          {
            label: '珠晖区',
            
            
            parentId: 167,
            code: '430405000000',
            value: '2612',
            
            id: 2612
          },
          {
            label: '雁峰区',
            
            
            parentId: 167,
            code: '430406000000',
            value: '2613',
            
            id: 2613
          },
          {
            label: '石鼓区',
            
            
            parentId: 167,
            code: '430407000000',
            value: '2614',
            
            id: 2614
          },
          {
            label: '蒸湘区',
            
            
            parentId: 167,
            code: '430408000000',
            value: '2615',
            
            id: 2615
          },
          {
            label: '南岳区',
            
            
            parentId: 167,
            code: '430412000000',
            value: '2616',
            
            id: 2616
          }
        ],
        id: 167
      },
      {
        label: '邵阳市',
        
        
        parentId: 14,
        code: '430500000000',
        value: '168',
        children: [
          {
            label: '双清区',
            
            
            parentId: 168,
            code: '430502000000',
            value: '2617',
            
            id: 2617
          },
          {
            label: '大祥区',
            
            
            parentId: 168,
            code: '430503000000',
            value: '2618',
            
            id: 2618
          },
          {
            label: '北塔区',
            
            
            parentId: 168,
            code: '430511000000',
            value: '2619',
            
            id: 2619
          },
          {
            label: '邵东县',
            
            
            parentId: 168,
            code: '430521000000',
            value: '2620',
            
            id: 2620
          },
          {
            label: '新邵县',
            
            
            parentId: 168,
            code: '430522000000',
            value: '2621',
            
            id: 2621
          },
          {
            label: '邵阳县',
            
            
            parentId: 168,
            code: '430523000000',
            value: '2622',
            
            id: 2622
          },
          {
            label: '隆回县',
            
            
            parentId: 168,
            code: '430524000000',
            value: '2623',
            
            id: 2623
          },
          {
            label: '洞口县',
            
            
            parentId: 168,
            code: '430525000000',
            value: '2624',
            
            id: 2624
          },
          {
            label: '绥宁县',
            
            
            parentId: 168,
            code: '430527000000',
            value: '2625',
            
            id: 2625
          },
          {
            label: '新宁县',
            
            
            parentId: 168,
            code: '430528000000',
            value: '2626',
            
            id: 2626
          },
          {
            label: '武冈市',
            
            
            parentId: 168,
            code: '430581000000',
            value: '2627',
            
            id: 2627
          },
          {
            label: '城步苗族自治县',
            
            
            parentId: 168,
            code: '430529000000',
            value: '2628',
            
            id: 2628
          }
        ],
        id: 168
      },
      {
        label: '岳阳市',
        
        
        parentId: 14,
        code: '430600000000',
        value: '169',
        children: [
          {
            label: '汨罗市',
            
            
            parentId: 169,
            code: '430681000000',
            value: '2629',
            
            id: 2629
          },
          {
            label: '临湘市',
            
            
            parentId: 169,
            code: '430682000000',
            value: '2630',
            
            id: 2630
          },
          {
            label: '岳阳县',
            
            
            parentId: 169,
            code: '430621000000',
            value: '2631',
            
            id: 2631
          },
          {
            label: '华容县',
            
            
            parentId: 169,
            code: '430623000000',
            value: '2632',
            
            id: 2632
          },
          {
            label: '湘阴县',
            
            
            parentId: 169,
            code: '430624000000',
            value: '2633',
            
            id: 2633
          },
          {
            label: '平江县',
            
            
            parentId: 169,
            code: '430626000000',
            value: '2634',
            
            id: 2634
          },
          {
            label: '岳阳楼区',
            
            
            parentId: 169,
            code: '430602000000',
            value: '2635',
            
            id: 2635
          },
          {
            label: '云溪区',
            
            
            parentId: 169,
            code: '430603000000',
            value: '2636',
            
            id: 2636
          },
          {
            label: '君山区',
            
            
            parentId: 169,
            code: '430611000000',
            value: '2637',
            
            id: 2637
          }
        ],
        id: 169
      },
      {
        label: '常德市',
        
        
        parentId: 14,
        code: '430700000000',
        value: '170',
        children: [
          {
            label: '安乡县',
            
            
            parentId: 170,
            code: '430721000000',
            value: '2638',
            
            id: 2638
          },
          {
            label: '汉寿县',
            
            
            parentId: 170,
            code: '430722000000',
            value: '2639',
            
            id: 2639
          },
          {
            label: '澧县',
            
            
            parentId: 170,
            code: '430723000000',
            value: '2640',
            
            id: 2640
          },
          {
            label: '临澧县',
            
            
            parentId: 170,
            code: '430724000000',
            value: '2641',
            
            id: 2641
          },
          {
            label: '桃源县',
            
            
            parentId: 170,
            code: '430725000000',
            value: '2642',
            
            id: 2642
          },
          {
            label: '石门县',
            
            
            parentId: 170,
            code: '430726000000',
            value: '2643',
            
            id: 2643
          },
          {
            label: '津市市',
            
            
            parentId: 170,
            code: '430781000000',
            value: '2644',
            
            id: 2644
          },
          {
            label: '武陵区',
            
            
            parentId: 170,
            code: '430702000000',
            value: '2645',
            
            id: 2645
          },
          {
            label: '鼎城区',
            
            
            parentId: 170,
            code: '430703000000',
            value: '2646',
            
            id: 2646
          }
        ],
        id: 170
      },
      {
        label: '张家界市',
        
        
        parentId: 14,
        code: '430800000000',
        value: '171',
        children: [
          {
            label: '永定区',
            
            
            parentId: 171,
            code: '430802000000',
            value: '2647',
            
            id: 2647
          },
          {
            label: '武陵源区',
            
            
            parentId: 171,
            code: '430811000000',
            value: '2648',
            
            id: 2648
          },
          {
            label: '慈利县',
            
            
            parentId: 171,
            code: '430821000000',
            value: '2649',
            
            id: 2649
          },
          {
            label: '桑植县',
            
            
            parentId: 171,
            code: '430822000000',
            value: '2650',
            
            id: 2650
          }
        ],
        id: 171
      },
      {
        label: '益阳市',
        
        
        parentId: 14,
        code: '430900000000',
        value: '172',
        children: [
          {
            label: '南县',
            
            
            parentId: 172,
            code: '430921000000',
            value: '2651',
            
            id: 2651
          },
          {
            label: '桃江县',
            
            
            parentId: 172,
            code: '430922000000',
            value: '2652',
            
            id: 2652
          },
          {
            label: '安化县',
            
            
            parentId: 172,
            code: '430923000000',
            value: '2653',
            
            id: 2653
          },
          {
            label: '资阳区',
            
            
            parentId: 172,
            code: '430902000000',
            value: '2654',
            
            id: 2654
          },
          {
            label: '赫山区',
            
            
            parentId: 172,
            code: '430903000000',
            value: '2655',
            
            id: 2655
          },
          {
            label: '沅江市',
            
            
            parentId: 172,
            code: '430981000000',
            value: '2656',
            
            id: 2656
          }
        ],
        id: 172
      },
      {
        label: '郴州市',
        
        
        parentId: 14,
        code: '431000000000',
        value: '173',
        children: [
          {
            label: '资兴市',
            
            
            parentId: 173,
            code: '431081000000',
            value: '2657',
            
            id: 2657
          },
          {
            label: '北湖区',
            
            
            parentId: 173,
            code: '431002000000',
            value: '2658',
            
            id: 2658
          },
          {
            label: '苏仙区',
            
            
            parentId: 173,
            code: '431003000000',
            value: '2659',
            
            id: 2659
          },
          {
            label: '桂阳县',
            
            
            parentId: 173,
            code: '431021000000',
            value: '2660',
            
            id: 2660
          },
          {
            label: '宜章县',
            
            
            parentId: 173,
            code: '431022000000',
            value: '2661',
            
            id: 2661
          },
          {
            label: '永兴县',
            
            
            parentId: 173,
            code: '431023000000',
            value: '2662',
            
            id: 2662
          },
          {
            label: '嘉禾县',
            
            
            parentId: 173,
            code: '431024000000',
            value: '2663',
            
            id: 2663
          },
          {
            label: '临武县',
            
            
            parentId: 173,
            code: '431025000000',
            value: '2664',
            
            id: 2664
          },
          {
            label: '汝城县',
            
            
            parentId: 173,
            code: '431026000000',
            value: '2665',
            
            id: 2665
          },
          {
            label: '桂东县',
            
            
            parentId: 173,
            code: '431027000000',
            value: '2666',
            
            id: 2666
          },
          {
            label: '安仁县',
            
            
            parentId: 173,
            code: '431028000000',
            value: '2667',
            
            id: 2667
          }
        ],
        id: 173
      },
      {
        label: '永州市',
        
        
        parentId: 14,
        code: '431100000000',
        value: '174',
        children: [
          {
            label: '祁阳县',
            
            
            parentId: 174,
            code: '431121000000',
            value: '2668',
            
            id: 2668
          },
          {
            label: '零陵区',
            
            
            parentId: 174,
            code: '431102000000',
            value: '2669',
            
            id: 2669
          },
          {
            label: '冷水滩区',
            
            
            parentId: 174,
            code: '431103000000',
            value: '2670',
            
            id: 2670
          },
          {
            label: '江华瑶族自治县',
            
            
            parentId: 174,
            code: '431129000000',
            value: '2671',
            
            id: 2671
          },
          {
            label: '东安县',
            
            
            parentId: 174,
            code: '431122000000',
            value: '2672',
            
            id: 2672
          },
          {
            label: '双牌县',
            
            
            parentId: 174,
            code: '431123000000',
            value: '2673',
            
            id: 2673
          },
          {
            label: '道县',
            
            
            parentId: 174,
            code: '431124000000',
            value: '2674',
            
            id: 2674
          },
          {
            label: '江永县',
            
            
            parentId: 174,
            code: '431125000000',
            value: '2675',
            
            id: 2675
          },
          {
            label: '宁远县',
            
            
            parentId: 174,
            code: '431126000000',
            value: '2676',
            
            id: 2676
          },
          {
            label: '蓝山县',
            
            
            parentId: 174,
            code: '431127000000',
            value: '2677',
            
            id: 2677
          },
          {
            label: '新田县',
            
            
            parentId: 174,
            code: '431128000000',
            value: '2678',
            
            id: 2678
          }
        ],
        id: 174
      },
      {
        label: '怀化市',
        
        
        parentId: 14,
        code: '431200000000',
        value: '175',
        children: [
          {
            label: '中方县',
            
            
            parentId: 175,
            code: '431221000000',
            value: '2679',
            
            id: 2679
          },
          {
            label: '沅陵县',
            
            
            parentId: 175,
            code: '431222000000',
            value: '2680',
            
            id: 2680
          },
          {
            label: '辰溪县',
            
            
            parentId: 175,
            code: '431223000000',
            value: '2681',
            
            id: 2681
          },
          {
            label: '溆浦县',
            
            
            parentId: 175,
            code: '431224000000',
            value: '2682',
            
            id: 2682
          },
          {
            label: '会同县',
            
            
            parentId: 175,
            code: '431225000000',
            value: '2683',
            
            id: 2683
          },
          {
            label: '洪江市',
            
            
            parentId: 175,
            code: '431281000000',
            value: '2684',
            
            id: 2684
          },
          {
            label: '麻阳苗族自治县',
            
            
            parentId: 175,
            code: '431226000000',
            value: '2685',
            
            id: 2685
          },
          {
            label: '新晃侗族自治县',
            
            
            parentId: 175,
            code: '431227000000',
            value: '2686',
            
            id: 2686
          },
          {
            label: '芷江侗族自治县',
            
            
            parentId: 175,
            code: '431228000000',
            value: '2687',
            
            id: 2687
          },
          {
            label: '靖州苗族侗族自治县',
            
            
            parentId: 175,
            code: '431229000000',
            value: '2688',
            
            id: 2688
          },
          {
            label: '通道侗族自治县',
            
            
            parentId: 175,
            code: '431230000000',
            value: '2689',
            
            id: 2689
          },
          {
            label: '鹤城区',
            
            
            parentId: 175,
            code: '431202000000',
            value: '2690',
            
            id: 2690
          }
        ],
        id: 175
      },
      {
        label: '娄底市',
        
        
        parentId: 14,
        code: '431300000000',
        value: '176',
        children: [
          {
            label: '娄星区',
            
            
            parentId: 176,
            code: '431302000000',
            value: '2691',
            
            id: 2691
          },
          {
            label: '冷水江市',
            
            
            parentId: 176,
            code: '431381000000',
            value: '2692',
            
            id: 2692
          },
          {
            label: '涟源市',
            
            
            parentId: 176,
            code: '431382000000',
            value: '2693',
            
            id: 2693
          },
          {
            label: '双峰县',
            
            
            parentId: 176,
            code: '431321000000',
            value: '2694',
            
            id: 2694
          },
          {
            label: '新化县',
            
            
            parentId: 176,
            code: '431322000000',
            value: '2695',
            
            id: 2695
          }
        ],
        id: 176
      }
    ],
    id: 14
  },
  {
    label: '吉林省',
    
    
    parentId: 1,
    code: '220000000000',
    value: '15',
    children: [
      {
        label: '长春市',
        
        
        parentId: 15,
        code: '220100000000',
        value: '177',
        children: [
          {
            label: '农安县',
            
            
            parentId: 177,
            code: '220122000000',
            value: '486',
            
            id: 486
          },
          {
            label: '九台区',
            
            
            parentId: 177,
            code: '220113000000',
            value: '487',
            
            id: 487
          },
          {
            label: '榆树市',
            
            
            parentId: 177,
            code: '220182000000',
            value: '488',
            
            id: 488
          },
          {
            label: '德惠市',
            
            
            parentId: 177,
            code: '220183000000',
            value: '489',
            
            id: 489
          },
          {
            label: '南关区',
            
            
            parentId: 177,
            code: '220102000000',
            value: '490',
            
            id: 490
          },
          {
            label: '宽城区',
            
            
            parentId: 177,
            code: '220103000000',
            value: '491',
            
            id: 491
          },
          {
            label: '朝阳区',
            
            
            parentId: 177,
            code: '220104000000',
            value: '492',
            
            id: 492
          },
          {
            label: '二道区',
            
            
            parentId: 177,
            code: '220105000000',
            value: '493',
            
            id: 493
          },
          {
            label: '绿园区',
            
            
            parentId: 177,
            code: '220106000000',
            value: '494',
            
            id: 494
          },
          {
            label: '双阳区',
            
            
            parentId: 177,
            code: '220112000000',
            value: '495',
            
            id: 495
          }
        ],
        id: 177
      },
      {
        label: '吉林市',
        
        
        parentId: 15,
        code: '220200000000',
        value: '178',
        children: [
          {
            label: '昌邑区',
            
            
            parentId: 178,
            code: '220202000000',
            value: '496',
            
            id: 496
          },
          {
            label: '龙潭区',
            
            
            parentId: 178,
            code: '220203000000',
            value: '497',
            
            id: 497
          },
          {
            label: '船营区',
            
            
            parentId: 178,
            code: '220204000000',
            value: '498',
            
            id: 498
          },
          {
            label: '丰满区',
            
            
            parentId: 178,
            code: '220211000000',
            value: '499',
            
            id: 499
          },
          {
            label: '蛟河市',
            
            
            parentId: 178,
            code: '220281000000',
            value: '500',
            
            id: 500
          },
          {
            label: '桦甸市',
            
            
            parentId: 178,
            code: '220282000000',
            value: '501',
            
            id: 501
          },
          {
            label: '舒兰市',
            
            
            parentId: 178,
            code: '220283000000',
            value: '502',
            
            id: 502
          },
          {
            label: '磐石市',
            
            
            parentId: 178,
            code: '220284000000',
            value: '503',
            
            id: 503
          },
          {
            label: '永吉县',
            
            
            parentId: 178,
            code: '220221000000',
            value: '504',
            
            id: 504
          }
        ],
        id: 178
      },
      {
        label: '四平市',
        
        
        parentId: 15,
        code: '220300000000',
        value: '179',
        children: [
          {
            label: '梨树县',
            
            
            parentId: 179,
            code: '220322000000',
            value: '505',
            
            id: 505
          },
          {
            label: '伊通满族自治县',
            
            
            parentId: 179,
            code: '220323000000',
            value: '506',
            
            id: 506
          },
          {
            label: '公主岭市',
            
            
            parentId: 179,
            code: '220381000000',
            value: '507',
            
            id: 507
          },
          {
            label: '双辽市',
            
            
            parentId: 179,
            code: '220382000000',
            value: '508',
            
            id: 508
          },
          {
            label: '铁西区',
            
            
            parentId: 179,
            code: '220302000000',
            value: '509',
            
            id: 509
          },
          {
            label: '铁东区',
            
            
            parentId: 179,
            code: '220303000000',
            value: '510',
            
            id: 510
          }
        ],
        id: 179
      },
      {
        label: '辽源市',
        
        
        parentId: 15,
        code: '220400000000',
        value: '180',
        children: [
          {
            label: '龙山区',
            
            
            parentId: 180,
            code: '220402000000',
            value: '511',
            
            id: 511
          },
          {
            label: '西安区',
            
            
            parentId: 180,
            code: '220403000000',
            value: '512',
            
            id: 512
          },
          {
            label: '东丰县',
            
            
            parentId: 180,
            code: '220421000000',
            value: '513',
            
            id: 513
          },
          {
            label: '东辽县',
            
            
            parentId: 180,
            code: '220422000000',
            value: '514',
            
            id: 514
          }
        ],
        id: 180
      },
      {
        label: '通化市',
        
        
        parentId: 15,
        code: '220500000000',
        value: '181',
        children: [
          {
            label: '通化县',
            
            
            parentId: 181,
            code: '220521000000',
            value: '515',
            
            id: 515
          },
          {
            label: '辉南县',
            
            
            parentId: 181,
            code: '220523000000',
            value: '516',
            
            id: 516
          },
          {
            label: '柳河县',
            
            
            parentId: 181,
            code: '220524000000',
            value: '517',
            
            id: 517
          },
          {
            label: '东昌区',
            
            
            parentId: 181,
            code: '220502000000',
            value: '518',
            
            id: 518
          },
          {
            label: '二道江区',
            
            
            parentId: 181,
            code: '220503000000',
            value: '519',
            
            id: 519
          },
          {
            label: '梅河口市',
            
            
            parentId: 181,
            code: '220581000000',
            value: '520',
            
            id: 520
          },
          {
            label: '集安市',
            
            
            parentId: 181,
            code: '220582000000',
            value: '521',
            
            id: 521
          }
        ],
        id: 181
      },
      {
        label: '白山市',
        
        
        parentId: 15,
        code: '220600000000',
        value: '182',
        children: [
          {
            label: '临江市',
            
            
            parentId: 182,
            code: '220681000000',
            value: '522',
            
            id: 522
          },
          {
            label: '浑江区',
            
            
            parentId: 182,
            code: '220602000000',
            value: '523',
            
            id: 523
          },
          {
            label: '江源区',
            
            
            parentId: 182,
            code: '220605000000',
            value: '524',
            
            id: 524
          },
          {
            label: '长白朝鲜族自治县',
            
            
            parentId: 182,
            code: '220623000000',
            value: '525',
            
            id: 525
          },
          {
            label: '抚松县',
            
            
            parentId: 182,
            code: '220621000000',
            value: '526',
            
            id: 526
          },
          {
            label: '靖宇县',
            
            
            parentId: 182,
            code: '220622000000',
            value: '527',
            
            id: 527
          }
        ],
        id: 182
      },
      {
        label: '松原市',
        
        
        parentId: 15,
        code: '220700000000',
        value: '183',
        children: [
          {
            label: '长岭县',
            
            
            parentId: 183,
            code: '220722000000',
            value: '528',
            
            id: 528
          },
          {
            label: '乾安县',
            
            
            parentId: 183,
            code: '220723000000',
            value: '529',
            
            id: 529
          },
          {
            label: '扶余市',
            
            
            parentId: 183,
            code: '220781000000',
            value: '530',
            
            id: 530
          },
          {
            label: '前郭尔罗斯蒙古族自治县',
            
            
            parentId: 183,
            code: '220721000000',
            value: '531',
            
            id: 531
          },
          {
            label: '宁江区',
            
            
            parentId: 183,
            code: '220702000000',
            value: '532',
            
            id: 532
          }
        ],
        id: 183
      },
      {
        label: '白城市',
        
        
        parentId: 15,
        code: '220800000000',
        value: '184',
        children: [
          {
            label: '洮北区',
            
            
            parentId: 184,
            code: '220802000000',
            value: '533',
            
            id: 533
          },
          {
            label: '洮南市',
            
            
            parentId: 184,
            code: '220881000000',
            value: '534',
            
            id: 534
          },
          {
            label: '大安市',
            
            
            parentId: 184,
            code: '220882000000',
            value: '535',
            
            id: 535
          },
          {
            label: '镇赉县',
            
            
            parentId: 184,
            code: '220821000000',
            value: '536',
            
            id: 536
          },
          {
            label: '通榆县',
            
            
            parentId: 184,
            code: '220822000000',
            value: '537',
            
            id: 537
          }
        ],
        id: 184
      },
      {
        label: '延边朝鲜族自治州',
        
        
        parentId: 15,
        code: '222400000000',
        value: '185',
        children: [
          {
            label: '汪清县',
            
            
            parentId: 185,
            code: '222424000000',
            value: '1251',
            
            id: 1251
          },
          {
            label: '安图县',
            
            
            parentId: 185,
            code: '222426000000',
            value: '1252',
            
            id: 1252
          },
          {
            label: '延吉市',
            
            
            parentId: 185,
            code: '222401000000',
            value: '1253',
            
            id: 1253
          },
          {
            label: '图们市',
            
            
            parentId: 185,
            code: '222402000000',
            value: '1254',
            
            id: 1254
          },
          {
            label: '敦化市',
            
            
            parentId: 185,
            code: '222403000000',
            value: '1255',
            
            id: 1255
          },
          {
            label: '珲春市',
            
            
            parentId: 185,
            code: '222404000000',
            value: '1256',
            
            id: 1256
          },
          {
            label: '龙井市',
            
            
            parentId: 185,
            code: '222405000000',
            value: '1257',
            
            id: 1257
          },
          {
            label: '和龙市',
            
            
            parentId: 185,
            code: '222406000000',
            value: '1258',
            
            id: 1258
          }
        ],
        id: 185
      }
    ],
    id: 15
  },
  {
    label: '江苏省',
    
    
    parentId: 1,
    code: '320000000000',
    value: '16',
    children: [
      {
        label: '南京市',
        
        
        parentId: 16,
        code: '320100000000',
        value: '186',
        children: [
          {
            label: '溧水区',
            
            
            parentId: 186,
            code: '320117000000',
            value: '3076',
            
            id: 3076
          },
          {
            label: '高淳区',
            
            
            parentId: 186,
            code: '320118000000',
            value: '3077',
            
            id: 3077
          },
          {
            label: '玄武区',
            
            
            parentId: 186,
            code: '320102000000',
            value: '3078',
            
            id: 3078
          },
          {
            label: '秦淮区',
            
            
            parentId: 186,
            code: '320104000000',
            value: '3079',
            
            id: 3079
          },
          {
            label: '建邺区',
            
            
            parentId: 186,
            code: '320105000000',
            value: '3080',
            
            id: 3080
          },
          {
            label: '鼓楼区',
            
            
            parentId: 186,
            code: '320106000000',
            value: '3081',
            
            id: 3081
          },
          {
            label: '浦口区',
            
            
            parentId: 186,
            code: '320111000000',
            value: '3082',
            
            id: 3082
          },
          {
            label: '栖霞区',
            
            
            parentId: 186,
            code: '320113000000',
            value: '3083',
            
            id: 3083
          },
          {
            label: '雨花台区',
            
            
            parentId: 186,
            code: '320114000000',
            value: '3084',
            
            id: 3084
          },
          {
            label: '江宁区',
            
            
            parentId: 186,
            code: '320115000000',
            value: '3085',
            
            id: 3085
          },
          {
            label: '六合区',
            
            
            parentId: 186,
            code: '320116000000',
            value: '3086',
            
            id: 3086
          }
        ],
        id: 186
      },
      {
        label: '无锡市',
        
        
        parentId: 16,
        code: '320200000000',
        value: '187',
        children: [
          {
            label: '崇安区',
            
            
            parentId: 187,
            code: '320202000000',
            value: '3087',
            
            id: 3087
          },
          {
            label: '南长区',
            
            
            parentId: 187,
            code: '320203000000',
            value: '3088',
            
            id: 3088
          },
          {
            label: '北塘区',
            
            
            parentId: 187,
            code: '320204000000',
            value: '3089',
            
            id: 3089
          },
          {
            label: '锡山区',
            
            
            parentId: 187,
            code: '320205000000',
            value: '3090',
            
            id: 3090
          },
          {
            label: '惠山区',
            
            
            parentId: 187,
            code: '320206000000',
            value: '3091',
            
            id: 3091
          },
          {
            label: '滨湖区',
            
            
            parentId: 187,
            code: '320211000000',
            value: '3092',
            
            id: 3092
          },
          {
            label: '江阴市',
            
            
            parentId: 187,
            code: '320281000000',
            value: '3093',
            
            id: 3093
          },
          {
            label: '宜兴市',
            
            
            parentId: 187,
            code: '320282000000',
            value: '3094',
            
            id: 3094
          }
        ],
        id: 187
      },
      {
        label: '徐州市',
        
        
        parentId: 16,
        code: '320300000000',
        value: '188',
        children: [
          {
            label: '新沂市',
            
            
            parentId: 188,
            code: '320381000000',
            value: '3095',
            
            id: 3095
          },
          {
            label: '邳州市',
            
            
            parentId: 188,
            code: '320382000000',
            value: '3096',
            
            id: 3096
          },
          {
            label: '鼓楼区',
            
            
            parentId: 188,
            code: '320302000000',
            value: '3097',
            
            id: 3097
          },
          {
            label: '云龙区',
            
            
            parentId: 188,
            code: '320303000000',
            value: '3098',
            
            id: 3098
          },
          {
            label: '贾汪区',
            
            
            parentId: 188,
            code: '320305000000',
            value: '3099',
            
            id: 3099
          },
          {
            label: '泉山区',
            
            
            parentId: 188,
            code: '320311000000',
            value: '3100',
            
            id: 3100
          },
          {
            label: '丰县',
            
            
            parentId: 188,
            code: '320321000000',
            value: '3101',
            
            id: 3101
          },
          {
            label: '沛县',
            
            
            parentId: 188,
            code: '320322000000',
            value: '3102',
            
            id: 3102
          },
          {
            label: '铜山区',
            
            
            parentId: 188,
            code: '320312000000',
            value: '3103',
            
            id: 3103
          },
          {
            label: '睢宁县',
            
            
            parentId: 188,
            code: '320324000000',
            value: '3104',
            
            id: 3104
          }
        ],
        id: 188
      },
      {
        label: '常州市',
        
        
        parentId: 16,
        code: '320400000000',
        value: '189',
        children: [
          {
            label: '天宁区',
            
            
            parentId: 189,
            code: '320402000000',
            value: '3105',
            
            id: 3105
          },
          {
            label: '钟楼区',
            
            
            parentId: 189,
            code: '320404000000',
            value: '3106',
            
            id: 3106
          },
          {
            label: '戚墅堰区',
            
            
            parentId: 189,
            code: '320405000000',
            value: '3107',
            
            id: 3107
          },
          {
            label: '新北区',
            
            
            parentId: 189,
            code: '320411000000',
            value: '3108',
            
            id: 3108
          },
          {
            label: '武进区',
            
            
            parentId: 189,
            code: '320412000000',
            value: '3109',
            
            id: 3109
          },
          {
            label: '溧阳市',
            
            
            parentId: 189,
            code: '320481000000',
            value: '3110',
            
            id: 3110
          },
          {
            label: '金坛市',
            
            
            parentId: 189,
            code: '320482000000',
            value: '3111',
            
            id: 3111
          }
        ],
        id: 189
      },
      {
        label: '苏州市',
        
        
        parentId: 16,
        code: '320500000000',
        value: '190',
        children: [
          {
            label: '常熟市',
            
            
            parentId: 190,
            code: '320581000000',
            value: '3112',
            
            id: 3112
          },
          {
            label: '张家港市',
            
            
            parentId: 190,
            code: '320582000000',
            value: '3113',
            
            id: 3113
          },
          {
            label: '昆山市',
            
            
            parentId: 190,
            code: '320583000000',
            value: '3114',
            
            id: 3114
          },
          {
            label: '吴江区',
            
            
            parentId: 190,
            code: '320509000000',
            value: '3115',
            
            id: 3115
          },
          {
            label: '太仓市',
            
            
            parentId: 190,
            code: '320585000000',
            value: '3116',
            
            id: 3116
          },
          {
            label: '虎丘区',
            
            
            parentId: 190,
            code: '320505000000',
            value: '3117',
            
            id: 3117
          },
          {
            label: '吴中区',
            
            
            parentId: 190,
            code: '320506000000',
            value: '3118',
            
            id: 3118
          },
          {
            label: '相城区',
            
            
            parentId: 190,
            code: '320507000000',
            value: '3119',
            
            id: 3119
          },
          {
            label: '姑苏区',
            
            
            parentId: 190,
            code: '320508000000',
            value: '3120',
            
            id: 3120
          }
        ],
        id: 190
      },
      {
        label: '南通市',
        
        
        parentId: 16,
        code: '320600000000',
        value: '191',
        children: [
          {
            label: '启东市',
            
            
            parentId: 191,
            code: '320681000000',
            value: '1357',
            
            id: 1357
          },
          {
            label: '如皋市',
            
            
            parentId: 191,
            code: '320682000000',
            value: '1358',
            
            id: 1358
          },
          {
            label: '通州区',
            
            
            parentId: 191,
            code: '320612000000',
            value: '1359',
            
            id: 1359
          },
          {
            label: '海门市',
            
            
            parentId: 191,
            code: '320684000000',
            value: '1360',
            
            id: 1360
          },
          {
            label: '海安县',
            
            
            parentId: 191,
            code: '320621000000',
            value: '1361',
            
            id: 1361
          },
          {
            label: '如东县',
            
            
            parentId: 191,
            code: '320623000000',
            value: '1362',
            
            id: 1362
          },
          {
            label: '崇川区',
            
            
            parentId: 191,
            code: '320602000000',
            value: '3121',
            
            id: 3121
          },
          {
            label: '港闸区',
            
            
            parentId: 191,
            code: '320611000000',
            value: '3122',
            
            id: 3122
          }
        ],
        id: 191
      },
      {
        label: '连云港市',
        
        
        parentId: 16,
        code: '320700000000',
        value: '192',
        children: [
          {
            label: '赣榆区',
            
            
            parentId: 192,
            code: '320707000000',
            value: '1363',
            
            id: 1363
          },
          {
            label: '东海县',
            
            
            parentId: 192,
            code: '320722000000',
            value: '1364',
            
            id: 1364
          },
          {
            label: '灌云县',
            
            
            parentId: 192,
            code: '320723000000',
            value: '1365',
            
            id: 1365
          },
          {
            label: '灌南县',
            
            
            parentId: 192,
            code: '320724000000',
            value: '1366',
            
            id: 1366
          },
          {
            label: '连云区',
            
            
            parentId: 192,
            code: '320703000000',
            value: '1367',
            
            id: 1367
          },
          {
            label: '海州区',
            
            
            parentId: 192,
            code: '320706000000',
            value: '1368',
            
            id: 1368
          }
        ],
        id: 192
      },
      {
        label: '淮安市',
        
        
        parentId: 16,
        code: '320800000000',
        value: '193',
        children: [
          {
            label: '清河区',
            
            
            parentId: 193,
            code: '320802000000',
            value: '1369',
            
            id: 1369
          },
          {
            label: '淮安区',
            
            
            parentId: 193,
            code: '320803000000',
            value: '1370',
            
            id: 1370
          },
          {
            label: '淮阴区',
            
            
            parentId: 193,
            code: '320804000000',
            value: '1371',
            
            id: 1371
          },
          {
            label: '清浦区',
            
            
            parentId: 193,
            code: '320811000000',
            value: '1372',
            
            id: 1372
          },
          {
            label: '涟水县',
            
            
            parentId: 193,
            code: '320826000000',
            value: '1373',
            
            id: 1373
          },
          {
            label: '洪泽县',
            
            
            parentId: 193,
            code: '320829000000',
            value: '1374',
            
            id: 1374
          },
          {
            label: '盱眙县',
            
            
            parentId: 193,
            code: '320830000000',
            value: '1375',
            
            id: 1375
          },
          {
            label: '金湖县',
            
            
            parentId: 193,
            code: '320831000000',
            value: '1376',
            
            id: 1376
          }
        ],
        id: 193
      },
      {
        label: '盐城市',
        
        
        parentId: 16,
        code: '320900000000',
        value: '194',
        children: [
          {
            label: '响水县',
            
            
            parentId: 194,
            code: '320921000000',
            value: '1377',
            
            id: 1377
          },
          {
            label: '滨海县',
            
            
            parentId: 194,
            code: '320922000000',
            value: '1378',
            
            id: 1378
          },
          {
            label: '阜宁县',
            
            
            parentId: 194,
            code: '320923000000',
            value: '1379',
            
            id: 1379
          },
          {
            label: '射阳县',
            
            
            parentId: 194,
            code: '320924000000',
            value: '1380',
            
            id: 1380
          },
          {
            label: '建湖县',
            
            
            parentId: 194,
            code: '320925000000',
            value: '1381',
            
            id: 1381
          },
          {
            label: '盐都区',
            
            
            parentId: 194,
            code: '320903000000',
            value: '1382',
            
            id: 1382
          },
          {
            label: '东台市',
            
            
            parentId: 194,
            code: '320981000000',
            value: '1383',
            
            id: 1383
          },
          {
            label: '大丰市',
            
            
            parentId: 194,
            code: '320982000000',
            value: '1384',
            
            id: 1384
          },
          {
            label: '亭湖区',
            
            
            parentId: 194,
            code: '320902000000',
            value: '1385',
            
            id: 1385
          }
        ],
        id: 194
      },
      {
        label: '扬州市',
        
        
        parentId: 16,
        code: '321000000000',
        value: '195',
        children: [
          {
            label: '广陵区',
            
            
            parentId: 195,
            code: '321002000000',
            value: '1386',
            
            id: 1386
          },
          {
            label: '邗江区',
            
            
            parentId: 195,
            code: '321003000000',
            value: '1387',
            
            id: 1387
          },
          {
            label: '仪征市',
            
            
            parentId: 195,
            code: '321081000000',
            value: '1388',
            
            id: 1388
          },
          {
            label: '高邮市',
            
            
            parentId: 195,
            code: '321084000000',
            value: '1389',
            
            id: 1389
          },
          {
            label: '江都区',
            
            
            parentId: 195,
            code: '321012000000',
            value: '1390',
            
            id: 1390
          },
          {
            label: '宝应县',
            
            
            parentId: 195,
            code: '321023000000',
            value: '1391',
            
            id: 1391
          }
        ],
        id: 195
      },
      {
        label: '镇江市',
        
        
        parentId: 16,
        code: '321100000000',
        value: '196',
        children: [
          {
            label: '丹阳市',
            
            
            parentId: 196,
            code: '321181000000',
            value: '1392',
            
            id: 1392
          },
          {
            label: '扬中市',
            
            
            parentId: 196,
            code: '321182000000',
            value: '1393',
            
            id: 1393
          },
          {
            label: '句容市',
            
            
            parentId: 196,
            code: '321183000000',
            value: '1394',
            
            id: 1394
          },
          {
            label: '京口区',
            
            
            parentId: 196,
            code: '321102000000',
            value: '1395',
            
            id: 1395
          },
          {
            label: '润州区',
            
            
            parentId: 196,
            code: '321111000000',
            value: '1396',
            
            id: 1396
          },
          {
            label: '丹徒区',
            
            
            parentId: 196,
            code: '321112000000',
            value: '1397',
            
            id: 1397
          }
        ],
        id: 196
      },
      {
        label: '泰州市',
        
        
        parentId: 16,
        code: '321200000000',
        value: '197',
        children: [
          {
            label: '海陵区',
            
            
            parentId: 197,
            code: '321202000000',
            value: '1398',
            
            id: 1398
          },
          {
            label: '高港区',
            
            
            parentId: 197,
            code: '321203000000',
            value: '1399',
            
            id: 1399
          },
          {
            label: '兴化市',
            
            
            parentId: 197,
            code: '321281000000',
            value: '1400',
            
            id: 1400
          },
          {
            label: '靖江市',
            
            
            parentId: 197,
            code: '321282000000',
            value: '1401',
            
            id: 1401
          },
          {
            label: '泰兴市',
            
            
            parentId: 197,
            code: '321283000000',
            value: '1402',
            
            id: 1402
          },
          {
            label: '姜堰区',
            
            
            parentId: 197,
            code: '321204000000',
            value: '1403',
            
            id: 1403
          }
        ],
        id: 197
      },
      {
        label: '宿迁市',
        
        
        parentId: 16,
        code: '321300000000',
        value: '198',
        children: [
          {
            label: '宿城区',
            
            
            parentId: 198,
            code: '321302000000',
            value: '1404',
            
            id: 1404
          },
          {
            label: '宿豫区',
            
            
            parentId: 198,
            code: '321311000000',
            value: '1405',
            
            id: 1405
          },
          {
            label: '沭阳县',
            
            
            parentId: 198,
            code: '321322000000',
            value: '1406',
            
            id: 1406
          },
          {
            label: '泗阳县',
            
            
            parentId: 198,
            code: '321323000000',
            value: '1407',
            
            id: 1407
          },
          {
            label: '泗洪县',
            
            
            parentId: 198,
            code: '321324000000',
            value: '1408',
            
            id: 1408
          }
        ],
        id: 198
      }
    ],
    id: 16
  },
  {
    label: '江西省',
    
    
    parentId: 1,
    code: '360000000000',
    value: '17',
    children: [
      {
        label: '南昌市',
        
        
        parentId: 17,
        code: '360100000000',
        value: '199',
        children: [
          {
            label: '东湖区',
            
            
            parentId: 199,
            code: '360102000000',
            value: '1689',
            
            id: 1689
          },
          {
            label: '西湖区',
            
            
            parentId: 199,
            code: '360103000000',
            value: '1690',
            
            id: 1690
          },
          {
            label: '青云谱区',
            
            
            parentId: 199,
            code: '360104000000',
            value: '1691',
            
            id: 1691
          },
          {
            label: '湾里区',
            
            
            parentId: 199,
            code: '360105000000',
            value: '1692',
            
            id: 1692
          },
          {
            label: '青山湖区',
            
            
            parentId: 199,
            code: '360111000000',
            value: '1693',
            
            id: 1693
          },
          {
            label: '南昌县',
            
            
            parentId: 199,
            code: '360121000000',
            value: '1694',
            
            id: 1694
          },
          {
            label: '新建县',
            
            
            parentId: 199,
            code: '360122000000',
            value: '1695',
            
            id: 1695
          },
          {
            label: '安义县',
            
            
            parentId: 199,
            code: '360123000000',
            value: '1696',
            
            id: 1696
          },
          {
            label: '进贤县',
            
            
            parentId: 199,
            code: '360124000000',
            value: '1697',
            
            id: 1697
          }
        ],
        id: 199
      },
      {
        label: '景德镇市',
        
        
        parentId: 17,
        code: '360200000000',
        value: '200',
        children: [
          {
            label: '乐平市',
            
            
            parentId: 200,
            code: '360281000000',
            value: '1698',
            
            id: 1698
          },
          {
            label: '昌江区',
            
            
            parentId: 200,
            code: '360202000000',
            value: '1699',
            
            id: 1699
          },
          {
            label: '珠山区',
            
            
            parentId: 200,
            code: '360203000000',
            value: '1700',
            
            id: 1700
          },
          {
            label: '浮梁县',
            
            
            parentId: 200,
            code: '360222000000',
            value: '1701',
            
            id: 1701
          }
        ],
        id: 200
      },
      {
        label: '萍乡市',
        
        
        parentId: 17,
        code: '360300000000',
        value: '201',
        children: [
          {
            label: '莲花县',
            
            
            parentId: 201,
            code: '360321000000',
            value: '1702',
            
            id: 1702
          },
          {
            label: '安源区',
            
            
            parentId: 201,
            code: '360302000000',
            value: '1703',
            
            id: 1703
          },
          {
            label: '湘东区',
            
            
            parentId: 201,
            code: '360313000000',
            value: '1704',
            
            id: 1704
          },
          {
            label: '上栗县',
            
            
            parentId: 201,
            code: '360322000000',
            value: '1705',
            
            id: 1705
          },
          {
            label: '芦溪县',
            
            
            parentId: 201,
            code: '360323000000',
            value: '1706',
            
            id: 1706
          }
        ],
        id: 201
      },
      {
        label: '九江市',
        
        
        parentId: 17,
        code: '360400000000',
        value: '202',
        children: [
          {
            label: '九江县',
            
            
            parentId: 202,
            code: '360421000000',
            value: '1707',
            
            id: 1707
          },
          {
            label: '武宁县',
            
            
            parentId: 202,
            code: '360423000000',
            value: '1708',
            
            id: 1708
          },
          {
            label: '修水县',
            
            
            parentId: 202,
            code: '360424000000',
            value: '1709',
            
            id: 1709
          },
          {
            label: '永修县',
            
            
            parentId: 202,
            code: '360425000000',
            value: '1710',
            
            id: 1710
          },
          {
            label: '德安县',
            
            
            parentId: 202,
            code: '360426000000',
            value: '1711',
            
            id: 1711
          },
          {
            label: '星子县',
            
            
            parentId: 202,
            code: '360427000000',
            value: '1712',
            
            id: 1712
          },
          {
            label: '都昌县',
            
            
            parentId: 202,
            code: '360428000000',
            value: '1713',
            
            id: 1713
          },
          {
            label: '湖口县',
            
            
            parentId: 202,
            code: '360429000000',
            value: '1714',
            
            id: 1714
          },
          {
            label: '彭泽县',
            
            
            parentId: 202,
            code: '360430000000',
            value: '1715',
            
            id: 1715
          },
          {
            label: '瑞昌市',
            
            
            parentId: 202,
            code: '360481000000',
            value: '1716',
            
            id: 1716
          },
          {
            label: '共青城市',
            
            
            parentId: 202,
            code: '360482000000',
            value: '1717',
            
            id: 1717
          },
          {
            label: '庐山区',
            
            
            parentId: 202,
            code: '360402000000',
            value: '1718',
            
            id: 1718
          },
          {
            label: '浔阳区',
            
            
            parentId: 202,
            code: '360403000000',
            value: '1719',
            
            id: 1719
          }
        ],
        id: 202
      },
      {
        label: '新余市',
        
        
        parentId: 17,
        code: '360500000000',
        value: '203',
        children: [
          {
            label: '渝水区',
            
            
            parentId: 203,
            code: '360502000000',
            value: '1720',
            
            id: 1720
          },
          {
            label: '分宜县',
            
            
            parentId: 203,
            code: '360521000000',
            value: '1721',
            
            id: 1721
          }
        ],
        id: 203
      },
      {
        label: '鹰潭市',
        
        
        parentId: 17,
        code: '360600000000',
        value: '204',
        children: [
          {
            label: '余江县',
            
            
            parentId: 204,
            code: '360622000000',
            value: '1722',
            
            id: 1722
          },
          {
            label: '贵溪市',
            
            
            parentId: 204,
            code: '360681000000',
            value: '1723',
            
            id: 1723
          },
          {
            label: '月湖区',
            
            
            parentId: 204,
            code: '360602000000',
            value: '1724',
            
            id: 1724
          }
        ],
        id: 204
      },
      {
        label: '赣州市',
        
        
        parentId: 17,
        code: '360700000000',
        value: '205',
        children: [
          {
            label: '章贡区',
            
            
            parentId: 205,
            code: '360702000000',
            value: '1725',
            
            id: 1725
          },
          {
            label: '瑞金市',
            
            
            parentId: 205,
            code: '360781000000',
            value: '1726',
            
            id: 1726
          },
          {
            label: '南康区',
            
            
            parentId: 205,
            code: '360703000000',
            value: '1727',
            
            id: 1727
          },
          {
            label: '赣县',
            
            
            parentId: 205,
            code: '360721000000',
            value: '1728',
            
            id: 1728
          },
          {
            label: '信丰县',
            
            
            parentId: 205,
            code: '360722000000',
            value: '1729',
            
            id: 1729
          },
          {
            label: '大余县',
            
            
            parentId: 205,
            code: '360723000000',
            value: '1730',
            
            id: 1730
          },
          {
            label: '上犹县',
            
            
            parentId: 205,
            code: '360724000000',
            value: '1731',
            
            id: 1731
          },
          {
            label: '崇义县',
            
            
            parentId: 205,
            code: '360725000000',
            value: '1732',
            
            id: 1732
          },
          {
            label: '安远县',
            
            
            parentId: 205,
            code: '360726000000',
            value: '1733',
            
            id: 1733
          },
          {
            label: '龙南县',
            
            
            parentId: 205,
            code: '360727000000',
            value: '1734',
            
            id: 1734
          },
          {
            label: '定南县',
            
            
            parentId: 205,
            code: '360728000000',
            value: '1735',
            
            id: 1735
          },
          {
            label: '全南县',
            
            
            parentId: 205,
            code: '360729000000',
            value: '1736',
            
            id: 1736
          },
          {
            label: '宁都县',
            
            
            parentId: 205,
            code: '360730000000',
            value: '1737',
            
            id: 1737
          },
          {
            label: '于都县',
            
            
            parentId: 205,
            code: '360731000000',
            value: '1738',
            
            id: 1738
          },
          {
            label: '兴国县',
            
            
            parentId: 205,
            code: '360732000000',
            value: '1739',
            
            id: 1739
          },
          {
            label: '会昌县',
            
            
            parentId: 205,
            code: '360733000000',
            value: '1740',
            
            id: 1740
          },
          {
            label: '寻乌县',
            
            
            parentId: 205,
            code: '360734000000',
            value: '1741',
            
            id: 1741
          },
          {
            label: '石城县',
            
            
            parentId: 205,
            code: '360735000000',
            value: '1742',
            
            id: 1742
          }
        ],
        id: 205
      },
      {
        label: '吉安市',
        
        
        parentId: 17,
        code: '360800000000',
        value: '206',
        children: [
          {
            label: '吉安县',
            
            
            parentId: 206,
            code: '360821000000',
            value: '1743',
            
            id: 1743
          },
          {
            label: '吉水县',
            
            
            parentId: 206,
            code: '360822000000',
            value: '1744',
            
            id: 1744
          },
          {
            label: '峡江县',
            
            
            parentId: 206,
            code: '360823000000',
            value: '1745',
            
            id: 1745
          },
          {
            label: '新干县',
            
            
            parentId: 206,
            code: '360824000000',
            value: '1746',
            
            id: 1746
          },
          {
            label: '永丰县',
            
            
            parentId: 206,
            code: '360825000000',
            value: '1747',
            
            id: 1747
          },
          {
            label: '泰和县',
            
            
            parentId: 206,
            code: '360826000000',
            value: '1748',
            
            id: 1748
          },
          {
            label: '遂川县',
            
            
            parentId: 206,
            code: '360827000000',
            value: '1749',
            
            id: 1749
          },
          {
            label: '万安县',
            
            
            parentId: 206,
            code: '360828000000',
            value: '1750',
            
            id: 1750
          },
          {
            label: '安福县',
            
            
            parentId: 206,
            code: '360829000000',
            value: '1751',
            
            id: 1751
          },
          {
            label: '永新县',
            
            
            parentId: 206,
            code: '360830000000',
            value: '1752',
            
            id: 1752
          },
          {
            label: '井冈山市',
            
            
            parentId: 206,
            code: '360881000000',
            value: '1753',
            
            id: 1753
          },
          {
            label: '吉州区',
            
            
            parentId: 206,
            code: '360802000000',
            value: '1754',
            
            id: 1754
          },
          {
            label: '青原区',
            
            
            parentId: 206,
            code: '360803000000',
            value: '1755',
            
            id: 1755
          }
        ],
        id: 206
      },
      {
        label: '宜春市',
        
        
        parentId: 17,
        code: '360900000000',
        value: '207',
        children: [
          {
            label: '袁州区',
            
            
            parentId: 207,
            code: '360902000000',
            value: '1756',
            
            id: 1756
          },
          {
            label: '丰城市',
            
            
            parentId: 207,
            code: '360981000000',
            value: '1757',
            
            id: 1757
          },
          {
            label: '樟树市',
            
            
            parentId: 207,
            code: '360982000000',
            value: '1758',
            
            id: 1758
          },
          {
            label: '高安市',
            
            
            parentId: 207,
            code: '360983000000',
            value: '1759',
            
            id: 1759
          },
          {
            label: '奉新县',
            
            
            parentId: 207,
            code: '360921000000',
            value: '1760',
            
            id: 1760
          },
          {
            label: '万载县',
            
            
            parentId: 207,
            code: '360922000000',
            value: '1761',
            
            id: 1761
          },
          {
            label: '上高县',
            
            
            parentId: 207,
            code: '360923000000',
            value: '1762',
            
            id: 1762
          },
          {
            label: '宜丰县',
            
            
            parentId: 207,
            code: '360924000000',
            value: '1763',
            
            id: 1763
          },
          {
            label: '靖安县',
            
            
            parentId: 207,
            code: '360925000000',
            value: '1764',
            
            id: 1764
          },
          {
            label: '铜鼓县',
            
            
            parentId: 207,
            code: '360926000000',
            value: '1765',
            
            id: 1765
          }
        ],
        id: 207
      },
      {
        label: '抚州市',
        
        
        parentId: 17,
        code: '361000000000',
        value: '208',
        children: [
          {
            label: '南城县',
            
            
            parentId: 208,
            code: '361021000000',
            value: '1766',
            
            id: 1766
          },
          {
            label: '黎川县',
            
            
            parentId: 208,
            code: '361022000000',
            value: '1767',
            
            id: 1767
          },
          {
            label: '南丰县',
            
            
            parentId: 208,
            code: '361023000000',
            value: '1768',
            
            id: 1768
          },
          {
            label: '崇仁县',
            
            
            parentId: 208,
            code: '361024000000',
            value: '1769',
            
            id: 1769
          },
          {
            label: '乐安县',
            
            
            parentId: 208,
            code: '361025000000',
            value: '1770',
            
            id: 1770
          },
          {
            label: '宜黄县',
            
            
            parentId: 208,
            code: '361026000000',
            value: '1771',
            
            id: 1771
          },
          {
            label: '金溪县',
            
            
            parentId: 208,
            code: '361027000000',
            value: '1772',
            
            id: 1772
          },
          {
            label: '资溪县',
            
            
            parentId: 208,
            code: '361028000000',
            value: '1773',
            
            id: 1773
          },
          {
            label: '东乡县',
            
            
            parentId: 208,
            code: '361029000000',
            value: '1774',
            
            id: 1774
          },
          {
            label: '广昌县',
            
            
            parentId: 208,
            code: '361030000000',
            value: '1775',
            
            id: 1775
          },
          {
            label: '临川区',
            
            
            parentId: 208,
            code: '361002000000',
            value: '1776',
            
            id: 1776
          }
        ],
        id: 208
      },
      {
        label: '上饶市',
        
        
        parentId: 17,
        code: '361100000000',
        value: '209',
        children: [
          {
            label: '信州区',
            
            
            parentId: 209,
            code: '361102000000',
            value: '1777',
            
            id: 1777
          },
          {
            label: '上饶县',
            
            
            parentId: 209,
            code: '361121000000',
            value: '1778',
            
            id: 1778
          },
          {
            label: '广丰县',
            
            
            parentId: 209,
            code: '361122000000',
            value: '1779',
            
            id: 1779
          },
          {
            label: '玉山县',
            
            
            parentId: 209,
            code: '361123000000',
            value: '1780',
            
            id: 1780
          },
          {
            label: '铅山县',
            
            
            parentId: 209,
            code: '361124000000',
            value: '1781',
            
            id: 1781
          },
          {
            label: '横峰县',
            
            
            parentId: 209,
            code: '361125000000',
            value: '1782',
            
            id: 1782
          },
          {
            label: '弋阳县',
            
            
            parentId: 209,
            code: '361126000000',
            value: '1783',
            
            id: 1783
          },
          {
            label: '余干县',
            
            
            parentId: 209,
            code: '361127000000',
            value: '1784',
            
            id: 1784
          },
          {
            label: '鄱阳县',
            
            
            parentId: 209,
            code: '361128000000',
            value: '1785',
            
            id: 1785
          },
          {
            label: '万年县',
            
            
            parentId: 209,
            code: '361129000000',
            value: '1786',
            
            id: 1786
          },
          {
            label: '婺源县',
            
            
            parentId: 209,
            code: '361130000000',
            value: '1787',
            
            id: 1787
          },
          {
            label: '德兴市',
            
            
            parentId: 209,
            code: '361181000000',
            value: '1788',
            
            id: 1788
          }
        ],
        id: 209
      }
    ],
    id: 17
  },
  {
    label: '辽宁省',
    
    
    parentId: 1,
    code: '210000000000',
    value: '18',
    children: [
      {
        label: '沈阳市',
        
        
        parentId: 18,
        code: '210100000000',
        value: '210',
        children: [
          {
            label: '辽中县',
            
            
            parentId: 210,
            code: '210122000000',
            value: '386',
            
            id: 386
          },
          {
            label: '康平县',
            
            
            parentId: 210,
            code: '210123000000',
            value: '387',
            
            id: 387
          },
          {
            label: '法库县',
            
            
            parentId: 210,
            code: '210124000000',
            value: '388',
            
            id: 388
          },
          {
            label: '和平区',
            
            
            parentId: 210,
            code: '210102000000',
            value: '389',
            
            id: 389
          },
          {
            label: '沈河区',
            
            
            parentId: 210,
            code: '210103000000',
            value: '390',
            
            id: 390
          },
          {
            label: '大东区',
            
            
            parentId: 210,
            code: '210104000000',
            value: '391',
            
            id: 391
          },
          {
            label: '皇姑区',
            
            
            parentId: 210,
            code: '210105000000',
            value: '392',
            
            id: 392
          },
          {
            label: '铁西区',
            
            
            parentId: 210,
            code: '210106000000',
            value: '393',
            
            id: 393
          },
          {
            label: '苏家屯区',
            
            
            parentId: 210,
            code: '210111000000',
            value: '394',
            
            id: 394
          },
          {
            label: '沈北新区',
            
            
            parentId: 210,
            code: '210113000000',
            value: '395',
            
            id: 395
          },
          {
            label: '于洪区',
            
            
            parentId: 210,
            code: '210114000000',
            value: '396',
            
            id: 396
          },
          {
            label: '新民市',
            
            
            parentId: 210,
            code: '210181000000',
            value: '397',
            
            id: 397
          },
          {
            label: '浑南区',
            
            
            parentId: 210,
            code: '210112000000',
            value: '398',
            
            id: 398
          }
        ],
        id: 210
      },
      {
        label: '大连市',
        
        
        parentId: 18,
        code: '210200000000',
        value: '211',
        children: [
          {
            label: '瓦房店市',
            
            
            parentId: 211,
            code: '210281000000',
            value: '399',
            
            id: 399
          },
          {
            label: '普兰店市',
            
            
            parentId: 211,
            code: '210282000000',
            value: '400',
            
            id: 400
          },
          {
            label: '庄河市',
            
            
            parentId: 211,
            code: '210283000000',
            value: '401',
            
            id: 401
          },
          {
            label: '中山区',
            
            
            parentId: 211,
            code: '210202000000',
            value: '402',
            
            id: 402
          },
          {
            label: '西岗区',
            
            
            parentId: 211,
            code: '210203000000',
            value: '403',
            
            id: 403
          },
          {
            label: '沙河口区',
            
            
            parentId: 211,
            code: '210204000000',
            value: '404',
            
            id: 404
          },
          {
            label: '甘井子区',
            
            
            parentId: 211,
            code: '210211000000',
            value: '405',
            
            id: 405
          },
          {
            label: '旅顺口区',
            
            
            parentId: 211,
            code: '210212000000',
            value: '406',
            
            id: 406
          },
          {
            label: '金州区',
            
            
            parentId: 211,
            code: '210213000000',
            value: '407',
            
            id: 407
          },
          {
            label: '长海县',
            
            
            parentId: 211,
            code: '210224000000',
            value: '408',
            
            id: 408
          }
        ],
        id: 211
      },
      {
        label: '鞍山市',
        
        
        parentId: 18,
        code: '210300000000',
        value: '212',
        children: [
          {
            label: '岫岩满族自治县',
            
            
            parentId: 212,
            code: '210323000000',
            value: '409',
            
            id: 409
          },
          {
            label: '铁东区',
            
            
            parentId: 212,
            code: '210302000000',
            value: '410',
            
            id: 410
          },
          {
            label: '铁西区',
            
            
            parentId: 212,
            code: '210303000000',
            value: '411',
            
            id: 411
          },
          {
            label: '立山区',
            
            
            parentId: 212,
            code: '210304000000',
            value: '412',
            
            id: 412
          },
          {
            label: '千山区',
            
            
            parentId: 212,
            code: '210311000000',
            value: '413',
            
            id: 413
          },
          {
            label: '海城市',
            
            
            parentId: 212,
            code: '210381000000',
            value: '414',
            
            id: 414
          },
          {
            label: '台安县',
            
            
            parentId: 212,
            code: '210321000000',
            value: '415',
            
            id: 415
          }
        ],
        id: 212
      },
      {
        label: '抚顺市',
        
        
        parentId: 18,
        code: '210400000000',
        value: '213',
        children: [
          {
            label: '新抚区',
            
            
            parentId: 213,
            code: '210402000000',
            value: '416',
            
            id: 416
          },
          {
            label: '东洲区',
            
            
            parentId: 213,
            code: '210403000000',
            value: '417',
            
            id: 417
          },
          {
            label: '望花区',
            
            
            parentId: 213,
            code: '210404000000',
            value: '418',
            
            id: 418
          },
          {
            label: '顺城区',
            
            
            parentId: 213,
            code: '210411000000',
            value: '419',
            
            id: 419
          },
          {
            label: '抚顺县',
            
            
            parentId: 213,
            code: '210421000000',
            value: '420',
            
            id: 420
          },
          {
            label: '新宾满族自治县',
            
            
            parentId: 213,
            code: '210422000000',
            value: '421',
            
            id: 421
          },
          {
            label: '清原满族自治县',
            
            
            parentId: 213,
            code: '210423000000',
            value: '422',
            
            id: 422
          }
        ],
        id: 213
      },
      {
        label: '本溪市',
        
        
        parentId: 18,
        code: '210500000000',
        value: '214',
        children: [
          {
            label: '本溪满族自治县',
            
            
            parentId: 214,
            code: '210521000000',
            value: '423',
            
            id: 423
          },
          {
            label: '桓仁满族自治县',
            
            
            parentId: 214,
            code: '210522000000',
            value: '424',
            
            id: 424
          },
          {
            label: '平山区',
            
            
            parentId: 214,
            code: '210502000000',
            value: '425',
            
            id: 425
          },
          {
            label: '溪湖区',
            
            
            parentId: 214,
            code: '210503000000',
            value: '426',
            
            id: 426
          },
          {
            label: '明山区',
            
            
            parentId: 214,
            code: '210504000000',
            value: '427',
            
            id: 427
          },
          {
            label: '南芬区',
            
            
            parentId: 214,
            code: '210505000000',
            value: '428',
            
            id: 428
          }
        ],
        id: 214
      },
      {
        label: '丹东市',
        
        
        parentId: 18,
        code: '210600000000',
        value: '215',
        children: [
          {
            label: '元宝区',
            
            
            parentId: 215,
            code: '210602000000',
            value: '429',
            
            id: 429
          },
          {
            label: '振兴区',
            
            
            parentId: 215,
            code: '210603000000',
            value: '430',
            
            id: 430
          },
          {
            label: '振安区',
            
            
            parentId: 215,
            code: '210604000000',
            value: '431',
            
            id: 431
          },
          {
            label: '东港市',
            
            
            parentId: 215,
            code: '210681000000',
            value: '432',
            
            id: 432
          },
          {
            label: '凤城市',
            
            
            parentId: 215,
            code: '210682000000',
            value: '433',
            
            id: 433
          },
          {
            label: '宽甸满族自治县',
            
            
            parentId: 215,
            code: '210624000000',
            value: '434',
            
            id: 434
          }
        ],
        id: 215
      },
      {
        label: '锦州市',
        
        
        parentId: 18,
        code: '210700000000',
        value: '216',
        children: [
          {
            label: '凌海市',
            
            
            parentId: 216,
            code: '210781000000',
            value: '435',
            
            id: 435
          },
          {
            label: '北镇市',
            
            
            parentId: 216,
            code: '210782000000',
            value: '436',
            
            id: 436
          },
          {
            label: '古塔区',
            
            
            parentId: 216,
            code: '210702000000',
            value: '437',
            
            id: 437
          },
          {
            label: '凌河区',
            
            
            parentId: 216,
            code: '210703000000',
            value: '438',
            
            id: 438
          },
          {
            label: '太和区',
            
            
            parentId: 216,
            code: '210711000000',
            value: '439',
            
            id: 439
          },
          {
            label: '黑山县',
            
            
            parentId: 216,
            code: '210726000000',
            value: '440',
            
            id: 440
          },
          {
            label: '义县',
            
            
            parentId: 216,
            code: '210727000000',
            value: '441',
            
            id: 441
          }
        ],
        id: 216
      },
      {
        label: '营口市',
        
        
        parentId: 18,
        code: '210800000000',
        value: '217',
        children: [
          {
            label: '站前区',
            
            
            parentId: 217,
            code: '210802000000',
            value: '442',
            
            id: 442
          },
          {
            label: '西市区',
            
            
            parentId: 217,
            code: '210803000000',
            value: '443',
            
            id: 443
          },
          {
            label: '鲅鱼圈区',
            
            
            parentId: 217,
            code: '210804000000',
            value: '444',
            
            id: 444
          },
          {
            label: '老边区',
            
            
            parentId: 217,
            code: '210811000000',
            value: '445',
            
            id: 445
          },
          {
            label: '盖州市',
            
            
            parentId: 217,
            code: '210881000000',
            value: '446',
            
            id: 446
          },
          {
            label: '大石桥市',
            
            
            parentId: 217,
            code: '210882000000',
            value: '447',
            
            id: 447
          }
        ],
        id: 217
      },
      {
        label: '阜新市',
        
        
        parentId: 18,
        code: '210900000000',
        value: '218',
        children: [
          {
            label: '阜新蒙古族自治县',
            
            
            parentId: 218,
            code: '210921000000',
            value: '448',
            
            id: 448
          },
          {
            label: '海州区',
            
            
            parentId: 218,
            code: '210902000000',
            value: '449',
            
            id: 449
          },
          {
            label: '新邱区',
            
            
            parentId: 218,
            code: '210903000000',
            value: '450',
            
            id: 450
          },
          {
            label: '太平区',
            
            
            parentId: 218,
            code: '210904000000',
            value: '451',
            
            id: 451
          },
          {
            label: '清河门区',
            
            
            parentId: 218,
            code: '210905000000',
            value: '452',
            
            id: 452
          },
          {
            label: '细河区',
            
            
            parentId: 218,
            code: '210911000000',
            value: '453',
            
            id: 453
          },
          {
            label: '彰武县',
            
            
            parentId: 218,
            code: '210922000000',
            value: '454',
            
            id: 454
          }
        ],
        id: 218
      },
      {
        label: '辽阳市',
        
        
        parentId: 18,
        code: '211000000000',
        value: '219',
        children: [
          {
            label: '辽阳县',
            
            
            parentId: 219,
            code: '211021000000',
            value: '455',
            
            id: 455
          },
          {
            label: '白塔区',
            
            
            parentId: 219,
            code: '211002000000',
            value: '456',
            
            id: 456
          },
          {
            label: '文圣区',
            
            
            parentId: 219,
            code: '211003000000',
            value: '457',
            
            id: 457
          },
          {
            label: '宏伟区',
            
            
            parentId: 219,
            code: '211004000000',
            value: '458',
            
            id: 458
          },
          {
            label: '弓长岭区',
            
            
            parentId: 219,
            code: '211005000000',
            value: '459',
            
            id: 459
          },
          {
            label: '太子河区',
            
            
            parentId: 219,
            code: '211011000000',
            value: '460',
            
            id: 460
          },
          {
            label: '灯塔市',
            
            
            parentId: 219,
            code: '211081000000',
            value: '461',
            
            id: 461
          }
        ],
        id: 219
      },
      {
        label: '盘锦市',
        
        
        parentId: 18,
        code: '211100000000',
        value: '220',
        children: [
          {
            label: '双台子区',
            
            
            parentId: 220,
            code: '211102000000',
            value: '462',
            
            id: 462
          },
          {
            label: '兴隆台区',
            
            
            parentId: 220,
            code: '211103000000',
            value: '463',
            
            id: 463
          },
          {
            label: '大洼县',
            
            
            parentId: 220,
            code: '211121000000',
            value: '464',
            
            id: 464
          },
          {
            label: '盘山县',
            
            
            parentId: 220,
            code: '211122000000',
            value: '465',
            
            id: 465
          }
        ],
        id: 220
      },
      {
        label: '铁岭市',
        
        
        parentId: 18,
        code: '211200000000',
        value: '221',
        children: [
          {
            label: '银州区',
            
            
            parentId: 221,
            code: '211202000000',
            value: '466',
            
            id: 466
          },
          {
            label: '清河区',
            
            
            parentId: 221,
            code: '211204000000',
            value: '467',
            
            id: 467
          },
          {
            label: '调兵山市',
            
            
            parentId: 221,
            code: '211281000000',
            value: '468',
            
            id: 468
          },
          {
            label: '开原市',
            
            
            parentId: 221,
            code: '211282000000',
            value: '469',
            
            id: 469
          },
          {
            label: '铁岭县',
            
            
            parentId: 221,
            code: '211221000000',
            value: '470',
            
            id: 470
          },
          {
            label: '西丰县',
            
            
            parentId: 221,
            code: '211223000000',
            value: '471',
            
            id: 471
          },
          {
            label: '昌图县',
            
            
            parentId: 221,
            code: '211224000000',
            value: '472',
            
            id: 472
          }
        ],
        id: 221
      },
      {
        label: '朝阳市',
        
        
        parentId: 18,
        code: '211300000000',
        value: '222',
        children: [
          {
            label: '朝阳县',
            
            
            parentId: 222,
            code: '211321000000',
            value: '473',
            
            id: 473
          },
          {
            label: '建平县',
            
            
            parentId: 222,
            code: '211322000000',
            value: '474',
            
            id: 474
          },
          {
            label: '喀喇沁左翼蒙古族自治县',
            
            
            parentId: 222,
            code: '211324000000',
            value: '475',
            
            id: 475
          },
          {
            label: '北票市',
            
            
            parentId: 222,
            code: '211381000000',
            value: '476',
            
            id: 476
          },
          {
            label: '凌源市',
            
            
            parentId: 222,
            code: '211382000000',
            value: '477',
            
            id: 477
          },
          {
            label: '双塔区',
            
            
            parentId: 222,
            code: '211302000000',
            value: '478',
            
            id: 478
          },
          {
            label: '龙城区',
            
            
            parentId: 222,
            code: '211303000000',
            value: '479',
            
            id: 479
          }
        ],
        id: 222
      },
      {
        label: '葫芦岛市',
        
        
        parentId: 18,
        code: '211400000000',
        value: '223',
        children: [
          {
            label: '连山区',
            
            
            parentId: 223,
            code: '211402000000',
            value: '480',
            
            id: 480
          },
          {
            label: '龙港区',
            
            
            parentId: 223,
            code: '211403000000',
            value: '481',
            
            id: 481
          },
          {
            label: '南票区',
            
            
            parentId: 223,
            code: '211404000000',
            value: '482',
            
            id: 482
          },
          {
            label: '兴城市',
            
            
            parentId: 223,
            code: '211481000000',
            value: '483',
            
            id: 483
          },
          {
            label: '绥中县',
            
            
            parentId: 223,
            code: '211421000000',
            value: '484',
            
            id: 484
          },
          {
            label: '建昌县',
            
            
            parentId: 223,
            code: '211422000000',
            value: '485',
            
            id: 485
          }
        ],
        id: 223
      }
    ],
    id: 18
  },
  {
    label: '内蒙古自治区',
    
    
    parentId: 1,
    code: '150000000000',
    value: '19',
    children: [
      {
        label: '呼伦贝尔市',
        
        
        parentId: 19,
        code: '150700000000',
        value: '224',
        children: [
          {
            label: '莫力达瓦达斡尔族自治旗',
            
            
            parentId: 224,
            code: '150722000000',
            value: '2443',
            
            id: 2443
          },
          {
            label: '鄂伦春自治旗',
            
            
            parentId: 224,
            code: '150723000000',
            value: '2444',
            
            id: 2444
          },
          {
            label: '鄂温克族自治旗',
            
            
            parentId: 224,
            code: '150724000000',
            value: '2445',
            
            id: 2445
          },
          {
            label: '陈巴尔虎旗',
            
            
            parentId: 224,
            code: '150725000000',
            value: '2446',
            
            id: 2446
          },
          {
            label: '新巴尔虎左旗',
            
            
            parentId: 224,
            code: '150726000000',
            value: '2447',
            
            id: 2447
          },
          {
            label: '新巴尔虎右旗',
            
            
            parentId: 224,
            code: '150727000000',
            value: '2448',
            
            id: 2448
          },
          {
            label: '阿荣旗',
            
            
            parentId: 224,
            code: '150721000000',
            value: '2449',
            
            id: 2449
          },
          {
            label: '海拉尔区',
            
            
            parentId: 224,
            code: '150702000000',
            value: '2450',
            
            id: 2450
          },
          {
            label: '扎赉诺尔区',
            
            
            parentId: 224,
            code: '150703000000',
            value: '2451',
            
            id: 2451
          },
          {
            label: '满洲里市',
            
            
            parentId: 224,
            code: '150781000000',
            value: '2452',
            
            id: 2452
          },
          {
            label: '牙克石市',
            
            
            parentId: 224,
            code: '150782000000',
            value: '2453',
            
            id: 2453
          },
          {
            label: '扎兰屯市',
            
            
            parentId: 224,
            code: '150783000000',
            value: '2454',
            
            id: 2454
          },
          {
            label: '额尔古纳市',
            
            
            parentId: 224,
            code: '150784000000',
            value: '2455',
            
            id: 2455
          },
          {
            label: '根河市',
            
            
            parentId: 224,
            code: '150785000000',
            value: '2456',
            
            id: 2456
          }
        ],
        id: 224
      },
      {
        label: '呼和浩特市',
        
        
        parentId: 19,
        code: '150100000000',
        value: '225',
        children: [
          {
            label: '土默特左旗',
            
            
            parentId: 225,
            code: '150121000000',
            value: '2696',
            
            id: 2696
          },
          {
            label: '托克托县',
            
            
            parentId: 225,
            code: '150122000000',
            value: '2697',
            
            id: 2697
          },
          {
            label: '和林格尔县',
            
            
            parentId: 225,
            code: '150123000000',
            value: '2698',
            
            id: 2698
          },
          {
            label: '清水河县',
            
            
            parentId: 225,
            code: '150124000000',
            value: '2699',
            
            id: 2699
          },
          {
            label: '武川县',
            
            
            parentId: 225,
            code: '150125000000',
            value: '2700',
            
            id: 2700
          },
          {
            label: '新城区',
            
            
            parentId: 225,
            code: '150102000000',
            value: '2701',
            
            id: 2701
          },
          {
            label: '回民区',
            
            
            parentId: 225,
            code: '150103000000',
            value: '2702',
            
            id: 2702
          },
          {
            label: '玉泉区',
            
            
            parentId: 225,
            code: '150104000000',
            value: '2703',
            
            id: 2703
          },
          {
            label: '赛罕区',
            
            
            parentId: 225,
            code: '150105000000',
            value: '2704',
            
            id: 2704
          }
        ],
        id: 225
      },
      {
        label: '包头市',
        
        
        parentId: 19,
        code: '150200000000',
        value: '226',
        children: [
          {
            label: '东河区',
            
            
            parentId: 226,
            code: '150202000000',
            value: '2705',
            
            id: 2705
          },
          {
            label: '昆都仑区',
            
            
            parentId: 226,
            code: '150203000000',
            value: '2706',
            
            id: 2706
          },
          {
            label: '青山区',
            
            
            parentId: 226,
            code: '150204000000',
            value: '2707',
            
            id: 2707
          },
          {
            label: '石拐区',
            
            
            parentId: 226,
            code: '150205000000',
            value: '2708',
            
            id: 2708
          },
          {
            label: '白云鄂博矿区',
            
            
            parentId: 226,
            code: '150206000000',
            value: '2709',
            
            id: 2709
          },
          {
            label: '九原区',
            
            
            parentId: 226,
            code: '150207000000',
            value: '2710',
            
            id: 2710
          },
          {
            label: '固阳县',
            
            
            parentId: 226,
            code: '150222000000',
            value: '2711',
            
            id: 2711
          },
          {
            label: '土默特右旗',
            
            
            parentId: 226,
            code: '150221000000',
            value: '2712',
            
            id: 2712
          },
          {
            label: '达尔罕茂明安联合旗',
            
            
            parentId: 226,
            code: '150223000000',
            value: '2713',
            
            id: 2713
          }
        ],
        id: 226
      },
      {
        label: '乌海市',
        
        
        parentId: 19,
        code: '150300000000',
        value: '227',
        children: [
          {
            label: '海勃湾区',
            
            
            parentId: 227,
            code: '150302000000',
            value: '2714',
            
            id: 2714
          },
          {
            label: '海南区',
            
            
            parentId: 227,
            code: '150303000000',
            value: '2715',
            
            id: 2715
          },
          {
            label: '乌达区',
            
            
            parentId: 227,
            code: '150304000000',
            value: '2716',
            
            id: 2716
          }
        ],
        id: 227
      },
      {
        label: '赤峰市',
        
        
        parentId: 19,
        code: '150400000000',
        value: '228',
        children: [
          {
            label: '红山区',
            
            
            parentId: 228,
            code: '150402000000',
            value: '2717',
            
            id: 2717
          },
          {
            label: '元宝山区',
            
            
            parentId: 228,
            code: '150403000000',
            value: '2718',
            
            id: 2718
          },
          {
            label: '松山区',
            
            
            parentId: 228,
            code: '150404000000',
            value: '2719',
            
            id: 2719
          },
          {
            label: '宁城县',
            
            
            parentId: 228,
            code: '150429000000',
            value: '2720',
            
            id: 2720
          },
          {
            label: '林西县',
            
            
            parentId: 228,
            code: '150424000000',
            value: '2721',
            
            id: 2721
          },
          {
            label: '克什克腾旗',
            
            
            parentId: 228,
            code: '150425000000',
            value: '2722',
            
            id: 2722
          },
          {
            label: '翁牛特旗',
            
            
            parentId: 228,
            code: '150426000000',
            value: '2723',
            
            id: 2723
          },
          {
            label: '喀喇沁旗',
            
            
            parentId: 228,
            code: '150428000000',
            value: '2724',
            
            id: 2724
          },
          {
            label: '阿鲁科尔沁旗',
            
            
            parentId: 228,
            code: '150421000000',
            value: '2725',
            
            id: 2725
          },
          {
            label: '巴林左旗',
            
            
            parentId: 228,
            code: '150422000000',
            value: '2726',
            
            id: 2726
          },
          {
            label: '巴林右旗',
            
            
            parentId: 228,
            code: '150423000000',
            value: '2727',
            
            id: 2727
          },
          {
            label: '敖汉旗',
            
            
            parentId: 228,
            code: '150430000000',
            value: '2728',
            
            id: 2728
          }
        ],
        id: 228
      },
      {
        label: '通辽市',
        
        
        parentId: 19,
        code: '150500000000',
        value: '229',
        children: [
          {
            label: '库伦旗',
            
            
            parentId: 229,
            code: '150524000000',
            value: '2729',
            
            id: 2729
          },
          {
            label: '奈曼旗',
            
            
            parentId: 229,
            code: '150525000000',
            value: '2730',
            
            id: 2730
          },
          {
            label: '扎鲁特旗',
            
            
            parentId: 229,
            code: '150526000000',
            value: '2731',
            
            id: 2731
          },
          {
            label: '科尔沁左翼中旗',
            
            
            parentId: 229,
            code: '150521000000',
            value: '2732',
            
            id: 2732
          },
          {
            label: '科尔沁左翼后旗',
            
            
            parentId: 229,
            code: '150522000000',
            value: '2733',
            
            id: 2733
          },
          {
            label: '开鲁县',
            
            
            parentId: 229,
            code: '150523000000',
            value: '2734',
            
            id: 2734
          },
          {
            label: '科尔沁区',
            
            
            parentId: 229,
            code: '150502000000',
            value: '2735',
            
            id: 2735
          },
          {
            label: '霍林郭勒市',
            
            
            parentId: 229,
            code: '150581000000',
            value: '2736',
            
            id: 2736
          }
        ],
        id: 229
      },
      {
        label: '鄂尔多斯市',
        
        
        parentId: 19,
        code: '150600000000',
        value: '230',
        children: [
          {
            label: '东胜区',
            
            
            parentId: 230,
            code: '150602000000',
            value: '2737',
            
            id: 2737
          },
          {
            label: '达拉特旗',
            
            
            parentId: 230,
            code: '150621000000',
            value: '2738',
            
            id: 2738
          },
          {
            label: '准格尔旗',
            
            
            parentId: 230,
            code: '150622000000',
            value: '2739',
            
            id: 2739
          },
          {
            label: '鄂托克前旗',
            
            
            parentId: 230,
            code: '150623000000',
            value: '2740',
            
            id: 2740
          },
          {
            label: '鄂托克旗',
            
            
            parentId: 230,
            code: '150624000000',
            value: '2741',
            
            id: 2741
          },
          {
            label: '杭锦旗',
            
            
            parentId: 230,
            code: '150625000000',
            value: '2742',
            
            id: 2742
          },
          {
            label: '乌审旗',
            
            
            parentId: 230,
            code: '150626000000',
            value: '2743',
            
            id: 2743
          },
          {
            label: '伊金霍洛旗',
            
            
            parentId: 230,
            code: '150627000000',
            value: '2744',
            
            id: 2744
          }
        ],
        id: 230
      },
      {
        label: '兴安盟',
        
        
        parentId: 19,
        code: '152200000000',
        value: '231',
        children: [
          {
            label: '突泉县',
            
            
            parentId: 231,
            code: '152224000000',
            value: '1315',
            
            id: 1315
          },
          {
            label: '乌兰浩特市',
            
            
            parentId: 231,
            code: '152201000000',
            value: '1316',
            
            id: 1316
          },
          {
            label: '阿尔山市',
            
            
            parentId: 231,
            code: '152202000000',
            value: '1317',
            
            id: 1317
          },
          {
            label: '科尔沁右翼前旗',
            
            
            parentId: 231,
            code: '152221000000',
            value: '1318',
            
            id: 1318
          },
          {
            label: '科尔沁右翼中旗',
            
            
            parentId: 231,
            code: '152222000000',
            value: '1319',
            
            id: 1319
          },
          {
            label: '扎赉特旗',
            
            
            parentId: 231,
            code: '152223000000',
            value: '1320',
            
            id: 1320
          }
        ],
        id: 231
      },
      {
        label: '锡林郭勒盟',
        
        
        parentId: 19,
        code: '152500000000',
        value: '232',
        children: [
          {
            label: '阿巴嘎旗',
            
            
            parentId: 232,
            code: '152522000000',
            value: '1321',
            
            id: 1321
          },
          {
            label: '苏尼特左旗',
            
            
            parentId: 232,
            code: '152523000000',
            value: '1322',
            
            id: 1322
          },
          {
            label: '苏尼特右旗',
            
            
            parentId: 232,
            code: '152524000000',
            value: '1323',
            
            id: 1323
          },
          {
            label: '东乌珠穆沁旗',
            
            
            parentId: 232,
            code: '152525000000',
            value: '1324',
            
            id: 1324
          },
          {
            label: '西乌珠穆沁旗',
            
            
            parentId: 232,
            code: '152526000000',
            value: '1325',
            
            id: 1325
          },
          {
            label: '太仆寺旗',
            
            
            parentId: 232,
            code: '152527000000',
            value: '1326',
            
            id: 1326
          },
          {
            label: '镶黄旗',
            
            
            parentId: 232,
            code: '152528000000',
            value: '1327',
            
            id: 1327
          },
          {
            label: '正镶白旗',
            
            
            parentId: 232,
            code: '152529000000',
            value: '1328',
            
            id: 1328
          },
          {
            label: '正蓝旗',
            
            
            parentId: 232,
            code: '152530000000',
            value: '1329',
            
            id: 1329
          },
          {
            label: '二连浩特市',
            
            
            parentId: 232,
            code: '152501000000',
            value: '1330',
            
            id: 1330
          },
          {
            label: '锡林浩特市',
            
            
            parentId: 232,
            code: '152502000000',
            value: '1331',
            
            id: 1331
          },
          {
            label: '多伦县',
            
            
            parentId: 232,
            code: '152531000000',
            value: '1332',
            
            id: 1332
          }
        ],
        id: 232
      },
      {
        label: '乌兰察布市',
        
        
        parentId: 19,
        code: '150900000000',
        value: '233',
        children: [
          {
            label: '卓资县',
            
            
            parentId: 233,
            code: '150921000000',
            value: '1333',
            
            id: 1333
          },
          {
            label: '化德县',
            
            
            parentId: 233,
            code: '150922000000',
            value: '1334',
            
            id: 1334
          },
          {
            label: '商都县',
            
            
            parentId: 233,
            code: '150923000000',
            value: '1335',
            
            id: 1335
          },
          {
            label: '兴和县',
            
            
            parentId: 233,
            code: '150924000000',
            value: '1336',
            
            id: 1336
          },
          {
            label: '凉城县',
            
            
            parentId: 233,
            code: '150925000000',
            value: '1337',
            
            id: 1337
          },
          {
            label: '集宁区',
            
            
            parentId: 233,
            code: '150902000000',
            value: '1338',
            
            id: 1338
          },
          {
            label: '丰镇市',
            
            
            parentId: 233,
            code: '150981000000',
            value: '1339',
            
            id: 1339
          },
          {
            label: '察哈尔右翼前旗',
            
            
            parentId: 233,
            code: '150926000000',
            value: '1340',
            
            id: 1340
          },
          {
            label: '察哈尔右翼中旗',
            
            
            parentId: 233,
            code: '150927000000',
            value: '1341',
            
            id: 1341
          },
          {
            label: '察哈尔右翼后旗',
            
            
            parentId: 233,
            code: '150928000000',
            value: '1342',
            
            id: 1342
          },
          {
            label: '四子王旗',
            
            
            parentId: 233,
            code: '150929000000',
            value: '1343',
            
            id: 1343
          }
        ],
        id: 233
      },
      {
        label: '巴彦淖尔市',
        
        
        parentId: 19,
        code: '150800000000',
        value: '234',
        children: [
          {
            label: '乌拉特前旗',
            
            
            parentId: 234,
            code: '150823000000',
            value: '1344',
            
            id: 1344
          },
          {
            label: '乌拉特中旗',
            
            
            parentId: 234,
            code: '150824000000',
            value: '1345',
            
            id: 1345
          },
          {
            label: '乌拉特后旗',
            
            
            parentId: 234,
            code: '150825000000',
            value: '1346',
            
            id: 1346
          },
          {
            label: '杭锦后旗',
            
            
            parentId: 234,
            code: '150826000000',
            value: '1347',
            
            id: 1347
          },
          {
            label: '临河区',
            
            
            parentId: 234,
            code: '150802000000',
            value: '1348',
            
            id: 1348
          },
          {
            label: '五原县',
            
            
            parentId: 234,
            code: '150821000000',
            value: '1349',
            
            id: 1349
          },
          {
            label: '磴口县',
            
            
            parentId: 234,
            code: '150822000000',
            value: '1350',
            
            id: 1350
          }
        ],
        id: 234
      },
      {
        label: '阿拉善盟',
        
        
        parentId: 19,
        code: '152900000000',
        value: '235',
        children: [
          {
            label: '阿拉善左旗',
            
            
            parentId: 235,
            code: '152921000000',
            value: '1351',
            
            id: 1351
          },
          {
            label: '阿拉善右旗',
            
            
            parentId: 235,
            code: '152922000000',
            value: '1352',
            
            id: 1352
          },
          {
            label: '额济纳旗',
            
            
            parentId: 235,
            code: '152923000000',
            value: '1353',
            
            id: 1353
          }
        ],
        id: 235
      }
    ],
    id: 19
  },
  {
    label: '宁夏回族自治区',
    
    
    parentId: 1,
    code: '640000000000',
    value: '20',
    children: [
      {
        label: '银川市',
        
        
        parentId: 20,
        code: '640100000000',
        value: '236',
        children: [
          {
            label: '永宁县',
            
            
            parentId: 236,
            code: '640121000000',
            value: '3032',
            
            id: 3032
          },
          {
            label: '贺兰县',
            
            
            parentId: 236,
            code: '640122000000',
            value: '3033',
            
            id: 3033
          },
          {
            label: '兴庆区',
            
            
            parentId: 236,
            code: '640104000000',
            value: '3034',
            
            id: 3034
          },
          {
            label: '西夏区',
            
            
            parentId: 236,
            code: '640105000000',
            value: '3035',
            
            id: 3035
          },
          {
            label: '金凤区',
            
            
            parentId: 236,
            code: '640106000000',
            value: '3036',
            
            id: 3036
          },
          {
            label: '灵武市',
            
            
            parentId: 236,
            code: '640181000000',
            value: '3037',
            
            id: 3037
          }
        ],
        id: 236
      },
      {
        label: '石嘴山市',
        
        
        parentId: 20,
        code: '640200000000',
        value: '237',
        children: [
          {
            label: '大武口区',
            
            
            parentId: 237,
            code: '640202000000',
            value: '3038',
            
            id: 3038
          },
          {
            label: '惠农区',
            
            
            parentId: 237,
            code: '640205000000',
            value: '3039',
            
            id: 3039
          },
          {
            label: '平罗县',
            
            
            parentId: 237,
            code: '640221000000',
            value: '3040',
            
            id: 3040
          }
        ],
        id: 237
      },
      {
        label: '吴忠市',
        
        
        parentId: 20,
        code: '640300000000',
        value: '238',
        children: [
          {
            label: '利通区',
            
            
            parentId: 238,
            code: '640302000000',
            value: '3041',
            
            id: 3041
          },
          {
            label: '红寺堡区',
            
            
            parentId: 238,
            code: '640303000000',
            value: '3042',
            
            id: 3042
          },
          {
            label: '青铜峡市',
            
            
            parentId: 238,
            code: '640381000000',
            value: '3043',
            
            id: 3043
          },
          {
            label: '盐池县',
            
            
            parentId: 238,
            code: '640323000000',
            value: '3044',
            
            id: 3044
          },
          {
            label: '同心县',
            
            
            parentId: 238,
            code: '640324000000',
            value: '3045',
            
            id: 3045
          }
        ],
        id: 238
      },
      {
        label: '固原市',
        
        
        parentId: 20,
        code: '640400000000',
        value: '239',
        children: [
          {
            label: '西吉县',
            
            
            parentId: 239,
            code: '640422000000',
            value: '3046',
            
            id: 3046
          },
          {
            label: '隆德县',
            
            
            parentId: 239,
            code: '640423000000',
            value: '3047',
            
            id: 3047
          },
          {
            label: '泾源县',
            
            
            parentId: 239,
            code: '640424000000',
            value: '3048',
            
            id: 3048
          },
          {
            label: '彭阳县',
            
            
            parentId: 239,
            code: '640425000000',
            value: '3049',
            
            id: 3049
          },
          {
            label: '原州区',
            
            
            parentId: 239,
            code: '640402000000',
            value: '3050',
            
            id: 3050
          }
        ],
        id: 239
      },
      {
        label: '中卫市',
        
        
        parentId: 20,
        code: '640500000000',
        value: '240',
        children: [
          {
            label: '中宁县',
            
            
            parentId: 240,
            code: '640521000000',
            value: '3073',
            
            id: 3073
          },
          {
            label: '海原县',
            
            
            parentId: 240,
            code: '640522000000',
            value: '3074',
            
            id: 3074
          },
          {
            label: '沙坡头区',
            
            
            parentId: 240,
            code: '640502000000',
            value: '3075',
            
            id: 3075
          }
        ],
        id: 240
      }
    ],
    id: 20
  },
  {
    label: '青海省',
    
    
    parentId: 1,
    code: '630000000000',
    value: '21',
    children: [
      {
        label: '海东市',
        
        
        parentId: 21,
        code: '630200000000',
        value: '241',
        children: [
          {
            label: '互助土族自治县',
            
            
            parentId: 241,
            code: '630223000000',
            value: '981',
            
            id: 981
          },
          {
            label: '化隆回族自治县',
            
            
            parentId: 241,
            code: '630224000000',
            value: '982',
            
            id: 982
          },
          {
            label: '循化撒拉族自治县',
            
            
            parentId: 241,
            code: '630225000000',
            value: '983',
            
            id: 983
          },
          {
            label: '民和回族土族自治县',
            
            
            parentId: 241,
            code: '630222000000',
            value: '984',
            
            id: 984
          },
          {
            label: '平安县',
            
            
            parentId: 241,
            code: '630221000000',
            value: '985',
            
            id: 985
          },
          {
            label: '乐都区',
            
            
            parentId: 241,
            code: '630202000000',
            value: '986',
            
            id: 986
          }
        ],
        id: 241
      },
      {
        label: '海北藏族自治州',
        
        
        parentId: 21,
        code: '632200000000',
        value: '242',
        children: [
          {
            label: '门源回族自治县',
            
            
            parentId: 242,
            code: '632221000000',
            value: '1129',
            
            id: 1129
          },
          {
            label: '祁连县',
            
            
            parentId: 242,
            code: '632222000000',
            value: '1130',
            
            id: 1130
          },
          {
            label: '海晏县',
            
            
            parentId: 242,
            code: '632223000000',
            value: '1131',
            
            id: 1131
          },
          {
            label: '刚察县',
            
            
            parentId: 242,
            code: '632224000000',
            value: '1132',
            
            id: 1132
          }
        ],
        id: 242
      },
      {
        label: '黄南藏族自治州',
        
        
        parentId: 21,
        code: '632300000000',
        value: '243',
        children: [
          {
            label: '同仁县',
            
            
            parentId: 243,
            code: '632321000000',
            value: '1133',
            
            id: 1133
          },
          {
            label: '尖扎县',
            
            
            parentId: 243,
            code: '632322000000',
            value: '1134',
            
            id: 1134
          },
          {
            label: '泽库县',
            
            
            parentId: 243,
            code: '632323000000',
            value: '1135',
            
            id: 1135
          },
          {
            label: '河南蒙古族自治县',
            
            
            parentId: 243,
            code: '632324000000',
            value: '1136',
            
            id: 1136
          }
        ],
        id: 243
      },
      {
        label: '海南藏族自治州',
        
        
        parentId: 21,
        code: '632500000000',
        value: '244',
        children: [
          {
            label: '共和县',
            
            
            parentId: 244,
            code: '632521000000',
            value: '1137',
            
            id: 1137
          },
          {
            label: '同德县',
            
            
            parentId: 244,
            code: '632522000000',
            value: '1138',
            
            id: 1138
          },
          {
            label: '贵德县',
            
            
            parentId: 244,
            code: '632523000000',
            value: '1139',
            
            id: 1139
          },
          {
            label: '兴海县',
            
            
            parentId: 244,
            code: '632524000000',
            value: '1140',
            
            id: 1140
          },
          {
            label: '贵南县',
            
            
            parentId: 244,
            code: '632525000000',
            value: '1141',
            
            id: 1141
          }
        ],
        id: 244
      },
      {
        label: '果洛藏族自治州',
        
        
        parentId: 21,
        code: '632600000000',
        value: '245',
        children: [
          {
            label: '玛沁县',
            
            
            parentId: 245,
            code: '632621000000',
            value: '1142',
            
            id: 1142
          },
          {
            label: '班玛县',
            
            
            parentId: 245,
            code: '632622000000',
            value: '1143',
            
            id: 1143
          },
          {
            label: '甘德县',
            
            
            parentId: 245,
            code: '632623000000',
            value: '1144',
            
            id: 1144
          },
          {
            label: '达日县',
            
            
            parentId: 245,
            code: '632624000000',
            value: '1145',
            
            id: 1145
          },
          {
            label: '久治县',
            
            
            parentId: 245,
            code: '632625000000',
            value: '1146',
            
            id: 1146
          },
          {
            label: '玛多县',
            
            
            parentId: 245,
            code: '632626000000',
            value: '1147',
            
            id: 1147
          }
        ],
        id: 245
      },
      {
        label: '玉树藏族自治州',
        
        
        parentId: 21,
        code: '632700000000',
        value: '246',
        children: [
          {
            label: '玉树市',
            
            
            parentId: 246,
            code: '632701000000',
            value: '1148',
            
            id: 1148
          },
          {
            label: '杂多县',
            
            
            parentId: 246,
            code: '632722000000',
            value: '1149',
            
            id: 1149
          },
          {
            label: '称多县',
            
            
            parentId: 246,
            code: '632723000000',
            value: '1150',
            
            id: 1150
          },
          {
            label: '治多县',
            
            
            parentId: 246,
            code: '632724000000',
            value: '1151',
            
            id: 1151
          },
          {
            label: '囊谦县',
            
            
            parentId: 246,
            code: '632725000000',
            value: '1152',
            
            id: 1152
          },
          {
            label: '曲麻莱县',
            
            
            parentId: 246,
            code: '632726000000',
            value: '1153',
            
            id: 1153
          }
        ],
        id: 246
      },
      {
        label: '海西蒙古族藏族自治州',
        
        
        parentId: 21,
        code: '632800000000',
        value: '247',
        children: [
          {
            label: '乌兰县',
            
            
            parentId: 247,
            code: '632821000000',
            value: '1154',
            
            id: 1154
          },
          {
            label: '都兰县',
            
            
            parentId: 247,
            code: '632822000000',
            value: '1155',
            
            id: 1155
          },
          {
            label: '天峻县',
            
            
            parentId: 247,
            code: '632823000000',
            value: '1156',
            
            id: 1156
          },
          {
            label: '冷湖行政委员会',
            
            
            parentId: 247,
            code: '632858000000',
            value: '1157',
            
            id: 1157
          },
          {
            label: '大柴旦行政委员会',
            
            
            parentId: 247,
            code: '632857000000',
            value: '1158',
            
            id: 1158
          },
          {
            label: '茫崖行政委员会',
            
            
            parentId: 247,
            code: '632859000000',
            value: '1159',
            
            id: 1159
          },
          {
            label: '格尔木市',
            
            
            parentId: 247,
            code: '632801000000',
            value: '1160',
            
            id: 1160
          },
          {
            label: '德令哈市',
            
            
            parentId: 247,
            code: '632802000000',
            value: '1161',
            
            id: 1161
          }
        ],
        id: 247
      },
      {
        label: '西宁市',
        
        
        parentId: 21,
        code: '630100000000',
        value: '248',
        children: [
          {
            label: '城东区',
            
            
            parentId: 248,
            code: '630102000000',
            value: '3025',
            
            id: 3025
          },
          {
            label: '城中区',
            
            
            parentId: 248,
            code: '630103000000',
            value: '3026',
            
            id: 3026
          },
          {
            label: '城西区',
            
            
            parentId: 248,
            code: '630104000000',
            value: '3027',
            
            id: 3027
          },
          {
            label: '城北区',
            
            
            parentId: 248,
            code: '630105000000',
            value: '3028',
            
            id: 3028
          },
          {
            label: '大通回族土族自治县',
            
            
            parentId: 248,
            code: '630121000000',
            value: '3029',
            
            id: 3029
          },
          {
            label: '湟中县',
            
            
            parentId: 248,
            code: '630122000000',
            value: '3030',
            
            id: 3030
          },
          {
            label: '湟源县',
            
            
            parentId: 248,
            code: '630123000000',
            value: '3031',
            
            id: 3031
          }
        ],
        id: 248
      }
    ],
    id: 21
  },
  {
    label: '山东省',
    
    
    parentId: 1,
    code: '370000000000',
    value: '22',
    children: [
      {
        label: '济南市',
        
        
        parentId: 22,
        code: '370100000000',
        value: '249',
        children: [
          {
            label: '章丘市',
            
            
            parentId: 249,
            code: '370181000000',
            value: '1789',
            
            id: 1789
          },
          {
            label: '平阴县',
            
            
            parentId: 249,
            code: '370124000000',
            value: '1790',
            
            id: 1790
          },
          {
            label: '济阳县',
            
            
            parentId: 249,
            code: '370125000000',
            value: '1791',
            
            id: 1791
          },
          {
            label: '商河县',
            
            
            parentId: 249,
            code: '370126000000',
            value: '1792',
            
            id: 1792
          },
          {
            label: '历下区',
            
            
            parentId: 249,
            code: '370102000000',
            value: '1793',
            
            id: 1793
          },
          {
            label: '市中区',
            
            
            parentId: 249,
            code: '370103000000',
            value: '1794',
            
            id: 1794
          },
          {
            label: '槐荫区',
            
            
            parentId: 249,
            code: '370104000000',
            value: '1795',
            
            id: 1795
          },
          {
            label: '天桥区',
            
            
            parentId: 249,
            code: '370105000000',
            value: '1796',
            
            id: 1796
          },
          {
            label: '历城区',
            
            
            parentId: 249,
            code: '370112000000',
            value: '1797',
            
            id: 1797
          },
          {
            label: '长清区',
            
            
            parentId: 249,
            code: '370113000000',
            value: '1798',
            
            id: 1798
          }
        ],
        id: 249
      },
      {
        label: '青岛市',
        
        
        parentId: 22,
        code: '370200000000',
        value: '250',
        children: [
          {
            label: '市南区',
            
            
            parentId: 250,
            code: '370202000000',
            value: '1799',
            
            id: 1799
          },
          {
            label: '市北区',
            
            
            parentId: 250,
            code: '370203000000',
            value: '1800',
            
            id: 1800
          },
          {
            label: '黄岛区',
            
            
            parentId: 250,
            code: '370211000000',
            value: '1801',
            
            id: 1801
          },
          {
            label: '崂山区',
            
            
            parentId: 250,
            code: '370212000000',
            value: '1802',
            
            id: 1802
          },
          {
            label: '李沧区',
            
            
            parentId: 250,
            code: '370213000000',
            value: '1803',
            
            id: 1803
          },
          {
            label: '城阳区',
            
            
            parentId: 250,
            code: '370214000000',
            value: '1804',
            
            id: 1804
          },
          {
            label: '胶州市',
            
            
            parentId: 250,
            code: '370281000000',
            value: '1805',
            
            id: 1805
          },
          {
            label: '即墨市',
            
            
            parentId: 250,
            code: '370282000000',
            value: '1806',
            
            id: 1806
          },
          {
            label: '平度市',
            
            
            parentId: 250,
            code: '370283000000',
            value: '1807',
            
            id: 1807
          },
          {
            label: '莱西市',
            
            
            parentId: 250,
            code: '370285000000',
            value: '1808',
            
            id: 1808
          }
        ],
        id: 250
      },
      {
        label: '淄博市',
        
        
        parentId: 22,
        code: '370300000000',
        value: '251',
        children: [
          {
            label: '桓台县',
            
            
            parentId: 251,
            code: '370321000000',
            value: '1809',
            
            id: 1809
          },
          {
            label: '高青县',
            
            
            parentId: 251,
            code: '370322000000',
            value: '1810',
            
            id: 1810
          },
          {
            label: '沂源县',
            
            
            parentId: 251,
            code: '370323000000',
            value: '1811',
            
            id: 1811
          },
          {
            label: '淄川区',
            
            
            parentId: 251,
            code: '370302000000',
            value: '1812',
            
            id: 1812
          },
          {
            label: '张店区',
            
            
            parentId: 251,
            code: '370303000000',
            value: '1813',
            
            id: 1813
          },
          {
            label: '博山区',
            
            
            parentId: 251,
            code: '370304000000',
            value: '1814',
            
            id: 1814
          },
          {
            label: '临淄区',
            
            
            parentId: 251,
            code: '370305000000',
            value: '1815',
            
            id: 1815
          },
          {
            label: '周村区',
            
            
            parentId: 251,
            code: '370306000000',
            value: '1816',
            
            id: 1816
          }
        ],
        id: 251
      },
      {
        label: '枣庄市',
        
        
        parentId: 22,
        code: '370400000000',
        value: '252',
        children: [
          {
            label: '市中区',
            
            
            parentId: 252,
            code: '370402000000',
            value: '1817',
            
            id: 1817
          },
          {
            label: '薛城区',
            
            
            parentId: 252,
            code: '370403000000',
            value: '1818',
            
            id: 1818
          },
          {
            label: '峄城区',
            
            
            parentId: 252,
            code: '370404000000',
            value: '1819',
            
            id: 1819
          },
          {
            label: '台儿庄区',
            
            
            parentId: 252,
            code: '370405000000',
            value: '1820',
            
            id: 1820
          },
          {
            label: '山亭区',
            
            
            parentId: 252,
            code: '370406000000',
            value: '1821',
            
            id: 1821
          },
          {
            label: '滕州市',
            
            
            parentId: 252,
            code: '370481000000',
            value: '1822',
            
            id: 1822
          }
        ],
        id: 252
      },
      {
        label: '东营市',
        
        
        parentId: 22,
        code: '370500000000',
        value: '253',
        children: [
          {
            label: '垦利县',
            
            
            parentId: 253,
            code: '370521000000',
            value: '1823',
            
            id: 1823
          },
          {
            label: '利津县',
            
            
            parentId: 253,
            code: '370522000000',
            value: '1824',
            
            id: 1824
          },
          {
            label: '广饶县',
            
            
            parentId: 253,
            code: '370523000000',
            value: '1825',
            
            id: 1825
          },
          {
            label: '东营区',
            
            
            parentId: 253,
            code: '370502000000',
            value: '1826',
            
            id: 1826
          },
          {
            label: '河口区',
            
            
            parentId: 253,
            code: '370503000000',
            value: '1827',
            
            id: 1827
          }
        ],
        id: 253
      },
      {
        label: '烟台市',
        
        
        parentId: 22,
        code: '370600000000',
        value: '254',
        children: [
          {
            label: '芝罘区',
            
            
            parentId: 254,
            code: '370602000000',
            value: '1828',
            
            id: 1828
          },
          {
            label: '福山区',
            
            
            parentId: 254,
            code: '370611000000',
            value: '1829',
            
            id: 1829
          },
          {
            label: '牟平区',
            
            
            parentId: 254,
            code: '370612000000',
            value: '1830',
            
            id: 1830
          },
          {
            label: '莱山区',
            
            
            parentId: 254,
            code: '370613000000',
            value: '1831',
            
            id: 1831
          },
          {
            label: '长岛县',
            
            
            parentId: 254,
            code: '370634000000',
            value: '1832',
            
            id: 1832
          },
          {
            label: '龙口市',
            
            
            parentId: 254,
            code: '370681000000',
            value: '1833',
            
            id: 1833
          },
          {
            label: '莱阳市',
            
            
            parentId: 254,
            code: '370682000000',
            value: '1834',
            
            id: 1834
          },
          {
            label: '莱州市',
            
            
            parentId: 254,
            code: '370683000000',
            value: '1835',
            
            id: 1835
          },
          {
            label: '蓬莱市',
            
            
            parentId: 254,
            code: '370684000000',
            value: '1836',
            
            id: 1836
          },
          {
            label: '招远市',
            
            
            parentId: 254,
            code: '370685000000',
            value: '1837',
            
            id: 1837
          },
          {
            label: '栖霞市',
            
            
            parentId: 254,
            code: '370686000000',
            value: '1838',
            
            id: 1838
          },
          {
            label: '海阳市',
            
            
            parentId: 254,
            code: '370687000000',
            value: '1839',
            
            id: 1839
          }
        ],
        id: 254
      },
      {
        label: '潍坊市',
        
        
        parentId: 22,
        code: '370700000000',
        value: '255',
        children: [
          {
            label: '青州市',
            
            
            parentId: 255,
            code: '370781000000',
            value: '1840',
            
            id: 1840
          },
          {
            label: '诸城市',
            
            
            parentId: 255,
            code: '370782000000',
            value: '1841',
            
            id: 1841
          },
          {
            label: '寿光市',
            
            
            parentId: 255,
            code: '370783000000',
            value: '1842',
            
            id: 1842
          },
          {
            label: '安丘市',
            
            
            parentId: 255,
            code: '370784000000',
            value: '1843',
            
            id: 1843
          },
          {
            label: '高密市',
            
            
            parentId: 255,
            code: '370785000000',
            value: '1844',
            
            id: 1844
          },
          {
            label: '昌邑市',
            
            
            parentId: 255,
            code: '370786000000',
            value: '1845',
            
            id: 1845
          },
          {
            label: '临朐县',
            
            
            parentId: 255,
            code: '370724000000',
            value: '1846',
            
            id: 1846
          },
          {
            label: '昌乐县',
            
            
            parentId: 255,
            code: '370725000000',
            value: '1847',
            
            id: 1847
          },
          {
            label: '潍城区',
            
            
            parentId: 255,
            code: '370702000000',
            value: '1848',
            
            id: 1848
          },
          {
            label: '寒亭区',
            
            
            parentId: 255,
            code: '370703000000',
            value: '1849',
            
            id: 1849
          },
          {
            label: '坊子区',
            
            
            parentId: 255,
            code: '370704000000',
            value: '1850',
            
            id: 1850
          },
          {
            label: '奎文区',
            
            
            parentId: 255,
            code: '370705000000',
            value: '1851',
            
            id: 1851
          }
        ],
        id: 255
      },
      {
        label: '济宁市',
        
        
        parentId: 22,
        code: '370800000000',
        value: '256',
        children: [
          {
            label: '任城区',
            
            
            parentId: 256,
            code: '370811000000',
            value: '1852',
            
            id: 1852
          },
          {
            label: '微山县',
            
            
            parentId: 256,
            code: '370826000000',
            value: '1853',
            
            id: 1853
          },
          {
            label: '鱼台县',
            
            
            parentId: 256,
            code: '370827000000',
            value: '1854',
            
            id: 1854
          },
          {
            label: '金乡县',
            
            
            parentId: 256,
            code: '370828000000',
            value: '1855',
            
            id: 1855
          },
          {
            label: '嘉祥县',
            
            
            parentId: 256,
            code: '370829000000',
            value: '1856',
            
            id: 1856
          },
          {
            label: '汶上县',
            
            
            parentId: 256,
            code: '370830000000',
            value: '1857',
            
            id: 1857
          },
          {
            label: '泗水县',
            
            
            parentId: 256,
            code: '370831000000',
            value: '1858',
            
            id: 1858
          },
          {
            label: '梁山县',
            
            
            parentId: 256,
            code: '370832000000',
            value: '1859',
            
            id: 1859
          },
          {
            label: '曲阜市',
            
            
            parentId: 256,
            code: '370881000000',
            value: '1860',
            
            id: 1860
          },
          {
            label: '兖州区',
            
            
            parentId: 256,
            code: '370812000000',
            value: '1861',
            
            id: 1861
          },
          {
            label: '邹城市',
            
            
            parentId: 256,
            code: '370883000000',
            value: '1862',
            
            id: 1862
          }
        ],
        id: 256
      },
      {
        label: '泰安市',
        
        
        parentId: 22,
        code: '370900000000',
        value: '257',
        children: [
          {
            label: '新泰市',
            
            
            parentId: 257,
            code: '370982000000',
            value: '1863',
            
            id: 1863
          },
          {
            label: '肥城市',
            
            
            parentId: 257,
            code: '370983000000',
            value: '1864',
            
            id: 1864
          },
          {
            label: '宁阳县',
            
            
            parentId: 257,
            code: '370921000000',
            value: '1865',
            
            id: 1865
          },
          {
            label: '东平县',
            
            
            parentId: 257,
            code: '370923000000',
            value: '1866',
            
            id: 1866
          },
          {
            label: '泰山区',
            
            
            parentId: 257,
            code: '370902000000',
            value: '1867',
            
            id: 1867
          },
          {
            label: '岱岳区',
            
            
            parentId: 257,
            code: '370911000000',
            value: '1868',
            
            id: 1868
          }
        ],
        id: 257
      },
      {
        label: '威海市',
        
        
        parentId: 22,
        code: '371000000000',
        value: '258',
        children: [
          {
            label: '环翠区',
            
            
            parentId: 258,
            code: '371002000000',
            value: '1869',
            
            id: 1869
          },
          {
            label: '文登区',
            
            
            parentId: 258,
            code: '371003000000',
            value: '1870',
            
            id: 1870
          },
          {
            label: '荣成市',
            
            
            parentId: 258,
            code: '371082000000',
            value: '1871',
            
            id: 1871
          },
          {
            label: '乳山市',
            
            
            parentId: 258,
            code: '371083000000',
            value: '1872',
            
            id: 1872
          }
        ],
        id: 258
      },
      {
        label: '日照市',
        
        
        parentId: 22,
        code: '371100000000',
        value: '259',
        children: [
          {
            label: '五莲县',
            
            
            parentId: 259,
            code: '371121000000',
            value: '1873',
            
            id: 1873
          },
          {
            label: '莒县',
            
            
            parentId: 259,
            code: '371122000000',
            value: '1874',
            
            id: 1874
          },
          {
            label: '岚山区',
            
            
            parentId: 259,
            code: '371103000000',
            value: '1875',
            
            id: 1875
          },
          {
            label: '东港区',
            
            
            parentId: 259,
            code: '371102000000',
            value: '1876',
            
            id: 1876
          }
        ],
        id: 259
      },
      {
        label: '莱芜市',
        
        
        parentId: 22,
        code: '371200000000',
        value: '260',
        children: [
          {
            label: '莱城区',
            
            
            parentId: 260,
            code: '371202000000',
            value: '1877',
            
            id: 1877
          },
          {
            label: '钢城区',
            
            
            parentId: 260,
            code: '371203000000',
            value: '1878',
            
            id: 1878
          }
        ],
        id: 260
      },
      {
        label: '临沂市',
        
        
        parentId: 22,
        code: '371300000000',
        value: '261',
        children: [
          {
            label: '沂南县',
            
            
            parentId: 261,
            code: '371321000000',
            value: '1879',
            
            id: 1879
          },
          {
            label: '郯城县',
            
            
            parentId: 261,
            code: '371322000000',
            value: '1880',
            
            id: 1880
          },
          {
            label: '沂水县',
            
            
            parentId: 261,
            code: '371323000000',
            value: '1881',
            
            id: 1881
          },
          {
            label: '兰陵县',
            
            
            parentId: 261,
            code: '371324000000',
            value: '1882',
            
            id: 1882
          },
          {
            label: '费县',
            
            
            parentId: 261,
            code: '371325000000',
            value: '1883',
            
            id: 1883
          },
          {
            label: '平邑县',
            
            
            parentId: 261,
            code: '371326000000',
            value: '1884',
            
            id: 1884
          },
          {
            label: '莒南县',
            
            
            parentId: 261,
            code: '371327000000',
            value: '1885',
            
            id: 1885
          },
          {
            label: '蒙阴县',
            
            
            parentId: 261,
            code: '371328000000',
            value: '1886',
            
            id: 1886
          },
          {
            label: '临沭县',
            
            
            parentId: 261,
            code: '371329000000',
            value: '1887',
            
            id: 1887
          },
          {
            label: '兰山区',
            
            
            parentId: 261,
            code: '371302000000',
            value: '1888',
            
            id: 1888
          },
          {
            label: '罗庄区',
            
            
            parentId: 261,
            code: '371311000000',
            value: '1889',
            
            id: 1889
          },
          {
            label: '河东区',
            
            
            parentId: 261,
            code: '371312000000',
            value: '1890',
            
            id: 1890
          }
        ],
        id: 261
      },
      {
        label: '德州市',
        
        
        parentId: 22,
        code: '371400000000',
        value: '262',
        children: [
          {
            label: '德城区',
            
            
            parentId: 262,
            code: '371402000000',
            value: '1891',
            
            id: 1891
          },
          {
            label: '陵城区',
            
            
            parentId: 262,
            code: '371403000000',
            value: '1892',
            
            id: 1892
          },
          {
            label: '宁津县',
            
            
            parentId: 262,
            code: '371422000000',
            value: '1893',
            
            id: 1893
          },
          {
            label: '庆云县',
            
            
            parentId: 262,
            code: '371423000000',
            value: '1894',
            
            id: 1894
          },
          {
            label: '临邑县',
            
            
            parentId: 262,
            code: '371424000000',
            value: '1895',
            
            id: 1895
          },
          {
            label: '齐河县',
            
            
            parentId: 262,
            code: '371425000000',
            value: '1896',
            
            id: 1896
          },
          {
            label: '平原县',
            
            
            parentId: 262,
            code: '371426000000',
            value: '1897',
            
            id: 1897
          },
          {
            label: '夏津县',
            
            
            parentId: 262,
            code: '371427000000',
            value: '1898',
            
            id: 1898
          },
          {
            label: '武城县',
            
            
            parentId: 262,
            code: '371428000000',
            value: '1899',
            
            id: 1899
          },
          {
            label: '乐陵市',
            
            
            parentId: 262,
            code: '371481000000',
            value: '1900',
            
            id: 1900
          },
          {
            label: '禹城市',
            
            
            parentId: 262,
            code: '371482000000',
            value: '1901',
            
            id: 1901
          }
        ],
        id: 262
      },
      {
        label: '聊城市',
        
        
        parentId: 22,
        code: '371500000000',
        value: '263',
        children: [
          {
            label: '临清市',
            
            
            parentId: 263,
            code: '371581000000',
            value: '1902',
            
            id: 1902
          },
          {
            label: '阳谷县',
            
            
            parentId: 263,
            code: '371521000000',
            value: '1903',
            
            id: 1903
          },
          {
            label: '莘县',
            
            
            parentId: 263,
            code: '371522000000',
            value: '1904',
            
            id: 1904
          },
          {
            label: '茌平县',
            
            
            parentId: 263,
            code: '371523000000',
            value: '1905',
            
            id: 1905
          },
          {
            label: '东阿县',
            
            
            parentId: 263,
            code: '371524000000',
            value: '1906',
            
            id: 1906
          },
          {
            label: '冠县',
            
            
            parentId: 263,
            code: '371525000000',
            value: '1907',
            
            id: 1907
          },
          {
            label: '高唐县',
            
            
            parentId: 263,
            code: '371526000000',
            value: '1908',
            
            id: 1908
          },
          {
            label: '东昌府区',
            
            
            parentId: 263,
            code: '371502000000',
            value: '1909',
            
            id: 1909
          }
        ],
        id: 263
      },
      {
        label: '滨州市',
        
        
        parentId: 22,
        code: '371600000000',
        value: '264',
        children: [
          {
            label: '滨城区',
            
            
            parentId: 264,
            code: '371602000000',
            value: '1910',
            
            id: 1910
          },
          {
            label: '惠民县',
            
            
            parentId: 264,
            code: '371621000000',
            value: '1911',
            
            id: 1911
          },
          {
            label: '阳信县',
            
            
            parentId: 264,
            code: '371622000000',
            value: '1912',
            
            id: 1912
          },
          {
            label: '无棣县',
            
            
            parentId: 264,
            code: '371623000000',
            value: '1913',
            
            id: 1913
          },
          {
            label: '沾化区',
            
            
            parentId: 264,
            code: '371603000000',
            value: '1914',
            
            id: 1914
          },
          {
            label: '博兴县',
            
            
            parentId: 264,
            code: '371625000000',
            value: '1915',
            
            id: 1915
          },
          {
            label: '邹平县',
            
            
            parentId: 264,
            code: '371626000000',
            value: '1916',
            
            id: 1916
          }
        ],
        id: 264
      },
      {
        label: '菏泽市',
        
        
        parentId: 22,
        code: '371700000000',
        value: '265',
        children: [
          {
            label: '曹县',
            
            
            parentId: 265,
            code: '371721000000',
            value: '1917',
            
            id: 1917
          },
          {
            label: '单县',
            
            
            parentId: 265,
            code: '371722000000',
            value: '1918',
            
            id: 1918
          },
          {
            label: '成武县',
            
            
            parentId: 265,
            code: '371723000000',
            value: '1919',
            
            id: 1919
          },
          {
            label: '巨野县',
            
            
            parentId: 265,
            code: '371724000000',
            value: '1920',
            
            id: 1920
          },
          {
            label: '郓城县',
            
            
            parentId: 265,
            code: '371725000000',
            value: '1921',
            
            id: 1921
          },
          {
            label: '鄄城县',
            
            
            parentId: 265,
            code: '371726000000',
            value: '1922',
            
            id: 1922
          },
          {
            label: '定陶县',
            
            
            parentId: 265,
            code: '371727000000',
            value: '1923',
            
            id: 1923
          },
          {
            label: '东明县',
            
            
            parentId: 265,
            code: '371728000000',
            value: '1924',
            
            id: 1924
          },
          {
            label: '牡丹区',
            
            
            parentId: 265,
            code: '371702000000',
            value: '1925',
            
            id: 1925
          }
        ],
        id: 265
      }
    ],
    id: 22
  },
  {
    label: '山西省',
    
    
    parentId: 1,
    code: '140000000000',
    value: '23',
    children: [
      {
        label: '吕梁市',
        
        
        parentId: 23,
        code: '141100000000',
        value: '266',
        children: [
          {
            label: '文水县',
            
            
            parentId: 266,
            code: '141121000000',
            value: '911',
            
            id: 911
          },
          {
            label: '交城县',
            
            
            parentId: 266,
            code: '141122000000',
            value: '912',
            
            id: 912
          },
          {
            label: '兴县',
            
            
            parentId: 266,
            code: '141123000000',
            value: '913',
            
            id: 913
          },
          {
            label: '临县',
            
            
            parentId: 266,
            code: '141124000000',
            value: '914',
            
            id: 914
          },
          {
            label: '柳林县',
            
            
            parentId: 266,
            code: '141125000000',
            value: '915',
            
            id: 915
          },
          {
            label: '石楼县',
            
            
            parentId: 266,
            code: '141126000000',
            value: '916',
            
            id: 916
          },
          {
            label: '岚县',
            
            
            parentId: 266,
            code: '141127000000',
            value: '917',
            
            id: 917
          },
          {
            label: '方山县',
            
            
            parentId: 266,
            code: '141128000000',
            value: '918',
            
            id: 918
          },
          {
            label: '中阳县',
            
            
            parentId: 266,
            code: '141129000000',
            value: '919',
            
            id: 919
          },
          {
            label: '交口县',
            
            
            parentId: 266,
            code: '141130000000',
            value: '920',
            
            id: 920
          },
          {
            label: '孝义市',
            
            
            parentId: 266,
            code: '141181000000',
            value: '921',
            
            id: 921
          },
          {
            label: '离石区',
            
            
            parentId: 266,
            code: '141102000000',
            value: '922',
            
            id: 922
          },
          {
            label: '汾阳市',
            
            
            parentId: 266,
            code: '141182000000',
            value: '923',
            
            id: 923
          }
        ],
        id: 266
      },
      {
        label: '太原市',
        
        
        parentId: 23,
        code: '140100000000',
        value: '267',
        children: [
          {
            label: '清徐县',
            
            
            parentId: 267,
            code: '140121000000',
            value: '2344',
            
            id: 2344
          },
          {
            label: '阳曲县',
            
            
            parentId: 267,
            code: '140122000000',
            value: '2345',
            
            id: 2345
          },
          {
            label: '娄烦县',
            
            
            parentId: 267,
            code: '140123000000',
            value: '2346',
            
            id: 2346
          },
          {
            label: '小店区',
            
            
            parentId: 267,
            code: '140105000000',
            value: '2347',
            
            id: 2347
          },
          {
            label: '迎泽区',
            
            
            parentId: 267,
            code: '140106000000',
            value: '2348',
            
            id: 2348
          },
          {
            label: '杏花岭区',
            
            
            parentId: 267,
            code: '140107000000',
            value: '2349',
            
            id: 2349
          },
          {
            label: '尖草坪区',
            
            
            parentId: 267,
            code: '140108000000',
            value: '2350',
            
            id: 2350
          },
          {
            label: '万柏林区',
            
            
            parentId: 267,
            code: '140109000000',
            value: '2351',
            
            id: 2351
          },
          {
            label: '晋源区',
            
            
            parentId: 267,
            code: '140110000000',
            value: '2352',
            
            id: 2352
          },
          {
            label: '古交市',
            
            
            parentId: 267,
            code: '140181000000',
            value: '2353',
            
            id: 2353
          }
        ],
        id: 267
      },
      {
        label: '大同市',
        
        
        parentId: 23,
        code: '140200000000',
        value: '268',
        children: [
          {
            label: '城区',
            
            
            parentId: 268,
            code: '140202000000',
            value: '2354',
            
            id: 2354
          },
          {
            label: '矿区',
            
            
            parentId: 268,
            code: '140203000000',
            value: '2355',
            
            id: 2355
          },
          {
            label: '南郊区',
            
            
            parentId: 268,
            code: '140211000000',
            value: '2356',
            
            id: 2356
          },
          {
            label: '新荣区',
            
            
            parentId: 268,
            code: '140212000000',
            value: '2357',
            
            id: 2357
          },
          {
            label: '阳高县',
            
            
            parentId: 268,
            code: '140221000000',
            value: '2358',
            
            id: 2358
          },
          {
            label: '天镇县',
            
            
            parentId: 268,
            code: '140222000000',
            value: '2359',
            
            id: 2359
          },
          {
            label: '广灵县',
            
            
            parentId: 268,
            code: '140223000000',
            value: '2360',
            
            id: 2360
          },
          {
            label: '灵丘县',
            
            
            parentId: 268,
            code: '140224000000',
            value: '2361',
            
            id: 2361
          },
          {
            label: '浑源县',
            
            
            parentId: 268,
            code: '140225000000',
            value: '2362',
            
            id: 2362
          },
          {
            label: '左云县',
            
            
            parentId: 268,
            code: '140226000000',
            value: '2363',
            
            id: 2363
          },
          {
            label: '大同县',
            
            
            parentId: 268,
            code: '140227000000',
            value: '2364',
            
            id: 2364
          }
        ],
        id: 268
      },
      {
        label: '阳泉市',
        
        
        parentId: 23,
        code: '140300000000',
        value: '269',
        children: [
          {
            label: '平定县',
            
            
            parentId: 269,
            code: '140321000000',
            value: '2365',
            
            id: 2365
          },
          {
            label: '盂县',
            
            
            parentId: 269,
            code: '140322000000',
            value: '2366',
            
            id: 2366
          },
          {
            label: '城区',
            
            
            parentId: 269,
            code: '140302000000',
            value: '2367',
            
            id: 2367
          },
          {
            label: '矿区',
            
            
            parentId: 269,
            code: '140303000000',
            value: '2368',
            
            id: 2368
          },
          {
            label: '郊区',
            
            
            parentId: 269,
            code: '140311000000',
            value: '2369',
            
            id: 2369
          }
        ],
        id: 269
      },
      {
        label: '长治市',
        
        
        parentId: 23,
        code: '140400000000',
        value: '270',
        children: [
          {
            label: '城区',
            
            
            parentId: 270,
            code: '140402000000',
            value: '2370',
            
            id: 2370
          },
          {
            label: '郊区',
            
            
            parentId: 270,
            code: '140411000000',
            value: '2371',
            
            id: 2371
          },
          {
            label: '长治县',
            
            
            parentId: 270,
            code: '140421000000',
            value: '2372',
            
            id: 2372
          },
          {
            label: '襄垣县',
            
            
            parentId: 270,
            code: '140423000000',
            value: '2373',
            
            id: 2373
          },
          {
            label: '屯留县',
            
            
            parentId: 270,
            code: '140424000000',
            value: '2374',
            
            id: 2374
          },
          {
            label: '平顺县',
            
            
            parentId: 270,
            code: '140425000000',
            value: '2375',
            
            id: 2375
          },
          {
            label: '黎城县',
            
            
            parentId: 270,
            code: '140426000000',
            value: '2376',
            
            id: 2376
          },
          {
            label: '壶关县',
            
            
            parentId: 270,
            code: '140427000000',
            value: '2377',
            
            id: 2377
          },
          {
            label: '长子县',
            
            
            parentId: 270,
            code: '140428000000',
            value: '2378',
            
            id: 2378
          },
          {
            label: '武乡县',
            
            
            parentId: 270,
            code: '140429000000',
            value: '2379',
            
            id: 2379
          },
          {
            label: '沁县',
            
            
            parentId: 270,
            code: '140430000000',
            value: '2380',
            
            id: 2380
          },
          {
            label: '沁源县',
            
            
            parentId: 270,
            code: '140431000000',
            value: '2381',
            
            id: 2381
          },
          {
            label: '潞城市',
            
            
            parentId: 270,
            code: '140481000000',
            value: '2382',
            
            id: 2382
          }
        ],
        id: 270
      },
      {
        label: '晋城市',
        
        
        parentId: 23,
        code: '140500000000',
        value: '271',
        children: [
          {
            label: '沁水县',
            
            
            parentId: 271,
            code: '140521000000',
            value: '2383',
            
            id: 2383
          },
          {
            label: '阳城县',
            
            
            parentId: 271,
            code: '140522000000',
            value: '2384',
            
            id: 2384
          },
          {
            label: '陵川县',
            
            
            parentId: 271,
            code: '140524000000',
            value: '2385',
            
            id: 2385
          },
          {
            label: '泽州县',
            
            
            parentId: 271,
            code: '140525000000',
            value: '2386',
            
            id: 2386
          },
          {
            label: '城区',
            
            
            parentId: 271,
            code: '140502000000',
            value: '2387',
            
            id: 2387
          },
          {
            label: '高平市',
            
            
            parentId: 271,
            code: '140581000000',
            value: '2388',
            
            id: 2388
          }
        ],
        id: 271
      },
      {
        label: '朔州市',
        
        
        parentId: 23,
        code: '140600000000',
        value: '272',
        children: [
          {
            label: '朔城区',
            
            
            parentId: 272,
            code: '140602000000',
            value: '2389',
            
            id: 2389
          },
          {
            label: '平鲁区',
            
            
            parentId: 272,
            code: '140603000000',
            value: '2390',
            
            id: 2390
          },
          {
            label: '山阴县',
            
            
            parentId: 272,
            code: '140621000000',
            value: '2391',
            
            id: 2391
          },
          {
            label: '应县',
            
            
            parentId: 272,
            code: '140622000000',
            value: '2392',
            
            id: 2392
          },
          {
            label: '右玉县',
            
            
            parentId: 272,
            code: '140623000000',
            value: '2393',
            
            id: 2393
          },
          {
            label: '怀仁县',
            
            
            parentId: 272,
            code: '140624000000',
            value: '2394',
            
            id: 2394
          }
        ],
        id: 272
      },
      {
        label: '晋中市',
        
        
        parentId: 23,
        code: '140700000000',
        value: '273',
        children: [
          {
            label: '榆社县',
            
            
            parentId: 273,
            code: '140721000000',
            value: '2395',
            
            id: 2395
          },
          {
            label: '左权县',
            
            
            parentId: 273,
            code: '140722000000',
            value: '2396',
            
            id: 2396
          },
          {
            label: '和顺县',
            
            
            parentId: 273,
            code: '140723000000',
            value: '2397',
            
            id: 2397
          },
          {
            label: '昔阳县',
            
            
            parentId: 273,
            code: '140724000000',
            value: '2398',
            
            id: 2398
          },
          {
            label: '寿阳县',
            
            
            parentId: 273,
            code: '140725000000',
            value: '2399',
            
            id: 2399
          },
          {
            label: '太谷县',
            
            
            parentId: 273,
            code: '140726000000',
            value: '2400',
            
            id: 2400
          },
          {
            label: '祁县',
            
            
            parentId: 273,
            code: '140727000000',
            value: '2401',
            
            id: 2401
          },
          {
            label: '平遥县',
            
            
            parentId: 273,
            code: '140728000000',
            value: '2402',
            
            id: 2402
          },
          {
            label: '灵石县',
            
            
            parentId: 273,
            code: '140729000000',
            value: '2403',
            
            id: 2403
          },
          {
            label: '榆次区',
            
            
            parentId: 273,
            code: '140702000000',
            value: '2404',
            
            id: 2404
          },
          {
            label: '介休市',
            
            
            parentId: 273,
            code: '140781000000',
            value: '2405',
            
            id: 2405
          }
        ],
        id: 273
      },
      {
        label: '运城市',
        
        
        parentId: 23,
        code: '140800000000',
        value: '274',
        children: [
          {
            label: '永济市',
            
            
            parentId: 274,
            code: '140881000000',
            value: '2406',
            
            id: 2406
          },
          {
            label: '河津市',
            
            
            parentId: 274,
            code: '140882000000',
            value: '2407',
            
            id: 2407
          },
          {
            label: '盐湖区',
            
            
            parentId: 274,
            code: '140802000000',
            value: '2408',
            
            id: 2408
          },
          {
            label: '临猗县',
            
            
            parentId: 274,
            code: '140821000000',
            value: '2409',
            
            id: 2409
          },
          {
            label: '万荣县',
            
            
            parentId: 274,
            code: '140822000000',
            value: '2410',
            
            id: 2410
          },
          {
            label: '闻喜县',
            
            
            parentId: 274,
            code: '140823000000',
            value: '2411',
            
            id: 2411
          },
          {
            label: '稷山县',
            
            
            parentId: 274,
            code: '140824000000',
            value: '2412',
            
            id: 2412
          },
          {
            label: '新绛县',
            
            
            parentId: 274,
            code: '140825000000',
            value: '2413',
            
            id: 2413
          },
          {
            label: '绛县',
            
            
            parentId: 274,
            code: '140826000000',
            value: '2414',
            
            id: 2414
          },
          {
            label: '垣曲县',
            
            
            parentId: 274,
            code: '140827000000',
            value: '2415',
            
            id: 2415
          },
          {
            label: '夏县',
            
            
            parentId: 274,
            code: '140828000000',
            value: '2416',
            
            id: 2416
          },
          {
            label: '平陆县',
            
            
            parentId: 274,
            code: '140829000000',
            value: '2417',
            
            id: 2417
          },
          {
            label: '芮城县',
            
            
            parentId: 274,
            code: '140830000000',
            value: '2418',
            
            id: 2418
          }
        ],
        id: 274
      },
      {
        label: '忻州市',
        
        
        parentId: 23,
        code: '140900000000',
        value: '275',
        children: [
          {
            label: '定襄县',
            
            
            parentId: 275,
            code: '140921000000',
            value: '2419',
            
            id: 2419
          },
          {
            label: '五台县',
            
            
            parentId: 275,
            code: '140922000000',
            value: '2420',
            
            id: 2420
          },
          {
            label: '代县',
            
            
            parentId: 275,
            code: '140923000000',
            value: '2421',
            
            id: 2421
          },
          {
            label: '繁峙县',
            
            
            parentId: 275,
            code: '140924000000',
            value: '2422',
            
            id: 2422
          },
          {
            label: '宁武县',
            
            
            parentId: 275,
            code: '140925000000',
            value: '2423',
            
            id: 2423
          },
          {
            label: '静乐县',
            
            
            parentId: 275,
            code: '140926000000',
            value: '2424',
            
            id: 2424
          },
          {
            label: '神池县',
            
            
            parentId: 275,
            code: '140927000000',
            value: '2425',
            
            id: 2425
          },
          {
            label: '五寨县',
            
            
            parentId: 275,
            code: '140928000000',
            value: '2426',
            
            id: 2426
          },
          {
            label: '岢岚县',
            
            
            parentId: 275,
            code: '140929000000',
            value: '2427',
            
            id: 2427
          },
          {
            label: '河曲县',
            
            
            parentId: 275,
            code: '140930000000',
            value: '2428',
            
            id: 2428
          },
          {
            label: '保德县',
            
            
            parentId: 275,
            code: '140931000000',
            value: '2429',
            
            id: 2429
          },
          {
            label: '偏关县',
            
            
            parentId: 275,
            code: '140932000000',
            value: '2430',
            
            id: 2430
          },
          {
            label: '忻府区',
            
            
            parentId: 275,
            code: '140902000000',
            value: '2431',
            
            id: 2431
          },
          {
            label: '原平市',
            
            
            parentId: 275,
            code: '140981000000',
            value: '2432',
            
            id: 2432
          }
        ],
        id: 275
      },
      {
        label: '临汾市',
        
        
        parentId: 23,
        code: '141000000000',
        value: '276',
        children: [
          {
            label: '吉县',
            
            
            parentId: 276,
            code: '141028000000',
            value: '379',
            
            id: 379
          },
          {
            label: '乡宁县',
            
            
            parentId: 276,
            code: '141029000000',
            value: '380',
            
            id: 380
          },
          {
            label: '大宁县',
            
            
            parentId: 276,
            code: '141030000000',
            value: '381',
            
            id: 381
          },
          {
            label: '隰县',
            
            
            parentId: 276,
            code: '141031000000',
            value: '382',
            
            id: 382
          },
          {
            label: '永和县',
            
            
            parentId: 276,
            code: '141032000000',
            value: '383',
            
            id: 383
          },
          {
            label: '蒲县',
            
            
            parentId: 276,
            code: '141033000000',
            value: '384',
            
            id: 384
          },
          {
            label: '汾西县',
            
            
            parentId: 276,
            code: '141034000000',
            value: '385',
            
            id: 385
          },
          {
            label: '侯马市',
            
            
            parentId: 276,
            code: '141081000000',
            value: '2433',
            
            id: 2433
          },
          {
            label: '霍州市',
            
            
            parentId: 276,
            code: '141082000000',
            value: '2434',
            
            id: 2434
          },
          {
            label: '尧都区',
            
            
            parentId: 276,
            code: '141002000000',
            value: '2435',
            
            id: 2435
          },
          {
            label: '曲沃县',
            
            
            parentId: 276,
            code: '141021000000',
            value: '2436',
            
            id: 2436
          },
          {
            label: '翼城县',
            
            
            parentId: 276,
            code: '141022000000',
            value: '2437',
            
            id: 2437
          },
          {
            label: '襄汾县',
            
            
            parentId: 276,
            code: '141023000000',
            value: '2438',
            
            id: 2438
          },
          {
            label: '洪洞县',
            
            
            parentId: 276,
            code: '141024000000',
            value: '2439',
            
            id: 2439
          },
          {
            label: '古县',
            
            
            parentId: 276,
            code: '141025000000',
            value: '2440',
            
            id: 2440
          },
          {
            label: '安泽县',
            
            
            parentId: 276,
            code: '141026000000',
            value: '2441',
            
            id: 2441
          },
          {
            label: '浮山县',
            
            
            parentId: 276,
            code: '141027000000',
            value: '2442',
            
            id: 2442
          }
        ],
        id: 276
      }
    ],
    id: 23
  },
  {
    label: '陕西省',
    
    
    parentId: 1,
    code: '610000000000',
    value: '24',
    children: [
      {
        label: '西安市',
        
        
        parentId: 24,
        code: '610100000000',
        value: '277',
        children: [
          {
            label: '新城区',
            
            
            parentId: 277,
            code: '610102000000',
            value: '2848',
            
            id: 2848
          },
          {
            label: '碑林区',
            
            
            parentId: 277,
            code: '610103000000',
            value: '2849',
            
            id: 2849
          },
          {
            label: '莲湖区',
            
            
            parentId: 277,
            code: '610104000000',
            value: '2850',
            
            id: 2850
          },
          {
            label: '灞桥区',
            
            
            parentId: 277,
            code: '610111000000',
            value: '2851',
            
            id: 2851
          },
          {
            label: '未央区',
            
            
            parentId: 277,
            code: '610112000000',
            value: '2852',
            
            id: 2852
          },
          {
            label: '雁塔区',
            
            
            parentId: 277,
            code: '610113000000',
            value: '2853',
            
            id: 2853
          },
          {
            label: '阎良区',
            
            
            parentId: 277,
            code: '610114000000',
            value: '2854',
            
            id: 2854
          },
          {
            label: '临潼区',
            
            
            parentId: 277,
            code: '610115000000',
            value: '2855',
            
            id: 2855
          },
          {
            label: '长安区',
            
            
            parentId: 277,
            code: '610116000000',
            value: '2856',
            
            id: 2856
          },
          {
            label: '蓝田县',
            
            
            parentId: 277,
            code: '610122000000',
            value: '2857',
            
            id: 2857
          },
          {
            label: '周至县',
            
            
            parentId: 277,
            code: '610124000000',
            value: '2858',
            
            id: 2858
          },
          {
            label: '户县',
            
            
            parentId: 277,
            code: '610125000000',
            value: '2859',
            
            id: 2859
          },
          {
            label: '高陵县',
            
            
            parentId: 277,
            code: '610126000000',
            value: '2860',
            
            id: 2860
          }
        ],
        id: 277
      },
      {
        label: '铜川市',
        
        
        parentId: 24,
        code: '610200000000',
        value: '278',
        children: [
          {
            label: '宜君县',
            
            
            parentId: 278,
            code: '610222000000',
            value: '2861',
            
            id: 2861
          },
          {
            label: '王益区',
            
            
            parentId: 278,
            code: '610202000000',
            value: '2862',
            
            id: 2862
          },
          {
            label: '印台区',
            
            
            parentId: 278,
            code: '610203000000',
            value: '2863',
            
            id: 2863
          },
          {
            label: '耀州区',
            
            
            parentId: 278,
            code: '610204000000',
            value: '2864',
            
            id: 2864
          }
        ],
        id: 278
      },
      {
        label: '宝鸡市',
        
        
        parentId: 24,
        code: '610300000000',
        value: '279',
        children: [
          {
            label: '渭滨区',
            
            
            parentId: 279,
            code: '610302000000',
            value: '2865',
            
            id: 2865
          },
          {
            label: '金台区',
            
            
            parentId: 279,
            code: '610303000000',
            value: '2866',
            
            id: 2866
          },
          {
            label: '陈仓区',
            
            
            parentId: 279,
            code: '610304000000',
            value: '2867',
            
            id: 2867
          },
          {
            label: '凤翔县',
            
            
            parentId: 279,
            code: '610322000000',
            value: '2868',
            
            id: 2868
          },
          {
            label: '岐山县',
            
            
            parentId: 279,
            code: '610323000000',
            value: '2869',
            
            id: 2869
          },
          {
            label: '扶风县',
            
            
            parentId: 279,
            code: '610324000000',
            value: '2870',
            
            id: 2870
          },
          {
            label: '眉县',
            
            
            parentId: 279,
            code: '610326000000',
            value: '2871',
            
            id: 2871
          },
          {
            label: '陇县',
            
            
            parentId: 279,
            code: '610327000000',
            value: '2872',
            
            id: 2872
          },
          {
            label: '千阳县',
            
            
            parentId: 279,
            code: '610328000000',
            value: '2873',
            
            id: 2873
          },
          {
            label: '麟游县',
            
            
            parentId: 279,
            code: '610329000000',
            value: '2874',
            
            id: 2874
          },
          {
            label: '凤县',
            
            
            parentId: 279,
            code: '610330000000',
            value: '2875',
            
            id: 2875
          },
          {
            label: '太白县',
            
            
            parentId: 279,
            code: '610331000000',
            value: '2876',
            
            id: 2876
          }
        ],
        id: 279
      },
      {
        label: '咸阳市',
        
        
        parentId: 24,
        code: '610400000000',
        value: '280',
        children: [
          {
            label: '三原县',
            
            
            parentId: 280,
            code: '610422000000',
            value: '2877',
            
            id: 2877
          },
          {
            label: '泾阳县',
            
            
            parentId: 280,
            code: '610423000000',
            value: '2878',
            
            id: 2878
          },
          {
            label: '乾县',
            
            
            parentId: 280,
            code: '610424000000',
            value: '2879',
            
            id: 2879
          },
          {
            label: '礼泉县',
            
            
            parentId: 280,
            code: '610425000000',
            value: '2880',
            
            id: 2880
          },
          {
            label: '永寿县',
            
            
            parentId: 280,
            code: '610426000000',
            value: '2881',
            
            id: 2881
          },
          {
            label: '彬县',
            
            
            parentId: 280,
            code: '610427000000',
            value: '2882',
            
            id: 2882
          },
          {
            label: '长武县',
            
            
            parentId: 280,
            code: '610428000000',
            value: '2883',
            
            id: 2883
          },
          {
            label: '旬邑县',
            
            
            parentId: 280,
            code: '610429000000',
            value: '2884',
            
            id: 2884
          },
          {
            label: '淳化县',
            
            
            parentId: 280,
            code: '610430000000',
            value: '2885',
            
            id: 2885
          },
          {
            label: '武功县',
            
            
            parentId: 280,
            code: '610431000000',
            value: '2886',
            
            id: 2886
          },
          {
            label: '杨陵区',
            
            
            parentId: 280,
            code: '610403000000',
            value: '2887',
            
            id: 2887
          },
          {
            label: '秦都区',
            
            
            parentId: 280,
            code: '610402000000',
            value: '2888',
            
            id: 2888
          },
          {
            label: '渭城区',
            
            
            parentId: 280,
            code: '610404000000',
            value: '2889',
            
            id: 2889
          },
          {
            label: '兴平市',
            
            
            parentId: 280,
            code: '610481000000',
            value: '2890',
            
            id: 2890
          }
        ],
        id: 280
      },
      {
        label: '渭南市',
        
        
        parentId: 24,
        code: '610500000000',
        value: '281',
        children: [
          {
            label: '韩城市',
            
            
            parentId: 281,
            code: '610581000000',
            value: '2891',
            
            id: 2891
          },
          {
            label: '华阴市',
            
            
            parentId: 281,
            code: '610582000000',
            value: '2892',
            
            id: 2892
          },
          {
            label: '临渭区',
            
            
            parentId: 281,
            code: '610502000000',
            value: '2893',
            
            id: 2893
          },
          {
            label: '白水县',
            
            
            parentId: 281,
            code: '610527000000',
            value: '2894',
            
            id: 2894
          },
          {
            label: '富平县',
            
            
            parentId: 281,
            code: '610528000000',
            value: '2895',
            
            id: 2895
          },
          {
            label: '华县',
            
            
            parentId: 281,
            code: '610521000000',
            value: '2896',
            
            id: 2896
          },
          {
            label: '潼关县',
            
            
            parentId: 281,
            code: '610522000000',
            value: '2897',
            
            id: 2897
          },
          {
            label: '大荔县',
            
            
            parentId: 281,
            code: '610523000000',
            value: '2898',
            
            id: 2898
          },
          {
            label: '合阳县',
            
            
            parentId: 281,
            code: '610524000000',
            value: '2899',
            
            id: 2899
          },
          {
            label: '澄城县',
            
            
            parentId: 281,
            code: '610525000000',
            value: '2900',
            
            id: 2900
          },
          {
            label: '蒲城县',
            
            
            parentId: 281,
            code: '610526000000',
            value: '2901',
            
            id: 2901
          }
        ],
        id: 281
      },
      {
        label: '延安市',
        
        
        parentId: 24,
        code: '610600000000',
        value: '282',
        children: [
          {
            label: '延长县',
            
            
            parentId: 282,
            code: '610621000000',
            value: '2902',
            
            id: 2902
          },
          {
            label: '延川县',
            
            
            parentId: 282,
            code: '610622000000',
            value: '2903',
            
            id: 2903
          },
          {
            label: '子长县',
            
            
            parentId: 282,
            code: '610623000000',
            value: '2904',
            
            id: 2904
          },
          {
            label: '安塞县',
            
            
            parentId: 282,
            code: '610624000000',
            value: '2905',
            
            id: 2905
          },
          {
            label: '志丹县',
            
            
            parentId: 282,
            code: '610625000000',
            value: '2906',
            
            id: 2906
          },
          {
            label: '吴起县',
            
            
            parentId: 282,
            code: '610626000000',
            value: '2907',
            
            id: 2907
          },
          {
            label: '甘泉县',
            
            
            parentId: 282,
            code: '610627000000',
            value: '2908',
            
            id: 2908
          },
          {
            label: '富县',
            
            
            parentId: 282,
            code: '610628000000',
            value: '2909',
            
            id: 2909
          },
          {
            label: '洛川县',
            
            
            parentId: 282,
            code: '610629000000',
            value: '2910',
            
            id: 2910
          },
          {
            label: '宜川县',
            
            
            parentId: 282,
            code: '610630000000',
            value: '2911',
            
            id: 2911
          },
          {
            label: '黄龙县',
            
            
            parentId: 282,
            code: '610631000000',
            value: '2912',
            
            id: 2912
          },
          {
            label: '黄陵县',
            
            
            parentId: 282,
            code: '610632000000',
            value: '2913',
            
            id: 2913
          },
          {
            label: '宝塔区',
            
            
            parentId: 282,
            code: '610602000000',
            value: '2914',
            
            id: 2914
          }
        ],
        id: 282
      },
      {
        label: '汉中市',
        
        
        parentId: 24,
        code: '610700000000',
        value: '283',
        children: [
          {
            label: '汉台区',
            
            
            parentId: 283,
            code: '610702000000',
            value: '2915',
            
            id: 2915
          },
          {
            label: '南郑县',
            
            
            parentId: 283,
            code: '610721000000',
            value: '2916',
            
            id: 2916
          },
          {
            label: '城固县',
            
            
            parentId: 283,
            code: '610722000000',
            value: '2917',
            
            id: 2917
          },
          {
            label: '洋县',
            
            
            parentId: 283,
            code: '610723000000',
            value: '2918',
            
            id: 2918
          },
          {
            label: '西乡县',
            
            
            parentId: 283,
            code: '610724000000',
            value: '2919',
            
            id: 2919
          },
          {
            label: '勉县',
            
            
            parentId: 283,
            code: '610725000000',
            value: '2920',
            
            id: 2920
          },
          {
            label: '宁强县',
            
            
            parentId: 283,
            code: '610726000000',
            value: '2921',
            
            id: 2921
          },
          {
            label: '略阳县',
            
            
            parentId: 283,
            code: '610727000000',
            value: '2922',
            
            id: 2922
          },
          {
            label: '镇巴县',
            
            
            parentId: 283,
            code: '610728000000',
            value: '2923',
            
            id: 2923
          },
          {
            label: '留坝县',
            
            
            parentId: 283,
            code: '610729000000',
            value: '2924',
            
            id: 2924
          },
          {
            label: '佛坪县',
            
            
            parentId: 283,
            code: '610730000000',
            value: '2925',
            
            id: 2925
          }
        ],
        id: 283
      },
      {
        label: '榆林市',
        
        
        parentId: 24,
        code: '610800000000',
        value: '284',
        children: [
          {
            label: '神木县',
            
            
            parentId: 284,
            code: '610821000000',
            value: '2926',
            
            id: 2926
          },
          {
            label: '府谷县',
            
            
            parentId: 284,
            code: '610822000000',
            value: '2927',
            
            id: 2927
          },
          {
            label: '横山县',
            
            
            parentId: 284,
            code: '610823000000',
            value: '2928',
            
            id: 2928
          },
          {
            label: '靖边县',
            
            
            parentId: 284,
            code: '610824000000',
            value: '2929',
            
            id: 2929
          },
          {
            label: '榆阳区',
            
            
            parentId: 284,
            code: '610802000000',
            value: '2930',
            
            id: 2930
          },
          {
            label: '定边县',
            
            
            parentId: 284,
            code: '610825000000',
            value: '2931',
            
            id: 2931
          },
          {
            label: '绥德县',
            
            
            parentId: 284,
            code: '610826000000',
            value: '2932',
            
            id: 2932
          },
          {
            label: '米脂县',
            
            
            parentId: 284,
            code: '610827000000',
            value: '2933',
            
            id: 2933
          },
          {
            label: '佳县',
            
            
            parentId: 284,
            code: '610828000000',
            value: '2934',
            
            id: 2934
          },
          {
            label: '吴堡县',
            
            
            parentId: 284,
            code: '610829000000',
            value: '2935',
            
            id: 2935
          },
          {
            label: '清涧县',
            
            
            parentId: 284,
            code: '610830000000',
            value: '2936',
            
            id: 2936
          },
          {
            label: '子洲县',
            
            
            parentId: 284,
            code: '610831000000',
            value: '2937',
            
            id: 2937
          }
        ],
        id: 284
      },
      {
        label: '安康市',
        
        
        parentId: 24,
        code: '610900000000',
        value: '285',
        children: [
          {
            label: '汉阴县',
            
            
            parentId: 285,
            code: '610921000000',
            value: '2938',
            
            id: 2938
          },
          {
            label: '石泉县',
            
            
            parentId: 285,
            code: '610922000000',
            value: '2939',
            
            id: 2939
          },
          {
            label: '宁陕县',
            
            
            parentId: 285,
            code: '610923000000',
            value: '2940',
            
            id: 2940
          },
          {
            label: '紫阳县',
            
            
            parentId: 285,
            code: '610924000000',
            value: '2941',
            
            id: 2941
          },
          {
            label: '岚皋县',
            
            
            parentId: 285,
            code: '610925000000',
            value: '2942',
            
            id: 2942
          },
          {
            label: '平利县',
            
            
            parentId: 285,
            code: '610926000000',
            value: '2943',
            
            id: 2943
          },
          {
            label: '镇坪县',
            
            
            parentId: 285,
            code: '610927000000',
            value: '2944',
            
            id: 2944
          },
          {
            label: '旬阳县',
            
            
            parentId: 285,
            code: '610928000000',
            value: '2945',
            
            id: 2945
          },
          {
            label: '白河县',
            
            
            parentId: 285,
            code: '610929000000',
            value: '2946',
            
            id: 2946
          },
          {
            label: '汉滨区',
            
            
            parentId: 285,
            code: '610902000000',
            value: '2947',
            
            id: 2947
          }
        ],
        id: 285
      },
      {
        label: '商洛市',
        
        
        parentId: 24,
        code: '611000000000',
        value: '286',
        children: [
          {
            label: '商州区',
            
            
            parentId: 286,
            code: '611002000000',
            value: '2948',
            
            id: 2948
          },
          {
            label: '洛南县',
            
            
            parentId: 286,
            code: '611021000000',
            value: '2949',
            
            id: 2949
          },
          {
            label: '丹凤县',
            
            
            parentId: 286,
            code: '611022000000',
            value: '2950',
            
            id: 2950
          },
          {
            label: '商南县',
            
            
            parentId: 286,
            code: '611023000000',
            value: '2951',
            
            id: 2951
          },
          {
            label: '山阳县',
            
            
            parentId: 286,
            code: '611024000000',
            value: '2952',
            
            id: 2952
          },
          {
            label: '镇安县',
            
            
            parentId: 286,
            code: '611025000000',
            value: '2953',
            
            id: 2953
          },
          {
            label: '柞水县',
            
            
            parentId: 286,
            code: '611026000000',
            value: '2954',
            
            id: 2954
          }
        ],
        id: 286
      }
    ],
    id: 24
  },
  {
    label: '上海市',
    
    
    parentId: 1,
    code: '310000000000',
    value: '25',
    children: [
      {
        label: '市辖区',
        
        
        parentId: 25,
        code: '310100000000',
        value: '287',
        children: [
          {
            label: '宝山区',
            
            
            parentId: 287,
            code: '310113000000',
            value: '3190',
            
            id: 3190
          },
          {
            label: '长宁区',
            
            
            parentId: 287,
            code: '310105000000',
            value: '3191',
            
            id: 3191
          },
          {
            label: '奉贤区',
            
            
            parentId: 287,
            code: '310120000000',
            value: '3192',
            
            id: 3192
          },
          {
            label: '虹口区',
            
            
            parentId: 287,
            code: '310109000000',
            value: '3193',
            
            id: 3193
          },
          {
            label: '黄浦区',
            
            
            parentId: 287,
            code: '310101000000',
            value: '3194',
            
            id: 3194
          },
          {
            label: '嘉定区',
            
            
            parentId: 287,
            code: '310114000000',
            value: '3195',
            
            id: 3195
          },
          {
            label: '金山区',
            
            
            parentId: 287,
            code: '310116000000',
            value: '3196',
            
            id: 3196
          },
          {
            label: '静安区',
            
            
            parentId: 287,
            code: '310106000000',
            value: '3197',
            
            id: 3197
          },
          {
            label: '闵行区',
            
            
            parentId: 287,
            code: '310112000000',
            value: '3198',
            
            id: 3198
          },
          {
            label: '浦东新区',
            
            
            parentId: 287,
            code: '310115000000',
            value: '3199',
            
            id: 3199
          },
          {
            label: '普陀区',
            
            
            parentId: 287,
            code: '310107000000',
            value: '3200',
            
            id: 3200
          },
          {
            label: '青浦区',
            
            
            parentId: 287,
            code: '310118000000',
            value: '3201',
            
            id: 3201
          },
          {
            label: '松江区',
            
            
            parentId: 287,
            code: '310117000000',
            value: '3202',
            
            id: 3202
          },
          {
            label: '徐汇区',
            
            
            parentId: 287,
            code: '310104000000',
            value: '3203',
            
            id: 3203
          },
          {
            label: '杨浦区',
            
            
            parentId: 287,
            code: '310110000000',
            value: '3204',
            
            id: 3204
          },
          {
            label: '闸北区',
            
            
            parentId: 287,
            code: '310108000000',
            value: '3205',
            
            id: 3205
          }
        ],
        id: 287
      },
      {
        label: '县',
        
        
        parentId: 25,
        code: '310200000000',
        value: '288',
        children: [
          {
            label: '崇明县',
            
            
            parentId: 288,
            code: '310230000000',
            value: '3220',
            
            id: 3220
          }
        ],
        id: 288
      }
    ],
    id: 25
  },
  {
    label: '四川省',
    
    
    parentId: 1,
    code: '510000000000',
    value: '26',
    children: [
      {
        label: '阿坝藏族羌族自治州',
        
        
        parentId: 26,
        code: '513200000000',
        value: '289',
        children: [
          {
            label: '汶川县',
            
            
            parentId: 289,
            code: '513221000000',
            value: '1259',
            
            id: 1259
          },
          {
            label: '理县',
            
            
            parentId: 289,
            code: '513222000000',
            value: '1260',
            
            id: 1260
          },
          {
            label: '茂县',
            
            
            parentId: 289,
            code: '513223000000',
            value: '1261',
            
            id: 1261
          },
          {
            label: '松潘县',
            
            
            parentId: 289,
            code: '513224000000',
            value: '1262',
            
            id: 1262
          },
          {
            label: '九寨沟县',
            
            
            parentId: 289,
            code: '513225000000',
            value: '1263',
            
            id: 1263
          },
          {
            label: '金川县',
            
            
            parentId: 289,
            code: '513226000000',
            value: '1264',
            
            id: 1264
          },
          {
            label: '小金县',
            
            
            parentId: 289,
            code: '513227000000',
            value: '1265',
            
            id: 1265
          },
          {
            label: '黑水县',
            
            
            parentId: 289,
            code: '513228000000',
            value: '1266',
            
            id: 1266
          },
          {
            label: '马尔康县',
            
            
            parentId: 289,
            code: '513229000000',
            value: '1267',
            
            id: 1267
          },
          {
            label: '壤塘县',
            
            
            parentId: 289,
            code: '513230000000',
            value: '1268',
            
            id: 1268
          },
          {
            label: '阿坝县',
            
            
            parentId: 289,
            code: '513231000000',
            value: '1269',
            
            id: 1269
          },
          {
            label: '若尔盖县',
            
            
            parentId: 289,
            code: '513232000000',
            value: '1270',
            
            id: 1270
          },
          {
            label: '红原县',
            
            
            parentId: 289,
            code: '513233000000',
            value: '1271',
            
            id: 1271
          }
        ],
        id: 289
      },
      {
        label: '甘孜藏族自治州',
        
        
        parentId: 26,
        code: '513300000000',
        value: '290',
        children: [
          {
            label: '康定县',
            
            
            parentId: 290,
            code: '513321000000',
            value: '1272',
            
            id: 1272
          },
          {
            label: '泸定县',
            
            
            parentId: 290,
            code: '513322000000',
            value: '1273',
            
            id: 1273
          },
          {
            label: '丹巴县',
            
            
            parentId: 290,
            code: '513323000000',
            value: '1274',
            
            id: 1274
          },
          {
            label: '九龙县',
            
            
            parentId: 290,
            code: '513324000000',
            value: '1275',
            
            id: 1275
          },
          {
            label: '雅江县',
            
            
            parentId: 290,
            code: '513325000000',
            value: '1276',
            
            id: 1276
          },
          {
            label: '道孚县',
            
            
            parentId: 290,
            code: '513326000000',
            value: '1277',
            
            id: 1277
          },
          {
            label: '炉霍县',
            
            
            parentId: 290,
            code: '513327000000',
            value: '1278',
            
            id: 1278
          },
          {
            label: '甘孜县',
            
            
            parentId: 290,
            code: '513328000000',
            value: '1279',
            
            id: 1279
          },
          {
            label: '新龙县',
            
            
            parentId: 290,
            code: '513329000000',
            value: '1280',
            
            id: 1280
          },
          {
            label: '德格县',
            
            
            parentId: 290,
            code: '513330000000',
            value: '1281',
            
            id: 1281
          },
          {
            label: '白玉县',
            
            
            parentId: 290,
            code: '513331000000',
            value: '1282',
            
            id: 1282
          },
          {
            label: '石渠县',
            
            
            parentId: 290,
            code: '513332000000',
            value: '1283',
            
            id: 1283
          },
          {
            label: '色达县',
            
            
            parentId: 290,
            code: '513333000000',
            value: '1284',
            
            id: 1284
          },
          {
            label: '理塘县',
            
            
            parentId: 290,
            code: '513334000000',
            value: '1285',
            
            id: 1285
          },
          {
            label: '巴塘县',
            
            
            parentId: 290,
            code: '513335000000',
            value: '1286',
            
            id: 1286
          },
          {
            label: '乡城县',
            
            
            parentId: 290,
            code: '513336000000',
            value: '1287',
            
            id: 1287
          },
          {
            label: '稻城县',
            
            
            parentId: 290,
            code: '513337000000',
            value: '1288',
            
            id: 1288
          },
          {
            label: '得荣县',
            
            
            parentId: 290,
            code: '513338000000',
            value: '1289',
            
            id: 1289
          }
        ],
        id: 290
      },
      {
        label: '凉山彝族自治州',
        
        
        parentId: 26,
        code: '513400000000',
        value: '291',
        children: [
          {
            label: '德昌县',
            
            
            parentId: 291,
            code: '513424000000',
            value: '1290',
            
            id: 1290
          },
          {
            label: '会理县',
            
            
            parentId: 291,
            code: '513425000000',
            value: '1291',
            
            id: 1291
          },
          {
            label: '会东县',
            
            
            parentId: 291,
            code: '513426000000',
            value: '1292',
            
            id: 1292
          },
          {
            label: '宁南县',
            
            
            parentId: 291,
            code: '513427000000',
            value: '1293',
            
            id: 1293
          },
          {
            label: '普格县',
            
            
            parentId: 291,
            code: '513428000000',
            value: '1294',
            
            id: 1294
          },
          {
            label: '布拖县',
            
            
            parentId: 291,
            code: '513429000000',
            value: '1295',
            
            id: 1295
          },
          {
            label: '金阳县',
            
            
            parentId: 291,
            code: '513430000000',
            value: '1296',
            
            id: 1296
          },
          {
            label: '昭觉县',
            
            
            parentId: 291,
            code: '513431000000',
            value: '1297',
            
            id: 1297
          },
          {
            label: '喜德县',
            
            
            parentId: 291,
            code: '513432000000',
            value: '1298',
            
            id: 1298
          },
          {
            label: '冕宁县',
            
            
            parentId: 291,
            code: '513433000000',
            value: '1299',
            
            id: 1299
          },
          {
            label: '越西县',
            
            
            parentId: 291,
            code: '513434000000',
            value: '1300',
            
            id: 1300
          },
          {
            label: '甘洛县',
            
            
            parentId: 291,
            code: '513435000000',
            value: '1301',
            
            id: 1301
          },
          {
            label: '美姑县',
            
            
            parentId: 291,
            code: '513436000000',
            value: '1302',
            
            id: 1302
          },
          {
            label: '雷波县',
            
            
            parentId: 291,
            code: '513437000000',
            value: '1303',
            
            id: 1303
          },
          {
            label: '盐源县',
            
            
            parentId: 291,
            code: '513423000000',
            value: '1304',
            
            id: 1304
          },
          {
            label: '西昌市',
            
            
            parentId: 291,
            code: '513401000000',
            value: '1305',
            
            id: 1305
          },
          {
            label: '木里藏族自治县',
            
            
            parentId: 291,
            code: '513422000000',
            value: '1306',
            
            id: 1306
          }
        ],
        id: 291
      },
      {
        label: '成都市',
        
        
        parentId: 26,
        code: '510100000000',
        value: '292',
        children: [
          {
            label: '都江堰市',
            
            
            parentId: 292,
            code: '510181000000',
            value: '776',
            
            id: 776
          },
          {
            label: '彭州市',
            
            
            parentId: 292,
            code: '510182000000',
            value: '777',
            
            id: 777
          },
          {
            label: '邛崃市',
            
            
            parentId: 292,
            code: '510183000000',
            value: '778',
            
            id: 778
          },
          {
            label: '崇州市',
            
            
            parentId: 292,
            code: '510184000000',
            value: '779',
            
            id: 779
          },
          {
            label: '青羊区',
            
            
            parentId: 292,
            code: '510105000000',
            value: '780',
            
            id: 780
          },
          {
            label: '金牛区',
            
            
            parentId: 292,
            code: '510106000000',
            value: '781',
            
            id: 781
          },
          {
            label: '武侯区',
            
            
            parentId: 292,
            code: '510107000000',
            value: '782',
            
            id: 782
          },
          {
            label: '成华区',
            
            
            parentId: 292,
            code: '510108000000',
            value: '783',
            
            id: 783
          },
          {
            label: '龙泉驿区',
            
            
            parentId: 292,
            code: '510112000000',
            value: '784',
            
            id: 784
          },
          {
            label: '青白江区',
            
            
            parentId: 292,
            code: '510113000000',
            value: '785',
            
            id: 785
          },
          {
            label: '新都区',
            
            
            parentId: 292,
            code: '510114000000',
            value: '786',
            
            id: 786
          },
          {
            label: '温江区',
            
            
            parentId: 292,
            code: '510115000000',
            value: '787',
            
            id: 787
          },
          {
            label: '锦江区',
            
            
            parentId: 292,
            code: '510104000000',
            value: '788',
            
            id: 788
          },
          {
            label: '金堂县',
            
            
            parentId: 292,
            code: '510121000000',
            value: '789',
            
            id: 789
          },
          {
            label: '双流县',
            
            
            parentId: 292,
            code: '510122000000',
            value: '790',
            
            id: 790
          },
          {
            label: '郫县',
            
            
            parentId: 292,
            code: '510124000000',
            value: '791',
            
            id: 791
          },
          {
            label: '大邑县',
            
            
            parentId: 292,
            code: '510129000000',
            value: '792',
            
            id: 792
          },
          {
            label: '蒲江县',
            
            
            parentId: 292,
            code: '510131000000',
            value: '793',
            
            id: 793
          },
          {
            label: '新津县',
            
            
            parentId: 292,
            code: '510132000000',
            value: '794',
            
            id: 794
          }
        ],
        id: 292
      },
      {
        label: '自贡市',
        
        
        parentId: 26,
        code: '510300000000',
        value: '293',
        children: [
          {
            label: '荣县',
            
            
            parentId: 293,
            code: '510321000000',
            value: '795',
            
            id: 795
          },
          {
            label: '富顺县',
            
            
            parentId: 293,
            code: '510322000000',
            value: '796',
            
            id: 796
          },
          {
            label: '自流井区',
            
            
            parentId: 293,
            code: '510302000000',
            value: '797',
            
            id: 797
          },
          {
            label: '贡井区',
            
            
            parentId: 293,
            code: '510303000000',
            value: '798',
            
            id: 798
          },
          {
            label: '大安区',
            
            
            parentId: 293,
            code: '510304000000',
            value: '799',
            
            id: 799
          },
          {
            label: '沿滩区',
            
            
            parentId: 293,
            code: '510311000000',
            value: '800',
            
            id: 800
          }
        ],
        id: 293
      },
      {
        label: '攀枝花市',
        
        
        parentId: 26,
        code: '510400000000',
        value: '294',
        children: [
          {
            label: '东区',
            
            
            parentId: 294,
            code: '510402000000',
            value: '801',
            
            id: 801
          },
          {
            label: '西区',
            
            
            parentId: 294,
            code: '510403000000',
            value: '802',
            
            id: 802
          },
          {
            label: '仁和区',
            
            
            parentId: 294,
            code: '510411000000',
            value: '803',
            
            id: 803
          },
          {
            label: '米易县',
            
            
            parentId: 294,
            code: '510421000000',
            value: '804',
            
            id: 804
          },
          {
            label: '盐边县',
            
            
            parentId: 294,
            code: '510422000000',
            value: '805',
            
            id: 805
          }
        ],
        id: 294
      },
      {
        label: '泸州市',
        
        
        parentId: 26,
        code: '510500000000',
        value: '295',
        children: [
          {
            label: '泸县',
            
            
            parentId: 295,
            code: '510521000000',
            value: '806',
            
            id: 806
          },
          {
            label: '合江县',
            
            
            parentId: 295,
            code: '510522000000',
            value: '807',
            
            id: 807
          },
          {
            label: '叙永县',
            
            
            parentId: 295,
            code: '510524000000',
            value: '808',
            
            id: 808
          },
          {
            label: '古蔺县',
            
            
            parentId: 295,
            code: '510525000000',
            value: '809',
            
            id: 809
          },
          {
            label: '江阳区',
            
            
            parentId: 295,
            code: '510502000000',
            value: '810',
            
            id: 810
          },
          {
            label: '纳溪区',
            
            
            parentId: 295,
            code: '510503000000',
            value: '811',
            
            id: 811
          },
          {
            label: '龙马潭区',
            
            
            parentId: 295,
            code: '510504000000',
            value: '812',
            
            id: 812
          }
        ],
        id: 295
      },
      {
        label: '德阳市',
        
        
        parentId: 26,
        code: '510600000000',
        value: '296',
        children: [
          {
            label: '旌阳区',
            
            
            parentId: 296,
            code: '510603000000',
            value: '813',
            
            id: 813
          },
          {
            label: '广汉市',
            
            
            parentId: 296,
            code: '510681000000',
            value: '814',
            
            id: 814
          },
          {
            label: '什邡市',
            
            
            parentId: 296,
            code: '510682000000',
            value: '815',
            
            id: 815
          },
          {
            label: '绵竹市',
            
            
            parentId: 296,
            code: '510683000000',
            value: '816',
            
            id: 816
          },
          {
            label: '中江县',
            
            
            parentId: 296,
            code: '510623000000',
            value: '817',
            
            id: 817
          },
          {
            label: '罗江县',
            
            
            parentId: 296,
            code: '510626000000',
            value: '818',
            
            id: 818
          }
        ],
        id: 296
      },
      {
        label: '绵阳市',
        
        
        parentId: 26,
        code: '510700000000',
        value: '297',
        children: [
          {
            label: '三台县',
            
            
            parentId: 297,
            code: '510722000000',
            value: '819',
            
            id: 819
          },
          {
            label: '盐亭县',
            
            
            parentId: 297,
            code: '510723000000',
            value: '820',
            
            id: 820
          },
          {
            label: '安县',
            
            
            parentId: 297,
            code: '510724000000',
            value: '821',
            
            id: 821
          },
          {
            label: '梓潼县',
            
            
            parentId: 297,
            code: '510725000000',
            value: '822',
            
            id: 822
          },
          {
            label: '北川羌族自治县',
            
            
            parentId: 297,
            code: '510726000000',
            value: '823',
            
            id: 823
          },
          {
            label: '平武县',
            
            
            parentId: 297,
            code: '510727000000',
            value: '824',
            
            id: 824
          },
          {
            label: '江油市',
            
            
            parentId: 297,
            code: '510781000000',
            value: '825',
            
            id: 825
          },
          {
            label: '涪城区',
            
            
            parentId: 297,
            code: '510703000000',
            value: '826',
            
            id: 826
          },
          {
            label: '游仙区',
            
            
            parentId: 297,
            code: '510704000000',
            value: '827',
            
            id: 827
          },
          {
            label: '安州区',
            
            
            parentId: 297,
            code: '500233100000',
            value: '3140',
            
            id: 3140
          }
        ],
        id: 297
      },
      {
        label: '广元市',
        
        
        parentId: 26,
        code: '510800000000',
        value: '298',
        children: [
          {
            label: '利州区',
            
            
            parentId: 298,
            code: '510802000000',
            value: '828',
            
            id: 828
          },
          {
            label: '昭化区',
            
            
            parentId: 298,
            code: '510811000000',
            value: '829',
            
            id: 829
          },
          {
            label: '朝天区',
            
            
            parentId: 298,
            code: '510812000000',
            value: '830',
            
            id: 830
          },
          {
            label: '旺苍县',
            
            
            parentId: 298,
            code: '510821000000',
            value: '831',
            
            id: 831
          },
          {
            label: '青川县',
            
            
            parentId: 298,
            code: '510822000000',
            value: '832',
            
            id: 832
          },
          {
            label: '剑阁县',
            
            
            parentId: 298,
            code: '510823000000',
            value: '833',
            
            id: 833
          },
          {
            label: '苍溪县',
            
            
            parentId: 298,
            code: '510824000000',
            value: '834',
            
            id: 834
          }
        ],
        id: 298
      },
      {
        label: '遂宁市',
        
        
        parentId: 26,
        code: '510900000000',
        value: '299',
        children: [
          {
            label: '蓬溪县',
            
            
            parentId: 299,
            code: '510921000000',
            value: '835',
            
            id: 835
          },
          {
            label: '射洪县',
            
            
            parentId: 299,
            code: '510922000000',
            value: '836',
            
            id: 836
          },
          {
            label: '大英县',
            
            
            parentId: 299,
            code: '510923000000',
            value: '837',
            
            id: 837
          },
          {
            label: '船山区',
            
            
            parentId: 299,
            code: '510903000000',
            value: '838',
            
            id: 838
          },
          {
            label: '安居区',
            
            
            parentId: 299,
            code: '510904000000',
            value: '839',
            
            id: 839
          }
        ],
        id: 299
      },
      {
        label: '内江市',
        
        
        parentId: 26,
        code: '511000000000',
        value: '300',
        children: [
          {
            label: '市中区',
            
            
            parentId: 300,
            code: '511002000000',
            value: '840',
            
            id: 840
          },
          {
            label: '东兴区',
            
            
            parentId: 300,
            code: '511011000000',
            value: '841',
            
            id: 841
          },
          {
            label: '威远县',
            
            
            parentId: 300,
            code: '511024000000',
            value: '842',
            
            id: 842
          },
          {
            label: '资中县',
            
            
            parentId: 300,
            code: '511025000000',
            value: '843',
            
            id: 843
          },
          {
            label: '隆昌县',
            
            
            parentId: 300,
            code: '511028000000',
            value: '844',
            
            id: 844
          }
        ],
        id: 300
      },
      {
        label: '乐山市',
        
        
        parentId: 26,
        code: '511100000000',
        value: '301',
        children: [
          {
            label: '犍为县',
            
            
            parentId: 301,
            code: '511123000000',
            value: '845',
            
            id: 845
          },
          {
            label: '井研县',
            
            
            parentId: 301,
            code: '511124000000',
            value: '846',
            
            id: 846
          },
          {
            label: '夹江县',
            
            
            parentId: 301,
            code: '511126000000',
            value: '847',
            
            id: 847
          },
          {
            label: '沐川县',
            
            
            parentId: 301,
            code: '511129000000',
            value: '848',
            
            id: 848
          },
          {
            label: '市中区',
            
            
            parentId: 301,
            code: '511102000000',
            value: '849',
            
            id: 849
          },
          {
            label: '沙湾区',
            
            
            parentId: 301,
            code: '511111000000',
            value: '850',
            
            id: 850
          },
          {
            label: '五通桥区',
            
            
            parentId: 301,
            code: '511112000000',
            value: '851',
            
            id: 851
          },
          {
            label: '金口河区',
            
            
            parentId: 301,
            code: '511113000000',
            value: '852',
            
            id: 852
          },
          {
            label: '峨边彝族自治县',
            
            
            parentId: 301,
            code: '511132000000',
            value: '853',
            
            id: 853
          },
          {
            label: '马边彝族自治县',
            
            
            parentId: 301,
            code: '511133000000',
            value: '854',
            
            id: 854
          },
          {
            label: '峨眉山市',
            
            
            parentId: 301,
            code: '511181000000',
            value: '855',
            
            id: 855
          }
        ],
        id: 301
      },
      {
        label: '南充市',
        
        
        parentId: 26,
        code: '511300000000',
        value: '302',
        children: [
          {
            label: '阆中市',
            
            
            parentId: 302,
            code: '511381000000',
            value: '856',
            
            id: 856
          },
          {
            label: '顺庆区',
            
            
            parentId: 302,
            code: '511302000000',
            value: '857',
            
            id: 857
          },
          {
            label: '高坪区',
            
            
            parentId: 302,
            code: '511303000000',
            value: '858',
            
            id: 858
          },
          {
            label: '嘉陵区',
            
            
            parentId: 302,
            code: '511304000000',
            value: '859',
            
            id: 859
          },
          {
            label: '南部县',
            
            
            parentId: 302,
            code: '511321000000',
            value: '860',
            
            id: 860
          },
          {
            label: '营山县',
            
            
            parentId: 302,
            code: '511322000000',
            value: '861',
            
            id: 861
          },
          {
            label: '蓬安县',
            
            
            parentId: 302,
            code: '511323000000',
            value: '862',
            
            id: 862
          },
          {
            label: '仪陇县',
            
            
            parentId: 302,
            code: '511324000000',
            value: '863',
            
            id: 863
          },
          {
            label: '西充县',
            
            
            parentId: 302,
            code: '511325000000',
            value: '864',
            
            id: 864
          }
        ],
        id: 302
      },
      {
        label: '眉山市',
        
        
        parentId: 26,
        code: '511400000000',
        value: '303',
        children: [
          {
            label: '仁寿县',
            
            
            parentId: 303,
            code: '511421000000',
            value: '865',
            
            id: 865
          },
          {
            label: '彭山县',
            
            
            parentId: 303,
            code: '511422000000',
            value: '866',
            
            id: 866
          },
          {
            label: '洪雅县',
            
            
            parentId: 303,
            code: '511423000000',
            value: '867',
            
            id: 867
          },
          {
            label: '丹棱县',
            
            
            parentId: 303,
            code: '511424000000',
            value: '868',
            
            id: 868
          },
          {
            label: '青神县',
            
            
            parentId: 303,
            code: '511425000000',
            value: '869',
            
            id: 869
          },
          {
            label: '东坡区',
            
            
            parentId: 303,
            code: '511402000000',
            value: '870',
            
            id: 870
          }
        ],
        id: 303
      },
      {
        label: '宜宾市',
        
        
        parentId: 26,
        code: '511500000000',
        value: '304',
        children: [
          {
            label: '翠屏区',
            
            
            parentId: 304,
            code: '511502000000',
            value: '871',
            
            id: 871
          },
          {
            label: '宜宾县',
            
            
            parentId: 304,
            code: '511521000000',
            value: '872',
            
            id: 872
          },
          {
            label: '南溪区',
            
            
            parentId: 304,
            code: '511503000000',
            value: '873',
            
            id: 873
          },
          {
            label: '江安县',
            
            
            parentId: 304,
            code: '511523000000',
            value: '874',
            
            id: 874
          },
          {
            label: '长宁县',
            
            
            parentId: 304,
            code: '511524000000',
            value: '875',
            
            id: 875
          },
          {
            label: '高县',
            
            
            parentId: 304,
            code: '511525000000',
            value: '876',
            
            id: 876
          },
          {
            label: '珙县',
            
            
            parentId: 304,
            code: '511526000000',
            value: '877',
            
            id: 877
          },
          {
            label: '筠连县',
            
            
            parentId: 304,
            code: '511527000000',
            value: '878',
            
            id: 878
          },
          {
            label: '兴文县',
            
            
            parentId: 304,
            code: '511528000000',
            value: '879',
            
            id: 879
          },
          {
            label: '屏山县',
            
            
            parentId: 304,
            code: '511529000000',
            value: '880',
            
            id: 880
          }
        ],
        id: 304
      },
      {
        label: '广安市',
        
        
        parentId: 26,
        code: '511600000000',
        value: '305',
        children: [
          {
            label: '前锋区',
            
            
            parentId: 305,
            code: '511603000000',
            value: '881',
            
            id: 881
          },
          {
            label: '岳池县',
            
            
            parentId: 305,
            code: '511621000000',
            value: '882',
            
            id: 882
          },
          {
            label: '武胜县',
            
            
            parentId: 305,
            code: '511622000000',
            value: '883',
            
            id: 883
          },
          {
            label: '邻水县',
            
            
            parentId: 305,
            code: '511623000000',
            value: '884',
            
            id: 884
          },
          {
            label: '广安区',
            
            
            parentId: 305,
            code: '511602000000',
            value: '885',
            
            id: 885
          },
          {
            label: '华蓥市',
            
            
            parentId: 305,
            code: '511681000000',
            value: '886',
            
            id: 886
          }
        ],
        id: 305
      },
      {
        label: '达州市',
        
        
        parentId: 26,
        code: '511700000000',
        value: '306',
        children: [
          {
            label: '万源市',
            
            
            parentId: 306,
            code: '511781000000',
            value: '887',
            
            id: 887
          },
          {
            label: '通川区',
            
            
            parentId: 306,
            code: '511702000000',
            value: '888',
            
            id: 888
          },
          {
            label: '达川区',
            
            
            parentId: 306,
            code: '511703000000',
            value: '889',
            
            id: 889
          },
          {
            label: '宣汉县',
            
            
            parentId: 306,
            code: '511722000000',
            value: '890',
            
            id: 890
          },
          {
            label: '开江县',
            
            
            parentId: 306,
            code: '511723000000',
            value: '891',
            
            id: 891
          },
          {
            label: '大竹县',
            
            
            parentId: 306,
            code: '511724000000',
            value: '892',
            
            id: 892
          },
          {
            label: '渠县',
            
            
            parentId: 306,
            code: '511725000000',
            value: '893',
            
            id: 893
          }
        ],
        id: 306
      },
      {
        label: '雅安市',
        
        
        parentId: 26,
        code: '511800000000',
        value: '307',
        children: [
          {
            label: '名山区',
            
            
            parentId: 307,
            code: '511803000000',
            value: '894',
            
            id: 894
          },
          {
            label: '荥经县',
            
            
            parentId: 307,
            code: '511822000000',
            value: '895',
            
            id: 895
          },
          {
            label: '汉源县',
            
            
            parentId: 307,
            code: '511823000000',
            value: '896',
            
            id: 896
          },
          {
            label: '石棉县',
            
            
            parentId: 307,
            code: '511824000000',
            value: '897',
            
            id: 897
          },
          {
            label: '天全县',
            
            
            parentId: 307,
            code: '511825000000',
            value: '898',
            
            id: 898
          },
          {
            label: '芦山县',
            
            
            parentId: 307,
            code: '511826000000',
            value: '899',
            
            id: 899
          },
          {
            label: '宝兴县',
            
            
            parentId: 307,
            code: '511827000000',
            value: '900',
            
            id: 900
          },
          {
            label: '雨城区',
            
            
            parentId: 307,
            code: '511802000000',
            value: '901',
            
            id: 901
          }
        ],
        id: 307
      },
      {
        label: '巴中市',
        
        
        parentId: 26,
        code: '511900000000',
        value: '308',
        children: [
          {
            label: '巴州区',
            
            
            parentId: 308,
            code: '511902000000',
            value: '902',
            
            id: 902
          },
          {
            label: '恩阳区',
            
            
            parentId: 308,
            code: '511903000000',
            value: '903',
            
            id: 903
          },
          {
            label: '通江县',
            
            
            parentId: 308,
            code: '511921000000',
            value: '904',
            
            id: 904
          },
          {
            label: '南江县',
            
            
            parentId: 308,
            code: '511922000000',
            value: '905',
            
            id: 905
          },
          {
            label: '平昌县',
            
            
            parentId: 308,
            code: '511923000000',
            value: '906',
            
            id: 906
          }
        ],
        id: 308
      },
      {
        label: '资阳市',
        
        
        parentId: 26,
        code: '512000000000',
        value: '309',
        children: [
          {
            label: '安岳县',
            
            
            parentId: 309,
            code: '512021000000',
            value: '907',
            
            id: 907
          },
          {
            label: '乐至县',
            
            
            parentId: 309,
            code: '512022000000',
            value: '908',
            
            id: 908
          },
          {
            label: '雁江区',
            
            
            parentId: 309,
            code: '512002000000',
            value: '909',
            
            id: 909
          },
          {
            label: '简阳市',
            
            
            parentId: 309,
            code: '512081000000',
            value: '910',
            
            id: 910
          }
        ],
        id: 309
      }
    ],
    id: 26
  },
  {
    label: '天津市',
    
    
    parentId: 1,
    code: '120000000000',
    value: '27',
    children: [
      {
        label: '市辖区',
        
        
        parentId: 27,
        code: '120100000000',
        value: '310',
        children: [
          {
            label: '宝坻区',
            
            
            parentId: 310,
            code: '120115000000',
            value: '3177',
            
            id: 3177
          },
          {
            label: '北辰区',
            
            
            parentId: 310,
            code: '120113000000',
            value: '3178',
            
            id: 3178
          },
          {
            label: '滨海新区',
            
            
            parentId: 310,
            code: '120116000000',
            value: '3179',
            
            id: 3179
          },
          {
            label: '东丽区',
            
            
            parentId: 310,
            code: '120110000000',
            value: '3180',
            
            id: 3180
          },
          {
            label: '和平区',
            
            
            parentId: 310,
            code: '120101000000',
            value: '3181',
            
            id: 3181
          },
          {
            label: '河北区',
            
            
            parentId: 310,
            code: '120105000000',
            value: '3182',
            
            id: 3182
          },
          {
            label: '河东区',
            
            
            parentId: 310,
            code: '120102000000',
            value: '3183',
            
            id: 3183
          },
          {
            label: '河西区',
            
            
            parentId: 310,
            code: '120103000000',
            value: '3184',
            
            id: 3184
          },
          {
            label: '红桥区',
            
            
            parentId: 310,
            code: '120106000000',
            value: '3185',
            
            id: 3185
          },
          {
            label: '津南区',
            
            
            parentId: 310,
            code: '120112000000',
            value: '3186',
            
            id: 3186
          },
          {
            label: '南开区',
            
            
            parentId: 310,
            code: '120104000000',
            value: '3187',
            
            id: 3187
          },
          {
            label: '武清区',
            
            
            parentId: 310,
            code: '120114000000',
            value: '3188',
            
            id: 3188
          },
          {
            label: '西青区',
            
            
            parentId: 310,
            code: '120111000000',
            value: '3189',
            
            id: 3189
          }
        ],
        id: 310
      },
      {
        label: '县',
        
        
        parentId: 27,
        code: '120200000000',
        value: '311',
        children: [
          {
            label: '蓟县',
            
            
            parentId: 311,
            code: '120225000000',
            value: '3214',
            
            id: 3214
          },
          {
            label: '静海县',
            
            
            parentId: 311,
            code: '120223000000',
            value: '3215',
            
            id: 3215
          },
          {
            label: '宁河县',
            
            
            parentId: 311,
            code: '120221000000',
            value: '3216',
            
            id: 3216
          }
        ],
        id: 311
      }
    ],
    id: 27
  },
  {
    label: '西藏自治区',
    
    
    parentId: 1,
    code: '540000000000',
    value: '28',
    children: [
      {
        label: '拉萨市',
        
        
        parentId: 28,
        code: '540100000000',
        value: '312',
        children: [
          {
            label: '林周县',
            
            
            parentId: 312,
            code: '540121000000',
            value: '2840',
            
            id: 2840
          },
          {
            label: '当雄县',
            
            
            parentId: 312,
            code: '540122000000',
            value: '2841',
            
            id: 2841
          },
          {
            label: '城关区',
            
            
            parentId: 312,
            code: '540102000000',
            value: '2842',
            
            id: 2842
          },
          {
            label: '尼木县',
            
            
            parentId: 312,
            code: '540123000000',
            value: '2843',
            
            id: 2843
          },
          {
            label: '曲水县',
            
            
            parentId: 312,
            code: '540124000000',
            value: '2844',
            
            id: 2844
          },
          {
            label: '堆龙德庆县',
            
            
            parentId: 312,
            code: '540125000000',
            value: '2845',
            
            id: 2845
          },
          {
            label: '达孜县',
            
            
            parentId: 312,
            code: '540126000000',
            value: '2846',
            
            id: 2846
          },
          {
            label: '墨竹工卡县',
            
            
            parentId: 312,
            code: '540127000000',
            value: '2847',
            
            id: 2847
          }
        ],
        id: 312
      },
      {
        label: '昌都地区',
        
        
        parentId: 28,
        code: '542100000000',
        value: '313',
        children: [
          {
            label: '昌都县',
            
            
            parentId: 313,
            code: '542121000000',
            value: '987',
            
            id: 987
          },
          {
            label: '江达县',
            
            
            parentId: 313,
            code: '542122000000',
            value: '988',
            
            id: 988
          },
          {
            label: '贡觉县',
            
            
            parentId: 313,
            code: '542123000000',
            value: '989',
            
            id: 989
          },
          {
            label: '类乌齐县',
            
            
            parentId: 313,
            code: '542124000000',
            value: '990',
            
            id: 990
          },
          {
            label: '丁青县',
            
            
            parentId: 313,
            code: '542125000000',
            value: '991',
            
            id: 991
          },
          {
            label: '察雅县',
            
            
            parentId: 313,
            code: '542126000000',
            value: '992',
            
            id: 992
          },
          {
            label: '八宿县',
            
            
            parentId: 313,
            code: '542127000000',
            value: '993',
            
            id: 993
          },
          {
            label: '左贡县',
            
            
            parentId: 313,
            code: '542128000000',
            value: '994',
            
            id: 994
          },
          {
            label: '芒康县',
            
            
            parentId: 313,
            code: '542129000000',
            value: '995',
            
            id: 995
          },
          {
            label: '洛隆县',
            
            
            parentId: 313,
            code: '542132000000',
            value: '996',
            
            id: 996
          },
          {
            label: '边坝县',
            
            
            parentId: 313,
            code: '542133000000',
            value: '997',
            
            id: 997
          }
        ],
        id: 313
      },
      {
        label: '山南地区',
        
        
        parentId: 28,
        code: '542200000000',
        value: '314',
        children: [
          {
            label: '乃东县',
            
            
            parentId: 314,
            code: '542221000000',
            value: '998',
            
            id: 998
          },
          {
            label: '扎囊县',
            
            
            parentId: 314,
            code: '542222000000',
            value: '999',
            
            id: 999
          },
          {
            label: '贡嘎县',
            
            
            parentId: 314,
            code: '542223000000',
            value: '1000',
            
            id: 1000
          },
          {
            label: '桑日县',
            
            
            parentId: 314,
            code: '542224000000',
            value: '1001',
            
            id: 1001
          },
          {
            label: '琼结县',
            
            
            parentId: 314,
            code: '542225000000',
            value: '1002',
            
            id: 1002
          },
          {
            label: '曲松县',
            
            
            parentId: 314,
            code: '542226000000',
            value: '1003',
            
            id: 1003
          },
          {
            label: '措美县',
            
            
            parentId: 314,
            code: '542227000000',
            value: '1004',
            
            id: 1004
          },
          {
            label: '洛扎县',
            
            
            parentId: 314,
            code: '542228000000',
            value: '1005',
            
            id: 1005
          },
          {
            label: '加查县',
            
            
            parentId: 314,
            code: '542229000000',
            value: '1006',
            
            id: 1006
          },
          {
            label: '隆子县',
            
            
            parentId: 314,
            code: '542231000000',
            value: '1007',
            
            id: 1007
          },
          {
            label: '错那县',
            
            
            parentId: 314,
            code: '542232000000',
            value: '1008',
            
            id: 1008
          },
          {
            label: '浪卡子县',
            
            
            parentId: 314,
            code: '542233000000',
            value: '1009',
            
            id: 1009
          }
        ],
        id: 314
      },
      {
        label: '日喀则市',
        
        
        parentId: 28,
        code: '540200000000',
        value: '315',
        children: [
          {
            label: '南木林县',
            
            
            parentId: 315,
            code: '540221000000',
            value: '1010',
            
            id: 1010
          },
          {
            label: '江孜县',
            
            
            parentId: 315,
            code: '540222000000',
            value: '1011',
            
            id: 1011
          },
          {
            label: '定日县',
            
            
            parentId: 315,
            code: '540223000000',
            value: '1012',
            
            id: 1012
          },
          {
            label: '萨迦县',
            
            
            parentId: 315,
            code: '540224000000',
            value: '1013',
            
            id: 1013
          },
          {
            label: '拉孜县',
            
            
            parentId: 315,
            code: '540225000000',
            value: '1014',
            
            id: 1014
          },
          {
            label: '昂仁县',
            
            
            parentId: 315,
            code: '540226000000',
            value: '1015',
            
            id: 1015
          },
          {
            label: '谢通门县',
            
            
            parentId: 315,
            code: '540227000000',
            value: '1016',
            
            id: 1016
          },
          {
            label: '白朗县',
            
            
            parentId: 315,
            code: '540228000000',
            value: '1017',
            
            id: 1017
          },
          {
            label: '仁布县',
            
            
            parentId: 315,
            code: '540229000000',
            value: '1018',
            
            id: 1018
          },
          {
            label: '康马县',
            
            
            parentId: 315,
            code: '540230000000',
            value: '1019',
            
            id: 1019
          },
          {
            label: '定结县',
            
            
            parentId: 315,
            code: '540231000000',
            value: '1020',
            
            id: 1020
          },
          {
            label: '仲巴县',
            
            
            parentId: 315,
            code: '540232000000',
            value: '1021',
            
            id: 1021
          },
          {
            label: '亚东县',
            
            
            parentId: 315,
            code: '540233000000',
            value: '1022',
            
            id: 1022
          },
          {
            label: '吉隆县',
            
            
            parentId: 315,
            code: '540234000000',
            value: '1023',
            
            id: 1023
          },
          {
            label: '聂拉木县',
            
            
            parentId: 315,
            code: '540235000000',
            value: '1024',
            
            id: 1024
          },
          {
            label: '萨嘎县',
            
            
            parentId: 315,
            code: '540236000000',
            value: '1025',
            
            id: 1025
          },
          {
            label: '岗巴县',
            
            
            parentId: 315,
            code: '540237000000',
            value: '1026',
            
            id: 1026
          },
          {
            label: '桑珠孜区',
            
            
            parentId: 315,
            code: '540202000000',
            value: '1027',
            
            id: 1027
          }
        ],
        id: 315
      },
      {
        label: '那曲地区',
        
        
        parentId: 28,
        code: '542400000000',
        value: '316',
        children: [
          {
            label: '双湖县',
            
            
            parentId: 316,
            code: '542431000000',
            value: '1028',
            
            id: 1028
          },
          {
            label: '那曲县',
            
            
            parentId: 316,
            code: '542421000000',
            value: '1029',
            
            id: 1029
          },
          {
            label: '嘉黎县',
            
            
            parentId: 316,
            code: '542422000000',
            value: '1030',
            
            id: 1030
          },
          {
            label: '比如县',
            
            
            parentId: 316,
            code: '542423000000',
            value: '1031',
            
            id: 1031
          },
          {
            label: '聂荣县',
            
            
            parentId: 316,
            code: '542424000000',
            value: '1032',
            
            id: 1032
          },
          {
            label: '安多县',
            
            
            parentId: 316,
            code: '542425000000',
            value: '1033',
            
            id: 1033
          },
          {
            label: '申扎县',
            
            
            parentId: 316,
            code: '542426000000',
            value: '1034',
            
            id: 1034
          },
          {
            label: '索县',
            
            
            parentId: 316,
            code: '542427000000',
            value: '1035',
            
            id: 1035
          },
          {
            label: '班戈县',
            
            
            parentId: 316,
            code: '542428000000',
            value: '1036',
            
            id: 1036
          },
          {
            label: '巴青县',
            
            
            parentId: 316,
            code: '542429000000',
            value: '1037',
            
            id: 1037
          },
          {
            label: '尼玛县',
            
            
            parentId: 316,
            code: '542430000000',
            value: '1038',
            
            id: 1038
          }
        ],
        id: 316
      },
      {
        label: '阿里地区',
        
        
        parentId: 28,
        code: '542500000000',
        value: '317',
        children: [
          {
            label: '普兰县',
            
            
            parentId: 317,
            code: '542521000000',
            value: '1039',
            
            id: 1039
          },
          {
            label: '札达县',
            
            
            parentId: 317,
            code: '542522000000',
            value: '1040',
            
            id: 1040
          },
          {
            label: '噶尔县',
            
            
            parentId: 317,
            code: '542523000000',
            value: '1041',
            
            id: 1041
          },
          {
            label: '日土县',
            
            
            parentId: 317,
            code: '542524000000',
            value: '1042',
            
            id: 1042
          },
          {
            label: '革吉县',
            
            
            parentId: 317,
            code: '542525000000',
            value: '1043',
            
            id: 1043
          },
          {
            label: '改则县',
            
            
            parentId: 317,
            code: '542526000000',
            value: '1044',
            
            id: 1044
          },
          {
            label: '措勤县',
            
            
            parentId: 317,
            code: '542527000000',
            value: '1045',
            
            id: 1045
          }
        ],
        id: 317
      },
      {
        label: '林芝地区',
        
        
        parentId: 28,
        code: '542600000000',
        value: '318',
        children: [
          {
            label: '林芝县',
            
            
            parentId: 318,
            code: '542621000000',
            value: '1046',
            
            id: 1046
          },
          {
            label: '工布江达县',
            
            
            parentId: 318,
            code: '542622000000',
            value: '1047',
            
            id: 1047
          },
          {
            label: '米林县',
            
            
            parentId: 318,
            code: '542623000000',
            value: '1048',
            
            id: 1048
          },
          {
            label: '墨脱县',
            
            
            parentId: 318,
            code: '542624000000',
            value: '1049',
            
            id: 1049
          },
          {
            label: '波密县',
            
            
            parentId: 318,
            code: '542625000000',
            value: '1050',
            
            id: 1050
          },
          {
            label: '察隅县',
            
            
            parentId: 318,
            code: '542626000000',
            value: '1051',
            
            id: 1051
          },
          {
            label: '朗县',
            
            
            parentId: 318,
            code: '542627000000',
            value: '1052',
            
            id: 1052
          }
        ],
        id: 318
      }
    ],
    id: 28
  },
  {
    label: '新疆维吾尔自治区',
    
    
    parentId: 1,
    code: '650000000000',
    value: '29',
    children: [
      {
        label: '阿克苏地区',
        
        
        parentId: 29,
        code: '652900000000',
        value: '319',
        children: [
          {
            label: '温宿县',
            
            
            parentId: 319,
            code: '652922000000',
            value: '966',
            
            id: 966
          },
          {
            label: '库车县',
            
            
            parentId: 319,
            code: '652923000000',
            value: '967',
            
            id: 967
          },
          {
            label: '沙雅县',
            
            
            parentId: 319,
            code: '652924000000',
            value: '968',
            
            id: 968
          },
          {
            label: '新和县',
            
            
            parentId: 319,
            code: '652925000000',
            value: '969',
            
            id: 969
          },
          {
            label: '拜城县',
            
            
            parentId: 319,
            code: '652926000000',
            value: '970',
            
            id: 970
          },
          {
            label: '乌什县',
            
            
            parentId: 319,
            code: '652927000000',
            value: '971',
            
            id: 971
          },
          {
            label: '阿瓦提县',
            
            
            parentId: 319,
            code: '652928000000',
            value: '972',
            
            id: 972
          },
          {
            label: '柯坪县',
            
            
            parentId: 319,
            code: '652929000000',
            value: '973',
            
            id: 973
          },
          {
            label: '阿克苏市',
            
            
            parentId: 319,
            code: '652901000000',
            value: '974',
            
            id: 974
          }
        ],
        id: 319
      },
      {
        label: '吐鲁番地区',
        
        
        parentId: 29,
        code: '652100000000',
        value: '320',
        children: [
          {
            label: '吐鲁番市',
            
            
            parentId: 320,
            code: '652101000000',
            value: '975',
            
            id: 975
          },
          {
            label: '鄯善县',
            
            
            parentId: 320,
            code: '652122000000',
            value: '976',
            
            id: 976
          },
          {
            label: '托克逊县',
            
            
            parentId: 320,
            code: '652123000000',
            value: '977',
            
            id: 977
          }
        ],
        id: 320
      },
      {
        label: '哈密地区',
        
        
        parentId: 29,
        code: '652200000000',
        value: '321',
        children: [
          {
            label: '哈密市',
            
            
            parentId: 321,
            code: '652201000000',
            value: '978',
            
            id: 978
          },
          {
            label: '伊吾县',
            
            
            parentId: 321,
            code: '652223000000',
            value: '979',
            
            id: 979
          },
          {
            label: '巴里坤哈萨克自治县',
            
            
            parentId: 321,
            code: '652222000000',
            value: '980',
            
            id: 980
          }
        ],
        id: 321
      },
      {
        label: '喀什地区',
        
        
        parentId: 29,
        code: '653100000000',
        value: '322',
        children: [
          {
            label: '喀什市',
            
            
            parentId: 322,
            code: '653101000000',
            value: '924',
            
            id: 924
          },
          {
            label: '塔什库尔干塔吉克自治县',
            
            
            parentId: 322,
            code: '653131000000',
            value: '925',
            
            id: 925
          },
          {
            label: '疏附县',
            
            
            parentId: 322,
            code: '653121000000',
            value: '926',
            
            id: 926
          },
          {
            label: '疏勒县',
            
            
            parentId: 322,
            code: '653122000000',
            value: '927',
            
            id: 927
          },
          {
            label: '英吉沙县',
            
            
            parentId: 322,
            code: '653123000000',
            value: '928',
            
            id: 928
          },
          {
            label: '泽普县',
            
            
            parentId: 322,
            code: '653124000000',
            value: '929',
            
            id: 929
          },
          {
            label: '莎车县',
            
            
            parentId: 322,
            code: '653125000000',
            value: '930',
            
            id: 930
          },
          {
            label: '叶城县',
            
            
            parentId: 322,
            code: '653126000000',
            value: '931',
            
            id: 931
          },
          {
            label: '麦盖提县',
            
            
            parentId: 322,
            code: '653127000000',
            value: '932',
            
            id: 932
          },
          {
            label: '岳普湖县',
            
            
            parentId: 322,
            code: '653128000000',
            value: '933',
            
            id: 933
          },
          {
            label: '伽师县',
            
            
            parentId: 322,
            code: '653129000000',
            value: '934',
            
            id: 934
          },
          {
            label: '巴楚县',
            
            
            parentId: 322,
            code: '653130000000',
            value: '935',
            
            id: 935
          }
        ],
        id: 322
      },
      {
        label: '和田地区',
        
        
        parentId: 29,
        code: '653200000000',
        value: '323',
        children: [
          {
            label: '和田县',
            
            
            parentId: 323,
            code: '653221000000',
            value: '936',
            
            id: 936
          },
          {
            label: '墨玉县',
            
            
            parentId: 323,
            code: '653222000000',
            value: '937',
            
            id: 937
          },
          {
            label: '皮山县',
            
            
            parentId: 323,
            code: '653223000000',
            value: '938',
            
            id: 938
          },
          {
            label: '洛浦县',
            
            
            parentId: 323,
            code: '653224000000',
            value: '939',
            
            id: 939
          },
          {
            label: '策勒县',
            
            
            parentId: 323,
            code: '653225000000',
            value: '940',
            
            id: 940
          },
          {
            label: '于田县',
            
            
            parentId: 323,
            code: '653226000000',
            value: '941',
            
            id: 941
          },
          {
            label: '民丰县',
            
            
            parentId: 323,
            code: '653227000000',
            value: '942',
            
            id: 942
          },
          {
            label: '和田市',
            
            
            parentId: 323,
            code: '653201000000',
            value: '943',
            
            id: 943
          }
        ],
        id: 323
      },
      {
        label: '塔城地区',
        
        
        parentId: 29,
        code: '654200000000',
        value: '324',
        children: [
          {
            label: '塔城市',
            
            
            parentId: 324,
            code: '654201000000',
            value: '944',
            
            id: 944
          },
          {
            label: '乌苏市',
            
            
            parentId: 324,
            code: '654202000000',
            value: '945',
            
            id: 945
          },
          {
            label: '和布克赛尔蒙古自治县',
            
            
            parentId: 324,
            code: '654226000000',
            value: '946',
            
            id: 946
          },
          {
            label: '额敏县',
            
            
            parentId: 324,
            code: '654221000000',
            value: '947',
            
            id: 947
          },
          {
            label: '沙湾县',
            
            
            parentId: 324,
            code: '654223000000',
            value: '948',
            
            id: 948
          },
          {
            label: '托里县',
            
            
            parentId: 324,
            code: '654224000000',
            value: '949',
            
            id: 949
          },
          {
            label: '裕民县',
            
            
            parentId: 324,
            code: '654225000000',
            value: '950',
            
            id: 950
          }
        ],
        id: 324
      },
      {
        label: '阿勒泰地区',
        
        
        parentId: 29,
        code: '654300000000',
        value: '325',
        children: [
          {
            label: '布尔津县',
            
            
            parentId: 325,
            code: '654321000000',
            value: '951',
            
            id: 951
          },
          {
            label: '富蕴县',
            
            
            parentId: 325,
            code: '654322000000',
            value: '952',
            
            id: 952
          },
          {
            label: '福海县',
            
            
            parentId: 325,
            code: '654323000000',
            value: '953',
            
            id: 953
          },
          {
            label: '哈巴河县',
            
            
            parentId: 325,
            code: '654324000000',
            value: '954',
            
            id: 954
          },
          {
            label: '青河县',
            
            
            parentId: 325,
            code: '654325000000',
            value: '955',
            
            id: 955
          },
          {
            label: '吉木乃县',
            
            
            parentId: 325,
            code: '654326000000',
            value: '956',
            
            id: 956
          },
          {
            label: '阿勒泰市',
            
            
            parentId: 325,
            code: '654301000000',
            value: '957',
            
            id: 957
          }
        ],
        id: 325
      },
      {
        label: '昌吉回族自治州',
        
        
        parentId: 29,
        code: '652300000000',
        value: '326',
        children: [
          {
            label: '阜康市',
            
            
            parentId: 326,
            code: '652302000000',
            value: '1162',
            
            id: 1162
          },
          {
            label: '昌吉市',
            
            
            parentId: 326,
            code: '652301000000',
            value: '1163',
            
            id: 1163
          },
          {
            label: '木垒哈萨克自治县',
            
            
            parentId: 326,
            code: '652328000000',
            value: '1164',
            
            id: 1164
          },
          {
            label: '呼图壁县',
            
            
            parentId: 326,
            code: '652323000000',
            value: '1165',
            
            id: 1165
          },
          {
            label: '玛纳斯县',
            
            
            parentId: 326,
            code: '652324000000',
            value: '1166',
            
            id: 1166
          },
          {
            label: '奇台县',
            
            
            parentId: 326,
            code: '652325000000',
            value: '1167',
            
            id: 1167
          },
          {
            label: '吉木萨尔县',
            
            
            parentId: 326,
            code: '652327000000',
            value: '1168',
            
            id: 1168
          }
        ],
        id: 326
      },
      {
        label: '博尔塔拉蒙古自治州',
        
        
        parentId: 29,
        code: '652700000000',
        value: '327',
        children: [
          {
            label: '精河县',
            
            
            parentId: 327,
            code: '652722000000',
            value: '1169',
            
            id: 1169
          },
          {
            label: '温泉县',
            
            
            parentId: 327,
            code: '652723000000',
            value: '1170',
            
            id: 1170
          },
          {
            label: '博乐市',
            
            
            parentId: 327,
            code: '652701000000',
            value: '1171',
            
            id: 1171
          },
          {
            label: '阿拉山口市',
            
            
            parentId: 327,
            code: '652702000000',
            value: '1172',
            
            id: 1172
          }
        ],
        id: 327
      },
      {
        label: '巴音郭楞蒙古自治州',
        
        
        parentId: 29,
        code: '652800000000',
        value: '328',
        children: [
          {
            label: '库尔勒市',
            
            
            parentId: 328,
            code: '652801000000',
            value: '1173',
            
            id: 1173
          },
          {
            label: '焉耆回族自治县',
            
            
            parentId: 328,
            code: '652826000000',
            value: '1174',
            
            id: 1174
          },
          {
            label: '和静县',
            
            
            parentId: 328,
            code: '652827000000',
            value: '1175',
            
            id: 1175
          },
          {
            label: '和硕县',
            
            
            parentId: 328,
            code: '652828000000',
            value: '1176',
            
            id: 1176
          },
          {
            label: '博湖县',
            
            
            parentId: 328,
            code: '652829000000',
            value: '1177',
            
            id: 1177
          },
          {
            label: '轮台县',
            
            
            parentId: 328,
            code: '652822000000',
            value: '1178',
            
            id: 1178
          },
          {
            label: '尉犁县',
            
            
            parentId: 328,
            code: '652823000000',
            value: '1179',
            
            id: 1179
          },
          {
            label: '若羌县',
            
            
            parentId: 328,
            code: '652824000000',
            value: '1180',
            
            id: 1180
          },
          {
            label: '且末县',
            
            
            parentId: 328,
            code: '652825000000',
            value: '1181',
            
            id: 1181
          }
        ],
        id: 328
      },
      {
        label: '克孜勒苏柯尔克孜自治州',
        
        
        parentId: 29,
        code: '653000000000',
        value: '329',
        children: [
          {
            label: '阿克陶县',
            
            
            parentId: 329,
            code: '653022000000',
            value: '1182',
            
            id: 1182
          },
          {
            label: '阿图什市',
            
            
            parentId: 329,
            code: '653001000000',
            value: '1183',
            
            id: 1183
          },
          {
            label: '阿合奇县',
            
            
            parentId: 329,
            code: '653023000000',
            value: '1184',
            
            id: 1184
          },
          {
            label: '乌恰县',
            
            
            parentId: 329,
            code: '653024000000',
            value: '1185',
            
            id: 1185
          }
        ],
        id: 329
      },
      {
        label: '乌鲁木齐市',
        
        
        parentId: 29,
        code: '650100000000',
        value: '330',
        children: [
          {
            label: '天山区',
            
            
            parentId: 330,
            code: '650102000000',
            value: '3051',
            
            id: 3051
          },
          {
            label: '沙依巴克区',
            
            
            parentId: 330,
            code: '650103000000',
            value: '3052',
            
            id: 3052
          },
          {
            label: '新市区',
            
            
            parentId: 330,
            code: '650104000000',
            value: '3053',
            
            id: 3053
          },
          {
            label: '水磨沟区',
            
            
            parentId: 330,
            code: '650105000000',
            value: '3054',
            
            id: 3054
          },
          {
            label: '头屯河区',
            
            
            parentId: 330,
            code: '650106000000',
            value: '3055',
            
            id: 3055
          },
          {
            label: '达坂城区',
            
            
            parentId: 330,
            code: '650107000000',
            value: '3056',
            
            id: 3056
          },
          {
            label: '米东区',
            
            
            parentId: 330,
            code: '650109000000',
            value: '3057',
            
            id: 3057
          },
          {
            label: '乌鲁木齐县',
            
            
            parentId: 330,
            code: '650121000000',
            value: '3058',
            
            id: 3058
          }
        ],
        id: 330
      },
      {
        label: '克拉玛依市',
        
        
        parentId: 29,
        code: '650200000000',
        value: '331',
        children: [
          {
            label: '独山子区',
            
            
            parentId: 331,
            code: '650202000000',
            value: '3059',
            
            id: 3059
          },
          {
            label: '克拉玛依区',
            
            
            parentId: 331,
            code: '650203000000',
            value: '3060',
            
            id: 3060
          },
          {
            label: '白碱滩区',
            
            
            parentId: 331,
            code: '650204000000',
            value: '3061',
            
            id: 3061
          },
          {
            label: '乌尔禾区',
            
            
            parentId: 331,
            code: '650205000000',
            value: '3062',
            
            id: 3062
          }
        ],
        id: 331
      },
      {
        label: '伊犁哈萨克自治州',
        
        
        parentId: 29,
        code: '654000000000',
        value: '332',
        children: [
          {
            label: '察布查尔锡伯自治县',
            
            
            parentId: 332,
            code: '654022000000',
            value: '1241',
            
            id: 1241
          },
          {
            label: '尼勒克县',
            
            
            parentId: 332,
            code: '654028000000',
            value: '1242',
            
            id: 1242
          },
          {
            label: '伊宁市',
            
            
            parentId: 332,
            code: '654002000000',
            value: '1243',
            
            id: 1243
          },
          {
            label: '奎屯市',
            
            
            parentId: 332,
            code: '654003000000',
            value: '1244',
            
            id: 1244
          },
          {
            label: '伊宁县',
            
            
            parentId: 332,
            code: '654021000000',
            value: '1245',
            
            id: 1245
          },
          {
            label: '霍城县',
            
            
            parentId: 332,
            code: '654023000000',
            value: '1246',
            
            id: 1246
          },
          {
            label: '巩留县',
            
            
            parentId: 332,
            code: '654024000000',
            value: '1247',
            
            id: 1247
          },
          {
            label: '新源县',
            
            
            parentId: 332,
            code: '654025000000',
            value: '1248',
            
            id: 1248
          },
          {
            label: '昭苏县',
            
            
            parentId: 332,
            code: '654026000000',
            value: '1249',
            
            id: 1249
          },
          {
            label: '特克斯县',
            
            
            parentId: 332,
            code: '654027000000',
            value: '1250',
            
            id: 1250
          }
        ],
        id: 332
      },
      {
        label: '自治区直辖县级行政区划',
        
        
        parentId: 29,
        code: '659000000000',
        value: '333',
        children: [
          {
            label: '阿拉尔市',
            
            
            parentId: 333,
            code: '659002000000',
            value: '3210',
            
            id: 3210
          },
          {
            label: '石河子市',
            
            
            parentId: 333,
            code: '659001000000',
            value: '3211',
            
            id: 3211
          },
          {
            label: '图木舒克市',
            
            
            parentId: 333,
            code: '659003000000',
            value: '3212',
            
            id: 3212
          },
          {
            label: '五家渠市',
            
            
            parentId: 333,
            code: '659004000000',
            value: '3213',
            
            id: 3213
          }
        ],
        id: 333
      }
    ],
    id: 29
  },
  {
    label: '云南省',
    
    
    parentId: 1,
    code: '530000000000',
    value: '30',
    children: [
      {
        label: '西双版纳傣族自治州',
        
        
        parentId: 30,
        code: '532800000000',
        value: '334',
        children: [
          {
            label: '勐海县',
            
            
            parentId: 334,
            code: '532822000000',
            value: '1214',
            
            id: 1214
          },
          {
            label: '勐腊县',
            
            
            parentId: 334,
            code: '532823000000',
            value: '1215',
            
            id: 1215
          },
          {
            label: '景洪市',
            
            
            parentId: 334,
            code: '532801000000',
            value: '1216',
            
            id: 1216
          }
        ],
        id: 334
      },
      {
        label: '大理白族自治州',
        
        
        parentId: 30,
        code: '532900000000',
        value: '335',
        children: [
          {
            label: '大理市',
            
            
            parentId: 335,
            code: '532901000000',
            value: '1217',
            
            id: 1217
          },
          {
            label: '漾濞彝族自治县',
            
            
            parentId: 335,
            code: '532922000000',
            value: '1218',
            
            id: 1218
          },
          {
            label: '南涧彝族自治县',
            
            
            parentId: 335,
            code: '532926000000',
            value: '1219',
            
            id: 1219
          },
          {
            label: '巍山彝族回族自治县',
            
            
            parentId: 335,
            code: '532927000000',
            value: '1220',
            
            id: 1220
          },
          {
            label: '永平县',
            
            
            parentId: 335,
            code: '532928000000',
            value: '1221',
            
            id: 1221
          },
          {
            label: '云龙县',
            
            
            parentId: 335,
            code: '532929000000',
            value: '1222',
            
            id: 1222
          },
          {
            label: '洱源县',
            
            
            parentId: 335,
            code: '532930000000',
            value: '1223',
            
            id: 1223
          },
          {
            label: '剑川县',
            
            
            parentId: 335,
            code: '532931000000',
            value: '1224',
            
            id: 1224
          },
          {
            label: '鹤庆县',
            
            
            parentId: 335,
            code: '532932000000',
            value: '1225',
            
            id: 1225
          },
          {
            label: '祥云县',
            
            
            parentId: 335,
            code: '532923000000',
            value: '1226',
            
            id: 1226
          },
          {
            label: '宾川县',
            
            
            parentId: 335,
            code: '532924000000',
            value: '1227',
            
            id: 1227
          },
          {
            label: '弥渡县',
            
            
            parentId: 335,
            code: '532925000000',
            value: '1228',
            
            id: 1228
          }
        ],
        id: 335
      },
      {
        label: '德宏傣族景颇族自治州',
        
        
        parentId: 30,
        code: '533100000000',
        value: '336',
        children: [
          {
            label: '梁河县',
            
            
            parentId: 336,
            code: '533122000000',
            value: '1229',
            
            id: 1229
          },
          {
            label: '盈江县',
            
            
            parentId: 336,
            code: '533123000000',
            value: '1230',
            
            id: 1230
          },
          {
            label: '陇川县',
            
            
            parentId: 336,
            code: '533124000000',
            value: '1231',
            
            id: 1231
          },
          {
            label: '瑞丽市',
            
            
            parentId: 336,
            code: '533102000000',
            value: '1232',
            
            id: 1232
          },
          {
            label: '芒市',
            
            
            parentId: 336,
            code: '533103000000',
            value: '1233',
            
            id: 1233
          }
        ],
        id: 336
      },
      {
        label: '怒江傈僳族自治州',
        
        
        parentId: 30,
        code: '533300000000',
        value: '337',
        children: [
          {
            label: '贡山独龙族怒族自治县',
            
            
            parentId: 337,
            code: '533324000000',
            value: '1234',
            
            id: 1234
          },
          {
            label: '兰坪白族普米族自治县',
            
            
            parentId: 337,
            code: '533325000000',
            value: '1235',
            
            id: 1235
          },
          {
            label: '泸水县',
            
            
            parentId: 337,
            code: '533321000000',
            value: '1236',
            
            id: 1236
          },
          {
            label: '福贡县',
            
            
            parentId: 337,
            code: '533323000000',
            value: '1237',
            
            id: 1237
          }
        ],
        id: 337
      },
      {
        label: '迪庆藏族自治州',
        
        
        parentId: 30,
        code: '533400000000',
        value: '338',
        children: [
          {
            label: '香格里拉县',
            
            
            parentId: 338,
            code: '533421000000',
            value: '1238',
            
            id: 1238
          },
          {
            label: '德钦县',
            
            
            parentId: 338,
            code: '533422000000',
            value: '1239',
            
            id: 1239
          },
          {
            label: '维西傈僳族自治县',
            
            
            parentId: 338,
            code: '533423000000',
            value: '1240',
            
            id: 1240
          }
        ],
        id: 338
      },
      {
        label: '普洱市',
        
        
        parentId: 30,
        code: '530800000000',
        value: '339',
        children: [
          {
            label: '思茅区',
            
            
            parentId: 339,
            code: '530802000000',
            value: '3063',
            
            id: 3063
          },
          {
            label: '宁洱哈尼族彝族自治县',
            
            
            parentId: 339,
            code: '530821000000',
            value: '3064',
            
            id: 3064
          },
          {
            label: '墨江哈尼族自治县',
            
            
            parentId: 339,
            code: '530822000000',
            value: '3065',
            
            id: 3065
          },
          {
            label: '景东彝族自治县',
            
            
            parentId: 339,
            code: '530823000000',
            value: '3066',
            
            id: 3066
          },
          {
            label: '景谷傣族彝族自治县',
            
            
            parentId: 339,
            code: '530824000000',
            value: '3067',
            
            id: 3067
          },
          {
            label: '镇沅彝族哈尼族拉祜族自治县',
            
            
            parentId: 339,
            code: '530825000000',
            value: '3068',
            
            id: 3068
          },
          {
            label: '江城哈尼族彝族自治县',
            
            
            parentId: 339,
            code: '530826000000',
            value: '3069',
            
            id: 3069
          },
          {
            label: '孟连傣族拉祜族佤族自治县',
            
            
            parentId: 339,
            code: '530827000000',
            value: '3070',
            
            id: 3070
          },
          {
            label: '澜沧拉祜族自治县',
            
            
            parentId: 339,
            code: '530828000000',
            value: '3071',
            
            id: 3071
          },
          {
            label: '西盟佤族自治县',
            
            
            parentId: 339,
            code: '530829000000',
            value: '3072',
            
            id: 3072
          }
        ],
        id: 339
      },
      {
        label: '昆明市',
        
        
        parentId: 30,
        code: '530100000000',
        value: '340',
        children: [
          {
            label: '五华区',
            
            
            parentId: 340,
            code: '530102000000',
            value: '2779',
            
            id: 2779
          },
          {
            label: '盘龙区',
            
            
            parentId: 340,
            code: '530103000000',
            value: '2780',
            
            id: 2780
          },
          {
            label: '官渡区',
            
            
            parentId: 340,
            code: '530111000000',
            value: '2781',
            
            id: 2781
          },
          {
            label: '西山区',
            
            
            parentId: 340,
            code: '530112000000',
            value: '2782',
            
            id: 2782
          },
          {
            label: '东川区',
            
            
            parentId: 340,
            code: '530113000000',
            value: '2783',
            
            id: 2783
          },
          {
            label: '石林彝族自治县',
            
            
            parentId: 340,
            code: '530126000000',
            value: '2784',
            
            id: 2784
          },
          {
            label: '禄劝彝族苗族自治县',
            
            
            parentId: 340,
            code: '530128000000',
            value: '2785',
            
            id: 2785
          },
          {
            label: '寻甸回族彝族自治县',
            
            
            parentId: 340,
            code: '530129000000',
            value: '2786',
            
            id: 2786
          },
          {
            label: '安宁市',
            
            
            parentId: 340,
            code: '530181000000',
            value: '2787',
            
            id: 2787
          },
          {
            label: '嵩明县',
            
            
            parentId: 340,
            code: '530127000000',
            value: '2788',
            
            id: 2788
          },
          {
            label: '呈贡区',
            
            
            parentId: 340,
            code: '530114000000',
            value: '2789',
            
            id: 2789
          },
          {
            label: '晋宁县',
            
            
            parentId: 340,
            code: '530122000000',
            value: '2790',
            
            id: 2790
          },
          {
            label: '富民县',
            
            
            parentId: 340,
            code: '530124000000',
            value: '2791',
            
            id: 2791
          },
          {
            label: '宜良县',
            
            
            parentId: 340,
            code: '530125000000',
            value: '2792',
            
            id: 2792
          }
        ],
        id: 340
      },
      {
        label: '曲靖市',
        
        
        parentId: 30,
        code: '530300000000',
        value: '341',
        children: [
          {
            label: '马龙县',
            
            
            parentId: 341,
            code: '530321000000',
            value: '2793',
            
            id: 2793
          },
          {
            label: '陆良县',
            
            
            parentId: 341,
            code: '530322000000',
            value: '2794',
            
            id: 2794
          },
          {
            label: '师宗县',
            
            
            parentId: 341,
            code: '530323000000',
            value: '2795',
            
            id: 2795
          },
          {
            label: '罗平县',
            
            
            parentId: 341,
            code: '530324000000',
            value: '2796',
            
            id: 2796
          },
          {
            label: '富源县',
            
            
            parentId: 341,
            code: '530325000000',
            value: '2797',
            
            id: 2797
          },
          {
            label: '会泽县',
            
            
            parentId: 341,
            code: '530326000000',
            value: '2798',
            
            id: 2798
          },
          {
            label: '沾益县',
            
            
            parentId: 341,
            code: '530328000000',
            value: '2799',
            
            id: 2799
          },
          {
            label: '宣威市',
            
            
            parentId: 341,
            code: '530381000000',
            value: '2800',
            
            id: 2800
          },
          {
            label: '麒麟区',
            
            
            parentId: 341,
            code: '530302000000',
            value: '2801',
            
            id: 2801
          }
        ],
        id: 341
      },
      {
        label: '玉溪市',
        
        
        parentId: 30,
        code: '530400000000',
        value: '342',
        children: [
          {
            label: '红塔区',
            
            
            parentId: 342,
            code: '530402000000',
            value: '2802',
            
            id: 2802
          },
          {
            label: '峨山彝族自治县',
            
            
            parentId: 342,
            code: '530426000000',
            value: '2803',
            
            id: 2803
          },
          {
            label: '新平彝族傣族自治县',
            
            
            parentId: 342,
            code: '530427000000',
            value: '2804',
            
            id: 2804
          },
          {
            label: '元江哈尼族彝族傣族自治县',
            
            
            parentId: 342,
            code: '530428000000',
            value: '2805',
            
            id: 2805
          },
          {
            label: '江川县',
            
            
            parentId: 342,
            code: '530421000000',
            value: '2806',
            
            id: 2806
          },
          {
            label: '澄江县',
            
            
            parentId: 342,
            code: '530422000000',
            value: '2807',
            
            id: 2807
          },
          {
            label: '通海县',
            
            
            parentId: 342,
            code: '530423000000',
            value: '2808',
            
            id: 2808
          },
          {
            label: '华宁县',
            
            
            parentId: 342,
            code: '530424000000',
            value: '2809',
            
            id: 2809
          },
          {
            label: '易门县',
            
            
            parentId: 342,
            code: '530425000000',
            value: '2810',
            
            id: 2810
          }
        ],
        id: 342
      },
      {
        label: '保山市',
        
        
        parentId: 30,
        code: '530500000000',
        value: '343',
        children: [
          {
            label: '隆阳区',
            
            
            parentId: 343,
            code: '530502000000',
            value: '2811',
            
            id: 2811
          },
          {
            label: '施甸县',
            
            
            parentId: 343,
            code: '530521000000',
            value: '2812',
            
            id: 2812
          },
          {
            label: '腾冲县',
            
            
            parentId: 343,
            code: '530522000000',
            value: '2813',
            
            id: 2813
          },
          {
            label: '龙陵县',
            
            
            parentId: 343,
            code: '530523000000',
            value: '2814',
            
            id: 2814
          },
          {
            label: '昌宁县',
            
            
            parentId: 343,
            code: '530524000000',
            value: '2815',
            
            id: 2815
          }
        ],
        id: 343
      },
      {
        label: '昭通市',
        
        
        parentId: 30,
        code: '530600000000',
        value: '344',
        children: [
          {
            label: '鲁甸县',
            
            
            parentId: 344,
            code: '530621000000',
            value: '2816',
            
            id: 2816
          },
          {
            label: '巧家县',
            
            
            parentId: 344,
            code: '530622000000',
            value: '2817',
            
            id: 2817
          },
          {
            label: '盐津县',
            
            
            parentId: 344,
            code: '530623000000',
            value: '2818',
            
            id: 2818
          },
          {
            label: '大关县',
            
            
            parentId: 344,
            code: '530624000000',
            value: '2819',
            
            id: 2819
          },
          {
            label: '永善县',
            
            
            parentId: 344,
            code: '530625000000',
            value: '2820',
            
            id: 2820
          },
          {
            label: '绥江县',
            
            
            parentId: 344,
            code: '530626000000',
            value: '2821',
            
            id: 2821
          },
          {
            label: '镇雄县',
            
            
            parentId: 344,
            code: '530627000000',
            value: '2822',
            
            id: 2822
          },
          {
            label: '彝良县',
            
            
            parentId: 344,
            code: '530628000000',
            value: '2823',
            
            id: 2823
          },
          {
            label: '威信县',
            
            
            parentId: 344,
            code: '530629000000',
            value: '2824',
            
            id: 2824
          },
          {
            label: '水富县',
            
            
            parentId: 344,
            code: '530630000000',
            value: '2825',
            
            id: 2825
          },
          {
            label: '昭阳区',
            
            
            parentId: 344,
            code: '530602000000',
            value: '2826',
            
            id: 2826
          }
        ],
        id: 344
      },
      {
        label: '丽江市',
        
        
        parentId: 30,
        code: '530700000000',
        value: '345',
        children: [
          {
            label: '古城区',
            
            
            parentId: 345,
            code: '530702000000',
            value: '2827',
            
            id: 2827
          },
          {
            label: '宁蒗彝族自治县',
            
            
            parentId: 345,
            code: '530724000000',
            value: '2828',
            
            id: 2828
          },
          {
            label: '玉龙纳西族自治县',
            
            
            parentId: 345,
            code: '530721000000',
            value: '2829',
            
            id: 2829
          },
          {
            label: '永胜县',
            
            
            parentId: 345,
            code: '530722000000',
            value: '2830',
            
            id: 2830
          },
          {
            label: '华坪县',
            
            
            parentId: 345,
            code: '530723000000',
            value: '2831',
            
            id: 2831
          }
        ],
        id: 345
      },
      {
        label: '临沧市',
        
        
        parentId: 30,
        code: '530900000000',
        value: '346',
        children: [
          {
            label: '临翔区',
            
            
            parentId: 346,
            code: '530902000000',
            value: '2832',
            
            id: 2832
          },
          {
            label: '凤庆县',
            
            
            parentId: 346,
            code: '530921000000',
            value: '2833',
            
            id: 2833
          },
          {
            label: '云县',
            
            
            parentId: 346,
            code: '530922000000',
            value: '2834',
            
            id: 2834
          },
          {
            label: '永德县',
            
            
            parentId: 346,
            code: '530923000000',
            value: '2835',
            
            id: 2835
          },
          {
            label: '镇康县',
            
            
            parentId: 346,
            code: '530924000000',
            value: '2836',
            
            id: 2836
          },
          {
            label: '双江拉祜族佤族布朗族傣族自治县',
            
            
            parentId: 346,
            code: '530925000000',
            value: '2837',
            
            id: 2837
          },
          {
            label: '耿马傣族佤族自治县',
            
            
            parentId: 346,
            code: '530926000000',
            value: '2838',
            
            id: 2838
          },
          {
            label: '沧源佤族自治县',
            
            
            parentId: 346,
            code: '530927000000',
            value: '2839',
            
            id: 2839
          }
        ],
        id: 346
      },
      {
        label: '楚雄彝族自治州',
        
        
        parentId: 30,
        code: '532300000000',
        value: '347',
        children: [
          {
            label: '楚雄市',
            
            
            parentId: 347,
            code: '532301000000',
            value: '1082',
            
            id: 1082
          },
          {
            label: '禄丰县',
            
            
            parentId: 347,
            code: '532331000000',
            value: '1083',
            
            id: 1083
          },
          {
            label: '双柏县',
            
            
            parentId: 347,
            code: '532322000000',
            value: '1084',
            
            id: 1084
          },
          {
            label: '牟定县',
            
            
            parentId: 347,
            code: '532323000000',
            value: '1085',
            
            id: 1085
          },
          {
            label: '南华县',
            
            
            parentId: 347,
            code: '532324000000',
            value: '1086',
            
            id: 1086
          },
          {
            label: '姚安县',
            
            
            parentId: 347,
            code: '532325000000',
            value: '1087',
            
            id: 1087
          },
          {
            label: '大姚县',
            
            
            parentId: 347,
            code: '532326000000',
            value: '1088',
            
            id: 1088
          },
          {
            label: '永仁县',
            
            
            parentId: 347,
            code: '532327000000',
            value: '1089',
            
            id: 1089
          },
          {
            label: '元谋县',
            
            
            parentId: 347,
            code: '532328000000',
            value: '1090',
            
            id: 1090
          },
          {
            label: '武定县',
            
            
            parentId: 347,
            code: '532329000000',
            value: '1091',
            
            id: 1091
          }
        ],
        id: 347
      },
      {
        label: '红河哈尼族彝族自治州',
        
        
        parentId: 30,
        code: '532500000000',
        value: '348',
        children: [
          {
            label: '建水县',
            
            
            parentId: 348,
            code: '532524000000',
            value: '1092',
            
            id: 1092
          },
          {
            label: '石屏县',
            
            
            parentId: 348,
            code: '532525000000',
            value: '1093',
            
            id: 1093
          },
          {
            label: '弥勒市',
            
            
            parentId: 348,
            code: '532504000000',
            value: '1094',
            
            id: 1094
          },
          {
            label: '泸西县',
            
            
            parentId: 348,
            code: '532527000000',
            value: '1095',
            
            id: 1095
          },
          {
            label: '元阳县',
            
            
            parentId: 348,
            code: '532528000000',
            value: '1096',
            
            id: 1096
          },
          {
            label: '红河县',
            
            
            parentId: 348,
            code: '532529000000',
            value: '1097',
            
            id: 1097
          },
          {
            label: '蒙自市',
            
            
            parentId: 348,
            code: '532503000000',
            value: '1098',
            
            id: 1098
          },
          {
            label: '绿春县',
            
            
            parentId: 348,
            code: '532531000000',
            value: '1099',
            
            id: 1099
          },
          {
            label: '个旧市',
            
            
            parentId: 348,
            code: '532501000000',
            value: '1100',
            
            id: 1100
          },
          {
            label: '开远市',
            
            
            parentId: 348,
            code: '532502000000',
            value: '1101',
            
            id: 1101
          },
          {
            label: '金平苗族瑶族傣族自治县',
            
            
            parentId: 348,
            code: '532530000000',
            value: '1102',
            
            id: 1102
          },
          {
            label: '河口瑶族自治县',
            
            
            parentId: 348,
            code: '532532000000',
            value: '1103',
            
            id: 1103
          },
          {
            label: '屏边苗族自治县',
            
            
            parentId: 348,
            code: '532523000000',
            value: '1104',
            
            id: 1104
          }
        ],
        id: 348
      },
      {
        label: '文山壮族苗族自治州',
        
        
        parentId: 30,
        code: '532600000000',
        value: '349',
        children: [
          {
            label: '文山市',
            
            
            parentId: 349,
            code: '532601000000',
            value: '1105',
            
            id: 1105
          },
          {
            label: '砚山县',
            
            
            parentId: 349,
            code: '532622000000',
            value: '1106',
            
            id: 1106
          },
          {
            label: '西畴县',
            
            
            parentId: 349,
            code: '532623000000',
            value: '1107',
            
            id: 1107
          },
          {
            label: '麻栗坡县',
            
            
            parentId: 349,
            code: '532624000000',
            value: '1108',
            
            id: 1108
          },
          {
            label: '马关县',
            
            
            parentId: 349,
            code: '532625000000',
            value: '1109',
            
            id: 1109
          },
          {
            label: '丘北县',
            
            
            parentId: 349,
            code: '532626000000',
            value: '1110',
            
            id: 1110
          },
          {
            label: '广南县',
            
            
            parentId: 349,
            code: '532627000000',
            value: '1111',
            
            id: 1111
          },
          {
            label: '富宁县',
            
            
            parentId: 349,
            code: '532628000000',
            value: '1112',
            
            id: 1112
          }
        ],
        id: 349
      }
    ],
    id: 30
  },
  {
    label: '浙江省',
    
    
    parentId: 1,
    code: '330000000000',
    value: '31',
    children: [
      {
        label: '杭州市',
        
        
        parentId: 31,
        code: '330100000000',
        value: '350',
        children: [
          {
            label: '桐庐县',
            
            
            parentId: 350,
            code: '330122000000',
            value: '1409',
            
            id: 1409
          },
          {
            label: '淳安县',
            
            
            parentId: 350,
            code: '330127000000',
            value: '1410',
            
            id: 1410
          },
          {
            label: '上城区',
            
            
            parentId: 350,
            code: '330102000000',
            value: '1411',
            
            id: 1411
          },
          {
            label: '下城区',
            
            
            parentId: 350,
            code: '330103000000',
            value: '1412',
            
            id: 1412
          },
          {
            label: '江干区',
            
            
            parentId: 350,
            code: '330104000000',
            value: '1413',
            
            id: 1413
          },
          {
            label: '拱墅区',
            
            
            parentId: 350,
            code: '330105000000',
            value: '1414',
            
            id: 1414
          },
          {
            label: '西湖区',
            
            
            parentId: 350,
            code: '330106000000',
            value: '1415',
            
            id: 1415
          },
          {
            label: '滨江区',
            
            
            parentId: 350,
            code: '330108000000',
            value: '1416',
            
            id: 1416
          },
          {
            label: '萧山区',
            
            
            parentId: 350,
            code: '330109000000',
            value: '1417',
            
            id: 1417
          },
          {
            label: '余杭区',
            
            
            parentId: 350,
            code: '330110000000',
            value: '1418',
            
            id: 1418
          },
          {
            label: '建德市',
            
            
            parentId: 350,
            code: '330182000000',
            value: '1419',
            
            id: 1419
          },
          {
            label: '富阳市',
            
            
            parentId: 350,
            code: '330183000000',
            value: '1420',
            
            id: 1420
          },
          {
            label: '临安市',
            
            
            parentId: 350,
            code: '330185000000',
            value: '1421',
            
            id: 1421
          }
        ],
        id: 350
      },
      {
        label: '宁波市',
        
        
        parentId: 31,
        code: '330200000000',
        value: '351',
        children: [
          {
            label: '余姚市',
            
            
            parentId: 351,
            code: '330281000000',
            value: '1422',
            
            id: 1422
          },
          {
            label: '慈溪市',
            
            
            parentId: 351,
            code: '330282000000',
            value: '1423',
            
            id: 1423
          },
          {
            label: '奉化市',
            
            
            parentId: 351,
            code: '330283000000',
            value: '1424',
            
            id: 1424
          },
          {
            label: '象山县',
            
            
            parentId: 351,
            code: '330225000000',
            value: '1425',
            
            id: 1425
          },
          {
            label: '宁海县',
            
            
            parentId: 351,
            code: '330226000000',
            value: '1426',
            
            id: 1426
          },
          {
            label: '海曙区',
            
            
            parentId: 351,
            code: '330203000000',
            value: '1427',
            
            id: 1427
          },
          {
            label: '江东区',
            
            
            parentId: 351,
            code: '330204000000',
            value: '1428',
            
            id: 1428
          },
          {
            label: '江北区',
            
            
            parentId: 351,
            code: '330205000000',
            value: '1429',
            
            id: 1429
          },
          {
            label: '北仑区',
            
            
            parentId: 351,
            code: '330206000000',
            value: '1430',
            
            id: 1430
          },
          {
            label: '镇海区',
            
            
            parentId: 351,
            code: '330211000000',
            value: '1431',
            
            id: 1431
          },
          {
            label: '鄞州区',
            
            
            parentId: 351,
            code: '330212000000',
            value: '1432',
            
            id: 1432
          }
        ],
        id: 351
      },
      {
        label: '温州市',
        
        
        parentId: 31,
        code: '330300000000',
        value: '352',
        children: [
          {
            label: '鹿城区',
            
            
            parentId: 352,
            code: '330302000000',
            value: '1433',
            
            id: 1433
          },
          {
            label: '龙湾区',
            
            
            parentId: 352,
            code: '330303000000',
            value: '1434',
            
            id: 1434
          },
          {
            label: '瓯海区',
            
            
            parentId: 352,
            code: '330304000000',
            value: '1435',
            
            id: 1435
          },
          {
            label: '洞头县',
            
            
            parentId: 352,
            code: '330322000000',
            value: '1436',
            
            id: 1436
          },
          {
            label: '永嘉县',
            
            
            parentId: 352,
            code: '330324000000',
            value: '1437',
            
            id: 1437
          },
          {
            label: '平阳县',
            
            
            parentId: 352,
            code: '330326000000',
            value: '1438',
            
            id: 1438
          },
          {
            label: '苍南县',
            
            
            parentId: 352,
            code: '330327000000',
            value: '1439',
            
            id: 1439
          },
          {
            label: '文成县',
            
            
            parentId: 352,
            code: '330328000000',
            value: '1440',
            
            id: 1440
          },
          {
            label: '泰顺县',
            
            
            parentId: 352,
            code: '330329000000',
            value: '1441',
            
            id: 1441
          },
          {
            label: '瑞安市',
            
            
            parentId: 352,
            code: '330381000000',
            value: '1442',
            
            id: 1442
          },
          {
            label: '乐清市',
            
            
            parentId: 352,
            code: '330382000000',
            value: '1443',
            
            id: 1443
          }
        ],
        id: 352
      },
      {
        label: '嘉兴市',
        
        
        parentId: 31,
        code: '330400000000',
        value: '353',
        children: [
          {
            label: '海宁市',
            
            
            parentId: 353,
            code: '330481000000',
            value: '1444',
            
            id: 1444
          },
          {
            label: '平湖市',
            
            
            parentId: 353,
            code: '330482000000',
            value: '1445',
            
            id: 1445
          },
          {
            label: '桐乡市',
            
            
            parentId: 353,
            code: '330483000000',
            value: '1446',
            
            id: 1446
          },
          {
            label: '嘉善县',
            
            
            parentId: 353,
            code: '330421000000',
            value: '1447',
            
            id: 1447
          },
          {
            label: '海盐县',
            
            
            parentId: 353,
            code: '330424000000',
            value: '1448',
            
            id: 1448
          },
          {
            label: '南湖区',
            
            
            parentId: 353,
            code: '330402000000',
            value: '1449',
            
            id: 1449
          },
          {
            label: '秀洲区',
            
            
            parentId: 353,
            code: '330411000000',
            value: '1450',
            
            id: 1450
          }
        ],
        id: 353
      },
      {
        label: '湖州市',
        
        
        parentId: 31,
        code: '330500000000',
        value: '354',
        children: [
          {
            label: '德清县',
            
            
            parentId: 354,
            code: '330521000000',
            value: '1451',
            
            id: 1451
          },
          {
            label: '长兴县',
            
            
            parentId: 354,
            code: '330522000000',
            value: '1452',
            
            id: 1452
          },
          {
            label: '安吉县',
            
            
            parentId: 354,
            code: '330523000000',
            value: '1453',
            
            id: 1453
          },
          {
            label: '吴兴区',
            
            
            parentId: 354,
            code: '330502000000',
            value: '1454',
            
            id: 1454
          },
          {
            label: '南浔区',
            
            
            parentId: 354,
            code: '330503000000',
            value: '1455',
            
            id: 1455
          }
        ],
        id: 354
      },
      {
        label: '绍兴市',
        
        
        parentId: 31,
        code: '330600000000',
        value: '355',
        children: [
          {
            label: '诸暨市',
            
            
            parentId: 355,
            code: '330681000000',
            value: '1456',
            
            id: 1456
          },
          {
            label: '上虞区',
            
            
            parentId: 355,
            code: '330604000000',
            value: '1457',
            
            id: 1457
          },
          {
            label: '嵊州市',
            
            
            parentId: 355,
            code: '330683000000',
            value: '1458',
            
            id: 1458
          },
          {
            label: '柯桥区',
            
            
            parentId: 355,
            code: '330603000000',
            value: '1459',
            
            id: 1459
          },
          {
            label: '新昌县',
            
            
            parentId: 355,
            code: '330624000000',
            value: '1460',
            
            id: 1460
          },
          {
            label: '越城区',
            
            
            parentId: 355,
            code: '330602000000',
            value: '1461',
            
            id: 1461
          }
        ],
        id: 355
      },
      {
        label: '金华市',
        
        
        parentId: 31,
        code: '330700000000',
        value: '356',
        children: [
          {
            label: '婺城区',
            
            
            parentId: 356,
            code: '330702000000',
            value: '1462',
            
            id: 1462
          },
          {
            label: '金东区',
            
            
            parentId: 356,
            code: '330703000000',
            value: '1463',
            
            id: 1463
          },
          {
            label: '武义县',
            
            
            parentId: 356,
            code: '330723000000',
            value: '1464',
            
            id: 1464
          },
          {
            label: '浦江县',
            
            
            parentId: 356,
            code: '330726000000',
            value: '1465',
            
            id: 1465
          },
          {
            label: '磐安县',
            
            
            parentId: 356,
            code: '330727000000',
            value: '1466',
            
            id: 1466
          },
          {
            label: '兰溪市',
            
            
            parentId: 356,
            code: '330781000000',
            value: '1467',
            
            id: 1467
          },
          {
            label: '义乌市',
            
            
            parentId: 356,
            code: '330782000000',
            value: '1468',
            
            id: 1468
          },
          {
            label: '东阳市',
            
            
            parentId: 356,
            code: '330783000000',
            value: '1469',
            
            id: 1469
          },
          {
            label: '永康市',
            
            
            parentId: 356,
            code: '330784000000',
            value: '1470',
            
            id: 1470
          }
        ],
        id: 356
      },
      {
        label: '衢州市',
        
        
        parentId: 31,
        code: '330800000000',
        value: '357',
        children: [
          {
            label: '江山市',
            
            
            parentId: 357,
            code: '330881000000',
            value: '1471',
            
            id: 1471
          },
          {
            label: '常山县',
            
            
            parentId: 357,
            code: '330822000000',
            value: '1472',
            
            id: 1472
          },
          {
            label: '开化县',
            
            
            parentId: 357,
            code: '330824000000',
            value: '1473',
            
            id: 1473
          },
          {
            label: '龙游县',
            
            
            parentId: 357,
            code: '330825000000',
            value: '1474',
            
            id: 1474
          },
          {
            label: '柯城区',
            
            
            parentId: 357,
            code: '330802000000',
            value: '1475',
            
            id: 1475
          },
          {
            label: '衢江区',
            
            
            parentId: 357,
            code: '330803000000',
            value: '1476',
            
            id: 1476
          }
        ],
        id: 357
      },
      {
        label: '舟山市',
        
        
        parentId: 31,
        code: '330900000000',
        value: '358',
        children: [
          {
            label: '定海区',
            
            
            parentId: 358,
            code: '330902000000',
            value: '1477',
            
            id: 1477
          },
          {
            label: '普陀区',
            
            
            parentId: 358,
            code: '330903000000',
            value: '1478',
            
            id: 1478
          },
          {
            label: '岱山县',
            
            
            parentId: 358,
            code: '330921000000',
            value: '1479',
            
            id: 1479
          },
          {
            label: '嵊泗县',
            
            
            parentId: 358,
            code: '330922000000',
            value: '1480',
            
            id: 1480
          }
        ],
        id: 358
      },
      {
        label: '台州市',
        
        
        parentId: 31,
        code: '331000000000',
        value: '359',
        children: [
          {
            label: '温岭市',
            
            
            parentId: 359,
            code: '331081000000',
            value: '1481',
            
            id: 1481
          },
          {
            label: '临海市',
            
            
            parentId: 359,
            code: '331082000000',
            value: '1482',
            
            id: 1482
          },
          {
            label: '玉环县',
            
            
            parentId: 359,
            code: '331021000000',
            value: '1483',
            
            id: 1483
          },
          {
            label: '三门县',
            
            
            parentId: 359,
            code: '331022000000',
            value: '1484',
            
            id: 1484
          },
          {
            label: '天台县',
            
            
            parentId: 359,
            code: '331023000000',
            value: '1485',
            
            id: 1485
          },
          {
            label: '仙居县',
            
            
            parentId: 359,
            code: '331024000000',
            value: '1486',
            
            id: 1486
          },
          {
            label: '椒江区',
            
            
            parentId: 359,
            code: '331002000000',
            value: '1487',
            
            id: 1487
          },
          {
            label: '黄岩区',
            
            
            parentId: 359,
            code: '331003000000',
            value: '1488',
            
            id: 1488
          },
          {
            label: '路桥区',
            
            
            parentId: 359,
            code: '331004000000',
            value: '1489',
            
            id: 1489
          }
        ],
        id: 359
      },
      {
        label: '丽水市',
        
        
        parentId: 31,
        code: '331100000000',
        value: '360',
        children: [
          {
            label: '莲都区',
            
            
            parentId: 360,
            code: '331102000000',
            value: '1490',
            
            id: 1490
          },
          {
            label: '青田县',
            
            
            parentId: 360,
            code: '331121000000',
            value: '1491',
            
            id: 1491
          },
          {
            label: '缙云县',
            
            
            parentId: 360,
            code: '331122000000',
            value: '1492',
            
            id: 1492
          },
          {
            label: '遂昌县',
            
            
            parentId: 360,
            code: '331123000000',
            value: '1493',
            
            id: 1493
          },
          {
            label: '松阳县',
            
            
            parentId: 360,
            code: '331124000000',
            value: '1494',
            
            id: 1494
          },
          {
            label: '云和县',
            
            
            parentId: 360,
            code: '331125000000',
            value: '1495',
            
            id: 1495
          },
          {
            label: '庆元县',
            
            
            parentId: 360,
            code: '331126000000',
            value: '1496',
            
            id: 1496
          },
          {
            label: '龙泉市',
            
            
            parentId: 360,
            code: '331181000000',
            value: '1497',
            
            id: 1497
          },
          {
            label: '景宁畲族自治县',
            
            
            parentId: 360,
            code: '331127000000',
            value: '1498',
            
            id: 1498
          }
        ],
        id: 360
      }
    ],
    id: 31
  },
  {
    label: '重庆市',
    
    
    parentId: 1,
    code: '500000000000',
    value: '32',
    children: [
      {
        label: '市辖区',
        
        
        parentId: 32,
        code: '500100000000',
        value: '361',
        children: [
          {
            label: '巴南区',
            
            
            parentId: 361,
            code: '500113000000',
            value: '3140',
            
            id: 3140
          },
          {
            label: '北碚区',
            
            
            parentId: 361,
            code: '500109000000',
            value: '3141',
            
            id: 3141
          },
          {
            label: '璧山区',
            
            
            parentId: 361,
            code: '500120000000',
            value: '3142',
            
            id: 3142
          },
          {
            label: '长寿区',
            
            
            parentId: 361,
            code: '500115000000',
            value: '3143',
            
            id: 3143
          },
          {
            label: '大渡口区',
            
            
            parentId: 361,
            code: '500104000000',
            value: '3144',
            
            id: 3144
          },
          {
            label: '大足区',
            
            
            parentId: 361,
            code: '500111000000',
            value: '3145',
            
            id: 3145
          },
          {
            label: '涪陵区',
            
            
            parentId: 361,
            code: '500102000000',
            value: '3146',
            
            id: 3146
          },
          {
            label: '合川区',
            
            
            parentId: 361,
            code: '500117000000',
            value: '3147',
            
            id: 3147
          },
          {
            label: '江北区',
            
            
            parentId: 361,
            code: '500105000000',
            value: '3148',
            
            id: 3148
          },
          {
            label: '江津区',
            
            
            parentId: 361,
            code: '500116000000',
            value: '3149',
            
            id: 3149
          },
          {
            label: '九龙坡区',
            
            
            parentId: 361,
            code: '500107000000',
            value: '3150',
            
            id: 3150
          },
          {
            label: '南岸区',
            
            
            parentId: 361,
            code: '500108000000',
            value: '3151',
            
            id: 3151
          },
          {
            label: '南川区',
            
            
            parentId: 361,
            code: '500119000000',
            value: '3152',
            
            id: 3152
          },
          {
            label: '綦江区',
            
            
            parentId: 361,
            code: '500110000000',
            value: '3153',
            
            id: 3153
          },
          {
            label: '黔江区',
            
            
            parentId: 361,
            code: '500114000000',
            value: '3154',
            
            id: 3154
          },
          {
            label: '沙坪坝区',
            
            
            parentId: 361,
            code: '500106000000',
            value: '3155',
            
            id: 3155
          },
          {
            label: '铜梁区',
            
            
            parentId: 361,
            code: '500151000000',
            value: '3156',
            
            id: 3156
          },
          {
            label: '万州区',
            
            
            parentId: 361,
            code: '500101000000',
            value: '3157',
            
            id: 3157
          },
          {
            label: '永川区',
            
            
            parentId: 361,
            code: '500118000000',
            value: '3158',
            
            id: 3158
          },
          {
            label: '渝北区',
            
            
            parentId: 361,
            code: '500112000000',
            value: '3159',
            
            id: 3159
          },
          {
            label: '渝中区',
            
            
            parentId: 361,
            code: '500103000000',
            value: '3160',
            
            id: 3160
          }
        ],
        id: 361
      },
      {
        label: '县',
        
        
        parentId: 32,
        code: '500200000000',
        value: '362',
        children: [
          {
            label: '城口县',
            
            
            parentId: 362,
            code: '500229000000',
            value: '3123',
            
            id: 3123
          },
          {
            label: '垫江县',
            
            
            parentId: 362,
            code: '500231000000',
            value: '3124',
            
            id: 3124
          },
          {
            label: '丰都县',
            
            
            parentId: 362,
            code: '500230000000',
            value: '3125',
            
            id: 3125
          },
          {
            label: '奉节县',
            
            
            parentId: 362,
            code: '500236000000',
            value: '3126',
            
            id: 3126
          },
          {
            label: '开县',
            
            
            parentId: 362,
            code: '500234000000',
            value: '3127',
            
            id: 3127
          },
          {
            label: '梁平县',
            
            
            parentId: 362,
            code: '500228000000',
            value: '3128',
            
            id: 3128
          },
          {
            label: '彭水苗族土家族自治县',
            
            
            parentId: 362,
            code: '500243000000',
            value: '3129',
            
            id: 3129
          },
          {
            label: '荣昌县',
            
            
            parentId: 362,
            code: '500226000000',
            value: '3130',
            
            id: 3130
          },
          {
            label: '石柱土家族自治县',
            
            
            parentId: 362,
            code: '500240000000',
            value: '3131',
            
            id: 3131
          },
          {
            label: '潼南县',
            
            
            parentId: 362,
            code: '500223000000',
            value: '3132',
            
            id: 3132
          },
          {
            label: '巫山县',
            
            
            parentId: 362,
            code: '500237000000',
            value: '3133',
            
            id: 3133
          },
          {
            label: '巫溪县',
            
            
            parentId: 362,
            code: '500238000000',
            value: '3134',
            
            id: 3134
          },
          {
            label: '武隆县',
            
            
            parentId: 362,
            code: '500232000000',
            value: '3135',
            
            id: 3135
          },
          {
            label: '秀山土家族苗族自治县',
            
            
            parentId: 362,
            code: '500241000000',
            value: '3136',
            
            id: 3136
          },
          {
            label: '酉阳土家族苗族自治县',
            
            
            parentId: 362,
            code: '500242000000',
            value: '3137',
            
            id: 3137
          },
          {
            label: '云阳县',
            
            
            parentId: 362,
            code: '500235000000',
            value: '3138',
            
            id: 3138
          },
          {
            label: '忠县',
            
            
            parentId: 362,
            code: '500233000000',
            value: '3139',
            
            id: 3139
          }
        ],
        id: 362
      }
    ],
    id: 32
  }
]



// WEBPACK FOOTER //
// ./src/config/address.js